/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum JobStatusTypeEnumDto {
  Undefined = 0,
  Pending = 5,
  Started = 6,
  Completed = 7,
  Failed = 8,
  Cancelled = 9,
  Retry = 10,
  Hold = 11,
}

export enum AchTransactionType2Dto {
  Undefined = 0,
  Debit = 1,
  Credit = 2,
  DebitCredit = 3,
}

export enum BankAccountType2Dto {
  Undefined = 0,
  Checking = 1,
  Savings = 2,
  Loan = 3,
  Mortgage = 4,
  ClubAccount = 5,
  TimeDeposit = 6,
  GL = 7,
}

export enum CurrencyTypeDto {
  Undefined = 0,
  USD = 1,
  CAD = 2,
  MXN = 3,
  GBP = 4,
  CHF = 5,
  EUR = 6,
}

export enum ForeignExchangeReferenceIndicatorDto {
  Undefined = 0,
  ForeignExchangeRate = 1,
  ForeignExchangeReferenceNumber = 2,
  None = 3,
}

export enum ForeignExchangeIndicatorTypeDto {
  Undefined = 0,
  FF = 1,
  FV = 2,
}

export enum AchFilterDateTypeDto {
  Undefined = 0,
  SpecificDate = 1,
  Range = 2,
}

export enum AchFilterAmountTypeDto {
  Undefined = 0,
  SpecificAmount = 1,
  Range = 2,
}

export enum AchSecCodeTypeDto {
  CCD = 1,
  CTX = 2,
  PPD = 3,
  TEL = 4,
  WEB = 5,
  IAT = 6,
}

export enum AchTemplateStatusTypeDto {
  PendingApproval = 1,
  Ready = 2,
  Rejected = 3,
  Deleted = 4,
}

export enum AchTransactionTypeDto {
  Undefined = 0,
  Debit = 1,
  Credit = 2,
  DebitCredit = 3,
}

export enum BankAccountTypeDto {
  Undefined = 0,
  Checking = 1,
  Savings = 2,
  Loan = 3,
  Mortgage = 4,
  ClubAccount = 5,
  TimeDeposit = 6,
  GL = 7,
}

export enum DateFilterOptionsDto {
  Undefined = 0,
  SpecificDate = 1,
  Range = 2,
}

export enum ActionSuccessLevelDto {
  Successful = 1,
  UnSuccessful = 2,
  NotExecuted = 3,
}

export enum ChallengeMethodTypeEnumAchServiceDto {
  None = 0,
  OutOfBand = 1,
  SecureToken = 2,
  OutOfBandViaEns = 3,
}

export enum TransactionTypeEnumDto {
  Posted = 0,
  Pending = 1,
}

export enum AmountTypeEnumDto {
  Debit = 0,
  Credit = 1,
  Both = 2,
}

export enum UploadTypeEnumDto {
  Undefined = 0,
  Batch = 1,
  Payment = 2,
}

export enum AchPaymentTypeEnumDto {
  AchPayment = 1,
  AchStateTaxPayment = 2,
  AchFederalTaxPayment = 3,
  AchChildSupportPayment = 4,
  AchInternationalPayment = 5,
}

export enum AchRecipientAddendaActionTypeDto {
  Undefined = 0,
  AddAchPaymentRecipientAddenda = 1,
  UpdateAchPaymentRecipientAddenda = 2,
  AddAchBatchRecipientAddenda = 3,
  UpdateAchBatchRecipientAddenda = 4,
}

export enum AchFileImportFieldEnumDto {
  Undefined = 0,
  Name = 1,
  IDNumber = 2,
  RoutingNumber = 3,
  AccountNumber = 4,
  Amount = 5,
  TransactionCode = 6,
  AccountType = 7,
  TransactionType = 8,
}

export enum FileFormatTypeEnumDto {
  Undefined = 0,
  Delimited = 1,
  FixedPosition = 2,
}

export enum ProductTypesEnumDto {
  Undefined = 0,
  InternalTransfer = 1,
  InformationReporting = 2,
  WireTransfer = 3,
  WireTransferDLI = 4,
  Ach = 5,
  Arp = 6,
  StopPayment = 7,
  ElectronicDocuments = 8,
  BillPay = 9,
  RemoteDeposits = 10,
  WausauStatements = 11,
  AccountRecon = 12,
  BdiEStatements = 13,
  AgileticsSso = 14,
  DerivativePath = 15,
  AmpliFiLoyalty = 16,
  CentrixSso = 17,
  HC3Sso = 18,
  Fiserv360Sso = 19,
  CorpaySso = 20,
  IntegratedServices = -1,
}

export enum TaxTemplateSearchTypeDto {
  Undefined = 0,
  Federal = 1,
  State = 2,
  Both = 3,
}

export enum AmountFilterTypeEnumDto {
  Undefined = 0,
  Specific = 1,
  Range = 2,
}

export enum OutPutTypeAchServiceDto {
  Entity = 0,
  Pdf = 1,
  Csv = 2,
  Tiff = 3,
  Bai = 4,
  Quicken = 5,
  QuickBook = 6,
  Nacha = 7,
}

export enum IssuedItemEntryTypeEnumDto {
  Undefined = 0,
  Manual = 1,
  Upload = 2,
  Other = 3,
  Transmitted = 4,
}

export enum CheckTypeEnumDto {
  Undefined = 0,
  Check = 2,
  Void = 3,
}

export enum PendingEditStatusAchServiceDto {
  Edited = 1,
  Pending = 2,
  Approved = 3,
  Discard = 4,
  Rejected = 5,
  FiPending = 6,
}

export enum WireActionTypeEnumAchServiceDto {
  Undefined = 0,
  New = 1,
  Modified = 2,
  Cancelled = 3,
  QuoteRequested = 4,
  QuoteAccepted = 5,
  QuoteRejected = 6,
  Approved = 7,
  Rejected = 8,
  Transmitted = 9,
  Expired = 10,
  Failed = 11,
  Posted = 12,
  Deleted = 13,
  PendingProcess = 14,
}

export enum ErrorTypeAchServiceDto {
  Error = 0,
  Info = 1,
  Warning = 2,
}

export enum ObjectStateAchServiceDto {
  Unchanged = 0,
  Added = 1,
  Modified = 2,
  Deleted = 3,
}

export enum UserTypeAchServiceDto {
  Undefined = 0,
  Banno = 1,
  CashManagement = 2,
  Esi = 3,
  NetTeller = 4,
  Sso = 5,
  Treasury = 6,
  ESIFIM = 7,
  BackOffice = 8,
  Geezeo = 9,
  GeezeoMobile = 10,
  BannoCashManagement = 11,
  GeezeoCashManagement = 12,
  GeezeoMobileCashManagement = 13,
  Newgen = 14,
  Server = 15,
  Jha = 16,
  BannoPeople = 17,
}

export enum ApplicationNameTypeAchServiceDto {
  Undefined = 0,
  BackOffice = 1,
  Banno = 2,
  ECS = 3,
  EPS = 4,
  Esi = 5,
  GoDough = 6,
  GoDoughClassic = 7,
  GoDough3X = 8,
  IPay = 9,
  NetTeller = 10,
  PointMobility = 11,
  Treasury = 12,
  BSLKeys = 13,
  BSL = 14,
  ESIFIM = 15,
  EStatements = 16,
  Geezeo = 17,
  BannoPeople = 18,
  CoreDirector = 19,
  Newgen = 20,
  Corserv = 21,
  BOKF = 22,
  Autobooks = 23,
  MobileWeb = 24,
  HCL = 25,
  JxChangeApp = 26,
  TreasuryMobile = 27,
  TreasuryBackOffice = 28,
  BslSubSystem = 29,
  AccountRecon = 30,
  Ach = 31,
  AlertNetCore = 32,
  BankAccount = 33,
  Company = 34,
  Event = 35,
  JxChangeProxy = 36,
  PositivePay = 37,
  Sso = 38,
  User = 39,
  Wire = 40,
  Edpp = 41,
  FxGateway = 42,
  InstitutionNetCore = 43,
  AuthorizationNetCore = 44,
  File = 45,
  Configuration = 46,
  AchReturn = 47,
  ApiCatalog = 48,
  BslSubsystemAdmin = 49,
  EsiMailProcessor = 50,
  Nacha = 51,
  Pdf = 52,
  AchNotificationOfChange = 53,
  RateLimiting = 54,
  AchCompany = 55,
  TreasuryScheduler = 56,
  Report = 57,
  AccountReconIssuedItems = 58,
  PositivePayIssuedItems = 59,
  InternalTransfer = 60,
  CheckExceptions = 61,
  AlertUpdate = 62,
  TreasuryAccount = 63,
  TreasuryAuthentication = 64,
  TreasuryOdiEesListener = 65,
  TreasuryPayment = 66,
  TreasuryReporting = 67,
  TreasuryAch = 68,
  TreasuryWire = 69,
  TreasuryBackOfficeApi = 70,
  TreasuryChannelApi = 71,
  TreasuryNotification = 72,
  NachaIngest = 73,
  AchReturnProcessor = 74,
  AchNocProcessor = 75,
  NachaProcessor = 76,
  NachaSerialize = 77,
  AchPayment = 78,
  TextMessagingNetCore = 79,
  EmailNetCore = 80,
  LoggingNetCore = 81,
  MessageCenterNetCore = 82,
  AuthenticationRules = 83,
  Credentials = 84,
  HttpProxy = 85,
  DocumentNetCore = 86,
  AuthenticationNetCore = 87,
  ChallengeManagementNetCore = 88,
  FileWatcher = 89,
  FileProcessor = 90,
  EsiApplication = 91,
  AccountReports = 92,
  AuditNetCore = 93,
  TreasuryWireNetCore = 94,
  FraudNetCore = 95,
  BslAdmin = 96,
  JxR = 97,
  HealthCheck = 98,
  EchoQueueHandlerService = 99,
  BackgroundUpload = 100,
  JxrBannoBusiness = 101,
  Disclosure = 102,
  FileMovement = 103,
  Fxgw = 104,
  NtEchoData = 105,
}

export enum ExceptionCorrectionItemDto {
  AccountNumber = 1,
  PostedDate = 2,
  CheckNumber = 3,
  Amount = 4,
  Payee = 5,
  DuplicateCheck = 6,
}

export enum IssuedItemTypeDto {
  Undefined = 0,
  None = 1,
  Check = 2,
  Void = 3,
}

export enum FileDetailActionTakenTypeDto {
  Undefined = 0,
  Added = 1,
  Edited = 2,
  Deleted = 3,
}

export enum BillPayAccessDto {
  Unknown = 0,
  Allow = 1,
  Deny = 2,
  DenyWithMessage = 3,
}

export enum PaymentStatusDto {
  Unknown = 0,
  Processed = 1,
  Paid = 2,
  Stopped = 3,
  Cancelled = 4,
  Resubmitted = 5,
  Refunded = 6,
  Skipped = 7,
  Approved = 8,
  Scheduled = 9,
  Pending = 10,
  PendingSkip = 11,
  ApprovalRequired = 12,
  Settled = 13,
  Returned = 14,
}

export enum PaymentFrequencyDto {
  None = 0,
  Once = 1,
  Weekly = 2,
  EveryOtherWeek = 3,
  Every4Weeks = 4,
  Monthly = 5,
  TwiceMonthly = 6,
  EveryOtherMonth = 7,
  Every3Months = 8,
  Every6Months = 9,
  Annual = 10,
}

export enum PaymentTypeDto {
  None = 0,
  Scheduled = 1,
  Past = 2,
}

export enum PayeeStatusDto {
  Activated = 0,
  NotActivated = 1,
  Deleted = 2,
}

export enum PaymentMethodDto {
  Check = 0,
  Email = 1,
  Electronic = 2,
}

export enum AccountType2Dto {
  Checking = 0,
  Savings = 1,
}

export enum PaymentDateModelDto {
  None = 0,
  ProcessDate = 1,
  DueDate = 1,
}

export enum LoanPaymentOptionTypeEnumDto {
  Undefined = 0,
  RegularPayment = 1,
  PrincipalOnly = 2,
  InterestOnly = 3,
}

export enum ErrorTypeModelDto {
  Error = 0,
  Info = 1,
  Warning = 2,
}

export enum UserActivityTypeDto {
  Account = 1,
  Ach = 2,
  Admin = 3,
  Dashboard = 4,
  Login = 5,
  MessageCenter = 6,
  Navigating = 7,
  PositivePay = 8,
  ProfileAndNotification = 9,
  Reporting = 10,
  StopPayment = 11,
  Transaction = 12,
  Transfer = 13,
  Wire = 14,
  AccountReconciliationReporting = 15,
  Authentication = 16,
}

export enum DayOfWeekDto {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export enum TimeAccessTypeDto {
  Undefined = 0,
  AllowAllDay = 1,
  RestrictAllDay = 2,
  TimeRange = 3,
}

export enum MultifactorAuthenticationResponseCodeDto {
  Undefined = 0,
  Allow = 30000,
  Decline = 30100,
  Challenge = 30200,
  OutOfBandPhoneChallenge = 30300,
  QuestionChallenge = 30400,
  Collect = 30500,
  Review = 30600,
  StopAndReview = 30700,
  DelayAndReview = 30800,
  UserLocked = 30900,
}

export enum ValidateChallengeFailTypeDto {
  Undefined = 0,
  Unknown = 1,
  Locked = 2,
}

export enum ChallengeMethodTypeEnumDto {
  None = 0,
  OutOfBand = 1,
  SecureToken = 2,
  OutOfBandViaEns = 3,
}

export enum ElectronicDocumentTypeEnumDto {
  Undefined = 0,
  PrintMail = 1,
  Esi = 2,
  Wausau = 3,
}

export enum SecureTokenMfaLoginResultStatusDto {
  Success = 1,
  Locked = 2,
  Failure = 3,
  InvalidCredentialState = 4,
}

export enum UserSecureTokenMfaLoginStatusDto {
  NoChallengeRequired = 1,
  NeedCredentialRegistration = 2,
  NeedChallenge = 3,
  AlreadySuccessfullyChallenged = 4,
  Locked = 5,
}

export enum ExternalAuthTypeDto {
  Undefined = 0,
  OOBVoice = 1,
  OOBSMS = 2,
  CustomV11Challenge = 3,
}

export enum RiskEventTypeDto {
  Undefined = 0,
  ActivateCard = 1,
  AddPayee = 2,
  ChangeAddress = 3,
  ChangeAlertSettings = 4,
  ChangeChallengeQuestion = 5,
  ChangeEmail = 6,
  ChangeLogOnId = 7,
  ChangePassword = 8,
  ChangePhone = 9,
  ChangeStatementSettings = 10,
  Deposit = 11,
  EditPayee = 12,
  ExtraAuth = 13,
  FailedChangePasswordAttempt = 14,
  FailedOpenNewAccount = 15,
  FailedLogOnAttempt = 16,
  FailedOlbEnrollAttempt = 17,
  LogOn = 18,
  OlbEnroll = 19,
  OpenNewAccount = 20,
  OptionsTrade = 21,
  Payment = 22,
  ReadSecureMessage = 23,
  RequestCheckCopy = 24,
  RequestChecks = 25,
  RequestCredit = 26,
  RequestNewCard = 27,
  RequestNewPin = 28,
  RequestStatementCopy = 29,
  SendSecureMessage = 30,
  StockTrade = 31,
  UserDefined = 32,
  UserDetails = 33,
  ChangeUserAuthenticationInfo = 34,
  ViewCheck = 35,
  ViewStatement = 36,
}

export enum AccountType1Dto {
  UNDEFINED = 0,
  CREDIT_CARD = 1,
  DEBIT_CARD = 2,
  CHECKING = 3,
  CHECKING_WITH_OVERDRAFT = 4,
  SAVINGS = 5,
  CD = 6,
  LINE_OF_CREDIT = 7,
  RETIREMENT = 8,
  MORTGAGE = 9,
  BILLER = 10,
  PERSONAL_ACCOUNT = 11,
}

export enum CustomRiskEventTypeDto {
  Undefined = 0,
  ACHBatchInitiation = 1,
  AddWire = 2,
  ARPDownload = 3,
  ARPUpload = 4,
  CMUserDownload = 5,
  DownloadACHBatch = 6,
  DownloadTransactions = 7,
  EditWire = 8,
  FailedWirePIN = 9,
  IBTAddForeignAccount = 10,
  IBTValidateForeignAccounts = 11,
  IBTSaveTransfer = 12,
  ModifyEntitlements = 13,
  StopPaymentsAdded = 14,
  StopPaymentsDeleted = 15,
  TaxPaymentInitiation = 16,
  Transfer = 17,
  UploadACHBatch = 18,
  ViewACHHistory = 19,
  ViewPowerPayHistory = 20,
  ViewPriorDay = 21,
  ViewTransactions = 22,
  ViewWireHistory = 23,
  WireTransfer = 24,
  AddNewPayment = 25,
  EditPayment = 26,
  QuickPaymentNew = 27,
  QuickPaymentEdit = 28,
}

export enum CompleteSecureTokenConfigActionTypeDto {
  Undefined = 0,
  RemindMeLater = 1,
  StopReminders = 2,
  Register = 3,
}

export enum PendingEditStatusDto {
  Edited = 1,
  Pending = 2,
  Approved = 3,
  Discard = 4,
  Rejected = 5,
  FiPending = 6,
}

export enum WireActionTypeEnumDto {
  Undefined = 0,
  New = 1,
  Modified = 2,
  Cancelled = 3,
  QuoteRequested = 4,
  QuoteAccepted = 5,
  QuoteRejected = 6,
  Approved = 7,
  Rejected = 8,
  Transmitted = 9,
  Expired = 10,
  Failed = 11,
  Posted = 12,
  Deleted = 13,
}

export enum ErrorTypeDto {
  Error = 0,
  Info = 1,
  Warning = 2,
}

export enum ObjectStateDto {
  Unchanged = 0,
  Added = 1,
  Modified = 2,
  Deleted = 3,
}

export enum ChallengePointEnumDto {
  CreateBatch = 1,
  EditBatch = 2,
  DeleteBatch = 3,
  ApproveBatch = 4,
  CreateOneTimeAchPayment = 5,
  CreateRecurringAchPayment = 6,
  EditAchPayment = 7,
  DeleteAchPayment = 8,
  ApproveAchPayment = 9,
  CreateBeneficiary = 11,
  EditBeneficiary = 12,
  DeleteBeneficiary = 13,
  ApproveBeneficiary = 14,
  CreateOneTimeWirePayment = 15,
  EditWirePayment = 17,
  DeleteWirePayment = 18,
  ApproveWirePayment = 19,
  CreateTransfer = 20,
  CreateRecurringTransfer = 21,
  CreateOneToManyTransfer = 22,
  CreateManyToOneTransfer = 23,
  EditTransfer = 24,
  DeleteTransfer = 25,
  ApproveTransfer = 26,
  CreatePayee = 27,
  EditPayee = 28,
  DeletePayee = 29,
  CreateOneTimePayment = 30,
  CreateRecurringPayment = 31,
  EditPayment = 32,
  DeletePayment = 33,
  CreatePayroll = 34,
  EditPayroll = 35,
  DeletePayroll = 36,
  CreateUser = 37,
  EditUser = 38,
  DeleteUser = 39,
  ApproveUser = 40,
  UpdateEmailAddress = 41,
  CreateFxBeneficiary = 42,
  EditFxBeneficiary = 43,
  DeleteFxBeneficiary = 44,
  ApproveFxBeneficiary = 45,
  CreateFxWire = 46,
  ApproveFxWire = 47,
}

export enum AuthenticationTokenTypeDto {
  Undefined = 0,
  CashManagement = 1,
  NetTeller = 2,
  Esi = 3,
  SingleSignOn = 4,
  JxR = 5,
  NodeApiGateway = 6,
}

export enum UserTypeAuthenticationServiceDto {
  Undefined = 0,
  Banno = 1,
  CashManagement = 2,
  Esi = 3,
  NetTeller = 4,
  Sso = 5,
  Treasury = 6,
  ESIFIM = 7,
  BackOffice = 8,
  Geezeo = 9,
  GeezeoMobile = 10,
  BannoCashManagement = 11,
  GeezeoCashManagement = 12,
  GeezeoMobileCashManagement = 13,
  Newgen = 14,
  Server = 15,
  Jha = 16,
  BannoPeople = 17,
}

export enum ApplicationNameTypeAuthenticationServiceDto {
  Undefined = 0,
  BackOffice = 1,
  Banno = 2,
  ECS = 3,
  EPS = 4,
  Esi = 5,
  GoDough = 6,
  GoDoughClassic = 7,
  GoDough3X = 8,
  IPay = 9,
  NetTeller = 10,
  PointMobility = 11,
  Treasury = 12,
  BSLKeys = 13,
  BSL = 14,
  ESIFIM = 15,
  EStatements = 16,
  Geezeo = 17,
  BannoPeople = 18,
  CoreDirector = 19,
  Newgen = 20,
  Corserv = 21,
  BOKF = 22,
  Autobooks = 23,
  MobileWeb = 24,
  HCL = 25,
  JxChangeApp = 26,
  TreasuryMobile = 27,
  TreasuryBackOffice = 28,
  BslSubSystem = 29,
  AccountRecon = 30,
  Ach = 31,
  AlertNetCore = 32,
  BankAccount = 33,
  Company = 34,
  Event = 35,
  JxChangeProxy = 36,
  PositivePay = 37,
  Sso = 38,
  User = 39,
  Wire = 40,
  Edpp = 41,
  FxGateway = 42,
  InstitutionNetCore = 43,
  AuthorizationNetCore = 44,
  File = 45,
  Configuration = 46,
  AchReturn = 47,
  ApiCatalog = 48,
  BslSubsystemAdmin = 49,
  EsiMailProcessor = 50,
  Nacha = 51,
  Pdf = 52,
  AchNotificationOfChange = 53,
  RateLimiting = 54,
  AchCompany = 55,
  TreasuryScheduler = 56,
  Report = 57,
  AccountReconIssuedItems = 58,
  PositivePayIssuedItems = 59,
  InternalTransfer = 60,
  CheckExceptions = 61,
  AlertUpdate = 62,
  TreasuryAccount = 63,
  TreasuryAuthentication = 64,
  TreasuryOdiEesListener = 65,
  TreasuryPayment = 66,
  TreasuryReporting = 67,
  TreasuryAch = 68,
  TreasuryWire = 69,
  TreasuryBackOfficeApi = 70,
  TreasuryChannelApi = 71,
  TreasuryNotification = 72,
  NachaIngest = 73,
  AchReturnProcessor = 74,
  AchNocProcessor = 75,
  NachaProcessor = 76,
  NachaSerialize = 77,
  AchPayment = 78,
  TextMessagingNetCore = 79,
  EmailNetCore = 80,
  LoggingNetCore = 81,
  MessageCenterNetCore = 82,
  AuthenticationRules = 83,
  Credentials = 84,
  HttpProxy = 85,
  DocumentNetCore = 86,
  AuthenticationNetCore = 87,
  ChallengeManagementNetCore = 88,
  FileWatcher = 89,
  FileProcessor = 90,
  EsiApplication = 91,
  AccountReports = 92,
  AuditNetCore = 93,
  TreasuryWireNetCore = 94,
  FraudNetCore = 95,
  BslAdmin = 96,
  JxR = 97,
  HealthCheck = 98,
  EchoQueueHandlerService = 99,
  BackgroundUpload = 100,
  JxrBannoBusiness = 101,
  Disclosure = 102,
  FileMovement = 103,
  Fxgw = 104,
  NtEchoData = 105,
}

export enum UserTypeDto {
  Undefined = 0,
  Banno = 1,
  CashManagement = 2,
  Esi = 3,
  NetTeller = 4,
  Sso = 5,
  Treasury = 6,
  ESIFIM = 7,
  BackOffice = 8,
  Geezeo = 9,
  GeezeoMobile = 10,
  BannoCashManagement = 11,
  GeezeoCashManagement = 12,
  GeezeoMobileCashManagement = 13,
  Newgen = 14,
  Server = 15,
  Jha = 16,
  BannoPeople = 17,
}

export enum ApplicationNameTypeDto {
  Undefined = 0,
  BackOffice = 1,
  Banno = 2,
  ECS = 3,
  EPS = 4,
  Esi = 5,
  GoDough = 6,
  GoDough3X = 8,
  IPay = 9,
  NetTeller = 10,
  PointMobility = 11,
  Treasury = 12,
  BSLKeys = 13,
  BSL = 14,
  ESIFIM = 15,
  EStatements = 16,
  Geezeo = 17,
  BannoPeople = 18,
  CoreDirector = 19,
  Newgen = 20,
  Corserv = 21,
  BOKF = 22,
  Autobooks = 23,
  MobileWeb = 24,
  HCL = 25,
  JxChangeApp = 26,
  TreasuryMobile = 27,
  TreasuryBackOffice = 28,
  BslSubSystem = 29,
  AccountRecon = 30,
  Ach = 31,
  AlertNetCore = 32,
  BankAccount = 33,
  Company = 34,
  Event = 35,
  JxChangeProxy = 36,
  PositivePay = 37,
  Sso = 38,
  User = 39,
  Wire = 40,
  Edpp = 41,
  FxGateway = 42,
  InstitutionNetCore = 43,
  AuthorizationNetCore = 44,
  File = 45,
  Configuration = 46,
  AchReturn = 47,
  ApiCatalog = 48,
  BslSubsystemAdmin = 49,
  EsiMailProcessor = 50,
  Nacha = 51,
  Pdf = 52,
  AchNotificationOfChange = 53,
  RateLimiting = 54,
  AchCompany = 55,
  TreasuryScheduler = 56,
  Report = 57,
  AccountReconIssuedItems = 58,
  PositivePayIssuedItems = 59,
  InternalTransfer = 60,
  CheckExceptions = 61,
  AlertUpdate = 62,
  TreasuryAccount = 63,
  TreasuryAuthentication = 64,
  TreasuryOdiEesListener = 65,
  TreasuryPayment = 66,
  TreasuryReporting = 67,
  TreasuryAch = 68,
  TreasuryWire = 69,
  TreasuryBackOfficeApi = 70,
  TreasuryChannelApi = 71,
  TreasuryNotification = 72,
  NachaIngest = 73,
  AchReturnProcessor = 74,
  AchNocProcessor = 75,
  NachaProcessor = 76,
  NachaSerialize = 77,
  AchPayment = 78,
  TextMessagingNetCore = 79,
  EmailNetCore = 80,
  LoggingNetCore = 81,
  MessageCenterNetCore = 82,
  AuthenticationRules = 83,
  Credentials = 84,
  HttpProxy = 85,
  DocumentNetCore = 86,
  AuthenticationNetCore = 87,
  ChallengeManagementNetCore = 88,
  FileWatcher = 89,
  FileProcessor = 90,
  EsiApplication = 91,
  AccountReports = 92,
  AuditNetCore = 93,
  TreasuryWireNetCore = 94,
  FraudNetCore = 95,
  BslAdmin = 96,
  JxR = 97,
  HealthCheck = 98,
  EchoQueueHandlerService = 99,
  BackgroundUpload = 100,
  JxrBannoBusiness = 101,
  Disclosure = 102,
  FileMovement = 103,
  Fxgw = 104,
  NtEchoData = 105,
}

export enum OutPutTypeDto {
  Entity = 0,
  Pdf = 1,
  Csv = 2,
  Tiff = 3,
  Bai = 4,
  Quicken = 5,
  QuickBook = 6,
  Nacha = 7,
  PdfInDetail = 8,
  CsvInDetail = 9,
  Ofx = 10,
  Qbo = 11,
  Qfx = 12,
  BaiPlusBal = 13,
  Text = 14,
}

export enum SearchTypeDto {
  None = 0,
  Contains = 1,
  StartsWith = 2,
  EndsWidth = 3,
  Equals = 4,
  NotEquals = 5,
  GreaterThan = 6,
  GreaterThanOrEqual = 7,
  LessThan = 8,
  LessThanOrEqual = 9,
  Between = 10,
}

export enum ReportDownloadTypeDto {
  Undefined = 0,
  Csv = 1,
  Pdf = 2,
}

export type UserInformationModelDto = RequestResponseDto & {
  /** @format int32 */
  userId: number;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  loginId: string;
  /** @minLength 1 */
  department: string;
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  phone: string;
  /** @minLength 1 */
  extension: string;
  mobile?: string;
  mobileExtension?: string;
  phoneCarrier?: PhoneCarrierModelDto;
  /** @minLength 1 */
  fax: string;
  accountNicknames?: boolean;
  accountMasking?: boolean;
  verificationMethod?: string;
  isMfaBlocked: boolean;
  isSuperUser: boolean;
  isAccountMaskingConfigurable: boolean;
  isMethodOfVerificationConfigurable: boolean;
  isAdmin: boolean;
  /** @format int32 */
  copyUserId?: number;
  isEnrolled?: boolean;
  isActive?: boolean;
  productPermissions?: ProductPermissionModelDto[];
  securityMessage?: SecurityMessageModelDto;
  institutionUniqueId?: string;
  modelKind?: string;
};

export type PhoneCarrierModelDto = ModelBaseDto & {
  /** @format int32 */
  phoneCarrierId?: number;
  phoneCarrierName?: string;
  active?: boolean;
};

export interface ModelBaseDto {
  /** @format int32 */
  id: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export type ProductPermissionModelDto = ModelBaseDto & {
  /** @minLength 1 */
  permission: string;
};

export interface SecurityMessageModelDto {
  /** @minLength 1 */
  actionType: string;
  status?: string;
  methodUsed?: string;
  hasAlternate?: boolean;
  errorCode?: string;
  message?: string;
  sendMessage?: string;
  /** @format int32 */
  challengeMethodTypeId?: number;
  oneTimePassword?: string;
}

export interface RequestResponseDto {
  success?: boolean;
  errorMessage?: string;
}

/**
 * The http error context for GlobalExceptionHandler.
 *
 */
export interface ErrorHttpContentDto {
  /**
   * The exception message.
   *
   */
  message?: string;
  /**
   * The exception code.
   *
   * @format int32
   */
  code?: number;
  /**
   * The exception time.
   *
   */
  time?: string;
}

export interface CredentialDto {
  statusCode?: string;
  message?: string;
  data?: SecurityQuestionDto[];
  /** @format int32 */
  numberOfSecurityQuestions?: number;
  /** @format int32 */
  daysUntilPasswordExpires?: number;
  biometricsInfo?: UserDeviceResponseModelDto;
}

export interface SecurityQuestionDto {
  answer?: string;
  id?: string;
  text?: string;
}

export type RecordedSecurityQuestionDto = SecurityQuestionDto & {
  answerOnFile?: string;
};

export interface UserDeviceResponseModelDto {
  authenticationId?: string;
  key?: string;
}

export interface UserModelDto {
  /** @format int32 */
  id?: number;
  institution?: string;
  companyID?: string;
  loginID?: string;
  code?: string;
  password?: string;
  email?: string;
  name?: string;
  useClientBiometricsAuthentication?: boolean;
  biometricsInfo?: UserDeviceRequestModelDto;
}

export interface UserDeviceRequestModelDto {
  authenticationId?: string;
  hash?: string;
}

export interface LogOffModelDto {
  reason?: string;
}

export type SecurityQuestionModelDto = ModelBaseDto & {
  answer?: string;
  id?: string;
  text?: string;
};

export interface UserPasswordModelDto {
  /** @minLength 1 */
  currentPassword: string;
  /** @minLength 1 */
  newPassword: string;
  /** @minLength 1 */
  confirmPassword: string;
}

export interface ChangePasswordViewModelDto {
  statusCode?: string;
  message?: string[];
}

export interface LoginCompletionStatusModelDto {
  isComplete: boolean;
  /** @format int32 */
  challengeMethodType?: number;
  action?: string;
}

export interface UserSettingsModelDto {
  /** @format int32 */
  idleTimeoutDuration?: number;
  areNotificationsEnabled?: boolean;
  accountDisplayField?: string;
  /** @format int32 */
  unreadMessageCount?: number;
}

export interface ErrorResponseModelDto {
  responseDetails?: ResponseDetailModelCollectionDto;
  time?: string;
}

export type ResponseDetailModelCollectionDto = ResponseDetailModelDto[];

export interface ResponseDetailModelDto {
  /** @format int32 */
  responseCode?: number;
  responseMessage?: string;
}

export interface AchFiltersSearchResponseModelDto {
  achFilters?: AchFilterModelCollectionDto;
  paging?: PagingResultModelDto;
}

export type AchFilterModelCollectionDto = AchFilterModelDto[];

export interface AchFilterModelDto {
  accountNickname?: string;
  accountNumber?: string;
  /** @format guid */
  accountUniqueId?: string;
  achCompanyId?: string;
  achCompanyName?: string;
  /** @format guid */
  achFilterUniqueId?: string;
  allowType?: string;
  accountAllowsAllCredits?: boolean;
  accountAllowsAllDebits?: boolean;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  expirationDate?: string;
  filterRuleName?: string;
  /** @format decimal */
  fromAmount?: number;
  remarks?: string;
  routingNumber?: string;
  secCode?: string;
  status?: string;
  /** @format decimal */
  toAmount?: number;
  transactionType?: string;
}

export interface PagingResultModelDto {
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  totalPages?: number;
}

export interface AchFilterReportDownloadRequestApiModelDto {
  accountUniqueIds?: GuidKeyCollectionDto;
  achCompanyId?: string;
  achCompanyName?: string;
  /** @format decimal */
  amountEnd?: number;
  /** @format decimal */
  amountStart?: number;
  downloadType?: ReportDownloadTypeDto;
  /** @format date-time */
  endDate?: string;
  pagingParameters?: PagingParametersDto;
  standardEntryClassCodes?: TextKeyCollectionDto;
  /** @format date-time */
  startDate?: string;
  statuses?: TextKeyCollectionDto;
  transactionTypes?: TextKeyCollectionDto;
  userUniqueIds?: GuidKeyCollectionDto;
}

export type GuidKeyCollectionDto = string[];

export interface PagingParametersDto {
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  pageNumber?: number;
  orderBys?: OrderByCollectionDto;
  searchBys?: SearchByCollectionDto;
}

export type OrderByCollectionDto = OrderByDto[];

export interface OrderByDto {
  name?: string;
  descending?: boolean;
}

export type SearchByCollectionDto = SearchByDto[];

export interface SearchByDto {
  name?: string;
  value?: string;
  secondValue?: string;
  searchType?: SearchTypeDto;
  values?: TextKeyCollectionDto;
}

export type TextKeyCollectionDto = string[];

export interface CheckImageModelDto {
  checkId?: string;
  /** @format byte */
  frontImage?: string;
  /** @format byte */
  backImage?: string;
}

export type CompanyAccountModelDto = ModelBaseDto & {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  number: string;
  /** @minLength 1 */
  status: string;
  account?: AccountModelDto;
  /** @format decimal */
  currentBalance?: number;
  /** @format decimal */
  collectedBalance?: number;
  /** @format decimal */
  availableBalance?: number;
  type?: string;
  /** @format decimal */
  perTransactionLimit?: number;
  /** @format decimal */
  dailyLimit?: number;
  cifNumber?: string;
  isDeleted?: boolean;
  showAccountNickName?: boolean;
  accountDisplayLabel?: string;
  /** @format decimal */
  transferAmount?: number;
  transferMemo?: string;
  /** @format decimal */
  loanPaymentAmountDue?: number;
  /** @format date-time */
  loanPaymentDueDate?: string;
  allowLoanPaymentPastDue?: boolean;
  /** @format guid */
  accountUniqueId?: string;
  /** @format date-time */
  originalLoanDate?: string;
  /** @format decimal */
  originalBalance?: number;
  /** @format date-time */
  maturityDate?: string;
  /** @format decimal */
  interestRate?: number;
  /** @format decimal */
  interestPaidYtd?: number;
  /** @format decimal */
  paymentAmountDue?: number;
  /** @format decimal */
  pastAmountDue?: number;
  /** @format decimal */
  totalAmountDue?: number;
  /** @format date-time */
  paymentDueDate?: string;
  /** @format decimal */
  currentPayoff?: number;
  /** @format date-time */
  payoffGoodThru?: string;
  /** @format decimal */
  billedPrincipal?: number;
  /** @format decimal */
  billedInterest?: number;
  /** @format decimal */
  billedEscrow?: number;
  /** @format decimal */
  billedLateCharge?: number;
  /** @format decimal */
  billedOtherCharge?: number;
  /** @format decimal */
  paymentTotalAmount?: number;
  /** @format int32 */
  remainingPayments?: number;
  modelKind?: string;
};

export interface AccountModelDto {
  /** @format int32 */
  id?: number;
  number?: string;
  type?: string;
  coreStatus?: string;
  accountDisplayLabel?: string;
  name?: string;
  /** @format guid */
  accountUniqueId?: string;
}

export interface CompanyCutoffTimesDto {
  processingCutoffs?: ProcessingCutoffDto[];
  /** @format date-time */
  currentFiTime?: string;
  timeZone?: string;
}

export interface ProcessingCutoffDto {
  /** @format duration */
  startTime?: string;
  /** @format duration */
  cutoffTime?: string;
  productType?: string;
  allowSameDay?: boolean;
  /** @format date-time */
  cutOffDateTime?: string;
}

export interface CompanyProductTypeCutoffTimeDto {
  processingCutoff?: ProcessingCutoffDto;
  /** @format date-time */
  currentFiTime?: string;
  fiTimeZone?: string;
  /** @format date-time */
  closestBusinessDate?: string;
}

export interface AccountSummaryModelDto {
  /** @format int32 */
  id?: number;
  number?: string;
  type?: string;
  name?: string;
  status?: string;
  isNew?: boolean;
  /** @format decimal */
  availableBalance?: number;
  /** @format decimal */
  currentBalance: number;
  /** @format decimal */
  collectedBalance?: number;
  category?: string;
  /** @format decimal */
  accruedInterest?: number;
  /** @format decimal */
  interestRate?: number;
  /** @format decimal */
  interestPaidYtd?: number;
  /** @format decimal */
  interestPaidPreviousYtd?: number;
  transactions?: AccountTransactionDetailModelDto[];
  balanceHistory?: AccountBalanceDetailDto[];
  permissions?: ProductPermissionModelDto[];
  showAccountNickName?: boolean;
  accountDisplayLabel?: string;
}

export interface AccountTransactionDetailModelDto {
  /** @format int32 */
  id: number;
  /**
   * @format date-time
   * @minLength 1
   */
  date: string;
  /** @minLength 1 */
  checkImageNumber: string;
  /** @minLength 1 */
  description: string;
  /** @format decimal */
  debit?: number;
  /** @format decimal */
  credit?: number;
  /** @format decimal */
  balance?: number;
  checkNumber?: string;
  isDebit?: boolean;
  checkNumberSortValue?: string;
  /** @format int64 */
  postingSequence?: number;
  tranCodeType?: string;
  tranCodeDescription?: string;
  /** @format decimal */
  runningBalance?: number;
}

export interface AccountBalanceDetailDto {
  /** @format date-time */
  date?: string;
  /** @format decimal */
  availableBalance?: number;
  /** @format decimal */
  currentBalance?: number;
}

export interface ToAccountPermissionModelDto {
  /** @format int32 */
  fromAccountId?: number;
  toAccount?: CompanyAccountModelDto;
  isAllowed?: boolean;
}

export interface KeyValuePairInt32ICollectionToAccountPermissionModelDto {
  /** @format int32 */
  key?: number;
  value?: ToAccountPermissionModelDto[];
}

export interface CountryModelDto {
  /** @format int32 */
  id?: number;
  countryName?: string;
  countryCode?: string;
  currencyName?: string;
  currencyCode?: string;
  intradaySpot?: boolean;
}

export interface DownloadBaseDto {
  pageId?: string;
  outputType?: OutPutTypeDto;
  includeHeader?: boolean;
  /** @format int32 */
  confirmationId?: number;
  filterModel?: any;
  downloadPdfTypeSelected?: string;
  isPortrait?: boolean;
}

export interface QboSettingsModelDto {
  intuitBankId?: string;
}

export interface QfxSettingsModelDto {
  enabledFlag?: boolean;
}

export interface ElectronicStatementsDownloadModelDto {
  productName?: string;
  reportId?: string;
  reportName?: string;
}

export interface ReportInformationModelDto {
  name?: string;
  id?: string;
  data?: string;
}

export type HealthCheckActionResponseDto = BaseResponseDto & {
  getPackageInformationSuccessful?: boolean;
  packageInformation?: PackageInformationDto;
  getRedisConnectivitySuccessful?: boolean;
  redisConnectivityStatus?: RedisConnectivityStatusCollectionDto;
  redisMultiplexerAbleToConnect?: boolean;
  getDatabaseConnectivitySuccessful?: boolean;
  databaseConnectivityStatus?: DatabaseConnectivityStatusCollectionDto;
  isGetRedisConnectivityActionRegistered?: boolean;
};

export interface PackageInformationDto {
  buildInformation?: BuildInformationDto;
  releaseInformation?: ReleaseInformationDto;
  /** @format date-time */
  createdDateTime?: string;
  machineName?: string;
}

export interface BuildInformationDto {
  commitId?: string;
  repository?: string;
  azdoProject?: string;
  packageVersion?: string;
  buildUrl?: string;
}

export interface ReleaseInformationDto {
  /** @format date-time */
  deploymentDateUtc?: string;
  releaseVersion?: string;
  projectId?: string;
  packageName?: string;
  packageVersion?: string;
}

export type RedisConnectivityStatusCollectionDto = RedisConnectivityStatusDto[];

export interface RedisConnectivityStatusDto {
  redisClusterName?: string;
  ableToConnect?: boolean;
  ipAddress?: string;
  isDefaultCluster?: boolean;
  additionalInformation?: string;
}

export type DatabaseConnectivityStatusCollectionDto = DatabaseConnectivityStatusDto[];

export interface DatabaseConnectivityStatusDto {
  connectionStringName?: string;
  ableToConnect?: boolean;
  additionalInformation?: string;
}

export interface BaseResponseDto {
  baseRequest?: BaseRequestDto;
  responseDetailCollection?: ResponseDetailCollectionDto;
  success?: boolean;
}

export interface BaseRequestDto {
  activityTracking?: ActivityTrackingDto;
  applicationNameType?: ApplicationNameTypeDto;
  authenticationUser?: AuthenticationUserDto;
  clientIpAddress?: string;
  institutionId?: string;
  endUser?: EndUserDto;
  productInformation?: ProductInformationDto;
  requestType?: string;
  authorizationInfo?: AuthorizationInfoDto;
  alias?: string;
  secondaryId?: string;
  institutionUniversalId?: string;
  userUniversalId?: string;
  userUniqueId?: string;
  companyUniqueIdentifier?: string;
  financialInstitutionIdentifier?: string;
}

export interface ActivityTrackingDto {
  activityId?: string;
  parentActivityId?: string;
}

export type AuthenticationUserDto = EndUserDto & object;

export interface EndUserDto {
  alias?: string;
  companyId?: string;
  externalId?: string;
  externalSecondaryId?: string;
  internalId?: string;
  internalSecondaryId?: string;
  userType?: UserTypeDto;
  device?: string;
  browser?: string;
}

export interface ProductInformationDto {
  productName?: string;
  featureName?: string;
  version?: string;
}

export interface AuthorizationInfoDto {
  associatedClaims?: AuthorizeAssociatedClaimCollectionDto;
  entitlements?: AuthorizeEntitlementCollectionDto;
  isSuperUser?: boolean;
  roles?: AuthorizeRoleCollectionDto;
}

export type AuthorizeAssociatedClaimCollectionDto = AuthorizeAssociatedClaimDto[];

export interface AuthorizeAssociatedClaimDto {
  /** @format int32 */
  accountId?: number;
  /** @format int32 */
  roleId?: number;
  /** @format int32 */
  claimId?: number;
}

export type AuthorizeEntitlementCollectionDto = AuthorizeEntitlementDto[];

export interface AuthorizeEntitlementDto {
  name?: string;
  /** @format int32 */
  id?: number;
}

export type AuthorizeRoleCollectionDto = AuthorizeRoleDto[];

export interface AuthorizeRoleDto {
  name?: string;
  /** @format int32 */
  id?: number;
}

export type ResponseDetailCollectionDto = ResponseDetailDto[];

export interface ResponseDetailDto {
  /** @format int32 */
  responseCode?: number;
  responseMessage?: string;
}

export type HolidayCalendarModelDto = ModelBaseDto & {
  /** @minLength 1 */
  name: string;
  /**
   * @format date-time
   * @minLength 1
   */
  date: string;
  isPastDue: boolean;
};

export interface GetInstitutionAboutResponseDto {
  name?: string;
  addressOne?: string;
  addressTwo?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  phone?: string;
  emailAddress?: string;
  errorMessage?: string;
}

export interface EnableMobileUiResponseDto {
  isMobileUiEnabled?: boolean;
}

export interface EnableMobileUiRequestDto {
  fiId?: string;
}

export interface MessageCategoryModelDto {
  /** @format int32 */
  fiMessageCategoryId?: number;
  messageCategory?: string;
  categoryDescription?: string;
}

export interface MessageModelDto {
  /** @format int32 */
  id?: number;
  messageId?: string;
  companyName?: string;
  /** @format int32 */
  companyId?: number;
  fromToUserName?: string;
  /** @format int32 */
  fromUserId?: number;
  /** @format int32 */
  toUserId?: number;
  /** @format int32 */
  categoryId?: number;
  subject?: string;
  body?: string;
  status?: string;
  assignedTo?: string;
  sentDate?: string;
  sentTime?: string;
  /** @format date-time */
  sentDateTime?: string;
  sentMessage?: boolean;
  hasAttachment?: boolean;
  attachmentNames?: string[];
  attachments?: MessageAttachmentModelDto[];
  parentMessage?: MessageModelDto;
  isArchived?: boolean;
  /** @format int32 */
  parentMessageId?: number;
  /** @format int32 */
  assignedToUserId?: number;
  isReply?: boolean;
  isSent?: boolean;
  messageIdSortValue?: string;
}

export interface MessageAttachmentModelDto {
  /** @format int32 */
  id?: number;
  messageAttachmentId?: string;
  name?: string;
  /** @format byte */
  data?: string;
  /** @format guid */
  fileIdentifier?: string;
  /** @format int32 */
  typeId?: number;
}

export interface MessageCenterSearchTermsDto {
  /** @format int32 */
  companyId?: number;
  /** @format int32 */
  statusId?: number;
  /** @format int32 */
  fromUserId?: number;
  /** @format int32 */
  assignedToUserId?: number;
  messageId?: string;
  dateFrom?: string;
  dateTo?: string;
  /** @format int32 */
  messageTypeId?: number;
  /** @format int32 */
  categoryId?: number;
}

export interface UpdateMessageModelDto {
  /** @format int32 */
  messageId?: number;
  /** @format int32 */
  actionTypeId?: number;
  /** @format int32 */
  statusTypeId?: number;
  /** @format int32 */
  assignedUserId?: number;
  updateConversation?: boolean;
}

export interface BasePathResponseDto {
  basePath?: string;
  errorMessage?: string;
}

export interface BasePathRequestDto {
  fiId?: string;
}

export interface NavigationModelDto {
  /** @minLength 1 */
  key: string;
  /** @minLength 1 */
  name: string;
  description?: string;
  path?: string;
  ssoUniqueId?: string;
  subMenus?: NavigationModelDto[];
}

export type NotificationConfigurationModelDto = SecurityBaseDto & {
  /** @minLength 1 */
  email: string;
  isDuplicateEmail?: boolean;
  phoneNumber?: string;
  isFirstTimeLoad?: boolean;
  groups?: NotificationConfigurationGroupModelDto[];
};

export interface NotificationConfigurationGroupModelDto {
  /** @minLength 1 */
  name: string;
  features?: NotificationConfigurationFeatureModelDto[];
}

export type NotificationConfigurationFeatureModelDto = ModelBaseDto & {
  /** @minLength 1 */
  name: string;
  isDesktopRequired: boolean;
  isActive: boolean;
  isChanged: boolean;
  isEmailAllowed: boolean;
  isEmailActive: boolean;
  isEmailRequired: boolean;
  isDesktopAllowed: boolean;
  isDesktopActive: boolean;
  isTextMessageActive: boolean;
  isTextMessageAllowed: boolean;
  isTextMessageRequired: boolean;
  /** @format int32 */
  notificationTypeId: number;
  /** @format int32 */
  sequence: number;
  /** @format int32 */
  sortOrder: number;
  threshold?: ThresholdDto;
};

export interface ThresholdDto {
  /** @format guid */
  id?: string;
  /** @format decimal */
  underAmount?: number;
  /** @format decimal */
  overAmount?: number;
  isDeleted?: boolean;
  accountIds?: GuidKeyCollectionDto;
}

export type SecurityBaseDto = ModelBaseDto & {
  securityMessage?: SecurityMessageModelDto;
};

export type LookupModelDto = SecurityBaseDto & {
  value?: string;
  key?: string;
};

export type NotificationModelDto = ModelBaseDto & {
  isImportant: boolean;
  /** @minLength 1 */
  subject: string;
  functionality?: string;
  detail?: string;
  isRead: boolean;
  /**
   * @format date-time
   * @minLength 1
   */
  createdOn: string;
  showAlert: boolean;
};

export interface NotificationListModelDto {
  /** @format int32 */
  totalUnreadCount?: number;
  topMessages?: NotificationModelDto[];
  webServer?: string;
}

export interface PrintAuditModelDto {
  printId?: string;
  additionalAuditInformation?: string;
}

export type AddItemResponseModelDto = AuthenticatedResponseModelDto & {
  item?: ItemModelDto;
};

export interface ItemModelDto {
  /** @format decimal */
  amount?: number;
  batchReference?: string;
  events?: EventModelDto[];
  iqaStatus?: string;
  itemReference?: string;
  processingStatus?: string;
  processingStatusDescription?: string;
  status?: string;
  statusDescription?: string;
  transactionReferenceNumber?: string;
}

export interface EventModelDto {
  /** @format date-time */
  date?: string;
  description?: string;
}

export type AuthenticatedResponseModelDto = ResultModelDto & {
  securityToken?: string;
};

export interface ResultModelDto {
  resultCode?: string;
  resultMessage?: string;
  /** @format int32 */
  result?: number;
  validationResults?: ValidationResultModelDto[];
}

export interface ValidationResultModelDto {
  code?: string;
  message?: string;
}

export type AddItemRequestModelDto = AuthenticatedRequestModelDto & {
  /** @format decimal */
  amount?: number;
  batchReference?: string;
  customerReference?: string;
  dataFields?: DataFieldModelDto[];
  frontImage?: string;
  geoLocation?: GeoLocationModelDto;
  locationReference?: string;
  rearImage?: string;
};

export interface DataFieldModelDto {
  fieldName?: string;
  /** @format int32 */
  fieldType?: number;
  isRequired?: boolean;
  text?: string;
  validation?: string;
  validationMessage?: string;
  value?: string;
}

export interface GeoLocationModelDto {
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
}

export interface AuthenticatedRequestModelDto {
  securityToken?: string;
}

export interface AuthenticateRequestModelDto {
  deviceTracking?: DeviceTrackingModelDto;
}

export interface DeviceTrackingModelDto {
  appBundleId?: string;
  appVersion?: string;
  deviceModel?: string;
  deviceSystemName?: string;
  deviceSystemVersion?: string;
}

export type UpdateBatchResponseModelDto = AuthenticatedResponseModelDto & {
  batch?: BatchModelDto;
};

export interface BatchModelDto {
  batchNumber?: string;
  batchReference?: string;
  events?: EventModelDto[];
  locationName?: string;
  status?: string;
  statusDescription?: string;
  /** @format decimal */
  totalAmount?: number;
  /** @format int32 */
  totalCount?: number;
}

export type UpdateBatchRequestModelDto = AuthenticatedRequestModelDto & {
  batchReference?: string;
};

export type CreateBatchResponseModelDto = AuthenticatedResponseModelDto & {
  batch?: BatchModelDto;
};

export type CreateBatchRequestModelDto = AuthenticatedRequestModelDto & {
  batchNumber?: string;
  locationReference?: string;
};

export type UpdateItemRequestModelDto = AuthenticatedRequestModelDto & {
  itemReference?: string;
};

export type GetBatchesResponseModelDto = AuthenticatedResponseModelDto & {
  batches?: BatchModelDto[];
};

export type GetCustomersResponseModelDto = AuthenticatedResponseModelDto & {
  customers?: CustomerModelDto[];
};

export interface CustomerModelDto {
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  country?: string;
  customerReference?: string;
  emailAddress?: string;
  firstName?: string;
  lastName?: string;
  postalCode?: string;
  state?: string;
}

export type GetCustomersRequestModelDto = AuthenticatedRequestModelDto & {
  accountNumber?: string;
  customerName?: string;
  customerNumber?: string;
};

export type GetDataFieldsResponseModelDto = AuthenticatedResponseModelDto & {
  dataFields?: DataFieldModelDto[];
};

export type GetDataFieldsRequestModelDto = AuthenticatedRequestModelDto & {
  locationReference?: string;
};

export type GetItemImagesResponseModelDto = AuthenticatedResponseModelDto & {
  images?: ItemImageModelDto;
};

export interface ItemImageModelDto {
  frontImage?: string;
  backImage?: string;
  itemReference?: string;
}

export type GetItemImagesRequestModelDto = AuthenticatedRequestModelDto & {
  itemReference?: string;
};

export type GetItemsResponseModelDto = AuthenticatedResponseModelDto & {
  items?: ItemModelDto[];
};

export type GetItemsRequestModelDto = AuthenticatedRequestModelDto & {
  batchReference?: string;
};

export type GetLocationsResponseModelDto = AuthenticatedResponseModelDto & {
  locations?: LocationModelDto[];
};

export interface LocationModelDto {
  isEnabled?: boolean;
  locationNumber?: string;
  name?: string;
  locationReference?: string;
}

export type GetSettingsResponseModelDto = AuthenticatedResponseModelDto & {
  allowSaveUsername?: boolean;
  enablePasswordChange?: boolean;
  /** @format int32 */
  geoLocationAccess?: number;
  showCustomBatchId?: boolean;
  showDataEntry?: boolean;
};

export interface StatusModelDto {
  isUserConfigured?: boolean;
  /** @format int32 */
  remoteDepositProductType?: number;
}

export interface SecurityVerificationMethodModelDto {
  /** @minLength 1 */
  method: string;
  /** @minLength 1 */
  phoneNumber: string;
  /** @minLength 1 */
  pinNumber: string;
}

export interface UserSecurityConfigModelDto {
  textVerificationMethod?: SecurityVerificationMethodModelDto;
  callVerificationMethod?: SecurityVerificationMethodModelDto;
  preferredMethod?: string;
  usePin?: boolean;
  allowActionBypass?: boolean;
}

export interface RecentLoginsModelDto {
  lastSuccessfulLogin?: string;
  lastSuccessfulLoginIPAddress?: string;
  lastFailedLogin?: string;
  lastFailedLoginIPAddress?: string;
}

export type CompleteSecureTokenConfigResponseDto = BaseResponseAuthenticationServiceDto & {
  isUserEntryError?: boolean;
};

export interface BaseResponseAuthenticationServiceDto {
  baseRequest?: BaseRequestAuthenticationServiceDto;
  responseDetailCollection?: ResponseDetailCollectionAuthenticationServiceDto;
  success?: boolean;
}

export interface BaseRequestAuthenticationServiceDto {
  activityTracking?: ActivityTrackingAuthenticationServiceDto;
  alias?: string;
  applicationNameType?: ApplicationNameTypeAuthenticationServiceDto;
  authenticationUser?: AuthenticationUserAuthenticationServiceDto;
  authorizationInfo?: AuthorizationInfoAuthenticationServiceDto;
  clientIpAddress?: string;
  endUser?: EndUserAuthenticationServiceDto;
  institutionId?: string;
  productInformation?: ProductInformationAuthenticationServiceDto;
  requestType?: string;
  secondaryId?: string;
}

export interface ActivityTrackingAuthenticationServiceDto {
  activityId?: string;
  parentActivityId?: string;
}

export type AuthenticationUserAuthenticationServiceDto = EndUserAuthenticationServiceDto & object;

export interface EndUserAuthenticationServiceDto {
  alias?: string;
  browser?: string;
  companyId?: string;
  device?: string;
  externalId?: string;
  externalSecondaryId?: string;
  internalId?: string;
  internalSecondaryId?: string;
  userType?: UserTypeAuthenticationServiceDto;
}

export interface AuthorizationInfoAuthenticationServiceDto {
  associatedClaims?: AuthorizeAssociatedClaimCollectionAuthenticationServiceDto;
  entitlements?: AuthorizeEntitlementCollectionAuthenticationServiceDto;
  isSuperUser?: boolean;
  roles?: AuthorizeRoleCollectionAuthenticationServiceDto;
}

export type AuthorizeAssociatedClaimCollectionAuthenticationServiceDto =
  AuthorizeAssociatedClaimAuthenticationServiceDto[];

export interface AuthorizeAssociatedClaimAuthenticationServiceDto {
  /** @format int32 */
  accountId?: number;
  /** @format int32 */
  claimId?: number;
  /** @format int32 */
  roleId?: number;
}

export type AuthorizeEntitlementCollectionAuthenticationServiceDto =
  AuthorizeEntitlementAuthenticationServiceDto[];

export interface AuthorizeEntitlementAuthenticationServiceDto {
  /** @format int32 */
  id?: number;
  name?: string;
}

export type AuthorizeRoleCollectionAuthenticationServiceDto =
  AuthorizeRoleAuthenticationServiceDto[];

export interface AuthorizeRoleAuthenticationServiceDto {
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface ProductInformationAuthenticationServiceDto {
  featureName?: string;
  productName?: string;
  version?: string;
}

export type LogoutUserRequestDto = BaseRequestAuthenticationServiceDto & {
  reason?: string;
};

export type GetUserSecureTokenMfaLoginStatusRequestDto = BaseRequestAuthenticationServiceDto &
  object;

export type SecureTokenMfaLoginRequestDto = BaseRequestAuthenticationServiceDto & {
  oneTimePasswordAndPin?: string;
};

export type GetUserSecureTokenMfaCredentialsRequestDto = BaseRequestAuthenticationServiceDto &
  object;

export type RegisterSecureTokenMfaRequestDto = BaseRequestAuthenticationServiceDto & {
  credentialId?: string;
  pin?: string;
  token?: string;
};

export type UnlockSecureTokenRequestDto = BaseRequestAuthenticationServiceDto & {
  recollectTokenCredentials?: boolean;
  /** @format int32 */
  userId?: number;
};

export type ResetSecureTokenRequestDto = BaseRequestAuthenticationServiceDto & {
  /** @format int32 */
  userId?: number;
};

export type RdcSsoLoginRequestDto = BaseRequestAuthenticationServiceDto & object;

export type GetCentrixSsoLoginRequestDto = BaseRequestAuthenticationServiceDto & object;

export type GetUserIdentityRequestDto = BaseRequestAuthenticationServiceDto & object;

export type ElectronicDocumentRequestDto = BaseRequestAuthenticationServiceDto & object;

export type DeviceRequestDto = BaseRequestAuthenticationServiceDto & {
  /** @format guid */
  connectionId?: string;
};

export type LogOffRequestDto = BaseRequestAuthenticationServiceDto & {
  reason?: string;
};

export type GenerateAuthenticationTokenRequestDto = BaseRequestAuthenticationServiceDto & {
  authenticationTokenType?: AuthenticationTokenTypeDto;
  validationToken?: string;
};

export type ValidateOnetimePasscodeRequestDto = BaseRequestAuthenticationServiceDto & {
  /** @format int32 */
  companyId?: number;
  onetimePasscode?: string;
  /** @format int32 */
  userId?: number;
};

export type UpdatePasswordRequestDto = BaseRequestAuthenticationServiceDto & {
  isFiUser?: boolean;
  password?: string;
};

export type ResetPasswordRequestDto = UpdatePasswordRequestDto & {
  isAutoReset?: boolean;
  /** @format int32 */
  userId?: number;
};

export type ChangePasswordRequestDto = BaseRequestAuthenticationServiceDto & {
  isFiUser?: boolean;
  loggingIn?: boolean;
  oldPassword?: string;
  password?: string;
  userAlias?: string;
};

export type HealthCheckActionRequestDto = BaseRequestAuthenticationServiceDto & {
  skipDatabaseConnectivity?: boolean;
  skipPackageInformation?: boolean;
  skipRedisConnectivity?: boolean;
};

export type UserChallengeRequestDto = BaseRequestAuthenticationServiceDto & {
  challengePointId?: ChallengePointEnumDto;
  /** @format int32 */
  companyId?: number;
  isNoThanks?: boolean;
  isReminedMeLater?: boolean;
  oobValidationMode?: string;
  /** @format int32 */
  userId?: number;
  userOobDetail?: UserOobDetailDto;
  validationPinRequired?: boolean;
};

export interface UserOobDetailDto {
  audioPhoneNumber?: string;
  challengePin?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  isLocked?: boolean;
  isOobPinCollected?: boolean;
  /** @format date-time */
  localSuspendEndDate?: string;
  needCollection?: boolean;
  oobAuthCount?: number;
  oobValidationMode?: OobValidationModeDto;
  /** @format int32 */
  preferredOobValidationModeId?: number;
  remindMeCount?: number;
  smsPhoneNumber?: string;
  /** @format date-time */
  suspendEndDate?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
}

export interface OobValidationModeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export type UserDto = BaseEntityDto & {
  accountLookups?: LookupDto[];
  accountProducts?: AccountProductDto[];
  achOffsetAccounts?: AchOffsetAccountDto[];
  alias?: string;
  associatedClaims?: AssociatedClaimDto[];
  backOfficeSsoEnabled?: boolean;
  beneficiaryAudits?: BeneficiaryAuditDto[];
  boReports?: BoReportDto[];
  company?: CompanyDto;
  /** @format int32 */
  companyId?: number;
  contactInfo?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  department?: string;
  email?: string;
  enrolled?: boolean;
  favoriteReports?: FavoriteReportDto[];
  fax?: string;
  hasLoggedIn?: boolean;
  /** @format int32 */
  id?: number;
  importBatchId?: string;
  institution?: InstitutionDto;
  /** @format int32 */
  institutionId?: number;
  isAdmin?: boolean;
  isEditor?: boolean;
  isSuperUser?: boolean;
  locked?: boolean;
  /** @format int32 */
  loginFailureCount?: number;
  mfaLocked?: boolean;
  name?: string;
  notificationEmail?: string;
  notificationPhoneCarrier?: TextMessagingCarrierDto;
  /** @format int32 */
  notificationPhoneCarrierId?: number;
  notificationPhoneNumber?: string;
  notificationRecipientId?: string;
  password?: string;
  /** @format date-time */
  passwordDate?: string;
  pendingEditsOfUser?: PendingEditOfUserDto[];
  pendingState?: PendingEditStatusDto;
  phoneExtension?: string;
  phoneNumber?: string;
  publishState?: string;
  reportingFilterSorts?: ReportingFilterSortDto[];
  reportingFilters?: ReportingFilterDto[];
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  sessions?: SessionDto[];
  showAccountNickName?: boolean;
  showMaskedAccount?: boolean;
  tempPasswordToken?: string;
  /** @format date-time */
  tempPasswordTokenExpirationDate?: string;
  /** @format date-time */
  termsAcceptedDate?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userAccountGroups?: UserAccountGroupDto[];
  userAccounts?: UserAccountDto[];
  userAchCompanies?: UserAchCompanyDto[];
  userAudits?: UserAuditDto[];
  userDevices?: UserDeviceDto[];
  userIpAccessSetting?: UserIpAccessSettingDto;
  userIpAccesses?: UserIpAccessDto[];
  userNotificationTypes?: UserNotificationTypeDto[];
  userNotifications?: UserNotificationDto[];
  userOobDetail?: UserOobDetailDto;
  userPasswordHistories?: UserPasswordHistoryDto[];
  userProductLimits?: UserProductLimitDto[];
  userRoles?: UserRoleDto[];
  userSecureTokenSecurity?: UserSecureTokenSecurityDto;
  userSsoLogins?: UserSsoLoginDto[];
  userTimeAccessSetting?: UserTimeAccessSettingDto;
  userTimeAccesses?: UserTimeAccessDto[];
  userType?: UserType1Dto;
  /** @format int32 */
  userTypeId?: number;
  /** @format guid */
  userUniqueId?: string;
  userWidgets?: UserWidgetDto[];
  wireAudits?: WireAuditDto[];
};

export interface LookupDto {
  key?: string;
  value?: string;
}

export type AccountProductDto = BaseEntityDto & {
  account?: AccountDto;
  /** @format int32 */
  accountId?: number;
  accountProductArp?: AccountProductArpDto;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  product?: ProductDto;
  productAccountPermission?: ProductAccountPermissionDto[];
  /** @format int32 */
  productId?: number;
};

export type AccountDto = BaseEntityDto & {
  accountNumberTypeFormat?: string;
  accountProducts?: AccountProductDto[];
  /** @format guid */
  accountUniqueId?: string;
  achOffsetAccounts?: AchOffsetAccountDto[];
  allowLoanPaymentPastDue?: boolean;
  analysisTransactionCounts?: AnalysisTransactionCountDto[];
  arpExceptions?: ArpExceptionDto[];
  arpReportFiles?: ArpReportFileDto[];
  associatedClaims?: AssociatedClaimDto[];
  /** @format decimal */
  balance?: number;
  cifNumber?: string;
  /** @format decimal */
  collectedBalance?: number;
  company?: CompanyDto;
  /** @format int32 */
  companyId?: number;
  coreAccount?: CoreAccountDto;
  coreStatus?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format decimal */
  currentBalance?: number;
  /** @format decimal */
  dailyLimit?: number;
  /** @format decimal */
  dailyUsedValue?: number;
  description?: string;
  /** @format int32 */
  id?: number;
  internalTransferTransactions?: InternalTransferTransactionDto[];
  internalTransferTransactions1?: InternalTransferTransactionDto[];
  isAccountLinked?: boolean;
  isCompanyAccount?: boolean;
  isSelected?: boolean;
  linkedTMCompanies?: string[];
  /** @format decimal */
  loanPaymentAmountDue?: number;
  /** @format date-time */
  loanPaymentDueDate?: string;
  name?: string;
  nonCoreWireCompanyInternationalAccounts?: NonCoreWireCompanyInternationalAccountDto[];
  number?: string;
  /** @format decimal */
  perTransactionLimit?: number;
  reportingFilterAccounts?: ReportingFilterAccountDto[];
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  showAccountNickName?: boolean;
  stopPayments?: StopPaymentDto[];
  /** @format decimal */
  templateTransferAmount?: number;
  templateTransferMemo?: string;
  type?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userAccountGroupAccounts?: UserAccountGroupAccountDto[];
  userAccounts?: UserAccountDto[];
  users?: UserDto[];
  wires?: WireDto[];
};

export interface AchOffsetAccountDto {
  account?: AccountDto;
  /** @format int32 */
  accountId?: number;
  achCompany?: AchCompanyDto;
  /** @format int32 */
  achCompanyId?: number;
  /** @format int32 */
  id?: number;
  isActive?: boolean;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
}

export type AchCompanyDto = BaseEntityDto & {
  /** @format int32 */
  achBatchBalanceTypeId?: number;
  achBatches?: AchBatchDto[];
  achCompanyId?: string;
  achCompanySecCodes?: AchCompanySecCodeDto[];
  achOffsetAccounts?: AchOffsetAccountDto[];
  achPayments?: AchPaymentDto[];
  allowUnbalancedPayments?: boolean;
  /** @format int32 */
  allowedNotOnUsTransactionTypeId?: number;
  availableBalanceTable?: string;
  balanceValidationType?: string;
  batchBalanceType?: BatchBalanceTypeDto;
  company?: CompanyDto;
  coreSecCode?: string;
  /** @format decimal */
  dailyLimit?: number;
  discretionaryData?: string;
  entryDescription?: string;
  /** @format int32 */
  id?: number;
  isPaymentProcessingCompany?: boolean;
  offsetAccountNumber?: string;
  paymentProcessingCompanyAllowed?: boolean;
  /** @format int32 */
  prefundingDays?: number;
  /** @format decimal */
  requiredOnUsAmountPerBatch?: number;
  /** @format int32 */
  requiredOnUsTransactionCount?: number;
  sameDayAchAllowed?: boolean;
  settlementAccount?: string;
  settlementAccountType?: string;
  transactionType?: TransactionTypeDto;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userAchCompanies?: UserAchCompanyDto[];
};

export type AchBatchDto = BaseEntityDto & {
  achBatchAudits?: AchBatchAuditDto[];
  achBatchRecipients?: AchBatchRecipientDto[];
  achCompany?: AchCompanyDto;
  /** @format int32 */
  achCompanyId?: number;
  /** @format int32 */
  achCompanyMatchType?: number;
  achCompanyName?: string;
  achFederalTaxTemplate?: AchFederalTaxTemplateDto;
  achPaymentType?: AchPaymentTypeDto;
  /** @format int32 */
  achPaymentTypeId?: number;
  achPayments?: AchPaymentDto[];
  achSecCode?: AchSecCodeDto;
  /** @format int32 */
  achSecCodeId?: number;
  achStateTaxTemplate?: AchStateTaxTemplateDto;
  /** @format int32 */
  approvalsRequired?: number;
  approvedBy?: TupleStringDateTimeDto[];
  batchName?: string;
  batchStatusType?: BatchStatusTypeDto;
  /** @format int32 */
  batchStatusTypeId?: number;
  /** @format int32 */
  batchUniqueId?: number;
  companyIdentity?: string;
  /** @format int32 */
  completedApprovals?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format decimal */
  credit?: number;
  /** @format decimal */
  creditAmount?: number;
  /** @format decimal */
  debit?: number;
  /** @format decimal */
  debitAmount?: number;
  descretionaryData?: string;
  eligibleApprovers?: string[];
  entryDescription?: string;
  errorMessage?: string;
  fileArchive?: FileArchiveDto;
  /** @format int32 */
  fileArchiveId?: number;
  /** @format int32 */
  id?: number;
  isEdited?: boolean;
  /** @format int32 */
  numberOfRecipients?: number;
  restricted?: boolean;
  secCode?: string;
  status?: string;
  successMessage?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userPermissions?: string[];
};

export type AchBatchAuditDto = BaseEntityDto & {
  achActionType?: AchActionTypeDto;
  achBatch?: AchBatchDto;
  /** @format int32 */
  achBatchId?: number;
  /** @format int32 */
  actionTypeId?: number;
  comments?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  userName?: string;
};

export type AchActionTypeDto = BaseEntityDto & {
  achBatchAudits?: AchBatchAuditDto[];
  achPaymentAudits?: AchPaymentAuditDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export type AchPaymentAuditDto = BaseEntityDto & {
  achActionType?: AchActionTypeDto;
  /** @format int32 */
  achActionTypeId?: number;
  achPayment?: AchPaymentDto;
  /** @format int32 */
  achPaymentId?: number;
  comments?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  userName?: string;
};

export type AchPaymentDto = BaseEntityDto & {
  account?: AccountDto;
  achBatch?: AchBatchDto;
  /** @format int32 */
  achBatchId?: number;
  achCompany?: AchCompanyDto;
  /** @format int32 */
  achCompanyId?: number;
  achCompanyName?: string;
  achFederalTaxPayment?: AchFederalTaxPaymentDto;
  achNachaFileCopyAudits?: AchNachaFileCopyAuditDto[];
  achPaymentAudits?: AchPaymentAuditDto[];
  /** @format int32 */
  achPaymentDraftId?: number;
  achPaymentRecipients?: AchPaymentRecipientDto[];
  /** @format int32 */
  achPaymentRecipientsCount?: number;
  achPaymentType?: AchPaymentTypeDto;
  /** @format int32 */
  achPaymentTypeId?: number;
  achStateTaxPayment?: AchStateTaxPaymentDto;
  achStatusType?: AchStatusTypeDto;
  achTransactionId?: string;
  /** @format int32 */
  approvalsRequired?: number;
  approvedBy?: TupleStringDateTimeDto[];
  balanceValidationNotRequired?: boolean;
  batchName?: string;
  /** @format int32 */
  batchUniqueId?: number;
  chilAchPayments?: AchPaymentDto[];
  comment?: string;
  companyIdentity?: string;
  /** @format int32 */
  completedApprovals?: number;
  copiedFromTransactionId?: string;
  createdBy?: string;
  createdByUser?: UserDto;
  /** @format date-time */
  createdDate?: string;
  /** @format decimal */
  credit?: number;
  /** @format decimal */
  debit?: number;
  descretionaryData?: string;
  destinationCountryCode?: string;
  destinationCurrency?: string;
  duplicatePreventionId?: string;
  /** @format date-time */
  effectiveDate?: string;
  eligibleApprovers?: string[];
  /** @format date-time */
  endDate?: string;
  entryDescription?: string;
  errorSummary?: ErrorSummaryDto;
  failureReason?: string;
  fileArchive?: FileArchiveDto;
  /** @format int32 */
  fileArchiveId?: number;
  fileName?: string;
  foreignExchangeIndicator?: string;
  foreignExchangeReference?: string;
  /** @format int32 */
  foreignExchangeReferenceIndicator?: number;
  hasAccess?: boolean;
  /** @format int32 */
  id?: number;
  /** @format date-time */
  initiatedDate?: string;
  /** @format int32 */
  offsetAccountId?: number;
  /** @format decimal */
  onUsAmount?: number;
  /** @format int32 */
  onUsCount?: number;
  originatorCurrencyCode?: string;
  parentAchPayment?: AchPaymentDto;
  /** @format int32 */
  parentAchPaymentId?: number;
  paymentFrequencyType?: PaymentFrequencyTypeDto;
  /** @format int32 */
  paymentFrequencyTypeId?: number;
  paymentOnLastBusinessDay?: boolean;
  paymentProcessingBasedOn1Record?: boolean;
  /** @format int32 */
  prefundingDays?: number;
  recipientIdsforReversal?: number[];
  referenceNumber?: string;
  /** @format int32 */
  repeatOnDayOne?: number;
  /** @format int32 */
  repeatOnDayTwo?: number;
  restricted?: boolean;
  /** @format int32 */
  reversalAchPaymentId?: number;
  secCode?: string;
  sentFileArchive?: FileArchiveDto;
  /** @format int32 */
  sentFileArchiveId?: number;
  source?: string;
  /** @format date-time */
  startDate?: string;
  /** @format int32 */
  statusTypeId?: number;
  successMessage?: string;
  updatedBy?: string;
  updatedByUser?: UserDto;
  /** @format date-time */
  updatedDate?: string;
  userPermissions?: string[];
  canReverseFull?: boolean;
  canReverseTransactions?: boolean;
};

export interface AchFederalTaxPaymentDto {
  achFederalTaxPaymentAmounts?: AchFederalTaxPaymentAmountDto[];
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  payFromAccount?: AccountDto;
  /** @format int32 */
  payFromAccountId?: number;
  recipientAccountNumber?: string;
  recipientAccountType?: AccountTypeDto;
  /** @format int32 */
  recipientAccountTypeId?: number;
  recipientIdNumber?: string;
  recipientName?: string;
  recipientRoutingNumber?: string;
  taxCode?: string;
  taxPayerId?: string;
  /** @format date-time */
  taxPeriodEndDate?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface AchFederalTaxPaymentAmountDto {
  achFederalAmountType?: AchFederalAmountTypeDto;
  /** @format int32 */
  achFederalAmountTypeId?: number;
  /** @format int32 */
  achPaymentId?: number;
  /** @format decimal */
  amount?: number;
  amountType?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface AchFederalAmountTypeDto {
  amountType?: string;
  description?: string;
  /** @format int32 */
  id?: number;
}

export interface AccountTypeDto {
  achBatchRecipients?: AchBatchRecipientDto[];
  achPaymentRecipients?: AchPaymentRecipientDto[];
  achTransactionCodes?: AchTransactionCodeDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  reportingType?: string;
}

export type AchBatchRecipientDto = BaseEntityDto & {
  accountNumber?: string;
  accountType?: AccountTypeDto;
  /** @format int32 */
  accountTypeId?: number;
  achBatch?: AchBatchDto;
  /** @format int32 */
  achBatchId?: number;
  achBatchRecipientAddendas?: AchBatchRecipientAddendaDto[];
  addenda?: string;
  /** @format decimal */
  amount?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  hold?: boolean;
  /** @format int32 */
  id?: number;
  preNote?: boolean;
  recipientIdNumber?: string;
  recipientName?: string;
  routingNumber?: string;
  /** @format int32 */
  rowNum?: number;
  transactionType?: TransactionTypeDto;
  /** @format int32 */
  transactionTypeId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type AchBatchRecipientAddendaDto = BaseEntityDto & {
  /** @format int32 */
  achBatchId?: number;
  achBatchRecipient?: AchBatchRecipientDto;
  /** @format int32 */
  achBatchRecipientId?: number;
  addenda?: string;
  addendaType?: AddendaTypeDto;
  /** @format int32 */
  addendaTypeId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  rowNum?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export interface AddendaTypeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface BaseEntityDto {
  objectState?: ObjectStateDto;
}

export type TransactionTypeDto = BaseEntityDto & {
  achBatchRecipients?: AchBatchRecipientDto[];
  achCompanies?: AchCompanyDto[];
  achPaymentRecipients?: AchPaymentRecipientDto[];
  achTransactionCodes?: AchTransactionCodeDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export type AchPaymentRecipientDto = BaseEntityDto & {
  accountNumber?: string;
  accountType?: AccountTypeDto;
  /** @format int32 */
  accountTypeId?: number;
  /** @format int32 */
  achMasterRecipientId?: number;
  achPayment?: AchPaymentDto;
  /** @format int32 */
  achPaymentId?: number;
  achPaymentRecipientAddendas?: AchPaymentRecipientAddendaDto[];
  addenda?: string;
  /** @format decimal */
  amount?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  hold?: boolean;
  /** @format int32 */
  id?: number;
  isRoutingNumberOnUs?: boolean;
  isRoutingNumberValid?: boolean;
  preNote?: boolean;
  recipientIdNumber?: string;
  recipientName?: string;
  routingNumber?: string;
  /** @format int32 */
  rowNum?: number;
  transactionType?: TransactionTypeDto;
  /** @format int32 */
  transactionTypeId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type AchPaymentRecipientAddendaDto = BaseEntityDto & {
  /** @format int32 */
  achPaymentId?: number;
  achPaymentRecipient?: AchPaymentRecipientDto;
  /** @format int32 */
  achPaymentRecipientId?: number;
  addenda?: string;
  addendaType?: AddendaTypeDto;
  /** @format int32 */
  addendaTypeId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  nonCustodialParentFirstName?: string;
  nonCustodialParentLastName?: string;
  /** @format int32 */
  rowNum?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export interface AchTransactionCodeDto {
  accountType?: AccountTypeDto;
  /** @format int32 */
  accountTypeId?: number;
  /** @format int32 */
  id?: number;
  transactionCode?: TransactionCodeDto;
  /** @format int32 */
  transactionCodeId?: number;
  transactionType?: TransactionTypeDto;
  /** @format int32 */
  transactionTypeId?: number;
}

export type TransactionCodeDto = BaseEntityDto & {
  achTransactionCodes?: AchTransactionCodeDto[];
  /** @format int32 */
  baiCode?: number;
  baiCodeType?: BaiCodeTypeDto;
  changeStatus?: string;
  code?: string;
  description?: string;
  excluded?: boolean;
  /** @format int32 */
  id?: number;
  institution?: InstitutionDto;
  /** @format int32 */
  institutionId?: number;
  isDeleted?: boolean;
  isDescriptionChanged?: boolean;
  isTypeChanged?: boolean;
  ofxTransactionType?: OfxTransactionTypeDto;
  /** @format int32 */
  ofxTransactionTypeId?: number;
  transactionCodeGroupAssociations?: TransactionCodeGroupAssociationDto[];
  type?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type BaiCodeTypeDto = BaseEntityDto & {
  /** @format int32 */
  baiCode?: number;
  /** @format int32 */
  baiCodeTitleId?: number;
  description?: string;
  isSelected?: boolean;
  level?: string;
  transactionType?: string;
};

export type InstitutionDto = BaseEntityDto & {
  accountAnalysisExceptions?: AccountAnalysisExceptionDto[];
  achExceptionReturnCode?: string;
  analysisTransactionCodes?: AnalysisTransactionCodeDto[];
  boReports?: BoReportDto[];
  brandName?: string;
  challengeGroups?: ChallengeGroupDto[];
  companies?: CompanyDto[];
  coreReleaseVersion?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  fiId?: string;
  fileArchive?: FileArchiveDto;
  /** @format int32 */
  fileArchiveId?: number;
  /** @format int32 */
  id?: number;
  informationCenterConfigurations?: InformationCenterConfigurationDto[];
  institutionAccountDisplaySetting?: InstitutionAccountDisplaySettingDto;
  institutionAffiliations?: InstitutionAffiliationDto[];
  institutionFraudProviders?: InstitutionFraudProviderDto;
  institutionMessageCenter?: InstitutionMessageCenterDto;
  institutionNachaFileRecord?: InstitutionNachaFileRecordDto;
  institutionName?: string;
  institutionNotificationTypes?: InstitutionNotificationTypeDto[];
  institutionOobConfiguration?: InstitutionOobConfigurationDto;
  institutionProductTypes?: InstitutionProductTypeDto[];
  institutionTerm?: InstitutionTermDto;
  institutionUserApprovalSetting?: InstitutionUserApprovalSettingDto;
  institutionWireInternationalWorkflowOverrides?: InstitutionWireInternationalWorkflowOverridesDto;
  jxEnvironment?: string;
  jxRoutingNumber?: string;
  loginConfigurations?: LoginConfigurationDto[];
  logo?: string;
  logoutURL?: string;
  notificationEmail?: string;
  notificationEnabled?: boolean;
  /** @format duration */
  paymentProcessTime?: string;
  resourceConfigurations?: ResourceConfigurationDto[];
  roles?: RoleDto[];
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  rsaInstId?: string;
  showCutOffTimeZone?: boolean;
  supportDepartmentName?: string;
  supportEmail?: string;
  supportPhone?: string;
  /** @format int32 */
  timeZoneId?: number;
  transactionCodeGroups?: TransactionCodeGroupDto[];
  transactionCodes?: TransactionCodeDto[];
  treasuryProductName?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  users?: UserDto[];
  welcomeEmailText?: string;
};

export interface AccountAnalysisExceptionDto {
  /** @format date-time */
  activityDate?: string;
  analysisTransactionType?: AnalysisTransactionTypeDto;
  /** @format int32 */
  analysisTransactionTypeId?: number;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  exceptionReason?: string;
  /** @format int32 */
  id?: number;
  institution?: InstitutionDto;
  /** @format int32 */
  institutionId?: number;
  transactionCode?: string;
  /** @format int32 */
  transactionCount?: number;
}

export type AnalysisTransactionTypeDto = BaseEntityDto & {
  accountAnalysisExceptions?: AccountAnalysisExceptionDto[];
  allowMultipleAccounts?: boolean;
  analysisTransactionCodes?: AnalysisTransactionCodeDto[];
  analysisTransactionCounts?: AnalysisTransactionCountDto[];
  analysisTransactionTypeCategory?: AnalysisTransactionTypeCategoryDto;
  /** @format int32 */
  analysisTransactionTypeCategoryId?: number;
  /** @format int32 */
  analysisTransactionTypeId?: number;
  description?: string;
  /** @format int32 */
  sortOrder?: number;
  transactionName?: string;
};

export type AnalysisTransactionCodeDto = BaseEntityDto & {
  active?: boolean;
  /** @format int32 */
  analysisTransactionCodeId?: number;
  analysisTransactionType?: AnalysisTransactionTypeDto;
  /** @format int32 */
  analysisTransactionTypeId?: number;
  institution?: InstitutionDto;
  /** @format int32 */
  institutionId?: number;
  transactionCode?: string;
};

export interface AnalysisTransactionCountDto {
  account?: AccountDto;
  accountAnalysisProcessStatusType?: AccountAnalysisProcessStatusTypeDto;
  /** @format int32 */
  accountAnalysisProcessStatusTypeId?: number;
  /** @format int32 */
  accountId?: number;
  /** @format date-time */
  activityDate?: string;
  /** @format int32 */
  analysisTransactionCountId?: number;
  analysisTransactionType?: AnalysisTransactionTypeDto;
  /** @format int32 */
  analysisTransactionTypeId?: number;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  exceptionReason?: string;
  transactionCode?: string;
  /** @format int32 */
  transactionCount?: number;
  /** @format date-time */
  updatedDate?: string;
}

export interface AccountAnalysisProcessStatusTypeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export type AnalysisTransactionTypeCategoryDto = BaseEntityDto & {
  categoryName?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  sortOrder?: number;
};

export type BoReportDto = BaseEntityDto & {
  boFavoriteReports?: BoFavoriteReportDto[];
  boReport1?: BoReportDto[];
  boReport2?: BoReportDto;
  boReportColumns?: BoReportColumnDto[];
  boReportFilters?: BoReportFilterDto[];
  customFilter?: string;
  description?: string;
  /** @format int32 */
  id?: number;
  institution?: InstitutionDto;
  /** @format int32 */
  institutionId?: number;
  isCustomReport?: boolean;
  isFavoriteReport?: boolean;
  /** @format int32 */
  ownerId?: number;
  reportName?: string;
  reportType?: string;
  rowStatusId?: number;
  runDefaultSearch?: boolean;
  sequences?: BoReportUISequenceDto[];
  /** @format int32 */
  standardReportId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
};

export type BoFavoriteReportDto = BaseEntityDto & {
  boReport?: BoReportDto;
  /** @format int32 */
  boReportId?: number;
  /** @format int32 */
  id?: number;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
};

export type BoReportColumnDto = BaseEntityDto & {
  boReport?: BoReportDto;
  /** @format int32 */
  boReportId?: number;
  columnName?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  description?: string;
  detailsAccessible?: boolean;
  displayName?: string;
  /** @format int32 */
  displayOrder?: number;
  displayType?: string;
  /** @format int32 */
  id?: number;
  isSortable?: boolean;
};

export type BoReportFilterDto = BaseEntityDto & {
  applyCascadeFilter?: boolean;
  boReport?: BoReportDto;
  /** @format int32 */
  boReportId?: number;
  filterLabel?: string;
  filterModel?: string;
  filterType?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  order?: number;
  required?: boolean;
  triggerCascadeFilter?: boolean;
};

export type BoReportUISequenceDto = BaseEntityDto & {
  boReport?: BoReportDto;
  /** @format int32 */
  boReportId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  order?: number;
  selector?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
};

export type ChallengeGroupDto = BaseEntityDto & {
  challengeGroupDetails?: ChallengeGroupDetailDto[];
  companyChallengeGroups?: CompanyChallengeGroupDto[];
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  description?: string;
  /** @format int32 */
  id?: number;
  institution?: InstitutionDto;
  /** @format int32 */
  institutionId?: number;
  isDefault?: boolean;
  name?: string;
  rowStatusId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type ChallengeGroupDetailDto = BaseEntityDto & {
  challengeGroup?: ChallengeGroupDto;
  /** @format int32 */
  challengeGroupId?: number;
  challengePoint?: ChallengePointDto;
  /** @format int32 */
  challengePointId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  isActivatedByThreshold?: boolean;
  isActive?: boolean;
  /** @format decimal */
  thresholdAmount?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type ChallengePointDto = BaseEntityDto & {
  challengeGroupDetails?: ChallengeGroupDetailDto[];
  challengeLocation?: string;
  challengePointCategory?: ChallengePointCategoryDto;
  /** @format int32 */
  challengePointCategoryId?: number;
  challengePointFrequencyType?: ChallengePointFrequencyTypeDto;
  /** @format int32 */
  challengePointFrequencyTypeId?: number;
  description?: string;
  hasThreshold?: boolean;
  hoverText?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  userSessionChallengeStatus?: UserSessionChallengeStatusDto[];
};

export type ChallengePointCategoryDto = BaseEntityDto & {
  challengePoints?: ChallengePointDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  /** @format decimal */
  sort?: number;
};

export type ChallengePointFrequencyTypeDto = BaseEntityDto & {
  challengePoints?: ChallengePointDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export interface UserSessionChallengeStatusDto {
  /** @format date-time */
  challengeDate?: string;
  /** @format int32 */
  challengeMethodTypeId?: number;
  challengePoint?: ChallengePointDto;
  /** @format int32 */
  challengePointId?: number;
  /** @format int32 */
  challengeStatusId?: number;
  challengeStatusType?: ChallengeStatusTypeDto;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  oobReceiptId?: number;
  oobValidationMode?: OobValidationModeDto;
  /** @format int32 */
  oobValidationModeId?: number;
  session?: SessionDto;
  /** @format guid */
  sessionId?: string;
}

export type ChallengeStatusTypeDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  userSessionChallengeStatus?: UserSessionChallengeStatusDto[];
};

export interface SessionDto {
  browser?: string;
  /** @format guid */
  clientConnectionId?: string;
  clientIpAddress?: string;
  device?: string;
  /** @format guid */
  id?: string;
  /** @format date-time */
  latestSessionActivityDate?: string;
  /** @format date-time */
  loginDate?: string;
  /** @format date-time */
  logoffDate?: string;
  mfaCompleted?: boolean;
  mfaRequired?: boolean;
  printMailSSoId?: string;
  printMailUrl?: string;
  secureTokenMfaCompleted?: boolean;
  secureTokenMfaRequired?: boolean;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
  userSessionChallengeStatus?: UserSessionChallengeStatusDto[];
}

export type CompanyChallengeGroupDto = BaseEntityDto & {
  challengeGroup?: ChallengeGroupDto;
  /** @format int32 */
  challengeGroupId?: number;
  /** @format int32 */
  challengeMethodTypeId?: number;
  company?: CompanyDto;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  rowStatusId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type CompanyDto = BaseEntityDto & {
  accounts?: AccountDto[];
  achCompany?: AchCompanyDto;
  address?: AddressDto;
  beneficiaries?: BeneficiaryDto[];
  canSelect?: boolean;
  childCompanies?: CompanyDto[];
  cifNumber?: string;
  comments?: string;
  companyAccountDisplaySetting?: CompanyAccountDisplaySettingDto;
  companyChallengeGroup?: CompanyChallengeGroupDto;
  /** @format guid */
  companyGuidUniqueId?: string;
  companyLimits?: CompanyLimitDto[];
  companyType?: CompanyTypeDto;
  /** @format int32 */
  companyTypeId?: number;
  companyUniqueId?: string;
  companyUserApprovalSetting?: CompanyUserApprovalSettingDto;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  customerSince?: string;
  fileImportLayouts?: FileImportLayoutDto[];
  /** @format int32 */
  id?: number;
  institution?: InstitutionDto;
  /** @format int32 */
  institutionId?: number;
  internalTransferTransactions?: InternalTransferTransactionDto[];
  name?: string;
  ofxAuthenticationCode?: string;
  parentCompany?: CompanyDto;
  /** @format int32 */
  parentCompanyId?: number;
  products?: ProductDto[];
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  taxNumber?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userAccounts?: UserAccountDto[];
  users?: UserDto[];
  wires?: WireDto[];
};

export type AddressDto = BaseEntityDto & {
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  buildingFloor?: string;
  buildingName?: string;
  buildingNumber?: string;
  buildingRoom?: string;
  city?: string;
  country?: CountryDto;
  /** @format int32 */
  countryId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  department?: string;
  districtName?: string;
  /** @format int32 */
  id?: number;
  postBox?: string;
  postalCode?: string;
  postalCodeExtension?: string;
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  /** @format int32 */
  rowVersionId?: number;
  state?: string;
  streetName?: string;
  subDepartment?: string;
  townLocationName?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type CountryDto = BaseEntityDto & {
  addresses?: AddressDto[];
  countryCode?: string;
  countryName?: string;
  currencyCode?: string;
  currencyName?: string;
  /** @format int32 */
  id?: number;
  intradaySpot?: boolean;
};

export type RowStatusDto = BaseEntityDto & {
  accounts?: AccountDto[];
  addresses?: AddressDto[];
  beneficiaries?: BeneficiaryDto[];
  beneficiaryAudits?: BeneficiaryAuditDto[];
  companies?: CompanyDto[];
  description?: string;
  domesticBanks?: DomesticBankDto[];
  id?: number;
  informationCenterConfigurations?: InformationCenterConfigurationDto[];
  institutionNotificationTypes?: InstitutionNotificationTypeDto[];
  institutionProductTypes?: InstitutionProductTypeDto[];
  institutions?: InstitutionDto[];
  name?: string;
  products?: ProductDto[];
  resourceConfigurations?: ResourceConfigurationDto[];
  roles?: RoleDto[];
  schedules?: ScheduleDto[];
  userNotificationTypes?: UserNotificationTypeDto[];
  users?: UserDto[];
};

export type BeneficiaryDto = BaseEntityDto & {
  additionalDetails?: string;
  address?: AddressDto;
  /** @format int32 */
  addressId?: number;
  /** @format int32 */
  approvalCount?: number;
  approvedBy?: TupleStringDateTimeDto[];
  beneficiaryAccountNumber?: string;
  beneficiaryAudits?: BeneficiaryAuditDto[];
  beneficiaryName?: string;
  company?: CompanyDto;
  /** @format int32 */
  companyId?: number;
  /** @format int32 */
  completedApprovals?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  domesticBank?: DomesticBankDto;
  /** @format int32 */
  domesticBankId?: number;
  domesticIntermediaryAccountNumber?: string;
  domesticIntermediaryBankAddress?: AddressDto;
  /** @format int32 */
  domesticIntermediaryBankAddressId?: number;
  domesticIntermediaryNotes?: string;
  eligibleApprovers?: string[];
  foreignBankAddress?: AddressDto;
  /** @format int32 */
  foreignBankAddressId?: number;
  foreignBankId?: string;
  foreignBankIdentificationType?: BankIdentificationTypeDto;
  /** @format int32 */
  foreignBankIdentificationTypeId?: number;
  foreignBankName?: string;
  foreignIntermediaryBankAddress?: AddressDto;
  /** @format int32 */
  foreignIntermediaryBankAddressId?: number;
  foreignIntermediaryBankId?: string;
  foreignIntermediaryBankIdentificationType?: BankIdentificationTypeDto;
  /** @format int32 */
  foreignIntermediaryBankIdentificationTypeId?: number;
  foreignIntermediaryBankName?: string;
  foreignIntermediaryNotes?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  institutionId?: number;
  intermediaryDomesticBank?: DomesticBankDto;
  /** @format int32 */
  intermediaryDomesticBankId?: number;
  isEdited?: boolean;
  isForeignCurrency?: boolean;
  isFreeForm?: boolean;
  isInternational?: boolean;
  isIsoCompliant?: boolean;
  isTemplateBeneficiary?: boolean;
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  status?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  useDomesticIntermediary?: boolean;
  useForeignIntermediary?: boolean;
  userDefinedDomesticBankAddress?: AddressDto;
  /** @format int32 */
  userDefinedDomesticBankAddressId?: number;
  userDefinedDomesticBankId?: string;
  userDefinedDomesticBankIdentificationType?: BankIdentificationTypeDto;
  /** @format int32 */
  userDefinedDomesticBankIdentificationTypeId?: number;
  userDefinedDomesticBankName?: string;
  userPermissions?: string[];
  wires?: WireDto[];
};

export interface TupleStringDateTimeDto {
  item1?: string;
  /** @format date-time */
  item2?: string;
}

export type BeneficiaryAuditDto = BaseEntityDto & {
  /** @format date-time */
  actionDate?: string;
  /** @format int32 */
  actionUserId?: number;
  beneficiary?: BeneficiaryDto;
  beneficiaryActionType?: BeneficiaryActionTypeDto;
  /** @format int32 */
  beneficiaryActionTypeId?: number;
  /** @format int32 */
  beneficiaryId?: number;
  comments?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  /** @format int32 */
  rowVersionId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
};

export type BeneficiaryActionTypeDto = BaseEntityDto & {
  beneficiaryAudits?: BeneficiaryAuditDto[];
  /** @format int32 */
  id?: number;
  name?: string;
};

export type DomesticBankDto = BaseEntityDto & {
  addressLine1?: string;
  addressLine2?: string;
  bankName?: string;
  city?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  domesticBankTypeId?: number;
  /** @format int32 */
  id?: number;
  isActive?: boolean;
  onUs?: boolean;
  routingNumber?: string;
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  /** @format int32 */
  rowVersionId?: number;
  settlementType?: string;
  state?: StateDto;
  stateCode?: string;
  /** @format int32 */
  stateId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  zipCode?: string;
};

export type StateDto = BaseEntityDto & {
  /** @format int32 */
  id?: number;
  stateCode?: string;
  stateName?: string;
};

export type BankIdentificationTypeDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export type WireDto = BaseWireDto & {
  approvedBy?: TupleStringDateTimeDto[];
  /** @format int32 */
  completedApprovals?: number;
  createdByUser?: UserDto;
  /** @format decimal */
  destinationCurrencyAmount?: number;
  duplicatePreventionId?: string;
  eligibleApprovers?: string[];
  errorSummary?: ErrorSummaryDto;
  /** @format decimal */
  exchangeFee?: number;
  fileName?: string;
  source?: string;
  /** @format decimal */
  totalCost?: number;
  updatedByUser?: UserDto;
  userPermissions?: string[];
  wireActionTypeEnum?: WireActionTypeEnumDto;
  wireAudits?: WireAuditDto[];
  wireFileUniqueId?: string;
  wireQuotes?: WireQuoteDto[];
};

export interface ErrorSummaryDto {
  details?: ErrorDetailDto[];
  summaryMessage?: string;
  summaryMessageList?: string[];
  type?: ErrorTypeDto;
}

export interface ErrorDetailDto {
  attributeName?: string;
  key?: string;
  message?: string;
  messageList?: LookupDto[];
  type?: ErrorTypeDto;
}

export type WireAuditDto = BaseEntityDto & {
  /** @format date-time */
  actionDate?: string;
  /** @format int32 */
  actionUserId?: number;
  comments?: string;
  /** @format int32 */
  id?: number;
  user?: UserDto;
  wire?: WireDto;
  wireActionType?: WireActionTypeDto;
  /** @format int32 */
  wireActionTypeId?: number;
  /** @format int32 */
  wireId?: number;
};

export type WireActionTypeDto = BaseEntityDto & {
  /** @format int32 */
  id?: number;
  wireActionType1?: string;
  wireAudits?: WireAuditDto[];
};

export type WireQuoteDto = BaseEntityDto & {
  amexContractNumber?: string;
  /** @format int32 */
  amexQuoteId?: number;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  createdUser?: UserDto;
  /** @format int32 */
  debitAccountId?: number;
  /** @format decimal */
  destinationCurrencyAmount?: number;
  destinationCurrencyCode?: string;
  /** @format decimal */
  exchangeFee?: number;
  /** @format decimal */
  exchangeRate?: number;
  /** @format date-time */
  expirationDate?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  institutionFxWireRatesheetId?: number;
  /** @format date-time */
  quoteDate?: string;
  /** @format int32 */
  quoteStatusTypeId?: number;
  rateId?: string;
  /** @format decimal */
  totalWireCost?: number;
  /** @format decimal */
  usdAmount?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  updatedUser?: UserDto;
  wire?: WireDto;
  /** @format decimal */
  wireFee?: number;
  wireFeeCurCode?: string;
  /** @format int32 */
  wireId?: number;
  wireQuoteStatusType?: WireQuoteStatusTypeDto;
};

export type WireQuoteStatusTypeDto = BaseEntityDto & {
  /** @format int32 */
  id?: number;
  name?: string;
  wireQuotes?: WireQuoteDto[];
};

export type BaseWireDto = BaseEntityDto & {
  account?: AccountDto;
  additionalInformation?: string;
  /** @format decimal */
  amount?: number;
  /** @format int32 */
  approvalCount?: number;
  associatedWire?: WireDto;
  /** @format int32 */
  associatedWireId?: number;
  beneficiary?: BeneficiaryDto;
  beneficiaryDetails?: string;
  /** @format int32 */
  beneficiaryId?: number;
  company?: CompanyDto;
  /** @format int32 */
  companyId?: number;
  confirmationNumber?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  debitAccountId?: number;
  destinationCurrencyCode?: string;
  /** @format date-time */
  endDate?: string;
  externallyProcessed?: boolean;
  failureReason?: string;
  /** @format int32 */
  firstRepeatOnDay?: number;
  /** @format int32 */
  frequencyTypeId?: number;
  /** @format int32 */
  id?: number;
  isDliWire?: boolean;
  isDomestic?: boolean;
  parentCompany?: CompanyDto;
  paymentFrequencyType?: PaymentFrequencyTypeDto;
  paymentId?: string;
  purpose?: string;
  referenceBeneficiary?: string;
  referenceNumber?: string;
  repeatOnLastBusinessDay?: boolean;
  /** @format int32 */
  secondRepeatOnDay?: number;
  /** @format date-time */
  startDate?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  /** @format date-time */
  valueDate?: string;
  /** @format int32 */
  wireCompanyId?: number;
  wireFile?: WireFileDto;
  /** @format int32 */
  wireFileId?: number;
  wireStatusType?: WireStatusTypeDto;
  /** @format int32 */
  wireStatusTypeId?: number;
  wireTemplate?: WireTemplateDto;
  /** @format int32 */
  wireTemplateId?: number;
};

export type PaymentFrequencyTypeDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  schedules?: ScheduleDto[];
  wires?: WireDto[];
};

export type ScheduleDto = BaseEntityDto & {
  canSpawnMultipleJobs?: boolean;
  /** @format int32 */
  companyId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  endDate?: string;
  /** @format int32 */
  firstRepeatOn?: number;
  /** @format int32 */
  frequencyId?: number;
  /** @format int32 */
  id?: number;
  importBatchId?: string;
  institutionFiId?: string;
  /** @format int32 */
  interval?: number;
  isWeekendIncluded?: boolean;
  /** @format date-time */
  lastScheduled?: string;
  pauseSchedule?: boolean;
  paymentFrequencyType?: PaymentFrequencyTypeDto;
  productType?: string;
  recycleJob?: boolean;
  repeatOnLastBusinessDay?: boolean;
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  /** @format int32 */
  runningTime?: number;
  scheduleName?: string;
  scheduleSystem?: ScheduleSystemDto;
  /** @format int32 */
  scheduleSystemId?: number;
  scheduledJobs?: ScheduledJobDto[];
  /** @format int32 */
  secondRepeatOn?: number;
  /** @format date-time */
  startDateTime?: string;
  /** @format int32 */
  systemUniqueId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  /** @format int32 */
  userId?: number;
  /** @format date-time */
  valueDateTime?: string;
};

export type ScheduleSystemDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  schedules?: ScheduleDto[];
};

export type ScheduledJobDto = BaseEntityDto & {
  /** @format guid */
  activityId?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  executionDateTime?: string;
  /** @format date-time */
  frequencyTargetDate?: string;
  /** @format int64 */
  id?: number;
  jobStatusType?: JobStatusTypeDto;
  /** @format byte */
  jobStatusTypeId?: number;
  responseMessages?: string;
  schedule?: ScheduleDto;
  /** @format int32 */
  scheduleId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type JobStatusTypeDto = BaseEntityDto & {
  description?: string;
  /** @format byte */
  id?: number;
  name?: string;
  scheduledJobs?: ScheduledJobDto[];
};

export interface WireFileDto {
  /** @format decimal */
  amount?: number;
  /** @format int32 */
  approvedCount?: number;
  /** @format int32 */
  batchCount?: number;
  /** @format int32 */
  companyId?: number;
  deletedBy?: string;
  /** @format date-time */
  deletedDate?: string;
  /** @format guid */
  duplicateWireFileUniqueId?: string;
  /** @format int32 */
  expiredCount?: number;
  fileArchive?: FileArchiveDto;
  /** @format int32 */
  fileArchiveId?: number;
  /** @format int32 */
  fileSize?: number;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  institutionId?: number;
  isDeleted?: boolean;
  isDuplicated?: boolean;
  isExpired?: boolean;
  /** @format int32 */
  pendingCount?: number;
  processedBy?: string;
  /** @format date-time */
  processedDate?: string;
  /** @format int32 */
  rejectedCount?: number;
  status?: string;
  /** @format int32 */
  totalWireCount?: number;
  /** @format guid */
  wireFileUniqueId?: string;
  wires?: WireDto[];
}

export type FileArchiveDto = BaseEntityDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format byte */
  fileContent?: string;
  /** @format int32 */
  fileFormatTypeId?: number;
  fileName?: string;
  /** @format int32 */
  fileTypeId?: number;
  fileValidationFailures?: FileValidationFailureDto[];
  /** @format int32 */
  id?: number;
  isValid?: boolean;
  /** @format guid */
  uniqueId?: string;
};

export interface FileValidationFailureDto {
  fileArchive?: FileArchiveDto;
  /** @format int32 */
  fileArchiveId?: number;
  fileValidationFailureType?: FileValidationFailureTypeDto;
  /** @format int32 */
  fileValidationFailureTypeId?: number;
  /** @format int32 */
  id?: number;
  validationFailureJson?: string;
}

export interface FileValidationFailureTypeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export type WireStatusTypeDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  wires?: WireDto[];
};

export type WireTemplateDto = BaseEntityDto & {
  /** @format int32 */
  approvalCount?: number;
  approvedBy?: TupleStringDateTimeDto[];
  beneficiary?: BeneficiaryDto;
  /** @format int32 */
  beneficiaryId?: number;
  /** @format int32 */
  completedApprovals?: number;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  debitAccount?: AccountDto;
  /** @format int32 */
  debitAccountId?: number;
  eligibleApprovers?: string[];
  errorSummary?: ErrorSummaryDto;
  /** @format int32 */
  id?: number;
  initiatedRecurringWire?: boolean;
  isInternational?: boolean;
  notes?: string;
  purpose?: string;
  referenceBeneficiary?: string;
  templateName?: string;
  templateStatusType?: WireTemplateStatusTypeDto;
  /** @format int32 */
  templateStatusTypeId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  updatedUser?: UserDto;
  userPermissions?: string[];
  wireCompany?: CompanyDto;
  /** @format int32 */
  wireCompanyId?: number;
  wireTemplateAudits?: WireTemplateAuditDto[];
};

export type WireTemplateStatusTypeDto = BaseEntityDto & {
  /** @format int32 */
  id?: number;
  name?: string;
  wireTemplates?: WireTemplateDto[];
};

export type WireTemplateAuditDto = BaseEntityDto & {
  /** @format date-time */
  actionDate?: string;
  actionUser?: UserDto;
  /** @format int32 */
  actionUserId?: number;
  /** @format int32 */
  id?: number;
  wireTemplateActionType?: WireTemplateActionTypeDto;
  /** @format int32 */
  wireTemplateActionTypeId?: number;
  /** @format int32 */
  wireTemplateId?: number;
};

export type WireTemplateActionTypeDto = BaseEntityDto & {
  /** @format int32 */
  id?: number;
  name?: string;
  wireTemplateAudits?: WireTemplateAuditDto[];
};

export type InformationCenterConfigurationDto = BaseEntityDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  description?: string;
  /** @format date-time */
  endDate?: string;
  /** @format int32 */
  id?: number;
  informationCenterMessageType?: InformationCenterMessageTypeDto;
  /** @format int32 */
  informationCenterMessageTypeId?: number;
  institution?: InstitutionDto;
  /** @format int32 */
  institutionId?: number;
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  /** @format int32 */
  sequence?: number;
  /** @format date-time */
  startDate?: string;
  title?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type InformationCenterMessageTypeDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  informationCenterConfigurations?: InformationCenterConfigurationDto[];
  name?: string;
};

export type InstitutionNotificationTypeDto = BaseEntityDto & {
  desktopNotification?: boolean;
  email?: boolean;
  /** @format int32 */
  id?: number;
  institution?: InstitutionDto;
  /** @format int32 */
  institutionId?: number;
  isNotificationEnabled?: boolean;
  isRequired?: boolean;
  notificationGroup?: string;
  notificationType?: NotificationTypeDto;
  /** @format int32 */
  notificationTypeId?: number;
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  /** @format int32 */
  sortOrder?: number;
  textMessage?: boolean;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type NotificationTypeDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  institutionNotificationTypes?: InstitutionNotificationTypeDto[];
  isActiveByDefault?: boolean;
  name?: string;
  notificationPriorityType?: NotificationPriorityTypeDto;
  /** @format int32 */
  notificationPriorityTypeId?: number;
  notificationProductType?: NotificationProductTypeDto;
  /** @format int32 */
  notificationProductTypeId?: number;
  notifications?: NotificationDto[];
  /** @format int32 */
  sortOrder?: number;
  userNotificationTypes?: UserNotificationTypeDto[];
};

export interface NotificationPriorityTypeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  notificationTypes?: NotificationTypeDto[];
}

export type NotificationProductTypeDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  notificationTypes?: NotificationTypeDto[];
};

export interface NotificationDto {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  createdDateFiLocalTime?: string;
  /** @format int32 */
  id?: number;
  notificationPayload?: string;
  notificationType?: NotificationTypeDto;
  /** @format int32 */
  notificationTypeId?: number;
  /** @format guid */
  notificationUniqueIdentifier?: string;
  showAlert?: boolean;
  /** @format int32 */
  userNotificationId?: number;
}

export type UserNotificationTypeDto = BaseEntityDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  desktopNotification?: boolean;
  email?: boolean;
  /** @format int32 */
  id?: number;
  isDesktopAllowed?: boolean;
  isDesktopRequired?: boolean;
  isEmailAllowed?: boolean;
  isEmailRequired?: boolean;
  isTextAllowed?: boolean;
  isTextRequired?: boolean;
  notificationGroup?: string;
  notificationType?: NotificationTypeDto;
  /** @format int32 */
  notificationTypeId?: number;
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  /** @format int32 */
  sortOrder?: number;
  textMessage?: boolean;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
};

export type InstitutionProductTypeDto = BaseEntityDto & {
  /** @format int32 */
  id?: number;
  institution?: InstitutionDto;
  institutionAchProduct?: InstitutionAchProductDto;
  institutionArpProduct?: InstitutionArpProductDto;
  institutionBillPayProduct?: InstitutionBillPayProductDto;
  institutionElectronicDocuments?: InstitutionElectronicDocumentsDto;
  /** @format int32 */
  institutionId?: number;
  institutionInternalTransferProduct?: InstitutionInternalTransferProductDto;
  institutionProductCutoffTimes?: InstitutionProductCutoffTimeDto[];
  institutionReportingConfigurations?: InstitutionReportingConfigurationDto[];
  institutionReportingProduct?: InstitutionReportingProductDto;
  institutionSsoProducts?: InstitutionSsoProductDto[];
  institutionStopPayment?: InstitutionStopPaymentDto;
  institutionWireInternationalProduct?: InstitutionWireInternationalProductDto;
  institutionWireProduct?: InstitutionWireProductDto;
  internationalUsdReadOnly?: boolean;
  isCompanyProductConfigurable?: boolean;
  productType?: ProductTypeDto;
  /** @format int32 */
  productTypeId?: number;
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export interface InstitutionAchProductDto {
  accountBalanceValidationConfiguredInCore?: boolean;
  achCompanyMatchType?: AchCompanyMatchTypeDto;
  /** @format int32 */
  achCompanyMatchTypeId?: number;
  allowChildSupportPayments?: boolean;
  allowFederalTaxPayments?: boolean;
  allowInternationalPayments?: boolean;
  allowNotificationOfChange?: boolean;
  allowOnUsAccessManagement?: boolean;
  allowReturnReview?: boolean;
  allowSameDayAch?: boolean;
  allowStateTaxPayments?: boolean;
  allowTaxPayments?: boolean;
  allowUnbalancedPayments?: boolean;
  /** @format int32 */
  batchApprovalCount?: number;
  batchAuthenticationType?: AuthenticationTypeDto;
  /** @format int32 */
  batchAuthenticationTypeId?: number;
  copyInitiatedNachaFiles?: boolean;
  /** @format int32 */
  daysInAdvance?: number;
  /** @format int32 */
  id?: number;
  institutionAchRoutings?: InstitutionAchRoutingDto[];
  institutionAchSecCodes?: InstitutionAchSecCodeDto[];
  institutionProductType?: InstitutionProductTypeDto;
  internationalEnabled?: boolean;
  /** @format int32 */
  internationalTemplateApprovalCount?: number;
  nachaFileUploadPath?: string;
  /** @format int32 */
  paymentApprovalCount?: number;
  paymentAuthenticationType?: AuthenticationTypeDto;
  /** @format int32 */
  paymentAuthenticationTypeId?: number;
  paymentProcessingCompanyConfiguredInCore?: boolean;
  /** @format int32 */
  recipientApprovalCount?: number;
  remoteServerHost?: string;
  remoteServerPassword?: string;
  /** @format int32 */
  remoteServerPort?: number;
  remoteServerUserName?: string;
  /** @format decimal */
  sameDayAchLimit?: number;
  stateTaxCodesArchiveFile?: FileArchiveDto;
  /** @format int32 */
  stateTaxCodesArchiveFileId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  validateAccountBalance?: boolean;
}

export type AchCompanyMatchTypeDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  institutionAchProducts?: InstitutionAchProductDto[];
  name?: string;
};

export type AuthenticationTypeDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export type InstitutionAchRoutingDto = BaseEntityDto & {
  bankName?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  endDate?: string;
  /** @format int32 */
  id?: number;
  institutionAchProduct?: InstitutionAchProductDto;
  /** @format int32 */
  institutionProductTypeId?: number;
  routingNumber?: string;
  /** @format date-time */
  startDate?: string;
};

export type InstitutionAchSecCodeDto = BaseEntityDto & {
  achSecCode?: AchSecCodeDto;
  /** @format int32 */
  achSecCodeId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  institutionAchProduct?: InstitutionAchProductDto;
  /** @format int32 */
  institutionProductTypeId?: number;
};

export interface AchSecCodeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  secCode?: string;
}

export interface InstitutionArpProductDto {
  allowIssuedItemActivityReview?: boolean;
  allowSubstituteProduct?: boolean;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeDto;
  manageAchExceptions?: boolean;
  showAchExceptions?: boolean;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  workAchException?: boolean;
  workCheckException?: boolean;
}

export interface InstitutionBillPayProductDto {
  allowIPayBusinessBillPayForMobile?: boolean;
  billPayServiceName?: string;
  billPayServiceUrl?: string;
  clientId?: string;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeDto;
  landingPageUrl?: string;
  /** @format int32 */
  navigationMode?: number;
  sharedKey?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
}

export interface InstitutionElectronicDocumentsDto {
  clientId?: string;
  electronicDocumentServiceName?: string;
  electronicDocumentServiceUri?: string;
  electronicDocumentType?: ElectronicDocumentTypeDto;
  /** @format int32 */
  electronicDocumentTypeId?: number;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeDto;
  /** @format double */
  monthlyFee?: number;
  /** @format int32 */
  navigationMode?: number;
  sharedKey?: string;
  showSsoFields?: boolean;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface ElectronicDocumentTypeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  institutionElectronicDocuments?: InstitutionElectronicDocumentsDto[];
  name?: string;
}

export type InstitutionInternalTransferProductDto = BaseEntityDto & {
  allowLoanPaymentPastDue?: boolean;
  /** @format int32 */
  id?: number;
  institutionInternalTransferProductLinkAccounts?: InstitutionInternalTransferProductLinkAccountDto[];
  institutionProductType?: InstitutionProductTypeDto;
};

export type InstitutionInternalTransferProductLinkAccountDto = BaseEntityDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  fromAccountTypeId?: number;
  /** @format int32 */
  id?: number;
  institutionInternalTransferProduct?: InstitutionInternalTransferProductDto;
  /** @format int32 */
  institutionProductTypeId?: number;
  /** @format int32 */
  toAccountTypeId?: number;
};

export type InstitutionProductCutoffTimeDto = BaseEntityDto & {
  /** @format duration */
  blackoutPeriodEndTime?: string;
  /** @format duration */
  blackoutPeriodStartTime?: string;
  cutoffTimeSubType?: CutoffTimeSubTypeDto;
  /** @format int32 */
  cutoffTimeSubTypeId?: number;
  /** @format duration */
  endCutoffTime?: string;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeDto;
  /** @format int32 */
  institutionProductTypeId?: number;
  processingDayType?: ProcessingDayTypeDto;
  /** @format int32 */
  processingDayTypeId?: number;
  showInChannel?: boolean;
  /** @format duration */
  startCutoffTime?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type CutoffTimeSubTypeDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export type ProcessingDayTypeDto = BaseEntityDto & {
  /** @format int32 */
  id?: number;
  institutionProductCutoffTimes?: InstitutionProductCutoffTimeDto[];
  processingDay?: string;
};

export type InstitutionReportingConfigurationDto = BaseEntityDto & {
  hasBai?: boolean;
  hasCsv?: boolean;
  hasDownload?: boolean;
  hasEmail?: boolean;
  hasPdf?: boolean;
  hasQuickBooks?: boolean;
  hasQuicken?: boolean;
  hasTiff?: boolean;
  hasWord?: boolean;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeDto;
  /** @format int32 */
  institutionProductTypeId?: number;
  /** @format int32 */
  standardReportId?: number;
  supportsBai?: boolean;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type InstitutionReportingProductDto = BaseEntityDto & {
  channelMobile?: boolean;
  channelTablet?: boolean;
  channelWeb?: boolean;
  exportFormats?: ReportExportFormatDto[];
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeDto;
};

export interface ReportExportFormatDto {
  isConfigured?: boolean;
  name?: string;
}

export type InstitutionSsoProductDto = BaseEntityDto & {
  clientId?: string;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeDto;
  /** @format int32 */
  institutionProductTypeId?: number;
  landingPageUrl?: string;
  rowStatusId?: number;
  serviceUrl?: string;
  sharedEncryptionInitializationVector?: string;
  sharedEncryptionKey?: string;
  ssoLoginSystem?: SsoLoginSystemDto;
  /** @format int32 */
  ssoLoginSystemId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
};

export type SsoLoginSystemDto = BaseEntityDto & {
  description?: string;
  institutionSsoProducts?: InstitutionSsoProductDto[];
  name?: string;
  /** @format int32 */
  ssoLoginSystemId?: number;
  userSsoLogins?: UserSsoLoginDto[];
};

export type UserSsoLoginDto = BaseEntityDto & {
  /** @format int32 */
  rowStatusId?: number;
  ssoAccessKey?: string;
  ssoLoginId?: string;
  ssoLoginSystem?: SsoLoginSystemDto;
  /** @format int32 */
  ssoLoginSystemId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
  /** @format int32 */
  userSsoLoginId?: number;
};

export interface InstitutionStopPaymentDto {
  approvalCount?: number;
  /** @format double */
  feePerRequest?: number;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeDto;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export type InstitutionWireInternationalProductDto = BaseEntityDto & {
  /** @format int32 */
  beneficiaryApprovalCount?: number;
  /** @format decimal */
  dailyLimit?: number;
  fxClientId?: string;
  fxPaymentNotificationEmailAddresses?: TextKeyCollectionAuthenticationServiceDto;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeDto;
  institutionWirePaymentApprovalSettings?: InstitutionWirePaymentApprovalSettingDto[];
  internationalUsdReadOnly?: boolean;
  /** @format byte */
  outgoingSettlementTypeId?: number;
  /** @format int32 */
  paymentApprovalCount?: number;
  /** @format byte */
  paymentApprovalType?: number;
  requirePaymentPurpose?: boolean;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  updatedUser?: UserDto;
  validateAccountBalance?: boolean;
  wireSettlementAccount?: string;
  wireTraditionalInternationalEnabled?: boolean;
  wireUsdEnabled?: boolean;
};

export type TextKeyCollectionAuthenticationServiceDto = string[];

export interface InstitutionWirePaymentApprovalSettingDto {
  /** @format byte */
  approvalCount?: number;
  /** @format decimal */
  endAmount?: number;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeDto;
  /** @format int32 */
  institutionProductTypeId?: number;
  /** @format decimal */
  startAmount?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
}

export type InstitutionWireProductDto = BaseEntityDto & {
  allowWireFileUpload?: boolean;
  /** @format int32 */
  beneficiaryApprovalCount?: number;
  beneficiaryAuthenticationType?: AuthenticationTypeDto;
  /** @format int32 */
  beneficiaryAuthenticationTypeId?: number;
  /** @format decimal */
  dailyLimit?: number;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeDto;
  institutionWirePaymentApprovalSettings?: InstitutionWirePaymentApprovalSettingDto[];
  internationalEnabled?: boolean;
  limitFutureDateEnabled?: boolean;
  /** @format int32 */
  maximumFutureDays?: number;
  /** @format int32 */
  paymentApprovalCount?: number;
  /** @format byte */
  paymentApprovalType?: number;
  paymentAuthenticationType?: AuthenticationTypeDto;
  /** @format int32 */
  paymentAuthenticationTypeId?: number;
  requirePaymentPurpose?: boolean;
  /** @format byte */
  templateApprovalCount?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  updatedUser?: UserDto;
  wireDliInternationalEnabled?: boolean;
};

export type ProductTypeDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  institutionProductTypes?: InstitutionProductTypeDto[];
  name?: string;
  productClaims?: ProductClaimDto[];
  products?: ProductDto[];
};

export type ProductClaimDto = BaseEntityDto & {
  claim?: ClaimDto;
  /** @format int32 */
  claimId?: number;
  /** @format int32 */
  id?: number;
  productType?: ProductTypeDto;
  /** @format int32 */
  productTypeId?: number;
};

export type ClaimDto = BaseEntityDto & {
  active?: boolean;
  associatedClaims?: AssociatedClaimDto[];
  claimNavigations?: ClaimNavigationDto[];
  claimPrerequisites?: ClaimPrerequisiteDto[];
  claimType?: string;
  dependentClaims?: ClaimPrerequisiteDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  productClaims?: ProductClaimDto[];
  uiPermission?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userType?: UserType1Dto;
  /** @format int32 */
  userTypeId?: number;
};

export type AssociatedClaimDto = BaseEntityDto & {
  account?: AccountDto;
  /** @format int32 */
  accountId?: number;
  claim?: ClaimDto;
  /** @format int32 */
  claimId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  endDate?: string;
  /** @format int32 */
  id?: number;
  role?: RoleDto;
  /** @format int32 */
  roleId?: number;
  /** @format date-time */
  startDate?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
};

export type RoleDto = BaseEntityDto & {
  associatedClaims?: AssociatedClaimDto[];
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  description?: string;
  /** @format int32 */
  id?: number;
  institution?: InstitutionDto;
  /** @format int32 */
  institutionId?: number;
  name?: string;
  roleType?: RoleTypeDto;
  /** @format int32 */
  roleTypeId?: number;
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userRoles?: UserRoleDto[];
};

export type RoleTypeDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  roles?: RoleDto[];
};

export type UserRoleDto = BaseEntityDto & {
  /** @format date-time */
  endDate?: string;
  /** @format int32 */
  id?: number;
  role?: RoleDto;
  /** @format int32 */
  roleId?: number;
  /** @format date-time */
  startDate?: string;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
};

export interface ClaimNavigationDto {
  /** @format int32 */
  _x003C_ClaimId_x003E_k_BackingField: number;
  /** @format int32 */
  _x003C_ClaimNavigationId_x003E_k_BackingField: number;
  _x003C_Claim_x003E_k_BackingField: ClaimDto;
  /** @format int32 */
  _x003C_NavigationId_x003E_k_BackingField: number;
  _x003C_Navigation_x003E_k_BackingField: NavigationDto;
}

export interface NavigationDto {
  applicationType?: ApplicationTypeDto;
  /** @format int32 */
  applicationTypeId?: number;
  childNavigations?: NavigationDto[];
  key?: string;
  name?: string;
  /** @format int32 */
  navigationId?: number;
  path?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export type ApplicationTypeDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  navigations?: NavigationDto[];
};

export interface ClaimPrerequisiteDto {
  claim?: ClaimDto;
  /** @format int32 */
  claimId?: number;
  /** @format int32 */
  id?: number;
  prerequisite?: ClaimDto;
  /** @format int32 */
  prerequisiteId?: number;
}

export type UserType1Dto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  users?: UserDto[];
};

export type ProductDto = BaseEntityDto & {
  accountProducts?: AccountProductDto[];
  achProduct?: AchProductDto;
  arpProduct?: ArpProductDto;
  billPayProduct?: BillPayProductDto;
  company?: CompanyDto;
  /** @format int32 */
  companyId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  electronicDocumentsProduct?: ElectronicDocumentsProductDto;
  /** @format int32 */
  id?: number;
  internalTransferProduct?: InternalTransferProductDto;
  isConfigurable?: boolean;
  productPermissions?: ProductPermissionDto[];
  productType?: ProductTypeDto;
  /** @format int32 */
  productTypeId?: number;
  /** @format guid */
  productUniqueId?: string;
  remoteDepositProduct?: RemoteDepositProductDto;
  reportingConfigurations?: ReportingConfigurationDto[];
  reportingProduct?: ReportingProductDto;
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  stopPaymentProduct?: StopPaymentProductDto;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userProductLimits?: UserProductLimitDto[];
  wireInternationalProduct?: WireInternationalProductDto;
  wireProduct?: WireProductDto;
};

export interface AchProductDto {
  accountBalanceValidationConfiguredInCore?: boolean;
  /** @format int32 */
  achCompanyMatchTypeId?: number;
  allowChildSupportPayments?: boolean;
  allowFederalTaxPayments?: boolean;
  allowInternationalPayments?: boolean;
  allowNotificationOfChange?: boolean;
  allowOnUsAccessManagement?: boolean;
  allowReturnReview?: boolean;
  allowSameDayAch?: boolean;
  allowStateTaxPayments?: boolean;
  allowTaxPayments?: boolean;
  allowUnbalancedPayments?: boolean;
  /** @format int32 */
  batchApprovalCount?: number;
  batchAuthenticationType?: AuthenticationTypeDto;
  /** @format int32 */
  batchAuthenticationTypeId?: number;
  /** @format decimal */
  dailyLimit?: number;
  disableSameDay?: boolean;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  internationalTemplateApprovalCount?: number;
  /** @format int32 */
  paymentApprovalCount?: number;
  paymentAuthenticationType?: AuthenticationTypeDto;
  /** @format int32 */
  paymentAuthenticationTypeId?: number;
  product?: ProductDto;
  /** @format int32 */
  recipientApprovalCount?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  validateAccountBalance?: boolean;
}

export interface ArpProductDto {
  allowIssuedItemActivityReview?: boolean;
  fiAllowSubstituteProduct?: boolean;
  fiManageAchExceptions?: boolean;
  fiShowAchExceptions?: boolean;
  fiWorkAchException?: boolean;
  fiWorkCheckException?: boolean;
  /** @format int32 */
  id?: number;
  manageAchExceptions?: boolean;
  product?: ProductDto;
  showAchExceptions?: boolean;
  substituteProductClientId?: string;
  substituteProductLandingPageUrl?: string;
  substituteProductName?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  useSubstituteProduct?: boolean;
  workAchException?: boolean;
  workAchFilter?: boolean;
  workCheckException?: boolean;
}

export interface BillPayProductDto {
  account?: AccountDto;
  /** @format int32 */
  accountId?: number;
  /** @format guid */
  accountUniqueId?: string;
  allowIPayBusinessBillPayForMobile?: boolean;
  billPayServiceName?: string;
  /** @format int32 */
  id?: number;
  product?: ProductDto;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
}

export interface ElectronicDocumentsProductDto {
  esiEmail?: string;
  esiId?: string;
  electronicDocumentServiceName?: string;
  /** @format int32 */
  electronicDocumentTypeId?: number;
  /** @format int32 */
  id?: number;
  /** @format double */
  monthlyFee?: number;
  product?: ProductDto;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export type InternalTransferProductDto = BaseEntityDto & {
  allowLoanPaymentPastDue?: boolean;
  /** @format int32 */
  approvalCount?: number;
  /** @format int32 */
  authenticationTypeId?: number;
  /** @format decimal */
  dailyLimit?: number;
  /** @format int32 */
  id?: number;
  internalTransferProductLinkAccounts?: InternalTransferProductLinkAccountDto[];
  product?: ProductDto;
  /** @format byte */
  templateApprovalCount?: number;
};

export type InternalTransferProductLinkAccountDto = BaseEntityDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  fromAccountType?: AccountTypeDto;
  /** @format int32 */
  fromAccountTypeId?: number;
  /** @format int32 */
  id?: number;
  internalTransferProduct?: InternalTransferProductDto;
  /** @format int32 */
  productId?: number;
  toAccountType?: AccountTypeDto;
  /** @format int32 */
  toAccountTypeId?: number;
};

export interface ProductPermissionDto {
  /** @format int32 */
  id?: number;
  permission?: string;
  product?: ProductDto;
  productAccountPermissions?: ProductAccountPermissionDto[];
  /** @format int32 */
  productId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface ProductAccountPermissionDto {
  accountProduct?: AccountProductDto;
  /** @format int32 */
  accountProductId?: number;
  entitlements?: EntitlementDto[];
  /** @format int32 */
  id?: number;
  productPermission?: ProductPermissionDto;
  /** @format int32 */
  productPermissionId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface EntitlementDto {
  /** @format int32 */
  id?: number;
  objectState?: ObjectStateDto;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
}

export interface RemoteDepositProductDto {
  companySsoLogin?: CompanySsoLoginDto;
  /** @format int32 */
  companySsoLoginId?: number;
  /** @format int32 */
  id?: number;
  /** @format decimal */
  monthlyFee?: number;
  remoteDepositProductType?: RemoteDepositProductTypeDto;
  /** @format int32 */
  remoteDepositProductTypeId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
}

export interface CompanySsoLoginDto {
  clientCompanyId?: string;
  company?: CompanyDto;
  /** @format int32 */
  companyId?: number;
  /** @format int32 */
  id?: number;
  ssoLoginSystem?: SsoLoginSystemDto;
  /** @format int32 */
  ssoLoginSystemId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
}

export interface RemoteDepositProductTypeDto {
  description?: string;
  name?: string;
  /** @format int32 */
  remoteDepositProductTypeId?: number;
}

export type ReportingConfigurationDto = BaseEntityDto & {
  hasBai?: boolean;
  hasCsv?: boolean;
  hasDownload?: boolean;
  hasEmail?: boolean;
  hasPdf?: boolean;
  hasQuickBooks?: boolean;
  hasQuicken?: boolean;
  hasTiff?: boolean;
  hasWord?: boolean;
  /** @format int32 */
  id?: number;
  product?: ProductDto;
  /** @format int32 */
  productId?: number;
  reportingFilter?: ReportingFilterDto;
  /** @format int32 */
  standardReportId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type ReportingFilterDto = BaseEntityDto & {
  accountTypes?: string;
  amountOperator?: string;
  companyUniqueId?: string;
  dateType?: string;
  favoriteReports?: FavoriteReportDto[];
  /** @format decimal */
  fromAmount?: number;
  /** @format date-time */
  fromDate?: string;
  fromPaymentId?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  institutionId?: number;
  isAscendingSort?: boolean;
  isFavorite?: boolean;
  isStandardReport?: boolean;
  name?: string;
  /** @format int32 */
  owner?: number;
  paymentIdOperator?: string;
  paymentTypes?: FilterPaymentTypeDto[];
  postedTransactions?: boolean;
  /** @format int32 */
  priorDays?: number;
  reportType?: string;
  reportingBalanceFilter?: ReportingBalanceFilterDto;
  reportingConfigurations?: ReportingConfigurationDto[];
  reportingFilter1?: ReportingFilterDto[];
  reportingFilter2?: ReportingFilterDto;
  reportingFilterAccounts?: ReportingFilterAccountDto[];
  reportingFilterPaymentTypes?: ReportingFilterPaymentTypeDto[];
  reportingFilterSorts?: ReportingFilterSortDto[];
  reportingTransactionFilter?: ReportingTransactionFilterDto;
  /** @format int32 */
  sequence?: number;
  sortBy?: string;
  /** @format date-time */
  specificDate?: string;
  /** @format int32 */
  standardReportTypeId?: number;
  /** @format decimal */
  toAmount?: number;
  /** @format date-time */
  toDate?: string;
  toPaymentId?: string;
  transactionDirection?: string;
  transactionType?: string;
  type?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
};

export type FavoriteReportDto = BaseEntityDto & {
  /** @format int32 */
  id?: number;
  reportingFilter?: ReportingFilterDto;
  /** @format int32 */
  reportingFilterId?: number;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
};

export interface FilterPaymentTypeDto {
  type?: string;
}

export type ReportingBalanceFilterDto = BaseEntityDto & {
  /** @format int32 */
  id?: number;
  reportingFilter?: ReportingFilterDto;
};

export type ReportingFilterAccountDto = BaseEntityDto & {
  account?: AccountDto;
  /** @format int32 */
  accountId?: number;
  /** @format int32 */
  id?: number;
  reportingFilter?: ReportingFilterDto;
  /** @format int32 */
  reportingFilterId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type ReportingFilterPaymentTypeDto = BaseEntityDto & {
  /** @format int32 */
  id?: number;
  paymentType?: string;
  reportingFilter?: ReportingFilterDto;
  /** @format int32 */
  reportingFilterId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export interface ReportingFilterSortDto {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  reportingFilter?: ReportingFilterDto;
  /** @format int32 */
  reportingFilterId?: number;
  /** @format int32 */
  sequence?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
}

export type ReportingTransactionFilterDto = BaseEntityDto & {
  amountOperator?: string;
  /** @format decimal */
  fromAmount?: number;
  fromPaymentId?: string;
  /** @format int32 */
  id?: number;
  paymentIdOperator?: string;
  reportingFilter?: ReportingFilterDto;
  /** @format decimal */
  toAmount?: number;
  toPaymentId?: string;
  transactionDirection?: string;
  transactionType?: string;
};

export interface ReportingProductDto {
  /** @format int32 */
  id?: number;
  product?: ProductDto;
}

export interface StopPaymentProductDto {
  approvalCount?: number;
  /** @format double */
  feePerRequest?: number;
  /** @format int32 */
  id?: number;
  product?: ProductDto;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export type UserProductLimitDto = BaseEntityDto & {
  /** @format decimal */
  approvalLimit?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  /** @format decimal */
  initiationLimit?: number;
  product?: ProductDto;
  /** @format int32 */
  productId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
};

export type WireInternationalProductDto = BaseEntityDto & {
  /** @format int32 */
  beneficiaryApprovalCount?: number;
  /** @format decimal */
  dailyLimit?: number;
  /** @format int32 */
  id?: number;
  internationalUsd?: boolean;
  internationalUsdReadOnly?: boolean;
  /** @format int32 */
  paymentApprovalCount?: number;
  /** @format byte */
  paymentApprovalType?: number;
  product?: ProductDto;
  requirePaymentPurpose?: boolean;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  updatedUser?: UserDto;
  validateAccountBalance?: boolean;
  wirePaymentApprovalSettings?: WirePaymentApprovalSettingDto[];
  wireUsdEnabled?: boolean;
};

export interface WirePaymentApprovalSettingDto {
  /** @format byte */
  approvalCount?: number;
  /** @format decimal */
  endAmount?: number;
  /** @format int32 */
  id?: number;
  product?: ProductDto;
  /** @format int32 */
  productId?: number;
  /** @format decimal */
  startAmount?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
  wireProduct?: WireProductDto;
}

export type WireProductDto = BaseEntityDto & {
  allowWireFileUpload?: boolean;
  /** @format int32 */
  beneficiaryApprovalCount?: number;
  /** @format int32 */
  beneficiaryAuthenticationTypeId?: number;
  /** @format decimal */
  dailyLimit?: number;
  /** @format int32 */
  farthestWireExistInDays?: number;
  /** @format int32 */
  id?: number;
  internationalEnabled?: boolean;
  internationalUsdReadOnly?: boolean;
  isCompanyDliUsdEnabled?: boolean;
  isCompanyWireProductEnabled?: boolean;
  isDliCompanyProductEnabled?: boolean;
  isFiDliProductEnabled?: boolean;
  isFiDliUsdEnabled?: boolean;
  isFiInternationalEnabled?: boolean;
  isFiWireProductEnabled?: boolean;
  isInternationalUsdEnabled?: boolean;
  limitFutureDateEnabled?: boolean;
  /** @format int32 */
  maximumFutureDays?: number;
  /** @format int32 */
  paymentApprovalCount?: number;
  /** @format byte */
  paymentApprovalType?: number;
  /** @format int32 */
  paymentAuthenticationTypeId?: number;
  product?: ProductDto;
  requirePaymentPurpose?: boolean;
  requirePaymentPurposeDli?: boolean;
  /** @format byte */
  templateApprovalCount?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  updatedUser?: UserDto;
  useExternalFxWireProcessing?: boolean;
  wirePaymentApprovalSettings?: WirePaymentApprovalSettingDto[];
};

export type ResourceConfigurationDto = BaseEntityDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  displayExternalWarning?: boolean;
  externalWarningMessage?: string;
  /** @format int32 */
  id?: number;
  institution?: InstitutionDto;
  /** @format int32 */
  institutionId?: number;
  link?: string;
  /** @format byte */
  logo?: string;
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  /** @format int32 */
  sequence?: number;
  title?: string;
  tooltip?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export interface CompanyAccountDisplaySettingDto {
  accountMaskType?: AccountMaskTypeDto;
  /** @format int32 */
  accountMaskTypeId?: number;
  allowOverrideMasking?: boolean;
  company?: CompanyDto;
  /** @format int32 */
  createdBy?: number;
  createdByUser?: UserDto;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  showAccountName?: boolean;
  /** @format int32 */
  updatedBy?: number;
  updatedByUser?: UserDto;
  /** @format date-time */
  updatedDate?: string;
}

export interface AccountMaskTypeDto {
  description?: string;
  /** @format int32 */
  id?: number;
}

export type CompanyLimitDto = BaseEntityDto & {
  company?: CompanyDto;
  /** @format int32 */
  companyId?: number;
  /** @format decimal */
  dailyLimit?: number;
  /** @format int32 */
  id?: number;
  /** @format decimal */
  monthlyLimit?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type CompanyTypeDto = BaseEntityDto & {
  companies?: CompanyDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export interface CompanyUserApprovalSettingDto {
  boUserRequireBoApproval?: boolean;
  chUserRequireBoApproval?: boolean;
  chUserRequireChApproval?: boolean;
  company?: CompanyDto;
  /** @format int32 */
  id?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export type FileImportLayoutDto = BaseEntityDto & {
  company?: CompanyDto;
  /** @format int32 */
  companyId?: number;
  delimiter?: string;
  fileFormatType?: FileFormatTypeDto;
  /** @format int32 */
  fileFormatTypeId?: number;
  fileImportLayoutDetails?: FileImportLayoutDetailDto[];
  /** @format int32 */
  footerRows?: number;
  /** @format int32 */
  headerRows?: number;
  /** @format int32 */
  id?: number;
  productType?: ProductTypeDto;
  /** @format int32 */
  productTypeId?: number;
  templateName?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type FileFormatTypeDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export type FileImportLayoutDetailDto = BaseEntityDto & {
  additionalInformationFour?: string;
  additionalInformationOne?: string;
  additionalInformationThree?: string;
  additionalInformationTwo?: string;
  /** @format int32 */
  beginPosition?: number;
  /** @format int32 */
  endPosition?: number;
  fileImportField?: FileImportFieldDto;
  /** @format int32 */
  fileImportFieldId?: number;
  fileImportLayout?: FileImportLayoutDto;
  /** @format int32 */
  fileImportLayoutId?: number;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  order?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type FileImportFieldDto = BaseEntityDto & {
  description?: string;
  fieldName?: string;
  fileImportFieldGroup?: FileImportFieldGroupDto;
  /** @format int32 */
  fileImportFieldGroupId?: number;
  fileType?: FileTypeDto;
  /** @format int32 */
  fileTypeId?: number;
  /** @format int32 */
  id?: number;
  info?: string;
  isRequired?: boolean;
};

export type FileImportFieldGroupDto = BaseEntityDto & {
  description?: string;
  fileFormatType?: FileFormatTypeDto;
  fileImportFields?: FileImportFieldDto[];
  /** @format int32 */
  fileTypeId?: number;
  groupName?: string;
  /** @format int32 */
  id?: number;
  info?: string;
};

export type FileTypeDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export type InternalTransferTransactionDto = BaseEntityDto & {
  /** @format decimal */
  amount?: number;
  approvedBy?: TupleStringDateTimeDto[];
  batchId?: string;
  childInternalTransferTransactions?: InternalTransferTransactionDto[];
  comments?: string;
  company?: CompanyDto;
  /** @format int32 */
  companyId?: number;
  /** @format int32 */
  completedApprovals?: number;
  confirmationNumber?: string;
  createdBy?: string;
  createdByUser?: UserDto;
  /** @format date-time */
  createdDate?: string;
  eligibleApprovers?: string[];
  /** @format date-time */
  endDate?: string;
  errorSummary?: ErrorSummaryDto;
  /** @format int32 */
  firstRepeatOnDay?: number;
  fromAccount?: AccountDto;
  /** @format int32 */
  fromAccountId?: number;
  hasNoEndDate?: boolean;
  /** @format int32 */
  id?: number;
  internalTransferAudits?: InternalTransferAuditDto[];
  internalTransferStatusType?: InternalTransferStatusTypeDto;
  /** @format int32 */
  internalTransferStatusTypeId?: number;
  internalTransferTemplate?: InternalTransferTemplateDto;
  /** @format int32 */
  internalTransferTemplateId?: number;
  isEdited?: boolean;
  /** @format date-time */
  lastEditedDate?: string;
  memo?: string;
  message?: string;
  messageType?: string;
  /** @format int32 */
  numberOfApprovalNeeded?: number;
  parentInternalTransferTransaction?: InternalTransferTransactionDto;
  /** @format int32 */
  parentInternalTransferTransactionId?: number;
  paymentFrequencyType?: PaymentFrequencyTypeDto;
  /** @format int32 */
  paymentFrequencyTypeId?: number;
  paymentOptionType?: PaymentOptionTypeDto;
  /** @format int32 */
  paymentOptionTypeId?: number;
  permissions?: ProductPermissionDto[];
  repeatOnLastBusinessDay?: boolean;
  /** @format int32 */
  seconRepeatOnDay?: number;
  /** @format date-time */
  startDate?: string;
  submittedToScheduler?: boolean;
  toAccount?: AccountDto;
  /** @format int32 */
  toAccountId?: number;
  transactionId?: string;
  /** @format date-time */
  transferDate?: string;
  updatedBy?: string;
  updatedByUser?: UserDto;
  /** @format date-time */
  updatedDate?: string;
};

export interface InternalTransferAuditDto {
  comments?: string;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  internalTransferActionType?: InternalTransferActionTypeDto;
  /** @format int32 */
  internalTransferActionTypeId?: number;
  /** @format int32 */
  internalTransferAuditId?: number;
  internalTransferTransaction?: InternalTransferTransactionDto;
  /** @format int32 */
  internalTransferTransactionId?: number;
  user?: UserDto;
}

export interface InternalTransferActionTypeDto {
  description?: string;
  /** @format int32 */
  internalTransferActionTypeId?: number;
  internalTransferAudits?: InternalTransferAuditDto[];
  name?: string;
}

export interface InternalTransferStatusTypeDto {
  description?: string;
  /** @format int32 */
  internalTransferStatusTypeId?: number;
  internalTransferTransactions?: InternalTransferTransactionDto[];
  name?: string;
}

export type InternalTransferTemplateDto = BaseEntityDto & {
  /** @format int32 */
  approvalCount?: number;
  company?: CompanyDto;
  /** @format int32 */
  companyId?: number;
  /** @format int32 */
  completedApprovals?: number;
  /** @format int32 */
  createdBy?: number;
  createdByUser?: UserDto;
  /** @format date-time */
  createdDate?: string;
  eligibleApprovers?: string[];
  fromAccountNumber?: string;
  /** @format int32 */
  id?: number;
  internalTransferTemplateAudits?: InternalTransferTemplateAuditDto[];
  internalTransferTemplateDetails?: InternalTransferTemplateDetailDto[];
  internalTransferTemplateStatusType?: InternalTransferTemplateStatusTypeDto;
  /** @format int32 */
  internalTransferTemplateStatusTypeId?: number;
  internalTransferType?: InternalTransferTypeDto;
  /** @format int32 */
  internalTransferTypeId?: number;
  oneToOneMemo?: string;
  templateAccountDetails?: AccountDto[];
  templateName?: string;
  toAccountNumber?: string;
  /** @format decimal */
  totalAmount?: number;
  /** @format int32 */
  updatedBy?: number;
  updatedByUser?: UserDto;
  /** @format date-time */
  updatedDate?: string;
  userPermissions?: string[];
};

export interface InternalTransferTemplateAuditDto {
  /** @format int32 */
  createdBy?: number;
  createdByUser?: UserDto;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  internalTransferTemplate?: InternalTransferTemplateDto;
  internalTransferTemplateActionType?: InternalTransferTemplateActionTypeDto;
  /** @format int32 */
  internalTransferTemplateActionTypeId?: number;
  /** @format int32 */
  internalTransferTemplateId?: number;
}

export interface InternalTransferTemplateActionTypeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface InternalTransferTemplateDetailDto {
  /** @format decimal */
  amount?: number;
  /** @format int32 */
  createdBy?: number;
  createdByUser?: UserDto;
  /** @format date-time */
  createdDate?: string;
  fromAccount?: AccountDto;
  /** @format int32 */
  fromAccountId?: number;
  /** @format int32 */
  id?: number;
  internalTransferTemplate?: InternalTransferTemplateDto;
  /** @format int32 */
  internalTransferTemplateId?: number;
  memo?: string;
  toAccount?: AccountDto;
  /** @format int32 */
  toAccountId?: number;
  /** @format int32 */
  updatedBy?: number;
  updatedByUser?: UserDto;
  /** @format date-time */
  updatedDate?: string;
}

export interface InternalTransferTemplateStatusTypeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface InternalTransferTypeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export type PaymentOptionTypeDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export type UserAccountDto = BaseEntityDto & {
  account?: AccountDto;
  /** @format int32 */
  accountId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  user?: UserDto;
  userAccountLimits?: UserAccountLimitDto[];
  /** @format int32 */
  userId?: number;
};

export type UserAccountLimitDto = BaseEntityDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format decimal */
  dailyLimit?: number;
  /** @format int32 */
  id?: number;
  /** @format decimal */
  perTransactionLimit?: number;
  productType?: ProductTypeDto;
  /** @format int32 */
  productTypeId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userAccount?: UserAccountDto;
  /** @format int32 */
  userAccountId?: number;
};

export interface InstitutionAccountDisplaySettingDto {
  accountMaskType?: AccountMaskTypeDto;
  /** @format int32 */
  accountMaskTypeId?: number;
  allowOverrideMasking?: boolean;
  /** @format int32 */
  createdBy?: number;
  createdByUser?: UserDto;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  institution?: InstitutionDto;
  showAccountName?: boolean;
  /** @format int32 */
  updatedBy?: number;
  updatedByUser?: UserDto;
  /** @format date-time */
  updatedDate?: string;
}

export interface InstitutionAffiliationDto {
  /** @format int32 */
  affiliatedInstitutionId?: number;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  institutionId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
}

export interface InstitutionFraudProviderDto {
  institution?: InstitutionDto;
  provider?: string;
  /** @format int32 */
  updatedBy?: number;
  updatedByUser?: UserDto;
  /** @format date-time */
  updatedDate?: string;
}

export type InstitutionMessageCenterDto = BaseEntityDto & {
  archiveSetting?: ArchiveSettingDto;
  /** @format int32 */
  archiveSettingId?: number;
  disclaimer?: string;
  /** @format int32 */
  id?: number;
  institution?: InstitutionDto;
  sharedEmail?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  updatedUser?: UserDto;
  useSharedEmail?: boolean;
};

export interface ArchiveSettingDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface InstitutionNachaFileRecordDto {
  addendaRecordIndicator?: string;
  blockingFactor?: string;
  checkDigit?: string;
  fileIdModifier?: string;
  formatCode?: string;
  /** @format int32 */
  id?: number;
  immediateDestination?: string;
  immediateDestinationName?: string;
  immediateOrigin?: string;
  immediateOriginName?: string;
  institution?: InstitutionDto;
  originatingDfi?: string;
  originatorStatusCode?: string;
  priorityCode?: string;
  receivingDfi?: string;
  recordSize?: string;
}

export interface InstitutionOobConfigurationDto {
  allowedOobChallengeFailureCount?: number;
  /** @format int32 */
  id?: number;
  institution?: InstitutionDto;
  oobChallengePinNeeded?: boolean;
  oobEnabled?: boolean;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export type InstitutionTermDto = BaseEntityDto & {
  /** @format int32 */
  id?: number;
  institution?: InstitutionDto;
  requireAcceptance?: boolean;
  termsAndConditions?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export interface InstitutionUserApprovalSettingDto {
  boUserRequireBoApproval?: boolean;
  chUserRequireBoApproval?: boolean;
  chUserRequireChApproval?: boolean;
  /** @format int32 */
  id?: number;
  institution?: InstitutionDto;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export type InstitutionWireInternationalWorkflowOverridesDto = BaseEntityDto & {
  allowAccountBalanceValidation?: boolean;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  forceInternationalUsdViaForeignCurrencyWorkflow?: boolean;
  /** @format int32 */
  id?: number;
  institution?: InstitutionDto;
  rowStatusId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  useExternalFxQuoteRatesheets?: boolean;
  useExternalFxWireProcessing?: boolean;
  useNonCoreWireCompanies?: boolean;
};

export type LoginConfigurationDto = BaseEntityDto & {
  allowAlphabetsInLoginId?: boolean;
  allowAlphabetsInPassword?: boolean;
  allowLockedOutMessage?: boolean;
  allowNumbersInLoginId?: boolean;
  allowNumbersInPassword?: boolean;
  allowSpecialCharactersInLoginId?: boolean;
  allowSpecialCharactersInPassword?: boolean;
  alphabetsInLoginIdAreRequired?: boolean;
  alphabetsInPasswordAreRequired?: boolean;
  /** @format int32 */
  id?: number;
  institution?: InstitutionDto;
  /** @format int32 */
  institutionId?: number;
  invalidLoginIdPasswordMessage?: string;
  isCompany?: boolean;
  isDefault?: boolean;
  lockedEmailMessage?: string;
  lockedOutMessage?: string;
  /** @format int32 */
  loginIdMaxLength?: number;
  /** @format int32 */
  loginIdMinLength?: number;
  /** @format int32 */
  numberOfAllowedAttemptsBeforeLock?: number;
  /** @format int32 */
  numberOfLowercaseRequiredInLoginId?: number;
  /** @format int32 */
  numberOfLowercaseRequiredInPassword?: number;
  /** @format int32 */
  numberOfPrevUsedPasswords?: number;
  /** @format int32 */
  numberOfUppercaseRequiredInLoginId?: number;
  /** @format int32 */
  numberOfUppercaseRequiredInPassword?: number;
  numbersInLoginIdAreRequired?: boolean;
  numbersInPasswordAreRequired?: boolean;
  /** @format int32 */
  passwordExpireInDays?: number;
  /** @format int32 */
  passwordMaxLength?: number;
  /** @format int32 */
  passwordMinLength?: number;
  sendLockedEmail?: boolean;
  /** @format int32 */
  sessionTimeoutMinutes?: number;
  specialCharactersInLoginIdAreRequired?: boolean;
  specialCharactersInPasswordAreRequired?: boolean;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  /** @format int32 */
  warnPasswordExpireInDays?: number;
  willPasswordExpire?: boolean;
};

export type TransactionCodeGroupDto = BaseEntityDto & {
  /** @format int32 */
  id?: number;
  institution?: InstitutionDto;
  /** @format int32 */
  institutionId?: number;
  isReadOnly?: boolean;
  name?: string;
  transactionCodeGroupAssociations?: TransactionCodeGroupAssociationDto[];
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type TransactionCodeGroupAssociationDto = BaseEntityDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  transactionCode?: TransactionCodeDto;
  transactionCodeGroup?: TransactionCodeGroupDto;
  /** @format int32 */
  transactionCodeGroupId?: number;
  /** @format int32 */
  transactionCodeId?: number;
};

export type OfxTransactionTypeDto = BaseEntityDto & {
  description?: string;
  displayName?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export type AchFederalTaxTemplateDto = BaseEntityDto & {
  achFederalTaxTemplateAmounts?: AchFederalTaxTemplateAmountDto[];
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  recipientAccountNumber?: string;
  recipientAccountType?: AccountTypeDto;
  /** @format int32 */
  recipientAccountTypeId?: number;
  recipientIdNumber?: string;
  recipientName?: string;
  recipientRoutingNumber?: string;
  taxCode?: string;
  taxPayerId?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
};

export type AchFederalTaxTemplateAmountDto = BaseEntityDto & {
  /** @format int32 */
  achBatchId?: number;
  achFederalAmountType?: AchFederalAmountTypeDto;
  /** @format int32 */
  achFederalAmountTypeId?: number;
  /** @format decimal */
  amount?: number;
  amountType?: string;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
};

export type AchStateTaxTemplateDto = BaseEntityDto & {
  achStateTaxTemplateAmounts?: AchStateTaxTemplateAmountDto[];
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  recipientAccountNumber?: string;
  recipientAccountType?: AccountTypeDto;
  /** @format int32 */
  recipientAccountTypeId?: number;
  recipientIdNumber?: string;
  recipientName?: string;
  recipientRoutingNumber?: string;
  state?: StateDto;
  /** @format int32 */
  stateId?: number;
  taxCode?: string;
  taxPayerId?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
};

export type AchStateTaxTemplateAmountDto = BaseEntityDto & {
  /** @format int32 */
  achBatchId?: number;
  achStateAmountType?: AchStateAmountTypeDto;
  /** @format int32 */
  achStateAmountTypeId?: number;
  /** @format decimal */
  amount?: number;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
};

export interface AchStateAmountTypeDto {
  amountType?: string;
  description?: string;
  /** @format int32 */
  id?: number;
}

export type BatchStatusTypeDto = BaseEntityDto & {
  achBatches?: AchBatchDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export type AchCompanySecCodeDto = BaseEntityDto & {
  achCompany?: AchCompanyDto;
  achSecCode?: AchSecCodeDto;
  /** @format int32 */
  achSecCodeId?: number;
  /** @format int32 */
  companyId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
};

export type UserAchCompanyDto = BaseEntityDto & {
  achCompany?: AchCompanyDto;
  /** @format int32 */
  achCompanyId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format decimal */
  dailyLimit?: number;
  /** @format int32 */
  id?: number;
  /** @format decimal */
  perTransactionLimit?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
};

export type ArpExceptionDto = BaseEntityDto & {
  account?: AccountDto;
  /** @format int32 */
  accountId?: number;
  activityIntentKey?: string;
  arpDecision?: ArpDecisionDto;
  /** @format int32 */
  arpDecisionId?: number;
  checkImageNumber?: string;
  checkNumber?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  ddaBatchNumber?: string;
  ddaSequenceNumber?: string;
  /** @format date-time */
  decisionDate?: string;
  fromworkStation?: string;
  /** @format int32 */
  id?: number;
  isDebit?: boolean;
  /** @format decimal */
  issuedAmount?: number;
  /** @format date-time */
  issuedDate?: string;
  /** @format decimal */
  paidAmount?: number;
  payee?: string;
  posPayItemId?: string;
  protected?: string;
  reason?: string;
  resolved?: string;
  sourceOfEntry?: string;
  transactionId?: string;
};

export interface ArpDecisionDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export type NonCoreWireCompanyInternationalAccountDto = BaseEntityDto & {
  account?: AccountDto;
  /** @format int32 */
  accountId?: number;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format decimal */
  dailyLimit?: number;
  /** @format int32 */
  id?: number;
  nonCoreWireCompanyInternational?: NonCoreWireCompanyInternationalDto;
  /** @format decimal */
  perTransactionLimit?: number;
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  /** @format int32 */
  wireCompanyId?: number;
};

export type NonCoreWireCompanyInternationalDto = BaseEntityDto & {
  /** @format int32 */
  availableBalanceValidationCoreTable?: number;
  company?: CompanyDto;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format decimal */
  dailyLimit?: number;
  /** @format int32 */
  id?: number;
  nonCoreWireCompanyInternationalAccounts?: NonCoreWireCompanyInternationalAccountDto[];
  /** @format decimal */
  perTransactionLimit?: number;
  rowStatus?: RowStatusDto;
  rowStatusId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  wireInternationalBalanceValidationType?: WireInternationalBalanceValidationTypeDto;
  /** @format int32 */
  wireInternationalBalanceValidationTypeId?: number;
};

export type WireInternationalBalanceValidationTypeDto = BaseEntityDto & {
  /** @format int32 */
  id?: number;
  name?: string;
};

export type StopPaymentDto = BaseEntityDto & {
  account?: AccountDto;
  /** @format int32 */
  accountId?: number;
  /** @format double */
  amount?: number;
  /** @format int32 */
  approvalCount?: number;
  /** @format int32 */
  approvalsCompleted?: number;
  approvedBy?: TupleStringDateTimeDto[];
  /** @format date-time */
  checkDate?: string;
  confirmationNumber?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  eligibleApprovers?: string[];
  /** @format int64 */
  endCheckNumber?: number;
  enteredBy?: string;
  /** @format date-time */
  expireDate?: string;
  /** @format int32 */
  id?: number;
  payee?: string;
  remarks?: string;
  /** @format int64 */
  startCheckNumber?: number;
  stopPaymentAudits?: StopPaymentAuditDto[];
  stopPaymentStatusType?: StopPaymentStatusTypeDto;
  /** @format int32 */
  stopPaymentStatusTypeId?: number;
  transactionId?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userPermissions?: string[];
};

export type StopPaymentAuditDto = BaseEntityDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  remarks?: string;
  stopPayment?: StopPaymentDto;
  stopPaymentAuditAction?: StopPaymentAuditActionDto;
  /** @format int32 */
  stopPaymentAuditActionId?: number;
  /** @format int32 */
  stopPaymentId?: number;
};

export type StopPaymentAuditActionDto = BaseEntityDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  stopPaymentAudits?: StopPaymentAuditDto[];
};

export interface StopPaymentStatusTypeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export type UserAccountGroupAccountDto = BaseEntityDto & {
  account?: AccountDto;
  /** @format int32 */
  accountId?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  sequence?: number;
  userAccountGroup?: UserAccountGroupDto;
  /** @format int32 */
  userAccountGroupId?: number;
};

export type UserAccountGroupDto = BaseEntityDto & {
  accountGroupName?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  /** @format byte */
  sequency?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
  userAccountGroupAccounts?: UserAccountGroupAccountDto[];
  /** @format int32 */
  userId?: number;
};

export type TextMessagingCarrierDto = BaseEntityDto & {
  active?: boolean;
  /** @format int32 */
  id?: number;
  name?: string;
  providerId?: string;
  serviceId?: string;
  serviceTypeId?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type UserAuditDto = BaseEntityDto & {
  comment?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
};

export type UserDeviceDto = BaseEntityDto & {
  authenticationId?: string;
  /** @format int32 */
  id?: number;
  key?: string;
  /** @format date-time */
  keyCreatedDate?: string;
  /** @format date-time */
  keyLastUsedDate?: string;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
};

export type UserIpAccessSettingDto = BaseEntityDto & {
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  restricted?: boolean;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
};

export type UserIpAccessDto = BaseEntityDto & {
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  ipAddress?: string;
  nickname?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
};

export type UserNotificationDto = BaseEntityDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  isEmailSent?: boolean;
  isRead?: boolean;
  isTextMessageSent?: boolean;
  notification?: NotificationDto;
  /** @format int32 */
  notificationId?: number;
  notificationStatusType?: NotificationStatusTypeDto;
  /** @format int32 */
  notificationStatusTypeId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
};

export interface NotificationStatusTypeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export type UserPasswordHistoryDto = BaseEntityDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  password?: string;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
};

export type UserTimeAccessSettingDto = BaseEntityDto & {
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  restricted?: boolean;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
};

export type UserTimeAccessDto = BaseEntityDto & {
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  dayOfWeekId?: number;
  /** @format duration */
  endTime?: string;
  /** @format int32 */
  id?: number;
  /** @format duration */
  startTime?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
  /** @format int32 */
  userId?: number;
  userTimeAccessTypeId?: number;
};

export type UserWidgetDto = BaseEntityDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  height?: number;
  /** @format int32 */
  id?: number;
  positionLeft?: number;
  positionTop?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  /** @format int32 */
  userId?: number;
  widget?: WidgetDto;
  /** @format int32 */
  widgetId?: number;
  width?: number;
};

export type WidgetDto = BaseEntityDto & {
  defaultContent?: string;
  defaultHeight?: number;
  defaultLeft?: number;
  defaultTop?: number;
  defaultWidth?: number;
  description?: string;
  hasPermission?: boolean;
  /** @format int32 */
  id?: number;
  imageUrl?: string;
  /** @format int32 */
  institutionId?: number;
  isFullScreenAllowed?: boolean;
  isPermissionRequired?: boolean;
  isRequired?: boolean;
  isResizable?: boolean;
  maxHeight?: number;
  maxWidth?: number;
  minHeight?: number;
  minWidth?: number;
  name?: string;
  permissionMessage?: string;
  title?: string;
  userWidgets?: UserWidgetDto[];
};

export interface AchNachaFileCopyAuditDto {
  achPayment?: AchPaymentDto;
  /** @format int32 */
  achPaymentId?: number;
  /** @format int32 */
  createdBy?: number;
  createdByUser?: UserDto;
  /** @format date-time */
  createdDate?: string;
  fileCopyStatus?: string;
  /** @format int32 */
  id?: number;
  message?: string;
  nachaFileName?: string;
}

export interface AchPaymentTypeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface AchStateTaxPaymentDto {
  achStateTaxPaymentAmounts?: AchStateTaxPaymentAmountDto[];
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  payFromAccount?: AccountDto;
  /** @format int32 */
  payFromAccountId?: number;
  recipientAccountNumber?: string;
  recipientAccountType?: AccountTypeDto;
  /** @format int32 */
  recipientAccountTypeId?: number;
  recipientIdNumber?: string;
  recipientName?: string;
  recipientRoutingNumber?: string;
  state?: StateDto;
  /** @format int32 */
  stateId?: number;
  taxCode?: string;
  taxPayerId?: string;
  /** @format date-time */
  taxPeriodEndDate?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface AchStateTaxPaymentAmountDto {
  /** @format int32 */
  achPaymentId?: number;
  achStateAmountType?: AchStateAmountTypeDto;
  /** @format int32 */
  achStateAmountTypeId?: number;
  /** @format decimal */
  amount?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface AchStatusTypeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface BatchBalanceTypeDto {
  achCompanies?: AchCompanyDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface ArpReportFileDto {
  account?: AccountDto;
  /** @format int32 */
  accountId?: number;
  /** @format date-time */
  createdDate?: string;
  fileContent?: string;
  fileName?: string;
  /** @format int32 */
  id?: number;
}

export interface CoreAccountDto {
  cifNumber?: string;
  coreStatus?: string;
  number?: string;
  type?: string;
}

export interface AccountProductArpDto {
  accountProduct?: AccountProductDto;
  hasAchException?: boolean;
  hasAchFilter?: boolean;
  hasCheckException?: boolean;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
}

export interface PendingEditOfUserDto {
  comment?: string;
  company?: CompanyDto;
  /** @format int32 */
  companyId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  isNew?: boolean;
  pendingEditInJson?: string;
  /** @format guid */
  pendingEditOfUserUniqueId?: string;
  /** @format int32 */
  pendingEditStatusId?: number;
  /** @format int32 */
  pendingEditTableId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  /** @format int32 */
  userId?: number;
}

export interface UserSecureTokenSecurityDto {
  challengePin?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  isLocked?: boolean;
  /** @format date-time */
  localSuspendEndDate?: string;
  needCollection?: boolean;
  remindMeCount?: number;
  secureChallengePin?: string;
  secureTokenCredentialId?: string;
  /** @format date-time */
  suspendEndDate?: string;
  tokenAuthFailureCount?: number;
  tokenCredentialId?: string;
  tokenVendorUserId?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserDto;
}

export type CheckLoginCompletionRequestDto = BaseRequestAuthenticationServiceDto & object;

export type GetUserOobConfigRequestDto = BaseRequestAuthenticationServiceDto & object;

export type VerifyOobMethodRequestDto = BaseRequestAuthenticationServiceDto & {
  method?: string;
  phoneNumber?: string;
  pinNumber?: string;
  useForBoth?: boolean;
};

export type CheckSecurityRequestDto = BaseRequestAuthenticationServiceDto & {
  actionType?: string;
  errorCode?: string;
  hasAlternate?: boolean;
  message?: string;
  methodUsed?: string;
  oneTimePassword?: string;
  sendMessage?: string;
  status?: string;
};

export type SetPreferredMethodRequestDto = BaseRequestAuthenticationServiceDto & {
  methodType?: string;
};

export type RemoveMethodRequestDto = BaseRequestAuthenticationServiceDto & {
  methodType?: string;
};

export type CompleteOobConfigRequestDto = BaseRequestAuthenticationServiceDto & {
  action?: string;
};

export type CompleteSecureTokenConfigRequestDto = BaseRequestAuthenticationServiceDto & {
  actionType?: CompleteSecureTokenConfigActionTypeDto;
  challengePin?: string;
  credentialId?: string;
  token?: string;
};

export type GetSecureTokenConfigRequestDto = BaseRequestAuthenticationServiceDto & object;

export type SendOutOfBandOneTimePasswordRequestDto = BaseRequestAuthenticationServiceDto & {
  challengePassword?: string;
  /** @format int32 */
  companyId?: number;
  /** @format int32 */
  institutionName?: number;
  phoneNumber?: string;
  /** @format int32 */
  userId?: number;
  validationMode?: string;
};

export type BaseMfaRequestDto = BaseRequestAuthenticationServiceDto & {
  imsOrgId?: string;
  multifactorAuthenticationUserData?: MultifactorAuthenticationUserDataDto;
  serviceProviderInfo?: ServiceProviderInfoDto;
  transactionRiskReceiptId?: string;
};

export interface MultifactorAuthenticationUserDataDto {
  acceptLanguage?: string;
  browserAgent?: string;
  colorDepth?: string;
  country?: string;
  /** @format date-time */
  dateLastOnlineBankingPasswordChange?: string;
  datePasswordChanged?: string;
  devicePrint?: string;
  ipAddress?: string;
  region?: string;
  screenResolution?: string;
  sessionId?: string;
  timeZone?: string;
  transactionId?: string;
  userCookie?: string;
  userLanguage?: string;
  zipCode?: string;
}

export interface ServiceProviderInfoDto {
  rsaConvVal?: string;
  rsaId?: string;
  rsaOrgId?: string;
}

export type PingRequestDto = BaseMfaRequestDto & {
  message?: string;
};

export type GetSecurityQuestionsRequestDto = BaseMfaRequestDto & {
  questionCount?: string;
  questionGroupCount?: string;
};

export type GetUserSecurityQuestionsRequestDto = BaseMfaRequestDto & {
  /** @format int32 */
  questionRequestCount?: number;
};

export type SaveUserSecurityQuestionsRequestDto = BaseMfaRequestDto & {
  recordedSecurityQuestionCollection?: RecordedSecurityQuestionCollectionDto;
};

export type RecordedSecurityQuestionCollectionDto = RecordedSecurityQuestionDto[];

export type ValidateChallengeRequestDto = BaseMfaRequestDto & {
  recordedSecurityQuestionCollection?: RecordedSecurityQuestionCollectionDto;
};

export type GetMfaIdRequestDto = BaseMfaRequestDto & {
  /** @format int32 */
  companyId?: number;
  /** @format int32 */
  userId?: number;
};

export type RiskRequestDto = BaseMfaRequestDto & {
  companyId?: string;
  isEditUser?: boolean;
  transactionCollection?: TransactionCollectionDto;
  userId?: string;
};

export type TransactionCollectionDto = TransactionDto[];

export interface TransactionDto {
  amount?: string;
  customRiskEventDescription?: string;
  customRiskEventType?: CustomRiskEventTypeDto;
  fromAccount?: MfaAccountDto;
  riskEventType?: RiskEventTypeDto;
  toAccount?: MfaAccountDto;
}

export interface MfaAccountDto {
  accountType?: AccountType1Dto;
  id?: string;
}

export type AddRiskEventRequestDto = RiskRequestDto & {
  externalAuthStat?: boolean;
  externalAuthType?: ExternalAuthTypeDto;
};

export type ResponseDetailCollectionAuthenticationServiceDto =
  ResponseDetailAuthenticationServiceDto[];

export interface ResponseDetailAuthenticationServiceDto {
  /** @format int32 */
  responseCode?: number;
  responseMessage?: string;
}

export type LogoutUserResponseDto = BaseResponseAuthenticationServiceDto & object;

export type GetUserSecureTokenMfaLoginStatusResponseDto = BaseResponseAuthenticationServiceDto & {
  status?: UserSecureTokenMfaLoginStatusDto;
};

export type SecureTokenMfaLoginResponseDto = BaseResponseAuthenticationServiceDto & {
  displayableMessage?: string;
  status?: SecureTokenMfaLoginResultStatusDto;
};

export type GetUserSecureTokenMfaCredentialsResponseDto = BaseResponseAuthenticationServiceDto & {
  credentialId?: string;
  shouldCancelCollection?: boolean;
};

export type RegisterSecureTokenMfaResponseDto = BaseResponseAuthenticationServiceDto & {
  wasCredentialRegistered?: boolean;
};

export type UnlockSecureTokenResponseDto = BaseResponseAuthenticationServiceDto & object;

export type ResetSecureTokenResponseDto = BaseResponseAuthenticationServiceDto & object;

export type RdcSsoLoginResponseDto = BaseResponseAuthenticationServiceDto & {
  customerId?: string;
  hash?: string;
  hashAlgorithmName?: string;
  /** @format int32 */
  remoteDepositProductTypeId?: number;
  ssoLoginUrl?: string;
  /** @format date-time */
  timestamp?: string;
  userId?: string;
};

export type GetCentrixSsoLoginResponseDto = BaseResponseAuthenticationServiceDto & {
  ssoLoginUrl?: string;
};

export type GetUserIdentityResponseDto = BaseResponseAuthenticationServiceDto & {
  /** @format int32 */
  companyId?: number;
  fiId?: string;
  /** @format int32 */
  userId?: number;
};

export type ElectronicDocumentResponseDto = BaseResponseAuthenticationServiceDto & {
  documentType?: ElectronicDocumentTypeEnumDto;
  electronicDocumentServiceName?: string;
  ssoFormPostInputs?: Record<string, string>;
  ssoUrl?: string;
};

export type DeviceResponseDto = BaseResponseAuthenticationServiceDto & object;

export type LogOffResponseDto = BaseResponseAuthenticationServiceDto & object;

export type GenerateAuthenticationTokenResponseDto = BaseResponseAuthenticationServiceDto & {
  /** @format int32 */
  tokenExpirationInSeconds?: number;
};

export type ValidateOnetimePasscodeResponseDto = BaseResponseAuthenticationServiceDto & object;

export type ResetPasswordResponseDto = BaseResponseAuthenticationServiceDto & {
  isValid?: boolean;
};

export type ChangePasswordResponseDto = BaseResponseAuthenticationServiceDto & {
  messages?: string[];
  statusCode?: string;
};

export type HealthCheckActionResponseAuthenticationServiceDto =
  BaseResponseAuthenticationServiceDto & {
    databaseConnectivityStatus?: DatabaseConnectivityStatusCollectionAuthenticationServiceDto;
    getDatabaseConnectivitySuccessful?: boolean;
    getPackageInformationSuccessful?: boolean;
    getRedisConnectivitySuccessful?: boolean;
    packageInformation?: PackageInformationAuthenticationServiceDto;
    redisConnectivityStatus?: RedisConnectivityStatusCollectionAuthenticationServiceDto;
    redisMultiplexerAbleToConnect?: boolean;
  };

export type DatabaseConnectivityStatusCollectionAuthenticationServiceDto =
  DatabaseConnectivityStatusAuthenticationServiceDto[];

export interface DatabaseConnectivityStatusAuthenticationServiceDto {
  ableToConnect?: boolean;
  additionalInformation?: string;
  connectionStringName?: string;
}

export interface PackageInformationAuthenticationServiceDto {
  buildInformation?: BuildInformationAuthenticationServiceDto;
  /** @format date-time */
  createdDateTime?: string;
  machineName?: string;
  releaseInformation?: ReleaseInformationAuthenticationServiceDto;
}

export interface BuildInformationAuthenticationServiceDto {
  azdoProject?: string;
  buildUrl?: string;
  commitId?: string;
  packageVersion?: string;
  repository?: string;
}

export interface ReleaseInformationAuthenticationServiceDto {
  /** @format date-time */
  deploymentDateUtc?: string;
  packageName?: string;
  packageVersion?: string;
  projectId?: string;
  releaseVersion?: string;
}

export type RedisConnectivityStatusCollectionAuthenticationServiceDto =
  RedisConnectivityStatusAuthenticationServiceDto[];

export interface RedisConnectivityStatusAuthenticationServiceDto {
  ableToConnect?: boolean;
  additionalInformation?: string;
  ipAddress?: string;
  redisClusterName?: string;
}

export type UserChallengeResponseDto = BaseResponseAuthenticationServiceDto & {
  errorSummary?: ErrorSummaryDto;
  isValid?: boolean;
  userOobDetail?: UserOobDetailDto;
};

export type CheckLoginCompletionResponseDto = BaseResponseAuthenticationServiceDto & {
  action?: string;
  challengeMethodType?: ChallengeMethodTypeEnumDto;
  isComplete?: boolean;
};

export type GetUserOobConfigResponseDto = BaseResponseAuthenticationServiceDto & {
  allowActionBypass?: boolean;
  usePin?: boolean;
  userOobDetail?: UserOobDetailDto;
};

export type VerifyOobMethodResponseDto = BaseResponseAuthenticationServiceDto & {
  errorSummary?: ErrorSummaryDto;
  isValid?: boolean;
  methodUsed?: string;
  userOobDetail?: UserOobDetailDto;
};

export type CheckSecurityResponseDto = BaseResponseAuthenticationServiceDto & {
  actionType?: string;
  challengeMethodType?: ChallengeMethodTypeEnumDto;
  errorCode?: string;
  hasAlternate?: boolean;
  message?: string;
  methodUsed?: string;
  sendMessage?: string;
  status?: string;
};

export type SetPreferredMethodResponseDto = BaseResponseAuthenticationServiceDto & object;

export type RemoveMethodResponseDto = BaseResponseAuthenticationServiceDto & object;

export type CompleteOobConfigResponseDto = BaseResponseAuthenticationServiceDto & object;

export type GetSecureTokenConfigResponseDto = BaseResponseAuthenticationServiceDto & {
  allowActionBypass?: boolean;
  cancelCollection?: boolean;
  credentialId?: string;
};

export type SendOutOfBandOneTimePasswordResponseDto = BaseResponseAuthenticationServiceDto & {
  isValid?: boolean;
};

export type BaseMfaResponseDto = BaseResponseAuthenticationServiceDto & {
  transactionRiskReceiptId?: string;
};

export type PingResponseDto = BaseMfaResponseDto & {
  pong?: string;
};

export type GetSecurityQuestionsResponseDto = BaseMfaResponseDto & {
  securityQuestionCollection?: SecurityQuestionCollectionDto;
};

export type SecurityQuestionCollectionDto = SecurityQuestionDto[];

export type GetUserSecurityQuestionsResponseDto = BaseMfaResponseDto & {
  securityQuestionCollection?: SecurityQuestionCollectionDto;
};

export type SaveUserSecurityQuestionsResponseDto = BaseMfaResponseDto & object;

export type ValidateChallengeResponseDto = BaseMfaResponseDto & {
  /** @format int32 */
  questionsSuccessCount?: number;
  validateChallengeFailType?: ValidateChallengeFailTypeDto;
};

export type RiskResponseDto = BaseMfaResponseDto & {
  multifactorAuthenticationResponseCode?: MultifactorAuthenticationResponseCodeDto;
  riskScore?: string;
};

export type GetMfaIdResponseDto = BaseMfaResponseDto & {
  mfaId?: string;
};

export type AddRiskEventResponseDto = BaseMfaResponseDto & object;

export interface CompleteSecureTokenConfigRequestModelDto {
  /** @format int32 */
  actionType?: number;
  credentialId?: string;
  token?: string;
  pin?: string;
}

export interface GetSecureTokenConfigResponseModelDto {
  success?: boolean;
  cancelCollection?: boolean;
  credentialId?: string;
  allowActionBypass?: boolean;
}

export interface ValidateOneTimePasswordResponseModelDto {
  status?: string;
}

export interface ValidateSecureTokenRequestModelDto {
  token?: string;
}

export type AccountTypeModelDto = ModelBaseDto & {
  name?: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  description: string;
  /**
   * @minLength 0
   * @maxLength 25
   */
  reportingType?: string;
};

export interface TermsAndConditionsModelDto {
  text?: string;
  /** @format date-time */
  lastAcceptedDate?: string;
  /** @format date-time */
  updatedDate?: string;
  requireUsersAcceptanceAfterEdit?: boolean;
  endUserLicenseAgreementText?: string;
}

export type TransactionCodeGroupModelDto = ModelBaseDto & {
  /** @minLength 1 */
  name: string;
  isReadOnly: boolean;
};

export interface UserSummaryModelDto {
  modelKind?: string;
  /** @format int32 */
  id?: number;
  userId?: string;
  userName?: string;
  isLocked?: boolean;
  isMfaLocked?: boolean;
  isAdmin?: boolean;
  isSuperUser?: boolean;
  status?: string;
  publishState?: string;
  isActive?: boolean;
  isEditor?: boolean;
  isDeleted?: boolean;
  digitalId?: string;
  securityAndPasswordSettingsLink?: string;
  userUniqueId?: string;
}

export interface SearchUserModelDto {
  activeUsersOnly?: boolean;
  enrolledUsersOnly?: boolean;
  includeRoles?: boolean;
}

export interface UserProductFeatureSummaryModelDto {
  /** @format int32 */
  userId: number;
  changedUserInformation: boolean;
  changedAccountAccess: boolean;
  hasAch: boolean;
  changedAchEntitlements: boolean;
  changedAchUserLimits: boolean;
  hasStandardPosPay: boolean;
  hasSsoPosPay: boolean;
  changedStandardPosPayEntitlements: boolean;
  changedSsoPosPayUserSettings: boolean;
  hasInformationReporting: boolean;
  changedInformationReportingEntitlements: boolean;
  hasInternalTransfers: boolean;
  changedInternalTransfersEntitlements: boolean;
  changedInternalTransfersUserLimits: boolean;
  hasWireTransfers: boolean;
  hasWireTransfersDomestic: boolean;
  hasWireTransfersInternational: boolean;
  changedWireTransfersEntitlements: boolean;
  changedWireTransfersUserLimits: boolean;
  hasWireTransfersDli: boolean;
  changedWireTransfersDliEntitlements: boolean;
  changedWireTransfersDliUserLimits: boolean;
  hasStopPayment: boolean;
  changedStopPaymentEntitlements: boolean;
  changedIpRestrictions: boolean;
  changedTimeAccess: boolean;
  hasIntegratedServices: boolean;
  changedIntegratedServices: boolean;
  hasReceivables: boolean;
  changedReceivables: boolean;
  hasAccountReconciliationReporting: boolean;
  changedAccountReconciliationReporting: boolean;
}

export type DeleteUserModelDto = SecurityBaseDto & {
  /** @format int32 */
  userId?: number;
};

export interface UserInformationResponseModelDto {
  user?: UserInformationModelDto;
  pendingUser?: UserInformationModelDto;
}

export type UserTimeAccess2Dto = RequestResponseDto & {
  timeRestricted?: boolean;
  timeRestrictedPending?: boolean;
  /** @format int32 */
  userId?: number;
  userTimeAccessDays?: UserTimeAccessDayDto[];
  userTimeAccessDaysPending?: UserTimeAccessDayDto[];
};

export interface UserTimeAccessDayDto {
  timeAccessType?: TimeAccessTypeDto;
  dayOfWeek?: DayOfWeekDto;
  /** @format duration */
  beginTime?: string;
  /** @format duration */
  endTime?: string;
}

export type ChallengesSupportedResponseModelDto = RequestResponseDto & {
  securityMessage?: SecurityMessageModelDto;
};

export type SaveUserTimeAccessRequestModelDto = RequestResponseDto & {
  securityMessage?: SecurityMessageModelDto;
  timeAccess?: UserTimeAccess2Dto;
};

export interface GetUserAccountAccessModelDto {
  accounts?: AccountAccessModelDto[];
}

export type AccountAccessModelDto = ModelBaseDto & {
  companyAccount?: CompanyAccountModelDto;
  hasUserAccess?: boolean;
  hasPendingUserAccess?: boolean;
};

export type SaveUserAccountAccessModelDto = RequestResponseDto & {
  addedAccounts?: AccountAccessModelDto[];
  removedAccounts?: AccountAccessModelDto[];
  securityMessage?: SecurityMessageModelDto;
};

export interface GetUserProductLimitsResponseModelDto {
  productType?: string;
  userProductLimit?: UserProductLimitsModelDto;
  pendingUserProductLimit?: UserProductLimitsModelDto;
  userAccountLimits?: AccountUserLimitModelDto[];
  /** @format decimal */
  productDailyLimit?: number;
}

export interface UserProductLimitsModelDto {
  /** @format decimal */
  initiationLimit?: number;
  /** @format decimal */
  approvalLimit?: number;
}

export interface AccountUserLimitModelDto {
  userAccount?: UserAccountModelDto;
  userAccountLimit?: UserAccountLimitModelDto;
  pendingUserAccountLimit?: UserAccountLimitModelDto;
}

export interface UserAccountModelDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  userId?: number;
  account?: CompanyAccountModelDto;
}

export interface UserAccountLimitModelDto {
  /** @format decimal */
  perTransactionLimit?: number;
  /** @format decimal */
  dailyLimit?: number;
}

export interface GetUserProductEntitlementsModelDto {
  productType?: string;
  userProductClaims?: UserClaimModelDto[];
  accountProductClaims?: ClaimModelDto[];
  accounts?: ProductAccountDto[];
}

export interface UserClaimModelDto {
  /** @format int32 */
  claimId?: number;
  claimName?: string;
  hasUserClaim?: boolean;
  hasPendingUserClaim?: boolean;
  claimDescription?: string;
}

export interface ClaimModelDto {
  /** @format int32 */
  claimId?: number;
  claimName?: string;
  claimDescription?: string;
}

export interface ProductAccountDto {
  /** @format int32 */
  id?: number;
  name?: string;
  number?: string;
  userAccountClaims?: UserClaimModelDto[];
}

export interface GetUserAchEntitlementsModelDto {
  achCompanies?: AchCompanyModelDto[];
  userAchCompanies?: AchCompanyModelDto[];
  userProductClaims?: UserClaimModelDto[];
}

export type AchCompanyModelDto = ModelBaseDto & {
  /** @minLength 1 */
  companyName: string;
  /** @minLength 1 */
  companyId: string;
  secCodes?: SecCodeModelDto[];
  /** @minLength 1 */
  entryDescription: string;
  /** @minLength 1 */
  discretionaryData: string;
  /** @format decimal */
  totalDailyLimit: number;
  /** @minLength 1 */
  notOnUsTransactionTypes: string;
  /** @minLength 1 */
  batchBalanceRequirements: string;
  /** @format int32 */
  onUsTransactionsRequired: number;
  /** @format decimal */
  onUsAmountRequiredPerBatch: number;
  isActive: boolean;
  /** @format int32 */
  prefundingDays?: number;
  offsetAccountNumber?: string;
  allowUnbalancedPayments?: boolean;
  /** @format guid */
  companyGuidUniqueId?: string;
};

export interface SecCodeModelDto {
  modelKind?: string;
  /** @minLength 1 */
  code: string;
  /** @minLength 1 */
  description: string;
}

export interface GetUserAchLimitsModelDto {
  userProductLimit?: UserProductLimitsModelDto;
  pendingUserProductLimit?: UserProductLimitsModelDto;
  userAchCompanies?: AchCompanyLimitModelDto[];
  /** @format decimal */
  productDailyLimit?: number;
}

export interface AchCompanyLimitModelDto {
  achCompany?: AchCompanyModelDto;
  userAchCompanyLimit?: CompanyLimitModelDto;
  pendingUserAchCompanyLimit?: CompanyLimitModelDto;
}

export interface CompanyLimitModelDto {
  /** @format decimal */
  perTransactionLimit?: number;
  /** @format decimal */
  dailyLimit?: number;
}

export interface SaveUserProductLimitsRequestModelDto {
  productType?: string;
  userProductLimit?: UserProductLimitsModelDto;
  pendingUserProductLimit?: UserProductLimitsModelDto;
  userAccountLimits?: AccountUserLimitModelDto[];
  /** @format decimal */
  productDailyLimit?: number;
  securityMessage?: SecurityMessageModelDto;
}

export interface SaveUserAchLimitsRequestModelDto {
  userProductLimit?: UserProductLimitsModelDto;
  pendingUserProductLimit?: UserProductLimitsModelDto;
  userAchCompanies?: AchCompanyLimitModelDto[];
  /** @format decimal */
  productDailyLimit?: number;
  securityMessage?: SecurityMessageModelDto;
}

export interface SaveUserProductEntitlementsModelDto {
  addedUserClaims?: number[];
  addedUserClaimAccounts?: Record<string, number[]>;
  removedUserClaims?: number[];
  removedUserClaimAccounts?: Record<string, number[]>;
  securityMessage?: SecurityMessageModelDto;
}

export interface SaveUserAchProductEntitlementsModelDto {
  achCompanies?: AchCompanyModelDto[];
  addedEntitlements?: UserProductEntitlementDto[];
  removedEntitlements?: UserProductEntitlementDto[];
  securityMessage?: SecurityMessageModelDto;
}

export interface UserProductEntitlementDto {
  account?: ProductAccountDto;
  claim?: ClaimModelDto;
}

export interface IpRestrictionModelDto {
  ipRestrictions?: IpRestrictionAddressModelDto[];
  ipRestrictionsPending?: IpRestrictionAddressModelDto[];
  /** @format int32 */
  userId?: number;
  restricted?: boolean;
  restrictedPending?: boolean;
}

export interface IpRestrictionAddressModelDto {
  /** @format int32 */
  id?: number;
  /** @format byte */
  octet1?: number;
  /** @format byte */
  octet2?: number;
  /** @format byte */
  octet3?: number;
  /** @format byte */
  octet4?: number;
  name?: string;
}

export type SaveUserIpAccessRequestModelDto = RequestResponseDto & {
  ipRestrictions?: IpRestrictionAddressModelDto[];
  securityMessage?: SecurityMessageModelDto;
};

export interface ElectronicDocumentSsoDto {
  useFormPost?: boolean;
  url?: string;
  formFields?: Record<string, string>;
  /** @format int32 */
  documentTypeId?: number;
  electronicDocumentServiceName?: string;
}

export interface ApprovalListModelDto {
  completedApprovals?: UserApprovalDto[];
  availableApprovers?: string[];
}

export interface UserApprovalDto {
  name?: string;
  /** @format date-time */
  dateApproved?: string;
}

export interface ApprovalListRequestModelDto {
  approvalEntity?: string;
  /** @format int32 */
  accountId?: number;
  /** @format decimal */
  amount?: number;
  /** @format int32 */
  createdBy?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format int32 */
  productId?: number;
}

export interface SsoPosPayUserSettingsModelDto {
  pendingSsoLoginId?: string;
  ssoLoginId?: string;
  userProductClaims?: UserClaimModelDto[];
}

export interface SaveSsoPosPayUserSettingsModelDto {
  settings?: SsoPosPayUserSettingsModelDto;
  securityMessage?: SecurityMessageModelDto;
}

export interface ReceivablesUserSettingsModelDto {
  pendingSsoAccessKey?: string;
  ssoAccessKey?: string;
  pendingSsoLoginId?: string;
  ssoLoginId?: string;
  userProductClaims?: UserClaimModelDto[];
  /** @format int32 */
  remoteDepositProductTypeId?: number;
}

export interface SaveReceivablesUserSettingsModelDto {
  settings?: ReceivablesUserSettingsModelDto;
  securityMessage?: SecurityMessageModelDto;
}

export interface ElectronicDocumentsModelDto {
  accounts?: CompanyAccountModelDto[];
  additionalSettings?: AdditionalElectronicDocumentSettingsModelDto;
}

export interface AdditionalElectronicDocumentSettingsModelDto {
  errorMessage?: string;
  noStatementMessage?: string;
  productDisplayName?: string;
  selectAccountLabel?: string;
}

export interface AdditionalSettingsModelDto {
  displayMethod?: string;
}

export interface CurrentUserTimeAccessDto {
  timeAccess?: TimeAccessDto;
}

export interface TimeAccessDto {
  timeRestricted?: boolean;
  userTimeAccessDays?: UserTimeAccessDayDto[];
}

export type SaveUserActivityRequestDto = BaseRequestDto & {
  /** @format date-time */
  activityDate?: string;
  activityMessage?: string;
  /** @format int32 */
  relatedId?: number;
  userActivityType?: UserActivityTypeDto;
};

export interface UisEnrollmentLinkResponseModelDto {
  uisEnrollmentLink?: string;
}

export interface UisEnrollmentLinkRequestModelDto {
  fiId?: string;
  treasuryEnrollmentId?: string;
  companyAlias?: string;
  userAlias?: string;
  returnUrl?: string;
}

export interface SaveUisUserEnrollmentDetailRequestModelDto {
  authCode?: string;
  fiId?: string;
  returnUrl?: string;
  state?: string;
}

export interface SsoViaUisResponseDto {
  statusCode?: string;
  message?: string;
  alias?: string;
  companyUniqueId?: string;
  digitalId?: string;
  userAccountSettingsLink?: string;
  userCompanyInformation?: UserCompanyInformationCollectionDto;
  errorMessage?: string;
}

export type UserCompanyInformationCollectionDto = UserCompanyInformationDto[];

export interface UserCompanyInformationDto {
  userAlias?: string;
  companyUniqueId?: string;
  companyName?: string;
  /** @format guid */
  userCompanyUniqueId?: string;
  digitalId?: string;
}

export interface InitiateSsoResponseDto {
  redirectTo?: string;
  formMarkup?: string;
  browserTarget?: string;
}

export interface InitiateSsoRequestDto {
  ssoUniqueId?: string;
}

export interface ProductTypeModelDto {
  content?: string;
  errorMessages?: any[];
}

export interface UserSsoResponseDto {
  userSsos?: UserSsoModelCollectionDto;
}

export type UserSsoModelCollectionDto = UserSsoModelDto[];

export interface UserSsoModelDto {
  ssoUniqueId?: string;
  ssoName?: string;
  parentMenuPath?: string;
}

export type BankModelDto = ModelBaseDto & {
  bankId?: string;
  bankIdType?: string;
  name?: string;
  /** @format int32 */
  addressId?: number;
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  postalCodeExtension?: string;
  country?: string;
  countryName?: string;
  isInternational?: boolean;
  notes?: string;
  onUs?: boolean;
  buildingNumber?: string;
  streetName?: string;
  department?: string;
  subDepartment?: string;
  postBox?: string;
  buildingName?: string;
  buildingFloor?: string;
  buildingRoom?: string;
  townLocationName?: string;
  districtName?: string;
};

export type BeneficiaryModelDto = SecurityBaseDto & {
  accountNumber?: string;
  name?: string;
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  countryName?: string;
  notes?: string;
  audit?: string;
  /** @format date-time */
  createdDate?: string;
  status?: string;
  /** @format int32 */
  numberOfApprovalsNeeded?: number;
  bank?: BankModelDto;
  intermediaryBanks?: IntermediaryBankModelDto[];
  isEdited?: boolean;
  isTemplateBeneficiary?: boolean;
  postalCodeExtension?: string;
  permissions?: ProductPermissionModelDto[];
  isInternational?: boolean;
  isUserApprovalLimitLess?: boolean;
  completedApprovals?: UserApprovalDto[];
  availableApprovers?: string[];
  /** @format int32 */
  completedApprovalCount?: number;
  isForeignCurrency?: boolean;
  currencyType?: string;
  isFreeForm?: boolean;
  buildingNumber?: string;
  streetName?: string;
  department?: string;
  subDepartment?: string;
  postBox?: string;
  buildingName?: string;
  buildingFloor?: string;
  buildingRoom?: string;
  townLocationName?: string;
  districtName?: string;
  isIsoCompliant?: boolean;
};

export type IntermediaryBankModelDto = BankModelDto & {
  accountNumber?: string;
  isDeleted?: boolean;
};

export type BeneficiarySearchCriteriaModelDto = ModelBaseDto & {
  beneficiaryType?: string;
  status?: string;
  beneficiaryName?: string;
  accountNumber?: string;
  bankId?: string;
  bankName?: string;
  country?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  createdDateStart?: string;
  /** @format date-time */
  createdDateEnd?: string;
  createdDateType?: string;
  requireEntitlement?: boolean;
};

export type DeleteBeneficiaryModelDto = SecurityBaseDto & {
  /** @format int32 */
  beneficiaryId?: number;
};

export type ApproveBeneficiaryModelDto = SecurityBaseDto & {
  /** @format int32 */
  beneficiaryId?: number;
  comments?: string;
};

export type CreditorModelDto = BeneficiaryModelDto & object;

export type SearchCreditorsRequestDto = BaseRequestDto & {
  beneficiaryType?: string;
  status?: string;
  beneficiaryName?: string;
  accountNumber?: string;
  bankId?: string;
  bankName?: string;
  country?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  createdDateStart?: string;
  /** @format date-time */
  createdDateEnd?: string;
  createdDateType?: string;
  requireEntitlement?: boolean;
};

export type WireCompanyModelDto = ModelBaseDto & {
  /** @minLength 1 */
  name: string;
  isDliWireCompany: boolean;
};

export interface WireConfigurationDto {
  fiDliProductEnabled?: boolean;
  fiDliUsdEnabled?: boolean;
  dliCompanyProductEnabled?: boolean;
  dliCompanyInternationalUsdEnabled?: boolean;
  requirePurposeDli?: boolean;
  fiWireProductEnabled?: boolean;
  fiInternationalUsdEnabled?: boolean;
  companyWireProductEnabled?: boolean;
  companyInternationalUsdEnabled?: boolean;
  /** @format int32 */
  maximumFutureDays?: number;
  requirePurpose?: boolean;
  useExternalFxWireProcessing?: boolean;
  useExternalFxQuoteRatesheets?: boolean;
}

export type WireModelDto = SecurityBaseDto & {
  /** @minLength 1 */
  transactionId: string;
  wireCompany: WireCompanyModelDto;
  debitAccount: CompanyAccountModelDto;
  /** @format decimal */
  amount: number;
  /** @minLength 1 */
  destinationCurrency: string;
  beneficiary: BeneficiaryModelDto;
  frequency: FrequencyModelDto;
  parentFrequency: FrequencyModelDto;
  additionalInformation?: LookupModelDto[];
  isInternational: boolean;
  isDliWire: boolean;
  /** @minLength 1 */
  status: string;
  /** @minLength 1 */
  audit: string;
  /** @format int32 */
  numberOfApprovalsNeeded: number;
  rateQuote?: RateQuoteModelDto;
  isUserApprovalLimitLess?: boolean;
  permissions?: ProductPermissionModelDto[];
  errorSummary?: ErrorSummaryModelDto;
  isEdited?: boolean;
  message?: string;
  messageType?: string;
  /** @minLength 1 */
  successMessage: string;
  /** @format date-time */
  createdDate?: string;
  purpose?: string;
  confirmationNumber?: string;
  completedApprovals?: UserApprovalDto[];
  availableApprovers?: string[];
  wireTemplate?: WireTemplateModelDto;
  createdBy?: string;
  source?: string;
  /** @format int32 */
  completedApprovalCount?: number;
  referenceBeneficiary?: string;
  /** @format int32 */
  wireFileId?: number;
  /** @format guid */
  wireFileUniqueId?: string;
  fileName?: string;
  duplicatePreventionId?: string;
};

export type FrequencyModelDto = ModelBaseDto & {
  repeatOn?: string;
  /** @format date-time */
  startOn?: string;
  /** @format date-time */
  endOn?: string;
  /** @format date-time */
  valueDate?: string;
  /** @format date-time */
  nextPaymentDate?: string;
  noEndDate?: boolean;
  /** @format int32 */
  repeatOnDay1?: number;
  /** @format int32 */
  repeatOnDay2?: number;
  repeatOnLastBusinessDay?: boolean;
  /** @minLength 1 */
  type: string;
  summary?: string;
};

export type RateQuoteModelDto = ModelBaseDto & {
  /** @minLength 1 */
  amexContractNumber: string;
  /** @format int32 */
  amexQuoteId?: number;
  /** @format decimal */
  originAmount: number;
  /** @format decimal */
  destinationAmount: number;
  /** @minLength 1 */
  destinationCurrencyCode: string;
  /**
   * @format date-time
   * @minLength 1
   */
  valueDate: string;
  /** @format decimal */
  wireFee: number;
  /** @format decimal */
  exchangeFee: number;
  /** @format decimal */
  totalCost: number;
  /** @format int32 */
  expirationTime: number;
  /** @format decimal */
  conversionRate: number;
};

export type ErrorSummaryModelDto = SecurityBaseDto & {
  type?: ErrorTypeModelDto;
  summaryMessage?: string;
  summaryMessageList?: string[];
  details?: ErrorDetailModelDto[];
};

export interface ErrorDetailModelDto {
  attributeName?: string;
  key?: string;
  type?: ErrorTypeModelDto;
  message?: string;
  messageList?: LookupModelDto[];
}

export type WireTemplateModelDto = ModelBaseDto & {
  name?: string;
  wireCompany: WireCompanyModelDto;
  debitAccount: CompanyAccountModelDto;
  beneficiary: BeneficiaryModelDto;
  purpose?: string;
  notes?: string[];
  isInternational: boolean;
  /** @minLength 1 */
  status: string;
  completedApprovals?: UserApprovalDto[];
  /** @format int32 */
  completedApprovalCount?: number;
  availableApprovers?: string[];
  /** @format int32 */
  numberOfApprovalsNeeded: number;
  errorSummary?: ErrorSummaryModelDto;
  isEdited?: boolean;
  permissions?: ProductPermissionModelDto[];
  audit?: string;
  isPendingEdit?: boolean;
  /** @minLength 1 */
  successMessage: string;
  initiatedRecurringWire?: boolean;
  referenceBeneficiary?: string;
  /** @format int32 */
  createdBy?: number;
};

export type WireSearchCriteriaModelDto = ModelBaseDto & {
  wireType?: string;
  wireCompanies?: WireCompanyModelDto[];
  statuses?: StatusModelModelDto[];
  debitAccounts?: CompanyAccountModelDto[];
  beneficiaryName?: string;
  transactionID?: string;
  omadNumber?: string;
  currency?: string;
  wireAmountType?: string;
  /** @format decimal */
  wireAmount?: number;
  /** @format decimal */
  wireAmountMin?: number;
  /** @format decimal */
  wireAmountMax?: number;
  valueDateType?: string;
  /** @format date-time */
  valueDate?: string;
  /** @format date-time */
  valueDateStart?: string;
  /** @format date-time */
  valueDateEnd?: string;
  createdDateType?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  createdDateStart?: string;
  /** @format date-time */
  createdDateEnd?: string;
  nextPaymentDateType?: string;
  /** @format date-time */
  nextPaymentDate?: string;
  /** @format date-time */
  nextPaymentDateStart?: string;
  /** @format date-time */
  nextPaymentDateEnd?: string;
  frequency?: LookupModelDto[];
  isDownloadReport?: boolean;
  /** @format int32 */
  wireFileId?: number;
  /** @format guid */
  wireFileUniqueId?: string;
  isWireTotalsRequired?: boolean;
};

export type StatusModelModelDto = ModelBaseDto & {
  name?: string;
};

export type CancelWireModelDto = SecurityBaseDto & {
  /** @format int32 */
  wireId?: number;
  comments?: string;
};

export type RequestQuoteModelDto = ModelBaseDto & {
  /** @minLength 1 */
  destinationCurrencyCode: string;
  /** @format decimal */
  amount: number;
  isAmountUSD: boolean;
};

export type WireListModelDto = SecurityBaseDto & {
  wires?: WireModelDto[];
  errorMessage?: string;
  successMessage?: string;
  errorSummary?: ErrorSummaryModelDto;
  bulkWireIds?: number[];
};

export type LookupListModelDto = SecurityBaseDto & {
  lookups?: LookupModelDto[];
};

export type CurrencyModelDto = ModelBaseDto & {
  currencyCode?: string;
  name?: string;
};

export type WireTemplateSearchModelDto = WireSearchCriteriaModelDto & {
  templateName?: string;
  wireCompanies?: WireCompanyModelDto[];
};

export type FileFormatModelDto = ModelBaseDto & {
  templateName?: string;
  fileFormatType?: string;
  fieldDelimiter?: string;
  /** @format int32 */
  headerRows?: number;
  /** @format int32 */
  footerRows?: number;
  fileFormatDetails?: FileFormatDetailModelDto[];
};

export type FileFormatDetailModelDto = ModelBaseDto & {
  fileFormatField?: string;
  /** @format int32 */
  order?: number;
  /** @format int32 */
  beginPosition?: number;
  /** @format int32 */
  endPosition?: number;
  additionalInformationOne?: string;
  additionalInformationTwo?: string;
  additionalInformationThree?: string;
  additionalInformationFour?: string;
};

export interface FileImportLayoutFieldModelDto {
  templateType?: string;
  fieldGroups?: FileFormatFieldGroupModelDto[];
}

export interface FileFormatFieldGroupModelDto {
  /** @format int32 */
  id?: number;
  name?: string;
  description?: string;
  info?: string;
  fields?: FileFormatFieldModelDto[];
}

export interface FileFormatFieldModelDto {
  /** @format int32 */
  id?: number;
  name?: string;
  description?: string;
  info?: string;
  required?: boolean;
  /** @format int32 */
  importFieldGroupId?: number;
}

export interface WireParseResultModelDto {
  fileErrors?: WireFileErrorDto[];
  wires?: WireModelDto[];
}

export interface WireFileErrorDto {
  /** @format int32 */
  lineNumber?: number;
  errorText?: string;
}

export interface PagedListModelWireFileModelDto {
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  maxPageSize?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalCount?: number;
  items?: WireFileModelDto[];
  /** @format int32 */
  recordCountInCurrentPage?: number;
}

export type WireFileModelDto = ModelBaseDto & {
  /** @format int32 */
  wireFileId?: number;
  fileName?: string;
  /** @format int32 */
  fileSize?: number;
  uploadedBy?: string;
  /** @format date-time */
  uploadDate?: string;
  /** @format decimal */
  amount?: number;
  /** @format int32 */
  totalWireCount?: number;
  /** @format int32 */
  batchCount?: number;
  /** @format int32 */
  approvedCount?: number;
  /** @format int32 */
  pendingCount?: number;
  /** @format int32 */
  rejectedCount?: number;
  /** @format int32 */
  expiredCount?: number;
  isValid?: boolean;
  isExpired?: boolean;
  isConfirmed?: boolean;
  /** @format guid */
  wireFileUniqueId?: string;
  processedBy?: string;
  /** @format date-time */
  processedDate?: string;
  contentData?: string;
  fileFormat?: string;
  isDuplicated?: boolean;
  /** @format guid */
  duplicatedWireFileUniqueId?: string;
};

export type WireFileSearchCriteriaModelDto = ModelBaseDto & {
  wireFileId?: string;
  /** @format guid */
  wireFileUniqueId?: string;
  fileName?: string;
  uploadedByIds?: number[];
  uploadDateType?: string;
  /** @format date-time */
  uploadDate?: string;
  /** @format date-time */
  uploadDateStart?: string;
  /** @format date-time */
  uploadDateEnd?: string;
  wireAmountType?: string;
  /** @format decimal */
  wireAmount?: number;
  /** @format decimal */
  wireAmountMin?: number;
  /** @format decimal */
  wireAmountMax?: number;
  pagingParameters?: PagingParametersModelDto;
  isDownloadReport?: boolean;
};

export interface PagingParametersModelDto {
  orderBys?: OrderByModelDto[];
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  pageNumber?: number;
  searchBys?: SearchByModelDto[];
}

export interface OrderByModelDto {
  descending?: boolean;
  name?: string;
}

export interface SearchByModelDto {
  name?: string;
  value?: string;
  secondValue?: string;
  searchType?: string;
  values?: TextKeyCollectionDto;
}

export interface WireProcessResultModelDto {
  fileErrors?: WireFileErrorDto[];
  wires?: WireModelDto[];
}

export interface WireSearchModelDto {
  searchResults?: WireModelDto[];
  totals?: WireTotalsModelDto[];
}

export interface WireTotalsModelDto {
  status?: string;
  /** @format int32 */
  count?: number;
  /** @format decimal */
  totalAmount?: number;
}

export interface StpModelDto {
  /** @format int32 */
  id?: number;
  account?: CompanyAccountModelDto;
  checkNumbers?: number[];
  /** @format date-time */
  checkDate?: string;
  /** @format double */
  checkAmount?: number;
  payee?: string;
  remarks?: string[];
  /** @format date-time */
  createdDate?: string;
  createdBy?: string;
  enteredBy?: string;
  /** @format date-time */
  expirationDate?: string;
  sequenceNumber?: string;
  status?: string;
  permissions?: ProductPermissionModelDto[];
  /** @format int32 */
  totalApprovalsRequired?: number;
  completedApprovals?: UserApprovalDto[];
  availableApprovers?: string[];
  /** @format int32 */
  completedApprovalCount?: number;
}

export interface StpSearchModelDto {
  accounts?: CompanyAccountModelDto[];
  statuses?: StatusModelModelDto[];
  checkNumberType?: string;
  checkNumber?: string;
  checkNumberEnd?: string;
  checkNumberStart?: string;
  checkAmountType?: string;
  /** @format decimal */
  checkAmount?: number;
  /** @format decimal */
  checkAmountEnd?: number;
  /** @format decimal */
  checkAmountStart?: number;
  checkDateType?: string;
  /** @format date-time */
  checkDate?: string;
  /** @format date-time */
  checkDateStart?: string;
  /** @format date-time */
  checkDateEnd?: string;
  createdDateType?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  createdDateStart?: string;
  /** @format date-time */
  createdDateEnd?: string;
  payee?: string;
}

export type InternalTransferTransactionModelDto = SecurityBaseDto & {
  transactionId?: string;
  /** @format date-time */
  lastEditedDate?: string;
  /**
   * @format date-time
   * @minLength 1
   */
  transferDate: string;
  /** @format decimal */
  amount: number;
  memo?: string;
  /** @minLength 1 */
  status: string;
  confirmationNumber?: string;
  batchId?: string;
  message?: string;
  messageType?: string;
  /** @format int32 */
  numberOfApprovalsNeeded?: number;
  comments?: string;
  isEdited?: boolean;
  fromAccount: CompanyAccountModelDto;
  toAccount: CompanyAccountModelDto;
  errorSummary?: ErrorSummaryModelDto;
  /** @format date-time */
  createdDate?: string;
  frequency?: string;
  frequencyDescription?: string;
  /** @format date-time */
  nextTransferDate?: string;
  /** @format date-time */
  endDate?: string;
  /** @format date-time */
  startDate?: string;
  audit?: InternalTransferAuditModelDto[];
  permissions?: ProductPermissionModelDto[];
  frequencyModel?: FrequencyModelDto;
  parentFrequencyModel?: FrequencyModelDto;
  completedApprovals?: UserApprovalDto[];
  availableApprovers?: string[];
  /** @format int32 */
  completedApprovalCount?: number;
  paymentOptionType?: string;
};

export interface InternalTransferAuditModelDto {
  /** @format date-time */
  date?: string;
  text?: string;
  comments?: string;
  createdBy?: string;
}

export type InternalTransferAddTransactionModelDto = ModelBaseDto & {
  batchId?: string;
  type?: string;
  errorSummary?: ErrorSummaryModelDto;
  securityMessage?: SecurityMessageModelDto;
  templateName?: string;
  /** @format int32 */
  templateId?: number;
  audit?: string;
  transactions?: InternalTransferAddTransactionDetailModelDto[];
};

export type InternalTransferAddTransactionDetailModelDto = ModelBaseDto & {
  /** @format date-time */
  transferDate?: string;
  /** @format decimal */
  amount?: number;
  memo?: string;
  fromAccount?: CompanyAccountModelDto;
  toAccount?: CompanyAccountModelDto;
  errorSummary?: ErrorSummaryModelDto;
  frequency?: FrequencyModelDto;
  status?: string;
  transactionId?: string;
  paymentOptionType?: LoanPaymentOptionTypeEnumDto;
};

export interface InternalTransferTransactionFilterModelDto {
  /** @format date-time */
  transferDateFrom?: string;
  /** @format date-time */
  transferDateTo?: string;
  accountOperator?: string;
  /** @format decimal */
  fromAmount?: number;
  /** @format decimal */
  toAmount?: number;
  transactionId?: string;
  /** @format date-time */
  createdDateFrom?: string;
  /** @format date-time */
  createdDateTo?: string;
  transferDateOperator?: string;
  amountOperator?: string;
  createdDateOperator?: string;
  status?: LookupModelDto[];
  fromAccounts?: CompanyAccountModelDto[];
  toAccounts?: CompanyAccountModelDto[];
  bothAccounts?: CompanyAccountModelDto[];
  batchId?: string;
  paymentOptionType?: LookupModelDto[];
}

export interface RecurringInternalTransferFilterModelDto {
  status?: LookupModelDto[];
  accountOperator?: string;
  fromAccounts?: CompanyAccountModelDto[];
  toAccounts?: CompanyAccountModelDto[];
  bothAccounts?: CompanyAccountModelDto[];
  transactionId?: string;
  frequency?: LookupModelDto[];
  amountType?: string;
  /** @format decimal */
  amountSpecific?: number;
  /** @format decimal */
  amountStart?: number;
  /** @format decimal */
  amountEnd?: number;
  nextTransferDateType?: string;
  /** @format date-time */
  nextTransferDateSpecific?: string;
  /** @format date-time */
  nextTransferDateStart?: string;
  /** @format date-time */
  nextTransferDateEnd?: string;
  createdDateType?: string;
  /** @format date-time */
  createdDateSpecific?: string;
  /** @format date-time */
  createdDateStart?: string;
  /** @format date-time */
  createdDateEnd?: string;
}

export type CancelTransferModelDto = SecurityBaseDto & {
  /** @format int32 */
  internalTransferId?: number;
  comments?: string;
};

export type InternalTransferBatchModelDto = SecurityBaseDto & {
  internalTransfers?: InternalTransferTransactionModelDto[];
  comments?: string;
  successMessage?: string;
  errorMessage?: string;
};

export interface InternalTransferTemplateFilterModelDto {
  templateName?: string;
  transferType?: LookupModelDto[];
  amountOperator?: string;
  /** @format decimal */
  amountStart?: number;
  /** @format decimal */
  amountEnd?: number;
  /** @format decimal */
  amountSpecific?: number;
  status?: LookupModelDto[];
  fromAccounts?: CompanyAccountModelDto[];
  toAccounts?: CompanyAccountModelDto[];
  bothAccounts?: CompanyAccountModelDto[];
  accountOperator?: string;
}

export type InternalTransferTemplateDetailModelDto = ModelBaseDto & {
  templateName?: string;
  transferFromAccount?: string;
  transferToAccount?: string;
  fromAccount?: CompanyAccountModelDto;
  toAccount?: CompanyAccountModelDto;
  memo?: string;
  audit?: string;
  transferType?: string;
  /** @format decimal */
  totalTransferAmount?: number;
  status?: string;
  templateTransferInfo?: CompanyAccountModelDto[];
  completedApprovals?: UserApprovalDto[];
  availableApprovers?: string[];
  /** @format int32 */
  completedApprovalCount?: number;
  /** @format int32 */
  numberOfApprovalsNeeded?: number;
  permissions?: ProductPermissionModelDto[];
};

export type InternalTransferTemplateModelDto = ModelBaseDto & {
  templateName?: string;
  transferType?: string;
  fromAccount?: CompanyAccountModelDto;
  toAccount?: CompanyAccountModelDto;
  /** @format decimal */
  amount?: number;
  status?: string;
  memo?: string;
  /** @format int32 */
  numberOfApprovalsNeeded?: number;
  completedApprovals?: UserApprovalDto[];
  availableApprovers?: string[];
  /** @format int32 */
  completedApprovalCount?: number;
  internalTransferTemplateDetails?: InternalTransferTemplateDetailModelDto[];
  permissions?: ProductPermissionModelDto[];
  isPendingApproval?: boolean;
  /** @format int32 */
  createdBy?: number;
};

export interface BillPaySsoDto {
  sessionId?: string;
  url?: string;
}

export interface GetInstitutionResponseModelDto {
  institution?: InstitutionModelDto;
}

export interface InstitutionModelDto {
  /** @format date-time */
  cutoff?: string;
  nonProcessingDays?: string[];
  paymentDateModel?: PaymentDateModelDto;
}

export interface GetPayeeResponseModelDto {
  payee?: PayeeModelDto;
}

export interface PayeeModelDto {
  account?: AccountModelBillPayDto;
  address?: AddressModelDto;
  defaultPayFromAccount?: AccountModelBillPayDto;
  email?: string;
  /** @format int32 */
  estimatedArrivalDay?: number;
  /** @format date-time */
  firstAvailableEstimatedArrivalDate?: string;
  /** @format date-time */
  firstAvailableProcessDate?: string;
  id?: string;
  keyword?: string;
  name?: string;
  nickName?: string;
  paymentMethod?: PaymentMethodDto;
  phoneNumber?: string;
  status?: PayeeStatusDto;
}

export interface AccountModelBillPayDto {
  accountNumber?: string;
  accountType?: AccountType2Dto;
  id?: string;
  name?: string;
  routingNumber?: string;
}

export interface AddressModelDto {
  city?: string;
  country?: string;
  line1?: string;
  line2?: string;
  postalCode?: string;
  state?: string;
}

export interface GetPaymentsResponseModelDto {
  payments?: PaymentModelDto[];
}

export interface PaymentModelDto {
  /** @format decimal */
  amount?: number;
  comment?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  estimatedArrivalDate?: string;
  fromAccount?: AccountModelBillPayDto;
  id?: string;
  payee?: PayeeSummaryModelDto;
  paymentMethod?: PaymentMethodDto;
  paymentType?: PaymentTypeDto;
  /** @format date-time */
  processDate?: string;
  recurrence?: PaymentRecurrenceModelDto;
  status?: PaymentStatusDto;
}

export interface PayeeSummaryModelDto {
  id?: string;
  name?: string;
  nickName?: string;
  paymentMethod?: PaymentMethodDto;
}

export interface PaymentRecurrenceModelDto {
  dayOfWeek?: DayOfWeekDto;
  /** @format date-time */
  expirationDate?: string;
  frequency?: PaymentFrequencyDto;
  isFinite?: boolean;
  /** @format int32 */
  occurrenceCount?: number;
  paymentDays?: PaymentDayModelDto[];
  /** @format date-time */
  startEstimatedArrivalDate?: string;
  /** @format date-time */
  startProcessDate?: string;
}

export interface PaymentDayModelDto {
  /** @format int32 */
  dayOfMonth?: number;
  useLastBusinessDay?: boolean;
}

export interface AddPaymentResponseModelDto {
  errorSummary?: ErrorSummaryModelDto;
  payment?: PaymentModelDto;
  paymentSucceeded?: boolean;
  canOverrideErrors?: boolean;
}

export interface AddBillPayPaymentRequestModelDto {
  /** @format decimal */
  amount?: number;
  comment?: string;
  /** @format date-time */
  estimatedArrivalDate?: string;
  payeeId?: string;
  payFromAccountId?: string;
  /** @format date-time */
  processDate?: string;
  recurrence?: PaymentRecurrenceModelDto;
  overrideErrors?: boolean;
}

export interface GetPaymentResponseModelDto {
  futurePayments?: FuturePaymentModelDto[];
  payment?: PaymentModelDto;
}

export interface FuturePaymentModelDto {
  /** @format date-time */
  actualProcessDate?: string;
  id?: string;
  status?: PaymentStatusDto;
}

export interface GetAccountsResponseModelDto {
  payFromAccounts?: AccountModelBillPayDto[];
}

export interface UpdatePaymentResponseModelDto {
  errorSummary?: ErrorSummaryModelDto;
  payment?: PaymentModelDto;
  updateSucceeded?: boolean;
}

export interface UpdatePaymentRequestModelDto {
  delete?: boolean;
  deleteRecurrence?: boolean;
  futurePaymentId?: string;
  paymentId?: string;
  skipFuturePayment?: boolean;
}

export interface GetUserResponseModelDto {
  user?: UserModelBillPayDto;
}

export interface UserModelBillPayDto {
  access?: BillPayAccessDto;
  accessMessage?: string;
  id?: string;
  permissions?: PermissionModelDto[];
}

export interface PermissionModelDto {
  code?: string;
  value?: string;
}

export interface ApproveAchFiltersResponseModelDto {
  success?: boolean;
  securityMessage?: SecurityMessageModelDto;
}

export interface ApproveAchFiltersRequestModelDto {
  achFilterUniqueIds: string[];
  comment?: string;
  securityMessage?: SecurityMessageModelDto;
}

export interface DeleteAchFiltersResponseModelDto {
  success?: boolean;
  securityMessage?: SecurityMessageModelDto;
}

export interface DeleteAchFiltersRequestModelDto {
  achFilterUniqueIds: string[];
  securityMessage?: SecurityMessageModelDto;
}

export interface RejectAchFiltersResponseModelDto {
  success?: boolean;
  securityMessage?: SecurityMessageModelDto;
}

export interface RejectAchFiltersRequestModelDto {
  achFilterIds: string[];
  comment?: string;
  securityMessage?: SecurityMessageModelDto;
}

export type AccountModelCollectionDto = AccountModelAchFiltersDto[];

export interface AccountModelAchFiltersDto {
  /** @format guid */
  accountUniqueId?: string;
  accountNickname?: string;
  accountNumber?: string;
  accountType?: string;
  claims?: TextKeyCollectionDto;
}

export interface AchFilterAccountMasterSettingsModelDto {
  creditDefaultAllowType?: string;
  debitDefaultAllowType?: string;
}

export type AchFilterAuditHistoryModelCollectionDto = AchFilterAuditHistoryModelDto[];

export interface AchFilterAuditHistoryModelDto {
  /** @format guid */
  achFilterUniqueId?: string;
  auditEvents?: AchFilterAuditEventModelCollectionDto;
}

export type AchFilterAuditEventModelCollectionDto = AchFilterAuditEventModelDto[];

export interface AchFilterAuditEventModelDto {
  /** @format int32 */
  achFilterAuditEventId?: number;
  /** @format date-time */
  actionDate?: string;
  action?: string;
  actionUsername?: string;
  editedFields?: string[];
}

export interface AchFilterAuditHistoryRequestModelDto {
  achFilterUniqueIds?: string[];
}

export interface AchFiltersSearchRequestModelDto {
  accountUniqueIds?: string[];
  achCompanyId?: string;
  achCompanyName?: string;
  /** @format decimal */
  amountEnd?: number;
  /** @format decimal */
  amountStart?: number;
  pagingParameters?: PagingParametersModelDto;
  routingNumbers?: string[];
  secCodes?: string[];
  statuses?: string[];
  transactionTypes?: string[];
}

export interface SaveAchFiltersResponseModelDto {
  /** @format guid */
  achFilterUniqueId?: string;
  securityMessage?: SecurityMessageModelDto;
}

export interface SaveAchFiltersRequestModelDto {
  /** @format guid */
  achFilterUniqueId?: string;
  /** @format guid */
  accountUniqueId?: string;
  /** @minLength 1 */
  achCompanyId: string;
  /**
   * @minLength 0
   * @maxLength 16
   */
  achCompanyName?: string;
  /** @minLength 1 */
  allowType: string;
  /** @format date-time */
  expirationDate?: string;
  /**
   * @minLength 0
   * @maxLength 30
   */
  filterRuleName?: string;
  /** @format decimal */
  fromAmount?: number;
  /**
   * @minLength 0
   * @maxLength 50
   */
  remarks?: string;
  /**
   * @minLength 3
   * @maxLength 3
   */
  secCode?: string;
  /** @format decimal */
  toAmount?: number;
  /** @minLength 1 */
  transactionType: string;
  /** @minLength 1 */
  accountNumber: string;
  /** @minLength 1 */
  accountType: string;
  nickName?: string;
  routingNumber?: string;
  securityMessage?: SecurityMessageModelDto;
}

export interface ValidateSaveAchFilterRequestRequestModelDto {
  saveAchFiltersRequest: SaveAchFiltersRequestModelDto;
  securityMessage?: SecurityMessageModelDto;
}

export type AchFilterUserModelCollectionDto = AchFilterUserModelDto[];

export interface AchFilterUserModelDto {
  /** @format guid */
  userUniqueId?: string;
  name?: string;
  alias?: string;
}

export type ArpExceptionDetailDataModelDto = ModelBaseDto & {
  accountNumber?: string;
  /** @format decimal */
  amount?: number;
  /** @format int32 */
  arpExceptionDetailId?: number;
  checkImageNumber?: string;
  checkNumber?: string;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  date?: string;
  ddaBatchNumber?: string;
  ddaSequenceNumber?: string;
  decisionHistory?: boolean;
  decisionTaken?: string;
  description?: string;
  exceptionsReason?: string;
  fiId?: string;
  fromWorkStation?: string;
  /** @format decimal */
  issuedAmount?: number;
  /** @format date-time */
  issuedDate?: string;
  issuedPayee?: string;
  lastDecisionBy?: string;
  /** @format date-time */
  lastDecisionDate?: string;
  /** @format decimal */
  paidAmount?: number;
  pay?: boolean;
  posPayItemId?: string;
  protected?: string;
  /** @format date-time */
  postDate?: string;
  sourceOfEntry?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  /** @format guid */
  returnReasonUniqueId?: string;
  /** @format guid */
  arpExceptionDetailUniqueId?: string;
  decisions?: ArpExceptionDetailDecisionModelDto[];
};

export interface ArpExceptionDetailDecisionModelDto {
  /** @format int32 */
  arpExceptionDetailDecisionId?: number;
  /** @format int32 */
  arpExceptionDetailId?: number;
  decisionBy?: string;
  decisionStatus?: string;
  /** @format date-time */
  decisionDate?: string;
  /** @format date-time */
  createdDate?: string;
  arpExceptionDetail?: ArpExceptionDetailModelDto;
}

export interface ArpExceptionDetailModelDto {
  /** @format int32 */
  arpExceptionDetailId?: number;
  accountNumber?: string;
  checkNumber?: string;
  checkImageNumber?: string;
  decisionTaken?: string;
  /** @format date-time */
  decisionDate?: string;
  /** @format decimal */
  issuedAmount?: number;
  /** @format decimal */
  paidAmount?: number;
  /** @format date-time */
  issuedDate?: string;
  issuedPayee?: string;
  exceptionsReason?: string;
  pay?: boolean;
  fromWorkStation?: string;
  sourceOfEntry?: string;
  protected?: string;
  ddaBatchNumber?: string;
  ddaSequenceNumber?: string;
  posPayItemId?: string;
  /** @format date-time */
  postedDate?: string;
  transactionId?: string;
  decisions?: ArpExceptionDetailDecisionModelDto[];
}

export type ArpExceptionViewModelDto = ModelBaseDto & {
  arpExceptions?: ArpExceptionModelDto[];
  arpExceptionDetails?: ArpExceptionDetailDataModelDto[];
  hasEtlRunSuccessfully?: boolean;
};

export type ArpExceptionModelDto = ModelBaseDto & {
  account?: AccountModelDto;
  accountNumber?: string;
  /** @format decimal */
  amount?: number;
  /** @format int32 */
  arpExceptionDetailId?: number;
  checkNumber?: string;
  checkImageNumber?: string;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  date?: string;
  description?: string;
  fiId?: string;
  /** @format decimal */
  issuedAmount?: number;
  /** @format decimal */
  paidAmount?: number;
  /** @format date-time */
  issuedDate?: string;
  /** @format date-time */
  postedDate?: string;
  payee?: string;
  reason?: string;
  pay?: boolean;
  decisionTaken?: string;
  /** @format date-time */
  decisionDate?: string;
  decisionHistory?: boolean;
  fromWorkstation?: string;
  sourceOfEntry?: string;
  protected?: string;
  ddaBatchNumber?: string;
  ddaSequenceNumber?: string;
  posPayItemId?: string;
  transactionId?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  decisions?: ArpExceptionDetailDecisionModelDto[];
};

export interface ArpExceptionSearchModelDto {
  type?: string;
  accounts?: AccountModelDto[];
  checkNumber?: string;
  issuedAmountType?: string;
  issuedAmountStart?: string;
  issuedAmountEnd?: string;
  issuedAmount?: string;
  paidAmountType?: string;
  paidAmountStart?: string;
  paidAmountEnd?: string;
  paidAmount?: string;
  issuedDateRangeType?: string;
  issuedDateStart?: string;
  issuedDateEnd?: string;
  issuedDate?: string;
  postedDateRangeType?: string;
  postedDateStart?: string;
  postedDateEnd?: string;
  postedDate?: string;
  payee?: string;
  decisionTaken?: string;
}

export type AchExceptionFilterModelDto = ModelBaseDto & {
  accountNumber?: string;
  allowAllDebits?: string;
  allowAllCredits?: string;
  achCompanyName?: string;
  companyId?: string;
  secCode?: string;
  /** @format decimal */
  amountFrom?: number;
  /** @format decimal */
  amountTo?: number;
  debitOrCredit?: string;
  exceptionFilter?: string;
  /** @format date-time */
  expirationDate?: string;
};

export interface AchExceptionFiltersSearchModelDto {
  accounts?: AccountModelDto[];
  achCompanyName?: string;
  achCompanyId?: string;
  secCodes?: SecCodeModelDto[];
  amountType?: string;
  /** @format decimal */
  amountStart?: number;
  /** @format decimal */
  amountEnd?: number;
  /** @format decimal */
  amount?: number;
  expirationDateType?: string;
  /** @format date-time */
  expirationDateStart?: string;
  /** @format date-time */
  expirationDateEnd?: string;
  /** @format date-time */
  expirationDate?: string;
  expirationFilter?: string;
}

export interface ArpOutputFileSearchModelDto {
  accounts?: AccountModelDto[];
  fileName?: string;
  fileReceivedDateType?: string;
  fileReceivedDateStart?: string;
  fileReceivedDateEnd?: string;
  fileReceivedDate?: string;
}

export type AchExceptionModelDto = ModelBaseDto & {
  account?: AccountModelDto;
  /** @format int32 */
  achExceptionDetailId?: number;
  /** @format int32 */
  achExceptionDecisionStatusId?: number;
  issuingCompany?: string;
  type?: string;
  secCode?: string;
  /** @format decimal */
  amount?: number;
  description?: string;
  pay?: boolean;
  itemId?: string;
  priorDecision?: string;
  protected?: string;
};

export interface AchExceptionSearchModelDto {
  accounts?: AccountModelDto[];
  achCompanies?: AchCompanyModelDto[];
  secCodes?: SecCodeModelDto[];
  amountType?: string;
  amountStart?: string;
  amountEnd?: string;
  amount?: string;
  type?: string;
  postedDateRangeType?: string;
  postedDateStart?: string;
  postedDateEnd?: string;
  postedDate?: string;
  decisionStatus?: string;
  entryDescription?: string;
}

export type AchExceptionViewModelDto = ModelBaseDto & {
  achExceptions?: AchExceptionModelDto[];
  achExceptionDetails?: AchExceptionDetailDataModelDto[];
  posPayExceptionEtlFiRuntimeStats?: PosPayExceptionEtlFiRuntimeStatsModelDto;
};

export type AchExceptionDetailDataModelDto = ModelBaseDto & {
  /** @format int32 */
  achExceptionDetailId?: number;
  /** @format int32 */
  accountId?: number;
  accountName?: string;
  accountNumber?: string;
  accountType?: string;
  /** @format decimal */
  amount?: number;
  batchNumber?: string;
  /** @format int32 */
  companyId?: number;
  companyName?: string;
  achCompanyName?: string;
  achCompanyId?: string;
  decisionBy?: string;
  /** @format date-time */
  decisionDate?: string;
  /** @format date-time */
  postedDate?: string;
  /** @format int32 */
  achExceptionDecisionStatusId?: number;
  entryDescription?: string;
  exceptionType?: string;
  exceptionItemId?: string;
  fromWorkStation?: string;
  secCode?: string;
  protected?: string;
};

export type PosPayExceptionEtlFiRuntimeStatsModelDto = ModelBaseDto & {
  hasEtlRunSuccessfully?: boolean;
  hasStartTimeOccurred?: boolean;
  hasEndTimeOccurred?: boolean;
  isEndOfDayRunning?: boolean;
  /** @format duration */
  timeUntilStartTime?: string;
  /** @format duration */
  timeUntilEndTime?: string;
};

export interface AchExceptionDetailSearchModelDto {
  accounts?: AccountModelDto[];
  amountType?: string;
  /** @format decimal */
  amountStart?: number;
  /** @format decimal */
  amountEnd?: number;
  /** @format decimal */
  amount?: number;
  achExceptionDecisionStatus?: string;
  secCodes?: SecCodeModelDto[];
  description?: string;
  postedDateType?: string;
  /** @format date-time */
  postedDate?: string;
  /** @format date-time */
  postedDateStart?: string;
  /** @format date-time */
  postedDateEnd?: string;
  searchType?: string;
}

export interface PagedListModelAchExceptionDetailDataModelDto {
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  maxPageSize?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalCount?: number;
  items?: AchExceptionDetailDataModelDto[];
  /** @format int32 */
  recordCountInCurrentPage?: number;
}

export interface AchExceptionsDecisionsActivityRequestModelDto {
  pagingParameters?: PagingParametersModelDto;
  achExceptionDetailSearchModel?: AchExceptionDetailSearchModelDto;
  searchText?: string;
  searchAccountNickname?: boolean;
  /** @format date-time */
  previousBusinessDayCutoff?: string;
  /** @format date-time */
  currentBusinessDayCutoff?: string;
}

export interface SaveAchExceptionDetailResponseModelDto {
  /** @format int32 */
  totalDecisionsCount?: number;
  /** @format int32 */
  failedDecisionsCount?: number;
  failedAchExceptions?: AchExceptionDetailModelDto[];
}

export type AchExceptionDetailModelDto = ModelBaseDto & {
  accountId?: string;
  achCompanyName?: string;
  accountNumber?: string;
  accountType?: string;
  /** @format decimal */
  amount?: number;
  batchNumber?: string;
  decisionBy?: string;
  /** @format int32 */
  achExceptionDecisionStatusId?: number;
  /** @format date-time */
  decisionDate?: string;
  exceptionItemId?: string;
  exceptionReason?: string;
  exceptionType?: string;
  entryDescription?: string;
  fromWorkStation?: string;
  /** @format int32 */
  institutionId?: number;
  /** @format date-time */
  postedDate?: string;
  secCode?: string;
  sourceOfEntry?: string;
};

export type ArpSecCodeModelCollectionDto = ArpSecCodeModelDto[];

export interface ArpSecCodeModelDto {
  secCode?: string;
  description?: string;
}

export type ArpSavedFormatModelDto = ModelBaseDto & {
  name?: string;
  type?: string;
  /** @format int32 */
  itemNumberOrder?: number;
  /** @format int32 */
  itemNumberBegin?: number;
  /** @format int32 */
  itemNumberEnd?: number;
  /** @format int32 */
  itemAmountOrder?: number;
  /** @format int32 */
  itemAmountBegin?: number;
  /** @format int32 */
  itemAmountEnd?: number;
  itemAmountFormat?: string;
  itemAmountDecimal?: boolean;
  /** @format int32 */
  issueDateOrder?: number;
  /** @format int32 */
  issueDateBegin?: number;
  /** @format int32 */
  issueDateEnd?: number;
  issueDateFormat?: string;
  /** @format int32 */
  payeeOrder?: number;
  /** @format int32 */
  payeeBegin?: number;
  /** @format int32 */
  payeeEnd?: number;
  /** @format int32 */
  accountNumberOrder?: number;
  /** @format int32 */
  accountNumberBegin?: number;
  /** @format int32 */
  accountNumberEnd?: number;
  /** @format int32 */
  accountTypeOrder?: number;
  /** @format int32 */
  accountTypeBegin?: number;
  /** @format int32 */
  accountTypeEnd?: number;
  accountTypeCheckingEquals?: string;
  accountTypeSavingsEquals?: string;
  /** @format int32 */
  voidDateOrder?: number;
  /** @format int32 */
  voidDateBegin?: number;
  /** @format int32 */
  voidDateEnd?: number;
  voidDateFormat?: string;
  /** @format int32 */
  voidIndicatorOrder?: number;
  /** @format int32 */
  voidIndicatorBegin?: number;
  /** @format int32 */
  voidIndicatorEnd?: number;
  voidYesIndicator?: string;
  textQualifier?: string;
  fieldDelimiter?: string;
  /** @format int32 */
  headerRows?: number;
  /** @format int32 */
  footerRows?: number;
};

export interface ArpIssuedItemModelDto {
  account?: CompanyAccountModelDto;
  /** @format decimal */
  checkAmount?: number;
  checkNumber?: string;
  /** @format date-time */
  dateIssued?: string;
  /** @format date-time */
  voidDate?: string;
  /** @format date-time */
  postDate?: string;
  /** @format date-time */
  createdDate?: string;
  errorSummary?: ErrorSummaryModelDto;
  /** @format int32 */
  index?: number;
  itemStatus?: string;
  isUploaded?: boolean;
  payee?: string;
  status?: string;
  type?: string;
  entryType?: string;
  auditItems?: ArpIssuedItemAuditModelDto[];
  filename?: string;
}

export interface ArpIssuedItemAuditModelDto {
  /** @format date-time */
  createdFiDateTime?: string;
  createdByUserName?: string;
  action?: string;
}

export interface ArpParseResultsModelDto {
  fileErrors?: ArpFileErrorDto[];
  issuedItems?: ArpIssuedItemModelDto[];
  isRetryable?: boolean;
  /** @format guid */
  issuedItemFileUniqueId?: string;
}

export interface ArpFileErrorDto {
  /** @format int32 */
  lineNumber?: number;
  errorText?: string;
}

export interface ArpModelDto {
  /** @deprecated */
  account?: CompanyAccountModelDto;
  issuedFileName?: string;
  issuedItems?: ArpIssuedItemModelDto[];
}

export interface IssuedItemSearchModelDto {
  accounts?: AccountModelDto[];
  /** @format int64 */
  checkNumber?: number;
  itemEntryType?: string;
  itemType?: string;
  payee?: string;
  issuedDateStart?: string;
  issuedDateEnd?: string;
  createdDateStart?: string;
  createdDateEnd?: string;
  voidDateStart?: string;
  voidDateEnd?: string;
  clearedDateStart?: string;
  clearedDateEnd?: string;
  amountStart?: string;
  amountEnd?: string;
  statusNames?: string[];
  entryTypes?: string[];
  isPortrait?: boolean;
}

export interface ArpIssuedItemEditModelDto {
  /** @format guid */
  accountReconItemDetailUniqueId?: string;
  account?: CompanyAccountModelDto;
  /** @format decimal */
  checkAmount?: number;
  checkNumber?: string;
  /** @format date-time */
  dateIssued?: string;
  /** @format date-time */
  voidDate?: string;
  /** @format date-time */
  postDate?: string;
  /** @format date-time */
  createdDate?: string;
  errorSummary?: ErrorSummaryModelDto;
  /** @format int32 */
  index?: number;
  itemStatus?: string;
  isUploaded?: boolean;
  payee?: string;
  status?: string;
  type?: string;
  entryType?: string;
  auditItems?: ArpIssuedItemAuditDetailModelDto[];
  userActions?: UserActionDto[];
  newPayee?: string;
  newCheckNumber?: string;
  /** @format decimal */
  newCheckAmount?: number;
  /** @format date-time */
  newDateIssued?: string;
  isPaidItemWithoutIssue?: boolean;
}

export interface ArpIssuedItemAuditDetailModelDto {
  /** @format date-time */
  createdFiDateTime?: string;
  createdByUserName?: string;
  action?: string;
  oldValue?: string;
  newValue?: string;
}

export interface UserActionDto {
  userActionName?: string;
  /** @format int32 */
  userActionId?: number;
}

export interface CheckExceptionIssuedItemSearchModelDto {
  arpExceptionDetailUniqueIds?: GuidKeyCollectionDto;
  /** @format int32 */
  companyId?: number;
  checkNumber?: string;
  itemEntryType?: string;
  itemType?: string;
  payee?: string;
  issuedDateStart?: string;
  issuedDateEnd?: string;
  createdDateStart?: string;
  createdDateEnd?: string;
  voidDateStart?: string;
  voidDateEnd?: string;
  clearedDateStart?: string;
  clearedDateEnd?: string;
  amountStart?: string;
  amountEnd?: string;
  paidAmountStart?: string;
  paidAmountEnd?: string;
  /** @format int64 */
  batchNumber?: number;
  /** @format int64 */
  sequenceNumber?: number;
}

export interface ArpEditModelDto {
  /** @deprecated */
  account?: CompanyAccountModelDto;
  issuedFileName?: string;
  issuedItems?: ArpIssuedItemModelDto[];
  editIssuedItems?: ArpIssuedItemEditModelDto[];
}

export interface InstitutionPosPayAchExceptionsCutOffTimesModelDto {
  /** @format date-time */
  previousBusinessDayCutoff?: string;
  /** @format date-time */
  currentBusinessDayCutoff?: string;
  /** @format date-time */
  currentBusinessDayStartTime?: string;
  /** @format date-time */
  fiLocalTime?: string;
  institutionName?: string;
  hasEtlRunSuccessfully?: boolean;
}

export type GetCreatedByUsersForIssuedItemFilesResponseDto = BaseResponseDto & {
  createdByUsers?: IssuedItemFileCreatedByUserCollectionDto;
};

export type IssuedItemFileCreatedByUserCollectionDto = IssuedItemFileCreatedByUserDto[];

export interface IssuedItemFileCreatedByUserDto {
  /** @format guid */
  userUniqueId?: string;
  name?: string;
}

export interface PagedListModelIssuedItemFileDto {
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  maxPageSize?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalCount?: number;
  items?: IssuedItemFileDto[];
  /** @format int32 */
  recordCountInCurrentPage?: number;
}

export interface IssuedItemFileDto {
  /** @format guid */
  issuedItemFileUniqueId?: string;
  fileName?: string;
  /** @format int32 */
  fileSize?: number;
  /** @format guid */
  uploadedByUserUniqueId?: string;
  uploadedByUserName?: string;
  /** @format date-time */
  uploadedDate?: string;
  /** @format double */
  totalIssueAmount?: number;
  /** @format int32 */
  totalIssueCount?: number;
  /** @format double */
  totalVoidAmount?: number;
  /** @format int32 */
  totalVoidCount?: number;
  /** @format double */
  totalItemAmount?: number;
  /** @format int32 */
  totalItemCount?: number;
  deleted?: boolean;
  /** @format int32 */
  fileFormatTypeId?: number;
  /** @format date-time */
  processedDate?: string;
  /** @format int32 */
  processedBy?: number;
  /** @format guid */
  processedByUserUniqueId?: string;
  processedByUserName?: string;
  canView?: boolean;
  canProcess?: boolean;
  canDelete?: boolean;
  isFileContentInvalid?: boolean;
}

export type SearchIssuedItemFilesActivityRequestDto = BaseRequestDto & {
  pagingParameters?: PagingParametersModelDto;
};

export type SearchIssuedItemFileDetailsResponseDto = BaseResponseDto & {
  issuedItemFile?: IssuedItemFileDto;
  issuedItemFileDetails?: PagedListModelIssuedItemFileDetailDto;
};

export interface PagedListModelIssuedItemFileDetailDto {
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  maxPageSize?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalCount?: number;
  items?: IssuedItemFileDetailDto[];
  /** @format int32 */
  recordCountInCurrentPage?: number;
}

export interface IssuedItemFileDetailDto {
  /** @format guid */
  uniqueId?: string;
  actionTaken?: FileDetailActionTakenTypeDto;
  /** @format date-time */
  createdDate?: string;
  itemType?: IssuedItemTypeDto;
  originalItemType?: IssuedItemTypeDto;
  /** @format date-time */
  issuedDate?: string;
  /** @format date-time */
  originalIssuedDate?: string;
  isIssuedDateModified?: boolean;
  /** @format date-time */
  checkVoidDate?: string;
  accountDisplay?: string;
  originalAccountDisplay?: string;
  /** @format double */
  amount?: number;
  /** @format double */
  originalAmount?: number;
  /** @format int64 */
  checkNumber?: number;
  /** @format int64 */
  originalCheckNumber?: number;
  payee?: string;
  originalPayee?: string;
  isIssuedItemSaved?: boolean;
}

export type SearchIssuedItemFileDetailsRequestDto = BaseRequestDto & {
  /** @format guid */
  issuedItemFileUniqueId?: string;
  pagingParameters?: PagingParametersModelDto;
};

export interface IssuedItemFileModelDto {
  filename?: string;
  fileContent?: string;
  /** @format int32 */
  fileSize?: number;
  displayFileSize?: string;
  fileFormatType?: string;
  success?: boolean;
}

export interface IssuedItemFileErrorModelDto {
  fileErrors?: ArpFileErrorDto[];
  processingErrors?: ArpFileProcessingErrorDto[];
  success?: boolean;
}

export interface ArpFileProcessingErrorDto {
  /** @format int32 */
  issuedItemIndex?: number;
  accountNumber?: string;
  accountType?: string;
  itemType?: string;
  /** @format int64 */
  checkNumber?: number;
  /** @format decimal */
  issuedAmount?: number;
  errorMessage?: string;
}

export type SearchAccountReconIssuedItemsResponseDto = BaseResponseDto & {
  issuedItems?: IssuedItemCollectionDto;
};

export type IssuedItemCollectionDto = IssuedItemDto[];

export interface IssuedItemDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  accountId?: number;
  accountNumber?: string;
  accountType?: string;
  companyName?: string;
  /** @format int64 */
  checkNumber?: number;
  /** @format date-time */
  checkDate?: string;
  /** @format double */
  issuedAmount?: number;
  payeeName?: string;
  createdBy?: string;
  createdByAlias?: string;
  /** @format date-time */
  effectiveDate?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  issuedStatus?: string;
  itemType?: string;
  entryType?: string;
  batchNumber?: string;
  sequenceNumber?: string;
  /** @format int32 */
  issuedItemFileId?: number;
  fileName?: string;
  /** @format guid */
  issuedItemFileUniqueId?: string;
  bankNumber?: string;
  dataView?: string;
  /** @format int32 */
  institutionId?: number;
  /** @format date-time */
  loadDate?: string;
  loadSequence?: string;
  deleteFlag?: boolean;
  deleted?: boolean;
  sourceKey?: string;
  foreignKey?: string;
  /** @format date-time */
  checkVoidDate?: string;
  transactionType?: string;
  payeeAddress1?: string;
  payeeAddress2?: string;
  payeeAddress3?: string;
  payeeAddress4?: string;
  payeeAddress5?: string;
  accountReconViolationRemark?: string;
  /** @format date-time */
  issuedItemCreatedDate?: string;
  /** @format double */
  transactionAmount?: number;
  /** @format date-time */
  staleDate?: string;
  /** @format date-time */
  postDate?: string;
  /** @format date-time */
  dormantDate?: string;
  transactionCodeCode?: string;
  transactionCodeDescription?: string;
  /** @format date-time */
  stopCheckPlaceDate?: string;
  /** @format date-time */
  stopCheckExpirationDate?: string;
  accountReconViolationType?: string;
  exceptionResolveType?: string;
  /** @format date-time */
  systemDate?: string;
  /** @format int32 */
  returnTransactionCount?: number;
  /** @format date-time */
  itemReturnDate?: string;
  accountReconAdjustedType?: string;
  accountReconPurgeCode?: string;
  accountReconPurgeDescription?: string;
  /** @format date-time */
  accountReconPurgeDate?: string;
  accountReconItemStatus?: string;
  imageNumber?: string;
  /** @format date-time */
  lastMainDate?: string;
  sourceFundsCode?: string;
  sourceFundsDescription?: string;
  /** @format date-time */
  staleExpirationDate?: string;
  /** @format date-time */
  postExpirationDate?: string;
  /** @format date-time */
  dormantExpirationDate?: string;
  /** @format date-time */
  checkVoidExpirationDate?: string;
  transactionBatchNumber?: string;
  transactionSequenceNumber?: string;
  sourceCode?: string;
  itemResolveType?: string;
  /** @format date-time */
  deleteDate?: string;
  /** @format date-time */
  previousStopCheckPlaceDate?: string;
  /** @format date-time */
  previousStopCheckExpirationDate?: string;
  /** @format date-time */
  stopCheckPurgeDate?: string;
  custom?: string;
  /** @format guid */
  accountReconItemDetailUniqueId?: string;
  accountReconItemAudits?: AccountReconItemAuditCollectionDto;
}

export type AccountReconItemAuditCollectionDto = AccountReconItemAuditDto[];

export interface AccountReconItemAuditDto {
  /** @format int32 */
  accountReconItemAuditId?: number;
  /** @format int32 */
  institutionId?: number;
  /** @format guid */
  accountReconItemDetailUniqueId?: string;
  accountReconItemActionType?: string;
  /** @format int32 */
  createdBy?: number;
  createdByAlias?: string;
  /** @format date-time */
  createdDate?: string;
}

export type SearchAccountReconIssuedItemsRequestDto = BaseRequestDto & {
  accountIds?: NumberKeyCollectionDto;
  /** @format int64 */
  checkNumber?: number;
  payeeName?: string;
  issuedDateStart?: string;
  issuedDateEnd?: string;
  issuedItemCreatedDateStart?: string;
  issuedItemCreatedDateEnd?: string;
  clearedDateStart?: string;
  clearedDateEnd?: string;
  issuedAmountStart?: string;
  issuedAmountEnd?: string;
  issuedItemStatusTypes?: TextKeyCollectionDto;
  itemTypes?: TextKeyCollectionDto;
  entryTypes?: TextKeyCollectionDto;
};

export type NumberKeyCollectionDto = number[];

export type SearchIssuedItemsVoidsResponseDto = BaseResponseDto & {
  searchIssuedItemsVoids?: SearchIssuedItemsVoidDictionaryDto;
};

export type SearchIssuedItemsVoidDictionaryDto = Record<string, SearchIssuedItemsVoidDto>;

export interface SearchIssuedItemsVoidDto {
  issuedItems?: IssuedItemCollectionDto;
  hasMore?: boolean;
}

export type SearchIssuedItemsVoidsRequestDto = BaseRequestDto & {
  /** @format int32 */
  maxMatches?: number;
  issuedItemsVoids?: IssuedItemEntryDictionaryDto;
};

export type IssuedItemEntryDictionaryDto = Record<string, IssuedItemEntryDto>;

export interface IssuedItemEntryDto {
  /** @format int64 */
  issuedItemId?: number;
  /** @format int32 */
  accountId?: number;
  /** @format int64 */
  checkNumber?: number;
  /** @format double */
  issuedAmount?: number;
  /** @format date-time */
  checkDate?: string;
  /** @format date-time */
  issuedItemCreatedDate?: string;
  /** @format date-time */
  checkVoidDate?: string;
  itemType?: string;
  entryType?: string;
  payeeName?: string;
  isModify?: boolean;
  batchNumber?: string;
  sequenceNumber?: string;
  actionTaken?: string;
  /** @format int32 */
  originalAccountId?: number;
  /** @format int32 */
  originalCheckNumber?: number;
  /** @format double */
  originalIssuedAmount?: number;
  /** @format date-time */
  originalCheckDate?: string;
  isCheckDateModified?: boolean;
  originalItemType?: string;
  originalPayee?: string;
}

export type SaveAccountReconIssuedItemsResponseDto = BaseResponseDto & {
  issuedItems?: IssuedItemCollectionDto;
  issuedItemErrors?: IssuedItemErrorCollectionDto;
};

export type IssuedItemErrorCollectionDto = IssuedItemErrorDto[];

export interface IssuedItemErrorDto {
  /** @format int32 */
  issuedItemId?: number;
  errorCode?: string;
  errorMessage?: string;
}

export type SaveAccountReconIssuedItemsRequestDto = BaseRequestDto & {
  uploadFileName?: string;
  /** @format int32 */
  uploadFileSize?: number;
  /** @format guid */
  issuedItemFileUniqueId?: string;
  issuedItems?: IssuedItemEntryCollectionDto;
};

export type IssuedItemEntryCollectionDto = IssuedItemEntryDto[];

export type CompanyOptionModelCollectionDto = CompanyOptionModelDto[];

export interface CompanyOptionModelDto {
  name?: string;
  value?: string;
}

export type CheckExceptionModelDataPageDto = DataPageCheckExceptionModelDto & {
  hasEtlCompletedSuccessfully?: boolean;
};

export interface DataPageCheckExceptionModelDto {
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  maxPageSize?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  recordCountInCurrentPage?: number;
  items?: CheckExceptionModelDto[];
}

export interface CheckExceptionModelDto {
  /** @format guid */
  arpExceptionDetailUniqueId?: string;
  /** @format int32 */
  arpExceptionDetailId?: number;
  accountNumber?: string;
  checkNumber?: string;
  /** @format decimal */
  paidAmount?: number;
  /** @format decimal */
  issuedAmount?: number;
  /** @format date-time */
  postedDate?: string;
  /** @format date-time */
  issuedDate?: string;
  issuedPayee?: string;
  decisionStatus?: string;
  comment?: string;
  exceptionReason?: string;
  financialInstitutionId?: string;
  companyName?: string;
  /** @format int32 */
  companyId?: number;
  companyUniqueId?: string;
  fromWorkStation?: string;
  attachmentFileName?: string;
  /** @format guid */
  returnReasonUniqueId?: string;
  /** @format int32 */
  returnReasonId?: number;
  /** @format guid */
  lastDecisionByUserUniqueId?: string;
  updatedBy?: string;
  sourceOfEntry?: string;
  protected?: string;
  ddaBatchNumber?: string;
  ddaSequenceNumber?: string;
  posPayItemId?: string;
  returnReasonDescription?: string;
  lastDecisionTakenBy?: string;
  audits?: AuditModelDto[];
  isCorrectionRequestCreated?: boolean;
  checkImageNumber?: string;
  /** @format guid */
  attachment?: string;
}

export interface AuditModelDto {
  username?: string;
  action?: string;
  /** @format date-time */
  timestamp?: string;
}

export interface SearchCheckExceptionModelDto {
  accountUniqueIds?: string[];
  checkNumber?: string;
  decisionStatus?: string;
  decisionByUserUniqueIds?: string[];
  issuedPayee?: string;
  issuedDate?: DateFilterModelDto;
  issuedAmount?: DecimalFilterModelDto;
  postedDate?: DateFilterModelDto;
  postedAmount?: DecimalFilterModelDto;
  exceptionReasons?: string[];
  type?: string;
  isPortrait?: boolean;
}

export interface DateFilterModelDto {
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  searchType?: string;
}

export interface DecimalFilterModelDto {
  /** @format decimal */
  startAmount?: number;
  /** @format decimal */
  endAmount?: number;
}

export interface SaveCheckExceptionAttachmentRequestModelDto {
  /** @format byte */
  attachment?: string;
  fileName?: string;
  comment?: string;
}

export interface ExceptionCorrectionModelDto {
  /** @format guid */
  arpExceptionDetailUniqueId?: string;
  comment?: string;
  /** @format byte */
  attachment?: string;
  attachmentFileName?: string;
  exceptionCorrectionItems?: ExceptionCorrectionItemModelDto[];
}

export interface ExceptionCorrectionItemModelDto {
  exceptionCorrectionItem?: ExceptionCorrectionItemDto;
  correctionValue?: string;
}

export interface InstitutionCheckExceptionReturnReasonDto {
  /** @format guid */
  returnReasonUniqueId?: string;
  description?: string;
  isDefault?: boolean;
  isDeleted?: boolean;
}

export type AchEditableBatchModelDto = SecurityBaseDto & {
  batch: AchBatchModelDto;
  settings: AchSettingsModelDto;
  errorMessage?: string;
  successMessage?: string;
  audit?: string;
};

export type AchBatchModelDto = SecurityBaseDto & {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  achCompanyName: string;
  errorSummary?: ErrorSummaryModelDto;
  /** @minLength 1 */
  achCompanyId: string;
  /** @minLength 1 */
  secCode: string;
  /** @minLength 1 */
  discretionaryData: string;
  /** @minLength 1 */
  entryDescription: string;
  restricted: boolean;
  recipients?: AchRecipientModelDto[];
  /**
   * @format date-time
   * @minLength 1
   */
  lastUpdated: string;
  /** @format decimal */
  debitAmount: number;
  /** @format decimal */
  creditAmount: number;
  /** @format int32 */
  numberOfApprovalsNeeded: number;
  /** @minLength 1 */
  status: string;
  /** @minLength 1 */
  successMessage: string;
  achCompany: AchCompanyModelDto;
  frequency: AchFrequencyModelDto;
  offsetAccount: LookupModelDto;
  permissions?: ProductPermissionModelDto[];
  transactionId?: string;
  audit?: string;
  completedApprovals?: UserApprovalDto[];
  /** @format int32 */
  completedApprovalCount?: number;
  availableApprovers?: string[];
  /** @format int32 */
  fileArchiveId?: number;
  paymentProcessingBasedOn1Record?: boolean;
  /** @format int32 */
  achPaymentTypeId?: number;
};

export type AchRecipientModelDto = AchRecipientModelBaseDto & {
  addenda?: LookupModelDto[];
};

export type AchRecipientModelBaseDto = ModelBaseDto & {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  idNumber: string;
  /** @minLength 1 */
  accountNumber: string;
  /** @minLength 1 */
  accountType: string;
  /** @minLength 1 */
  routingNumber: string;
  /** @minLength 1 */
  transactionType: string;
  /** @format decimal */
  amount: number;
  prenote: boolean;
  hold: boolean;
  reversal: boolean;
  /** @minLength 1 */
  addendaType: string;
  /** @minLength 1 */
  addendaBody: string;
  /** @minLength 1 */
  errorMessage: string;
  isRoutingNumberValid: boolean;
  isRoutingNumberOnUs: boolean;
  /** @format int32 */
  achMasterRecipientId?: number;
};

export type AchFrequencyModelDto = ModelBaseDto & {
  repeatOn?: string;
  /** @format date-time */
  startOn?: string;
  /** @format date-time */
  endOn?: string;
  /** @format date-time */
  effectiveDate?: string;
  /** @format date-time */
  initiatedDate?: string;
  noEndDate: boolean;
  /** @format int32 */
  repeatOnDay1: number;
  /** @format int32 */
  repeatOnDay2: number;
  repeatOnLastBusinessDay?: boolean;
  /** @minLength 1 */
  type: string;
  /** @format date-time */
  nextPaymentDate?: string;
  summary?: string;
};

export interface AchSettingsModelDto {
  /** @format int32 */
  achCompanyMatchType: number;
  allowStateTaxPayments?: boolean;
  allowFederalTaxPayments?: boolean;
  allowTaxPayments?: boolean;
  allowOnUsAccessManagement?: boolean;
  allowUnbalancedPayments?: boolean;
  allowChildSupportPayments?: boolean;
  allowInternationalPayments?: boolean;
}

export type AchStateTaxTemplateModelDto = AchTaxTemplateModelDto & {
  /** @format int32 */
  stateId?: number;
  state?: string;
  achStateTaxPaymentAmounts?: AchStateTaxTemplateAmountModelDto[];
};

export type AchStateTaxTemplateAmountModelDto = ModelBaseDto & {
  /** @format int32 */
  achBatchId?: number;
  /** @format decimal */
  amount?: number;
  /** @format int32 */
  achStateAmountTypeId?: number;
  achStateAmountTypeName?: string;
  achStateAmountTypeDescription?: string;
};

export type AchTaxTemplateModelDto = AchBatchModelDto & {
  taxCode?: string;
  taxPayerId?: string;
  /** @format int32 */
  recipientAccountTypeId?: number;
  recipientAccountType?: string;
  recipientName?: string;
  recipientRoutingNumber?: string;
  recipientAccountNumber?: string;
  recipientIdNumber?: string;
};

export type AchFederalTaxTemplateModelDto = AchTaxTemplateModelDto & {
  achFederalTaxPaymentAmounts?: AchFederalTaxTemplateAmountModelDto[];
};

export type AchFederalTaxTemplateAmountModelDto = ModelBaseDto & {
  /** @format int32 */
  achBatchId?: number;
  /** @format decimal */
  amount?: number;
  amountType?: string;
  /** @format int32 */
  achFederalAmountTypeId?: number;
  achFederalAmountTypeName?: string;
  achFederalAmountTypeDescription?: string;
};

export type AchBatchSummaryModelDto = AchBatchModelDto & {
  isEdited: boolean;
  errorMessage?: string;
  /** @format int32 */
  numberOfRecipients: number;
  /** @format int32 */
  fileArchiveId?: number;
  /** @format int32 */
  batchUniqueId?: number;
  hasAccess?: boolean;
  /** @format int32 */
  achPaymentDraftId?: number;
  isValid?: boolean;
  /** @format int32 */
  createdBy?: number;
  /** @format int32 */
  updatedByUserId?: number;
};

export interface AchBatchFilterModelDto {
  achCompanyList: AchCompanyModelDto[];
  /** @minLength 1 */
  batchName: string;
  /** @minLength 1 */
  secCode: string;
  /**
   * @format date-time
   * @minLength 1
   */
  lastUpdatedStart: string;
  /**
   * @format date-time
   * @minLength 1
   */
  lastUpdatedEnd: string;
  /** @format decimal */
  amountMin: number;
  /** @format decimal */
  amountMax: number;
  /** @format decimal */
  debitAmountMax: number;
  /** @format decimal */
  debitAmountMin: number;
  /** @format decimal */
  creditAmountMax: number;
  /** @format decimal */
  creditAmountMin: number;
  /** @minLength 1 */
  status: string;
  /** @minLength 1 */
  amountType: string;
  /** @minLength 1 */
  creditAmountType: string;
  /** @minLength 1 */
  debitAmountType: string;
  /** @minLength 1 */
  updatedDateType: string;
  /** @format decimal */
  debitAmount: number;
  /** @format decimal */
  creditAmount: number;
  /**
   * @format date-time
   * @minLength 1
   */
  updatedDate: string;
  /** @format int32 */
  taxTemplateType?: number;
}

export type DeleteAchBatchModelDto = SecurityBaseDto & {
  /** @format int32 */
  achBatchId?: number;
};

export type AchPaymentModelDto = AchPaymentModelBaseDto & {
  recipients: AchRecipientModelDto[];
};

export type AchPaymentModelBaseDto = ModelBaseDto & {
  /** @minLength 1 */
  type: string;
  frequency: AchFrequencyModelDto;
  parentFrequency: AchFrequencyModelDto;
  applyUpdatesToBatch: boolean;
  /** @format int32 */
  parentId: number;
  errorSummary?: ErrorSummaryModelDto;
  /** @format int32 */
  batchId: number;
  offsetAccount: LookupModelDto;
  /** @minLength 1 */
  name: string;
  templateName?: string;
  /** @minLength 1 */
  parentFrequencyType: string;
  /** @minLength 1 */
  achCompanyName: string;
  /** @minLength 1 */
  achCompanyId: string;
  /** @minLength 1 */
  secCode: string;
  isEdited?: boolean;
  /** @minLength 1 */
  discretionaryData: string;
  /** @minLength 1 */
  entryDescription: string;
  restricted: boolean;
  /** @format decimal */
  debitAmount: number;
  /** @format decimal */
  creditAmount: number;
  /** @minLength 1 */
  errorMessage: string;
  /** @minLength 1 */
  transactionId: string;
  /** @minLength 1 */
  status: string;
  /** @minLength 1 */
  successMessage: string;
  /** @format int32 */
  numberOfApprovalsNeeded: number;
  achCompany: AchCompanyModelDto;
  securityMessage?: SecurityMessageModelDto;
  permissions?: ProductPermissionModelDto[];
  userPermissions?: string[];
  audit?: string;
  message?: string;
  messageType?: string;
  completedApprovals?: UserApprovalDto[];
  /** @format int32 */
  completedApprovalCount?: number;
  availableApprovers?: string[];
  /** @format int32 */
  fileArchiveId?: number;
  canReverseFull?: boolean;
  canReverseTransactions?: boolean;
  recipientIdsforReversal?: number[];
  /** @format int32 */
  reversalAchPaymentId?: number;
  fileName?: string;
  fileSize?: string;
  /** @format int32 */
  achPaymentDraftId?: number;
  failureReason?: string;
  /** @format int32 */
  achPaymentTypeId?: number;
  /**
   * @minLength 0
   * @maxLength 50
   */
  achPaymentTypeName: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  achPaymentTypeDescription: string;
  paymentProcessingBasedOn1Record?: boolean;
  copiedFromTransactionId?: string;
  duplicatePreventionId?: string;
  destinationCountryCode?: string;
  foreignExchangeIndicator?: string;
  /** @format int32 */
  foreignExchangeReferenceNumber?: number;
  foreignExchangeReference?: string;
  destinationCurrencyCode?: string;
  originatorCurrencyCode?: string;
  source?: string;
  /** @format date-time */
  createdDate?: string;
};

export type AchPaymentWithBatchesModelDto = AchPaymentModelDto & {
  achBatchSummaries?: AchBatchSummaryModelDto[];
  achPaymentIds?: number[];
  /** @format decimal */
  totalCreditAmount?: number;
  /** @format decimal */
  totalDebitAmount?: number;
  /** @format int32 */
  totalCreditTransactions?: number;
  /** @format int32 */
  totalDebitTransactions?: number;
  uploadedBy?: string;
  /** @format int32 */
  totalBalancedBatches?: number;
  /** @format decimal */
  totalBalancedCreditAmount?: number;
  /** @format decimal */
  totalBalancedDebitAmount?: number;
  /** @format int32 */
  totalUnBalancedBatches?: number;
  /** @format decimal */
  totalUnBalancedCreditAmount?: number;
  /** @format decimal */
  totalUnBalancedDebitAmount?: number;
  fileName?: string;
  fileSize?: string;
};

export interface AchBatchImportModelDto {
  achBatchSummaries?: AchBatchSummaryModelDto[];
  errorMessage?: string;
  /** @format int32 */
  totalDebitTransactions?: number;
  /** @format decimal */
  totalCreditAmount?: number;
  /** @format int32 */
  totalCreditTransactions?: number;
  /** @format decimal */
  totalDebitAmount?: number;
}

export type AchSourceModelDto = ModelBaseDto & {
  name?: string;
  key?: string;
};

export interface FilterUsersDto {
  errorSummary?: ErrorSummaryModelDto;
  success?: boolean;
  users?: FilterUserDto[];
}

export interface FilterUserDto {
  /** @format int32 */
  id?: number;
  /** @format guid */
  uniqueId?: string;
  name?: string;
}

export interface DeleteAchFileModelDto {
  responseDetailCollection?: ResponseDetailCollectionDto;
  success?: boolean;
  isDeleted?: boolean;
  filename?: string;
}

export type AchFileActivityModelDto = ModelBaseDto & {
  fileName?: string;
  /** @format int32 */
  fileId?: number;
  /** @format int32 */
  fileArchiveId?: number;
  validationError?: string;
  hasValidationError?: boolean;
  isActive?: boolean;
  achCompanyName?: string;
  fileSize?: string;
  source?: string;
  /** @format date-time */
  uploadDate?: string;
  /** @format int32 */
  totalBatches?: number;
  /** @format int32 */
  approvedCount?: number;
  /** @format int32 */
  pendingApprovalCount?: number;
  /** @format int32 */
  rejectedCount?: number;
  /** @format int32 */
  expiredCount?: number;
  /** @format decimal */
  debitAmount?: number;
  /** @format decimal */
  creditAmount?: number;
  status?: string;
  processedBy?: string;
  /** @format date-time */
  processedDate?: string;
  isExpired?: boolean;
  isProcessable?: boolean;
  permissions?: ProductPermissionModelDto[];
};

export interface AchFileActivityFilterModelDto {
  achFileName?: string;
  /** @format int32 */
  fileArchiveId?: number;
  achSourceList?: AchSourceModelDto[];
  achCompanyList?: AchCompanyModelDto[];
  uploadDateType?: string;
  /** @format date-time */
  uploadSpecificDate?: string;
  /** @format date-time */
  uploadDateStart?: string;
  /** @format date-time */
  uploadDateEnd?: string;
  processedByList?: FilterUserDto[];
  processedDateType?: string;
  /** @format date-time */
  processedSpecificDate?: string;
  /** @format date-time */
  processedDateStart?: string;
  /** @format date-time */
  processedDateEnd?: string;
}

export interface AchFileModelDto {
  /** @format int32 */
  id?: number;
  fileContent?: string;
  fileName?: string;
  fileSize?: string;
  success?: boolean;
}

export interface AchFileErrorModelDto {
  validationErrors?: AchFileValidationErrorDto[];
  success?: boolean;
  errorSummary?: ErrorSummaryModelDto;
}

export interface AchFileValidationErrorDto {
  batchName?: string;
  /** @format int32 */
  lineNumber?: number;
  message?: string;
  action?: string;
  record?: string;
}

export type AchImportLayoutModelDto = ModelBaseDto & {
  /** @format int32 */
  delimitedId?: number;
  /** @format int32 */
  fixedPositionId?: number;
  delimiter?: string;
  /** @format int32 */
  nameColumn?: number;
  /** @format int32 */
  nameBegin?: number;
  /** @format int32 */
  nameEnd?: number;
  /** @format int32 */
  idNumberColumn?: number;
  /** @format int32 */
  idNumberBegin?: number;
  /** @format int32 */
  idNumberEnd?: number;
  /** @format int32 */
  routingNumberColumn?: number;
  /** @format int32 */
  routingNumberBegin?: number;
  /** @format int32 */
  routingNumberEnd?: number;
  /** @format int32 */
  accountNumberColumn?: number;
  /** @format int32 */
  accountNumberBegin?: number;
  /** @format int32 */
  accountNumberEnd?: number;
  /** @format int32 */
  amountColumn?: number;
  /** @format int32 */
  amountBegin?: number;
  /** @format int32 */
  amountEnd?: number;
  /** @format int32 */
  transactionCodeColumn?: number;
  /** @format int32 */
  transactionCodeBegin?: number;
  /** @format int32 */
  transactionCodeEnd?: number;
  /** @format int32 */
  accountTypeColumn?: number;
  /** @format int32 */
  accountTypeBegin?: number;
  /** @format int32 */
  accountTypeEnd?: number;
  accountTypeCheckingDelimited?: string;
  accountTypeCheckingFixedPosition?: string;
  accountTypeSavingsDelimited?: string;
  accountTypeSavingsFixedPosition?: string;
  accountTypeLoanDelimited?: string;
  accountTypeLoanFixedPosition?: string;
  accountTypeGlDelimited?: string;
  accountTypeGlFixedPosition?: string;
  /** @format int32 */
  transactionTypeColumn?: number;
  /** @format int32 */
  transactionTypeBegin?: number;
  /** @format int32 */
  transactionTypeEnd?: number;
  transactionTypeDebitDelimited?: string;
  transactionTypeDebitFixedPosition?: string;
  transactionTypeCreditDelimited?: string;
  transactionTypeCreditFixedPosition?: string;
  /** @minLength 1 */
  uploadFormat: string;
};

export interface BaseResponseAchServiceDto {
  baseRequest?: BaseRequestAchServiceDto;
  responseDetailCollection?: ResponseDetailCollectionAchServiceDto;
  success?: boolean;
}

export interface BaseRequestAchServiceDto {
  activityTracking?: ActivityTrackingAchServiceDto;
  alias?: string;
  applicationNameType?: ApplicationNameTypeAchServiceDto;
  authenticationUser?: AuthenticationUserAchServiceDto;
  authorizationInfo?: AuthorizationInfoAchServiceDto;
  clientIpAddress?: string;
  endUser?: EndUserAchServiceDto;
  institutionId?: string;
  productInformation?: ProductInformationAchServiceDto;
  requestType?: string;
  secondaryId?: string;
}

export interface ActivityTrackingAchServiceDto {
  activityId?: string;
  parentActivityId?: string;
}

export type AuthenticationUserAchServiceDto = EndUserAchServiceDto & object;

export interface EndUserAchServiceDto {
  alias?: string;
  browser?: string;
  companyId?: string;
  device?: string;
  externalId?: string;
  externalSecondaryId?: string;
  internalId?: string;
  internalSecondaryId?: string;
  userType?: UserTypeAchServiceDto;
}

export interface AuthorizationInfoAchServiceDto {
  associatedClaims?: AuthorizeAssociatedClaimCollectionAchServiceDto;
  entitlements?: AuthorizeEntitlementCollectionAchServiceDto;
  isSuperUser?: boolean;
  roles?: AuthorizeRoleCollectionAchServiceDto;
}

export type AuthorizeAssociatedClaimCollectionAchServiceDto =
  AuthorizeAssociatedClaimAchServiceDto[];

export interface AuthorizeAssociatedClaimAchServiceDto {
  /** @format int32 */
  accountId?: number;
  /** @format int32 */
  claimId?: number;
  /** @format int32 */
  roleId?: number;
}

export type AuthorizeEntitlementCollectionAchServiceDto = AuthorizeEntitlementAchServiceDto[];

export interface AuthorizeEntitlementAchServiceDto {
  /** @format int32 */
  id?: number;
  name?: string;
}

export type AuthorizeRoleCollectionAchServiceDto = AuthorizeRoleAchServiceDto[];

export interface AuthorizeRoleAchServiceDto {
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface ProductInformationAchServiceDto {
  featureName?: string;
  productName?: string;
  version?: string;
}

export type SearchJxAchExceptionsRequestDto = BaseRequestAchServiceDto & {
  achExceptionSearchModel?: AchExceptionSearchModelAchServiceDto;
};

export interface AchExceptionSearchModelAchServiceDto {
  accounts?: AccountAchServiceDto[];
  achCompanies?: AchCompanyAchServiceDto[];
  achExceptionDecisionStatus?: string;
  /** @format decimal */
  amount?: number;
  /** @format decimal */
  amountEnd?: number;
  /** @format decimal */
  amountStart?: number;
  amountType?: string;
  entryDescription?: string;
  /** @format date-time */
  postedDate?: string;
  /** @format date-time */
  postedDateEnd?: string;
  postedDateRangeType?: string;
  /** @format date-time */
  postedDateStart?: string;
  secCodes?: AchSecCodeAchServiceDto[];
  type?: string;
}

export type AccountAchServiceDto = BaseEntityAchServiceDto & {
  accountNumberTypeFormat?: string;
  accountProducts?: AccountProductAchServiceDto[];
  /** @format guid */
  accountUniqueId?: string;
  achOffsetAccounts?: AchOffsetAccountAchServiceDto[];
  allowLoanPaymentPastDue?: boolean;
  analysisTransactionCounts?: AnalysisTransactionCountAchServiceDto[];
  arpExceptions?: ArpExceptionAchServiceDto[];
  arpReportFiles?: ArpReportFileAchServiceDto[];
  associatedClaims?: AssociatedClaimAchServiceDto[];
  /** @format decimal */
  balance?: number;
  cifNumber?: string;
  /** @format decimal */
  collectedBalance?: number;
  company?: CompanyAchServiceDto;
  /** @format int32 */
  companyId?: number;
  coreAccount?: CoreAccountAchServiceDto;
  coreStatus?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format decimal */
  currentBalance?: number;
  /** @format decimal */
  dailyLimit?: number;
  /** @format decimal */
  dailyUsedValue?: number;
  description?: string;
  /** @format int32 */
  id?: number;
  internalTransferTransactions?: InternalTransferTransactionAchServiceDto[];
  internalTransferTransactions1?: InternalTransferTransactionAchServiceDto[];
  isAccountLinked?: boolean;
  isCompanyAccount?: boolean;
  isSelected?: boolean;
  linkedTMCompanies?: string[];
  /** @format decimal */
  loanPaymentAmountDue?: number;
  /** @format date-time */
  loanPaymentDueDate?: string;
  name?: string;
  nonCoreWireCompanyInternationalAccounts?: NonCoreWireCompanyInternationalAccountAchServiceDto[];
  number?: string;
  /** @format decimal */
  perTransactionLimit?: number;
  reportingFilterAccounts?: ReportingFilterAccountAchServiceDto[];
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  showAccountNickName?: boolean;
  stopPayments?: StopPaymentAchServiceDto[];
  /** @format decimal */
  templateTransferAmount?: number;
  templateTransferMemo?: string;
  type?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userAccountGroupAccounts?: UserAccountGroupAccountAchServiceDto[];
  userAccounts?: UserAccountAchServiceDto[];
  users?: UserAchServiceDto[];
  wires?: WireAchServiceDto[];
};

export type AccountProductAchServiceDto = BaseEntityAchServiceDto & {
  account?: AccountAchServiceDto;
  /** @format int32 */
  accountId?: number;
  accountProductArp?: AccountProductArpAchServiceDto;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  product?: ProductAchServiceDto;
  productAccountPermission?: ProductAccountPermissionAchServiceDto[];
  /** @format int32 */
  productId?: number;
};

export interface AccountProductArpAchServiceDto {
  accountProduct?: AccountProductAchServiceDto;
  hasAchException?: boolean;
  hasAchFilter?: boolean;
  hasCheckException?: boolean;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
}

export type ProductAchServiceDto = BaseEntityAchServiceDto & {
  accountProducts?: AccountProductAchServiceDto[];
  achProduct?: AchProductAchServiceDto;
  arpProduct?: ArpProductAchServiceDto;
  billPayProduct?: BillPayProductAchServiceDto;
  company?: CompanyAchServiceDto;
  /** @format int32 */
  companyId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  electronicDocumentsProduct?: ElectronicDocumentsProductAchServiceDto;
  /** @format int32 */
  id?: number;
  internalTransferProduct?: InternalTransferProductAchServiceDto;
  isConfigurable?: boolean;
  productPermissions?: ProductPermissionAchServiceDto[];
  productType?: ProductTypeAchServiceDto;
  /** @format int32 */
  productTypeId?: number;
  /** @format guid */
  productUniqueId?: string;
  remoteDepositProduct?: RemoteDepositProductAchServiceDto;
  reportingConfigurations?: ReportingConfigurationAchServiceDto[];
  reportingProduct?: ReportingProductAchServiceDto;
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  stopPaymentProduct?: StopPaymentProductAchServiceDto;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userProductLimits?: UserProductLimitAchServiceDto[];
  wireInternationalProduct?: WireInternationalProductAchServiceDto;
  wireProduct?: WireProductAchServiceDto;
};

export interface AchProductAchServiceDto {
  accountBalanceValidationConfiguredInCore?: boolean;
  /** @format int32 */
  achCompanyMatchTypeId?: number;
  allowChildSupportPayments?: boolean;
  allowFederalTaxPayments?: boolean;
  allowInternationalPayments?: boolean;
  allowNotificationOfChange?: boolean;
  allowOnUsAccessManagement?: boolean;
  allowReturnReview?: boolean;
  allowSameDayAch?: boolean;
  allowStateTaxPayments?: boolean;
  allowTaxPayments?: boolean;
  allowUnbalancedPayments?: boolean;
  /** @format int32 */
  batchApprovalCount?: number;
  batchAuthenticationType?: AuthenticationTypeAchServiceDto;
  /** @format int32 */
  batchAuthenticationTypeId?: number;
  /** @format decimal */
  dailyLimit?: number;
  disableSameDay?: boolean;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  internationalTemplateApprovalCount?: number;
  /** @format int32 */
  paymentApprovalCount?: number;
  paymentAuthenticationType?: AuthenticationTypeAchServiceDto;
  /** @format int32 */
  paymentAuthenticationTypeId?: number;
  product?: ProductAchServiceDto;
  /** @format int32 */
  recipientApprovalCount?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  validateAccountBalance?: boolean;
}

export type AuthenticationTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export interface BaseEntityAchServiceDto {
  objectState?: ObjectStateAchServiceDto;
}

export type AchExceptionDto = BaseEntityAchServiceDto & {
  account?: AccountAchServiceDto;
  /** @format int32 */
  accountId?: number;
  /** @format int32 */
  achDecisionId?: number;
  /** @format decimal */
  amount?: number;
  batchNumber?: string;
  createdBy?: string;
  createdByUserId?: string;
  /** @format date-time */
  createdDate?: string;
  decision?: string;
  decisionBy?: string;
  /** @format date-time */
  decisionDate?: string;
  description?: string;
  excActnCode?: string;
  exceptionType?: string;
  fromWorkStation?: string;
  /** @format int32 */
  id?: number;
  issuingCompanyId?: string;
  issuingCompanyName?: string;
  itemId?: string;
  pay?: boolean;
  /** @format date-time */
  postedDate?: string;
  return?: boolean;
  secCode?: string;
};

export type AchPaymentAchServiceDto = BaseEntityAchServiceDto & {
  account?: AccountAchServiceDto;
  achBatch?: AchBatchAchServiceDto;
  /** @format int32 */
  achBatchId?: number;
  achCompany?: AchCompanyAchServiceDto;
  /** @format int32 */
  achCompanyId?: number;
  achCompanyName?: string;
  achFederalTaxPayment?: AchFederalTaxPaymentAchServiceDto;
  achNachaFileCopyAudits?: AchNachaFileCopyAuditAchServiceDto[];
  achPaymentAudits?: AchPaymentAuditAchServiceDto[];
  /** @format int32 */
  achPaymentDraftId?: number;
  achPaymentRecipients?: AchPaymentRecipientAchServiceDto[];
  /** @format int32 */
  achPaymentRecipientsCount?: number;
  achPaymentType?: AchPaymentTypeAchServiceDto;
  /** @format int32 */
  achPaymentTypeId?: number;
  achStateTaxPayment?: AchStateTaxPaymentAchServiceDto;
  achStatusType?: AchStatusTypeAchServiceDto;
  achTransactionId?: string;
  /** @format int32 */
  approvalsRequired?: number;
  approvedBy?: TupleStringDateTimeDto[];
  balanceValidationNotRequired?: boolean;
  batchName?: string;
  /** @format int32 */
  batchUniqueId?: number;
  chilAchPayments?: AchPaymentAchServiceDto[];
  comment?: string;
  companyIdentity?: string;
  /** @format int32 */
  completedApprovals?: number;
  copiedFromTransactionId?: string;
  createdBy?: string;
  createdByUser?: UserAchServiceDto;
  /** @format date-time */
  createdDate?: string;
  /** @format decimal */
  credit?: number;
  /** @format decimal */
  debit?: number;
  descretionaryData?: string;
  destinationCountryCode?: string;
  destinationCurrency?: string;
  duplicatePreventionId?: string;
  /** @format date-time */
  effectiveDate?: string;
  eligibleApprovers?: string[];
  /** @format date-time */
  endDate?: string;
  entryDescription?: string;
  errorSummary?: ErrorSummaryAchServiceDto;
  failureReason?: string;
  fileArchive?: FileArchiveAchServiceDto;
  /** @format int32 */
  fileArchiveId?: number;
  fileName?: string;
  foreignExchangeIndicator?: string;
  foreignExchangeReference?: string;
  /** @format int32 */
  foreignExchangeReferenceIndicator?: number;
  hasAccess?: boolean;
  /** @format int32 */
  id?: number;
  /** @format date-time */
  initiatedDate?: string;
  /** @format int32 */
  offsetAccountId?: number;
  /** @format decimal */
  onUsAmount?: number;
  /** @format int32 */
  onUsCount?: number;
  originatorCurrencyCode?: string;
  parentAchPayment?: AchPaymentAchServiceDto;
  /** @format int32 */
  parentAchPaymentId?: number;
  paymentFrequencyType?: PaymentFrequencyTypeAchServiceDto;
  /** @format int32 */
  paymentFrequencyTypeId?: number;
  paymentOnLastBusinessDay?: boolean;
  paymentProcessingBasedOn1Record?: boolean;
  /** @format int32 */
  prefundingDays?: number;
  recipientIdsforReversal?: number[];
  referenceNumber?: string;
  /** @format int32 */
  repeatOnDayOne?: number;
  /** @format int32 */
  repeatOnDayTwo?: number;
  restricted?: boolean;
  /** @format int32 */
  reversalAchPaymentId?: number;
  secCode?: string;
  sentFileArchive?: FileArchiveAchServiceDto;
  /** @format int32 */
  sentFileArchiveId?: number;
  source?: string;
  /** @format date-time */
  startDate?: string;
  /** @format int32 */
  statusTypeId?: number;
  successMessage?: string;
  updatedBy?: string;
  updatedByUser?: UserAchServiceDto;
  /** @format date-time */
  updatedDate?: string;
  userPermissions?: string[];
  canReverseFull?: boolean;
  canReverseTransactions?: boolean;
};

export type AchBatchAchServiceDto = BaseEntityAchServiceDto & {
  achBatchAudits?: AchBatchAuditAchServiceDto[];
  achBatchRecipients?: AchBatchRecipientAchServiceDto[];
  achCompany?: AchCompanyAchServiceDto;
  /** @format int32 */
  achCompanyId?: number;
  /** @format int32 */
  achCompanyMatchType?: number;
  achCompanyName?: string;
  achFederalTaxTemplate?: AchFederalTaxTemplateAchServiceDto;
  achPaymentType?: AchPaymentTypeAchServiceDto;
  /** @format int32 */
  achPaymentTypeId?: number;
  achPayments?: AchPaymentAchServiceDto[];
  achSecCode?: AchSecCodeAchServiceDto;
  /** @format int32 */
  achSecCodeId?: number;
  achStateTaxTemplate?: AchStateTaxTemplateAchServiceDto;
  /** @format int32 */
  approvalsRequired?: number;
  approvedBy?: TupleStringDateTimeDto[];
  batchName?: string;
  batchStatusType?: BatchStatusTypeAchServiceDto;
  /** @format int32 */
  batchStatusTypeId?: number;
  /** @format int32 */
  batchUniqueId?: number;
  companyIdentity?: string;
  /** @format int32 */
  completedApprovals?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format decimal */
  credit?: number;
  /** @format decimal */
  creditAmount?: number;
  /** @format decimal */
  debit?: number;
  /** @format decimal */
  debitAmount?: number;
  descretionaryData?: string;
  eligibleApprovers?: string[];
  entryDescription?: string;
  errorMessage?: string;
  fileArchive?: FileArchiveAchServiceDto;
  /** @format int32 */
  fileArchiveId?: number;
  /** @format int32 */
  id?: number;
  isEdited?: boolean;
  /** @format int32 */
  numberOfRecipients?: number;
  restricted?: boolean;
  secCode?: string;
  status?: string;
  successMessage?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userPermissions?: string[];
};

export type AchBatchAuditAchServiceDto = BaseEntityAchServiceDto & {
  achActionType?: AchActionTypeAchServiceDto;
  achBatch?: AchBatchAchServiceDto;
  /** @format int32 */
  achBatchId?: number;
  /** @format int32 */
  actionTypeId?: number;
  comments?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  userName?: string;
};

export type AchActionTypeAchServiceDto = BaseEntityAchServiceDto & {
  achBatchAudits?: AchBatchAuditAchServiceDto[];
  achPaymentAudits?: AchPaymentAuditAchServiceDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export type AchPaymentAuditAchServiceDto = BaseEntityAchServiceDto & {
  achActionType?: AchActionTypeAchServiceDto;
  /** @format int32 */
  achActionTypeId?: number;
  achPayment?: AchPaymentAchServiceDto;
  /** @format int32 */
  achPaymentId?: number;
  comments?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  userName?: string;
};

export type AchBatchRecipientAchServiceDto = BaseEntityAchServiceDto & {
  accountNumber?: string;
  accountType?: AccountTypeAchServiceDto;
  /** @format int32 */
  accountTypeId?: number;
  achBatch?: AchBatchAchServiceDto;
  /** @format int32 */
  achBatchId?: number;
  achBatchRecipientAddendas?: AchBatchRecipientAddendaAchServiceDto[];
  addenda?: string;
  /** @format decimal */
  amount?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  hold?: boolean;
  /** @format int32 */
  id?: number;
  preNote?: boolean;
  recipientIdNumber?: string;
  recipientName?: string;
  routingNumber?: string;
  /** @format int32 */
  rowNum?: number;
  transactionType?: TransactionTypeAchServiceDto;
  /** @format int32 */
  transactionTypeId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export interface AccountTypeAchServiceDto {
  achBatchRecipients?: AchBatchRecipientAchServiceDto[];
  achPaymentRecipients?: AchPaymentRecipientAchServiceDto[];
  achTransactionCodes?: AchTransactionCodeAchServiceDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  reportingType?: string;
}

export type AchPaymentRecipientAchServiceDto = BaseEntityAchServiceDto & {
  accountNumber?: string;
  accountType?: AccountTypeAchServiceDto;
  /** @format int32 */
  accountTypeId?: number;
  /** @format int32 */
  achMasterRecipientId?: number;
  achPayment?: AchPaymentAchServiceDto;
  /** @format int32 */
  achPaymentId?: number;
  achPaymentRecipientAddendas?: AchPaymentRecipientAddendaAchServiceDto[];
  addenda?: string;
  /** @format decimal */
  amount?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  hold?: boolean;
  /** @format int32 */
  id?: number;
  isRoutingNumberOnUs?: boolean;
  isRoutingNumberValid?: boolean;
  preNote?: boolean;
  recipientIdNumber?: string;
  recipientName?: string;
  routingNumber?: string;
  /** @format int32 */
  rowNum?: number;
  transactionType?: TransactionTypeAchServiceDto;
  /** @format int32 */
  transactionTypeId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type AchPaymentRecipientAddendaAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  achPaymentId?: number;
  achPaymentRecipient?: AchPaymentRecipientAchServiceDto;
  /** @format int32 */
  achPaymentRecipientId?: number;
  addenda?: string;
  addendaType?: AddendaTypeAchServiceDto;
  /** @format int32 */
  addendaTypeId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  nonCustodialParentFirstName?: string;
  nonCustodialParentLastName?: string;
  /** @format int32 */
  rowNum?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export interface AddendaTypeAchServiceDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export type TransactionTypeAchServiceDto = BaseEntityAchServiceDto & {
  achBatchRecipients?: AchBatchRecipientAchServiceDto[];
  achCompanies?: AchCompanyAchServiceDto[];
  achPaymentRecipients?: AchPaymentRecipientAchServiceDto[];
  achTransactionCodes?: AchTransactionCodeAchServiceDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export type AchCompanyAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  achBatchBalanceTypeId?: number;
  achBatches?: AchBatchAchServiceDto[];
  achCompanyId?: string;
  achCompanySecCodes?: AchCompanySecCodeAchServiceDto[];
  achOffsetAccounts?: AchOffsetAccountAchServiceDto[];
  achPayments?: AchPaymentAchServiceDto[];
  allowUnbalancedPayments?: boolean;
  /** @format int32 */
  allowedNotOnUsTransactionTypeId?: number;
  availableBalanceTable?: string;
  balanceValidationType?: string;
  batchBalanceType?: BatchBalanceTypeAchServiceDto;
  company?: CompanyAchServiceDto;
  coreSecCode?: string;
  /** @format decimal */
  dailyLimit?: number;
  discretionaryData?: string;
  entryDescription?: string;
  /** @format int32 */
  id?: number;
  isPaymentProcessingCompany?: boolean;
  offsetAccountNumber?: string;
  paymentProcessingCompanyAllowed?: boolean;
  /** @format int32 */
  prefundingDays?: number;
  /** @format decimal */
  requiredOnUsAmountPerBatch?: number;
  /** @format int32 */
  requiredOnUsTransactionCount?: number;
  sameDayAchAllowed?: boolean;
  settlementAccount?: string;
  settlementAccountType?: string;
  transactionType?: TransactionTypeAchServiceDto;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userAchCompanies?: UserAchCompanyAchServiceDto[];
};

export type AchCompanySecCodeAchServiceDto = BaseEntityAchServiceDto & {
  achCompany?: AchCompanyAchServiceDto;
  achSecCode?: AchSecCodeAchServiceDto;
  /** @format int32 */
  achSecCodeId?: number;
  /** @format int32 */
  companyId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
};

export interface AchSecCodeAchServiceDto {
  description?: string;
  /** @format int32 */
  id?: number;
  secCode?: string;
}

export interface AchOffsetAccountAchServiceDto {
  account?: AccountAchServiceDto;
  /** @format int32 */
  accountId?: number;
  achCompany?: AchCompanyAchServiceDto;
  /** @format int32 */
  achCompanyId?: number;
  /** @format int32 */
  id?: number;
  isActive?: boolean;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
}

export type UserAchServiceDto = BaseEntityAchServiceDto & {
  accountLookups?: LookupAchServiceDto[];
  accountProducts?: AccountProductAchServiceDto[];
  achOffsetAccounts?: AchOffsetAccountAchServiceDto[];
  alias?: string;
  associatedClaims?: AssociatedClaimAchServiceDto[];
  backOfficeSsoEnabled?: boolean;
  beneficiaryAudits?: BeneficiaryAuditAchServiceDto[];
  boReports?: BoReportAchServiceDto[];
  company?: CompanyAchServiceDto;
  /** @format int32 */
  companyId?: number;
  contactInfo?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  department?: string;
  email?: string;
  enrolled?: boolean;
  favoriteReports?: FavoriteReportAchServiceDto[];
  fax?: string;
  hasLoggedIn?: boolean;
  /** @format int32 */
  id?: number;
  importBatchId?: string;
  institution?: InstitutionAchServiceDto;
  /** @format int32 */
  institutionId?: number;
  isAdmin?: boolean;
  isEditor?: boolean;
  isSuperUser?: boolean;
  locked?: boolean;
  /** @format int32 */
  loginFailureCount?: number;
  mfaLocked?: boolean;
  name?: string;
  notificationEmail?: string;
  notificationPhoneCarrier?: TextMessagingCarrierAchServiceDto;
  /** @format int32 */
  notificationPhoneCarrierId?: number;
  notificationPhoneNumber?: string;
  notificationRecipientId?: string;
  password?: string;
  /** @format date-time */
  passwordDate?: string;
  pendingEditsOfUser?: PendingEditOfUserAchServiceDto[];
  pendingState?: PendingEditStatusAchServiceDto;
  phoneExtension?: string;
  phoneNumber?: string;
  publishState?: string;
  reportingFilterSorts?: ReportingFilterSortAchServiceDto[];
  reportingFilters?: ReportingFilterAchServiceDto[];
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  sessions?: SessionAchServiceDto[];
  showAccountNickName?: boolean;
  showMaskedAccount?: boolean;
  tempPasswordToken?: string;
  /** @format date-time */
  tempPasswordTokenExpirationDate?: string;
  /** @format date-time */
  termsAcceptedDate?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userAccountGroups?: UserAccountGroupAchServiceDto[];
  userAccounts?: UserAccountAchServiceDto[];
  userAchCompanies?: UserAchCompanyAchServiceDto[];
  userAudits?: UserAuditAchServiceDto[];
  userDevices?: UserDeviceAchServiceDto[];
  userIpAccessSetting?: UserIpAccessSettingAchServiceDto;
  userIpAccesses?: UserIpAccessAchServiceDto[];
  userNotificationTypes?: UserNotificationTypeAchServiceDto[];
  userNotifications?: UserNotificationAchServiceDto[];
  userOobDetail?: UserOobDetailAchServiceDto;
  userPasswordHistories?: UserPasswordHistoryAchServiceDto[];
  userProductLimits?: UserProductLimitAchServiceDto[];
  userRoles?: UserRoleAchServiceDto[];
  userSecureTokenSecurity?: UserSecureTokenSecurityAchServiceDto;
  userSsoLogins?: UserSsoLoginAchServiceDto[];
  userTimeAccessSetting?: UserTimeAccessSettingAchServiceDto;
  userTimeAccesses?: UserTimeAccessAchServiceDto[];
  userType?: UserType1AchServiceDto;
  /** @format int32 */
  userTypeId?: number;
  /** @format guid */
  userUniqueId?: string;
  userWidgets?: UserWidgetAchServiceDto[];
  wireAudits?: WireAuditAchServiceDto[];
};

export interface LookupAchServiceDto {
  key?: string;
  value?: string;
}

export type AssociatedClaimAchServiceDto = BaseEntityAchServiceDto & {
  account?: AccountAchServiceDto;
  /** @format int32 */
  accountId?: number;
  claim?: ClaimAchServiceDto;
  /** @format int32 */
  claimId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  endDate?: string;
  /** @format int32 */
  id?: number;
  role?: RoleAchServiceDto;
  /** @format int32 */
  roleId?: number;
  /** @format date-time */
  startDate?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
};

export type ClaimAchServiceDto = BaseEntityAchServiceDto & {
  active?: boolean;
  associatedClaims?: AssociatedClaimAchServiceDto[];
  claimNavigations?: ClaimNavigationAchServiceDto[];
  claimPrerequisites?: ClaimPrerequisiteAchServiceDto[];
  claimType?: string;
  dependentClaims?: ClaimPrerequisiteAchServiceDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  productClaims?: ProductClaimAchServiceDto[];
  uiPermission?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userType?: UserType1AchServiceDto;
  /** @format int32 */
  userTypeId?: number;
};

export interface ClaimNavigationAchServiceDto {
  /** @format int32 */
  _x003C_ClaimId_x003E_k_BackingField: number;
  /** @format int32 */
  _x003C_ClaimNavigationId_x003E_k_BackingField: number;
  _x003C_Claim_x003E_k_BackingField: ClaimAchServiceDto;
  /** @format int32 */
  _x003C_NavigationId_x003E_k_BackingField: number;
  _x003C_Navigation_x003E_k_BackingField: NavigationAchServiceDto;
}

export interface NavigationAchServiceDto {
  applicationType?: ApplicationTypeAchServiceDto;
  /** @format int32 */
  applicationTypeId?: number;
  childNavigations?: NavigationAchServiceDto[];
  key?: string;
  name?: string;
  /** @format int32 */
  navigationId?: number;
  path?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export type ApplicationTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  navigations?: NavigationAchServiceDto[];
};

export interface ClaimPrerequisiteAchServiceDto {
  claim?: ClaimAchServiceDto;
  /** @format int32 */
  claimId?: number;
  /** @format int32 */
  id?: number;
  prerequisite?: ClaimAchServiceDto;
  /** @format int32 */
  prerequisiteId?: number;
}

export type ProductClaimAchServiceDto = BaseEntityAchServiceDto & {
  claim?: ClaimAchServiceDto;
  /** @format int32 */
  claimId?: number;
  /** @format int32 */
  id?: number;
  productType?: ProductTypeAchServiceDto;
  /** @format int32 */
  productTypeId?: number;
};

export type ProductTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  institutionProductTypes?: InstitutionProductTypeAchServiceDto[];
  name?: string;
  productClaims?: ProductClaimAchServiceDto[];
  products?: ProductAchServiceDto[];
};

export type InstitutionProductTypeAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  id?: number;
  institution?: InstitutionAchServiceDto;
  institutionAchProduct?: InstitutionAchProductAchServiceDto;
  institutionArpProduct?: InstitutionArpProductAchServiceDto;
  institutionBillPayProduct?: InstitutionBillPayProductAchServiceDto;
  institutionElectronicDocuments?: InstitutionElectronicDocumentsAchServiceDto;
  /** @format int32 */
  institutionId?: number;
  institutionInternalTransferProduct?: InstitutionInternalTransferProductAchServiceDto;
  institutionProductCutoffTimes?: InstitutionProductCutoffTimeAchServiceDto[];
  /** @format guid */
  institutionProductTypeUniqueId?: string;
  institutionReportingConfigurations?: InstitutionReportingConfigurationAchServiceDto[];
  institutionReportingProduct?: InstitutionReportingProductAchServiceDto;
  institutionSsoProducts?: InstitutionSsoProductAchServiceDto[];
  institutionStopPayment?: InstitutionStopPaymentAchServiceDto;
  institutionWireInternationalProduct?: InstitutionWireInternationalProductAchServiceDto;
  institutionWireProduct?: InstitutionWireProductAchServiceDto;
  internationalUsdReadOnly?: boolean;
  isCompanyProductConfigurable?: boolean;
  productType?: ProductTypeAchServiceDto;
  /** @format int32 */
  productTypeId?: number;
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type InstitutionAchServiceDto = BaseEntityAchServiceDto & {
  accountAnalysisExceptions?: AccountAnalysisExceptionAchServiceDto[];
  achExceptionReturnCode?: string;
  analysisTransactionCodes?: AnalysisTransactionCodeAchServiceDto[];
  boReports?: BoReportAchServiceDto[];
  brandName?: string;
  challengeGroups?: ChallengeGroupAchServiceDto[];
  companies?: CompanyAchServiceDto[];
  coreReleaseVersion?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  fiId?: string;
  fileArchive?: FileArchiveAchServiceDto;
  /** @format int32 */
  fileArchiveId?: number;
  /** @format int32 */
  id?: number;
  informationCenterConfigurations?: InformationCenterConfigurationAchServiceDto[];
  institutionAccountDisplaySetting?: InstitutionAccountDisplaySettingAchServiceDto;
  institutionAffiliations?: InstitutionAffiliationAchServiceDto[];
  institutionFraudProviders?: InstitutionFraudProviderAchServiceDto;
  institutionMessageCenter?: InstitutionMessageCenterAchServiceDto;
  institutionNachaFileRecord?: InstitutionNachaFileRecordAchServiceDto;
  institutionName?: string;
  institutionNotificationTypes?: InstitutionNotificationTypeAchServiceDto[];
  institutionOobConfiguration?: InstitutionOobConfigurationAchServiceDto;
  institutionProductTypes?: InstitutionProductTypeAchServiceDto[];
  institutionTerm?: InstitutionTermAchServiceDto;
  institutionUniversalId?: string;
  institutionUserApprovalSetting?: InstitutionUserApprovalSettingAchServiceDto;
  institutionWireInternationalWorkflowOverrides?: InstitutionWireInternationalWorkflowOverridesAchServiceDto;
  jxEnvironment?: string;
  jxRoutingNumber?: string;
  loginConfigurations?: LoginConfigurationAchServiceDto[];
  logo?: string;
  logoutURL?: string;
  notificationEmail?: string;
  notificationEnabled?: boolean;
  /** @format duration */
  paymentProcessTime?: string;
  resourceConfigurations?: ResourceConfigurationAchServiceDto[];
  roles?: RoleAchServiceDto[];
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  rsaInstId?: string;
  showCutOffTimeZone?: boolean;
  supportDepartmentName?: string;
  supportEmail?: string;
  supportPhone?: string;
  /** @format int32 */
  timeZoneId?: number;
  transactionCodeGroups?: TransactionCodeGroupAchServiceDto[];
  transactionCodes?: TransactionCodeAchServiceDto[];
  treasuryProductName?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  users?: UserAchServiceDto[];
  welcomeEmailText?: string;
};

export interface AccountAnalysisExceptionAchServiceDto {
  /** @format date-time */
  activityDate?: string;
  analysisTransactionType?: AnalysisTransactionTypeAchServiceDto;
  /** @format int32 */
  analysisTransactionTypeId?: number;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  exceptionReason?: string;
  /** @format int32 */
  id?: number;
  institution?: InstitutionAchServiceDto;
  /** @format int32 */
  institutionId?: number;
  transactionCode?: string;
  /** @format int32 */
  transactionCount?: number;
}

export type AnalysisTransactionTypeAchServiceDto = BaseEntityAchServiceDto & {
  accountAnalysisExceptions?: AccountAnalysisExceptionAchServiceDto[];
  allowMultipleAccounts?: boolean;
  analysisTransactionCodes?: AnalysisTransactionCodeAchServiceDto[];
  analysisTransactionCounts?: AnalysisTransactionCountAchServiceDto[];
  analysisTransactionTypeCategory?: AnalysisTransactionTypeCategoryAchServiceDto;
  /** @format int32 */
  analysisTransactionTypeCategoryId?: number;
  /** @format int32 */
  analysisTransactionTypeId?: number;
  description?: string;
  /** @format int32 */
  sortOrder?: number;
  transactionName?: string;
};

export type AnalysisTransactionCodeAchServiceDto = BaseEntityAchServiceDto & {
  active?: boolean;
  /** @format int32 */
  analysisTransactionCodeId?: number;
  analysisTransactionType?: AnalysisTransactionTypeAchServiceDto;
  /** @format int32 */
  analysisTransactionTypeId?: number;
  institution?: InstitutionAchServiceDto;
  /** @format int32 */
  institutionId?: number;
  transactionCode?: string;
};

export interface AnalysisTransactionCountAchServiceDto {
  account?: AccountAchServiceDto;
  accountAnalysisProcessStatusType?: AccountAnalysisProcessStatusTypeAchServiceDto;
  /** @format int32 */
  accountAnalysisProcessStatusTypeId?: number;
  /** @format int32 */
  accountId?: number;
  /** @format date-time */
  activityDate?: string;
  /** @format int32 */
  analysisTransactionCountId?: number;
  analysisTransactionType?: AnalysisTransactionTypeAchServiceDto;
  /** @format int32 */
  analysisTransactionTypeId?: number;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  exceptionReason?: string;
  transactionCode?: string;
  /** @format int32 */
  transactionCount?: number;
  /** @format date-time */
  updatedDate?: string;
}

export interface AccountAnalysisProcessStatusTypeAchServiceDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export type AnalysisTransactionTypeCategoryAchServiceDto = BaseEntityAchServiceDto & {
  categoryName?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  sortOrder?: number;
};

export type BoReportAchServiceDto = BaseEntityAchServiceDto & {
  boFavoriteReports?: BoFavoriteReportAchServiceDto[];
  boReport1?: BoReportAchServiceDto[];
  boReport2?: BoReportAchServiceDto;
  boReportColumns?: BoReportColumnAchServiceDto[];
  boReportFilters?: BoReportFilterAchServiceDto[];
  customFilter?: string;
  description?: string;
  /** @format int32 */
  id?: number;
  institution?: InstitutionAchServiceDto;
  /** @format int32 */
  institutionId?: number;
  isCustomReport?: boolean;
  isFavoriteReport?: boolean;
  /** @format int32 */
  ownerId?: number;
  reportName?: string;
  reportType?: string;
  rowStatusId?: number;
  runDefaultSearch?: boolean;
  sequences?: BoReportUISequenceAchServiceDto[];
  /** @format int32 */
  standardReportId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
};

export type BoFavoriteReportAchServiceDto = BaseEntityAchServiceDto & {
  boReport?: BoReportAchServiceDto;
  /** @format int32 */
  boReportId?: number;
  /** @format int32 */
  id?: number;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
};

export type BoReportColumnAchServiceDto = BaseEntityAchServiceDto & {
  boReport?: BoReportAchServiceDto;
  /** @format int32 */
  boReportId?: number;
  columnName?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  description?: string;
  detailsAccessible?: boolean;
  displayName?: string;
  /** @format int32 */
  displayOrder?: number;
  displayType?: string;
  /** @format int32 */
  id?: number;
  isSortable?: boolean;
};

export type BoReportFilterAchServiceDto = BaseEntityAchServiceDto & {
  applyCascadeFilter?: boolean;
  boReport?: BoReportAchServiceDto;
  /** @format int32 */
  boReportId?: number;
  filterLabel?: string;
  filterModel?: string;
  filterType?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  order?: number;
  required?: boolean;
  triggerCascadeFilter?: boolean;
};

export type BoReportUISequenceAchServiceDto = BaseEntityAchServiceDto & {
  boReport?: BoReportAchServiceDto;
  /** @format int32 */
  boReportId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  order?: number;
  selector?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
};

export type ChallengeGroupAchServiceDto = BaseEntityAchServiceDto & {
  challengeGroupDetails?: ChallengeGroupDetailAchServiceDto[];
  companyChallengeGroups?: CompanyChallengeGroupAchServiceDto[];
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  description?: string;
  /** @format int32 */
  id?: number;
  institution?: InstitutionAchServiceDto;
  /** @format int32 */
  institutionId?: number;
  isDefault?: boolean;
  name?: string;
  rowStatusId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type ChallengeGroupDetailAchServiceDto = BaseEntityAchServiceDto & {
  challengeGroup?: ChallengeGroupAchServiceDto;
  /** @format int32 */
  challengeGroupId?: number;
  challengePoint?: ChallengePointAchServiceDto;
  /** @format int32 */
  challengePointId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  isActivatedByThreshold?: boolean;
  isActive?: boolean;
  /** @format decimal */
  thresholdAmount?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type ChallengePointAchServiceDto = BaseEntityAchServiceDto & {
  challengeGroupDetails?: ChallengeGroupDetailAchServiceDto[];
  challengeLocation?: string;
  challengePointCategory?: ChallengePointCategoryAchServiceDto;
  /** @format int32 */
  challengePointCategoryId?: number;
  challengePointFrequencyType?: ChallengePointFrequencyTypeAchServiceDto;
  /** @format int32 */
  challengePointFrequencyTypeId?: number;
  description?: string;
  hasThreshold?: boolean;
  hoverText?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  userSessionChallengeStatus?: UserSessionChallengeStatusAchServiceDto[];
};

export type ChallengePointCategoryAchServiceDto = BaseEntityAchServiceDto & {
  challengePoints?: ChallengePointAchServiceDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  /** @format decimal */
  sort?: number;
};

export type ChallengePointFrequencyTypeAchServiceDto = BaseEntityAchServiceDto & {
  challengePoints?: ChallengePointAchServiceDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export interface UserSessionChallengeStatusAchServiceDto {
  /** @format date-time */
  challengeDate?: string;
  /** @format int32 */
  challengeMethodTypeId?: number;
  challengePoint?: ChallengePointAchServiceDto;
  /** @format int32 */
  challengePointId?: number;
  /** @format int32 */
  challengeStatusId?: number;
  challengeStatusType?: ChallengeStatusTypeAchServiceDto;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  oobReceiptId?: number;
  oobValidationMode?: OobValidationModeAchServiceDto;
  /** @format int32 */
  oobValidationModeId?: number;
  session?: SessionAchServiceDto;
  /** @format guid */
  sessionId?: string;
}

export type ChallengeStatusTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  userSessionChallengeStatus?: UserSessionChallengeStatusAchServiceDto[];
};

export interface OobValidationModeAchServiceDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface SessionAchServiceDto {
  browser?: string;
  /** @format guid */
  clientConnectionId?: string;
  clientIpAddress?: string;
  device?: string;
  /** @format guid */
  id?: string;
  /** @format date-time */
  latestSessionActivityDate?: string;
  /** @format date-time */
  loginDate?: string;
  /** @format date-time */
  logoffDate?: string;
  mfaCompleted?: boolean;
  mfaRequired?: boolean;
  printMailSSoId?: string;
  printMailUrl?: string;
  secureTokenMfaCompleted?: boolean;
  secureTokenMfaRequired?: boolean;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
  userSessionChallengeStatus?: UserSessionChallengeStatusAchServiceDto[];
}

export type CompanyChallengeGroupAchServiceDto = BaseEntityAchServiceDto & {
  challengeGroup?: ChallengeGroupAchServiceDto;
  /** @format int32 */
  challengeGroupId?: number;
  /** @format int32 */
  challengeMethodTypeId?: number;
  company?: CompanyAchServiceDto;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  rowStatusId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type CompanyAchServiceDto = BaseEntityAchServiceDto & {
  accounts?: AccountAchServiceDto[];
  achCompany?: AchCompanyAchServiceDto;
  address?: AddressAchServiceDto;
  beneficiaries?: BeneficiaryAchServiceDto[];
  canSelect?: boolean;
  childCompanies?: CompanyAchServiceDto[];
  cifNumber?: string;
  comments?: string;
  companyAccountDisplaySetting?: CompanyAccountDisplaySettingAchServiceDto;
  companyChallengeGroup?: CompanyChallengeGroupAchServiceDto;
  /** @format guid */
  companyGuidUniqueId?: string;
  companyLimits?: CompanyLimitAchServiceDto[];
  companyType?: CompanyTypeAchServiceDto;
  /** @format int32 */
  companyTypeId?: number;
  companyUniqueId?: string;
  companyUserApprovalSetting?: CompanyUserApprovalSettingAchServiceDto;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  customerSince?: string;
  fileImportLayouts?: FileImportLayoutAchServiceDto[];
  /** @format int32 */
  id?: number;
  institution?: InstitutionAchServiceDto;
  /** @format int32 */
  institutionId?: number;
  internalTransferTransactions?: InternalTransferTransactionAchServiceDto[];
  name?: string;
  ofxAuthenticationCode?: string;
  parentCompany?: CompanyAchServiceDto;
  /** @format int32 */
  parentCompanyId?: number;
  products?: ProductAchServiceDto[];
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  taxNumber?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userAccounts?: UserAccountAchServiceDto[];
  users?: UserAchServiceDto[];
  wires?: WireAchServiceDto[];
};

export type AddressAchServiceDto = BaseEntityAchServiceDto & {
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  buildingFloor?: string;
  buildingName?: string;
  buildingNumber?: string;
  buildingRoom?: string;
  city?: string;
  country?: CountryAchServiceDto;
  /** @format int32 */
  countryId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  department?: string;
  districtName?: string;
  /** @format int32 */
  id?: number;
  postBox?: string;
  postalCode?: string;
  postalCodeExtension?: string;
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  /** @format int32 */
  rowVersionId?: number;
  state?: string;
  streetName?: string;
  subDepartment?: string;
  townLocationName?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type CountryAchServiceDto = BaseEntityAchServiceDto & {
  addresses?: AddressAchServiceDto[];
  countryCode?: string;
  countryName?: string;
  currencyCode?: string;
  currencyName?: string;
  /** @format int32 */
  id?: number;
  intradaySpot?: boolean;
};

export type RowStatusAchServiceDto = BaseEntityAchServiceDto & {
  accounts?: AccountAchServiceDto[];
  addresses?: AddressAchServiceDto[];
  beneficiaries?: BeneficiaryAchServiceDto[];
  beneficiaryAudits?: BeneficiaryAuditAchServiceDto[];
  companies?: CompanyAchServiceDto[];
  description?: string;
  domesticBanks?: DomesticBankAchServiceDto[];
  id?: number;
  informationCenterConfigurations?: InformationCenterConfigurationAchServiceDto[];
  institutionNotificationTypes?: InstitutionNotificationTypeAchServiceDto[];
  institutionProductTypes?: InstitutionProductTypeAchServiceDto[];
  institutions?: InstitutionAchServiceDto[];
  name?: string;
  products?: ProductAchServiceDto[];
  resourceConfigurations?: ResourceConfigurationAchServiceDto[];
  roles?: RoleAchServiceDto[];
  schedules?: ScheduleAchServiceDto[];
  userNotificationTypes?: UserNotificationTypeAchServiceDto[];
  users?: UserAchServiceDto[];
};

export type BeneficiaryAchServiceDto = BaseEntityAchServiceDto & {
  additionalDetails?: string;
  address?: AddressAchServiceDto;
  /** @format int32 */
  addressId?: number;
  /** @format int32 */
  approvalCount?: number;
  approvedBy?: TupleStringDateTimeDto[];
  beneficiaryAccountNumber?: string;
  beneficiaryAudits?: BeneficiaryAuditAchServiceDto[];
  beneficiaryName?: string;
  company?: CompanyAchServiceDto;
  /** @format int32 */
  companyId?: number;
  /** @format int32 */
  completedApprovals?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  domesticBank?: DomesticBankAchServiceDto;
  /** @format int32 */
  domesticBankId?: number;
  domesticIntermediaryAccountNumber?: string;
  domesticIntermediaryBankAddress?: AddressAchServiceDto;
  /** @format int32 */
  domesticIntermediaryBankAddressId?: number;
  domesticIntermediaryNotes?: string;
  eligibleApprovers?: string[];
  foreignBankAddress?: AddressAchServiceDto;
  /** @format int32 */
  foreignBankAddressId?: number;
  foreignBankId?: string;
  foreignBankIdentificationType?: BankIdentificationTypeAchServiceDto;
  /** @format int32 */
  foreignBankIdentificationTypeId?: number;
  foreignBankName?: string;
  foreignIntermediaryBankAddress?: AddressAchServiceDto;
  /** @format int32 */
  foreignIntermediaryBankAddressId?: number;
  foreignIntermediaryBankId?: string;
  foreignIntermediaryBankIdentificationType?: BankIdentificationTypeAchServiceDto;
  /** @format int32 */
  foreignIntermediaryBankIdentificationTypeId?: number;
  foreignIntermediaryBankName?: string;
  foreignIntermediaryNotes?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  institutionId?: number;
  intermediaryDomesticBank?: DomesticBankAchServiceDto;
  /** @format int32 */
  intermediaryDomesticBankId?: number;
  isEdited?: boolean;
  isForeignCurrency?: boolean;
  isFreeForm?: boolean;
  isInternational?: boolean;
  isIsoCompliant?: boolean;
  isTemplateBeneficiary?: boolean;
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  status?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  useDomesticIntermediary?: boolean;
  useForeignIntermediary?: boolean;
  userDefinedDomesticBankAddress?: AddressAchServiceDto;
  /** @format int32 */
  userDefinedDomesticBankAddressId?: number;
  userDefinedDomesticBankId?: string;
  userDefinedDomesticBankIdentificationType?: BankIdentificationTypeAchServiceDto;
  /** @format int32 */
  userDefinedDomesticBankIdentificationTypeId?: number;
  userDefinedDomesticBankName?: string;
  userPermissions?: string[];
  wires?: WireAchServiceDto[];
};

export type BeneficiaryAuditAchServiceDto = BaseEntityAchServiceDto & {
  /** @format date-time */
  actionDate?: string;
  /** @format int32 */
  actionUserId?: number;
  beneficiary?: BeneficiaryAchServiceDto;
  beneficiaryActionType?: BeneficiaryActionTypeAchServiceDto;
  /** @format int32 */
  beneficiaryActionTypeId?: number;
  /** @format int32 */
  beneficiaryId?: number;
  comments?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  /** @format int32 */
  rowVersionId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
};

export type BeneficiaryActionTypeAchServiceDto = BaseEntityAchServiceDto & {
  beneficiaryAudits?: BeneficiaryAuditAchServiceDto[];
  /** @format int32 */
  id?: number;
  name?: string;
};

export type DomesticBankAchServiceDto = BaseEntityAchServiceDto & {
  addressLine1?: string;
  addressLine2?: string;
  bankName?: string;
  city?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  domesticBankTypeId?: number;
  /** @format int32 */
  id?: number;
  isActive?: boolean;
  onUs?: boolean;
  routingNumber?: string;
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  /** @format int32 */
  rowVersionId?: number;
  settlementType?: string;
  state?: StateAchServiceDto;
  stateCode?: string;
  /** @format int32 */
  stateId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  zipCode?: string;
};

export type StateAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  id?: number;
  stateCode?: string;
  stateName?: string;
};

export type BankIdentificationTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export type WireAchServiceDto = BaseWireAchServiceDto & {
  approvedBy?: TupleStringDateTimeDto[];
  /** @format int32 */
  completedApprovals?: number;
  createdByUser?: UserAchServiceDto;
  /** @format decimal */
  destinationCurrencyAmount?: number;
  duplicatePreventionId?: string;
  eligibleApprovers?: string[];
  errorSummary?: ErrorSummaryAchServiceDto;
  /** @format decimal */
  exchangeFee?: number;
  fileName?: string;
  source?: string;
  /** @format decimal */
  totalCost?: number;
  updatedByUser?: UserAchServiceDto;
  userPermissions?: string[];
  wireActionTypeEnum?: WireActionTypeEnumAchServiceDto;
  wireAudits?: WireAuditAchServiceDto[];
  wireFileUniqueId?: string;
  wireQuotes?: WireQuoteAchServiceDto[];
};

export interface ErrorSummaryAchServiceDto {
  details?: ErrorDetailAchServiceDto[];
  summaryMessage?: string;
  summaryMessageList?: string[];
  type?: ErrorTypeAchServiceDto;
}

export interface ErrorDetailAchServiceDto {
  attributeName?: string;
  key?: string;
  message?: string;
  messageList?: LookupAchServiceDto[];
  type?: ErrorTypeAchServiceDto;
}

export type WireAuditAchServiceDto = BaseEntityAchServiceDto & {
  /** @format date-time */
  actionDate?: string;
  /** @format int32 */
  actionUserId?: number;
  comments?: string;
  /** @format int32 */
  id?: number;
  user?: UserAchServiceDto;
  wire?: WireAchServiceDto;
  wireActionType?: WireActionTypeAchServiceDto;
  /** @format int32 */
  wireActionTypeId?: number;
  /** @format int32 */
  wireId?: number;
};

export type WireActionTypeAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  id?: number;
  wireActionType1?: string;
  wireAudits?: WireAuditAchServiceDto[];
};

export type WireQuoteAchServiceDto = BaseEntityAchServiceDto & {
  amexContractNumber?: string;
  /** @format int32 */
  amexQuoteId?: number;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  createdUser?: UserAchServiceDto;
  /** @format int32 */
  debitAccountId?: number;
  /** @format decimal */
  destinationCurrencyAmount?: number;
  destinationCurrencyCode?: string;
  /** @format decimal */
  exchangeFee?: number;
  /** @format decimal */
  exchangeRate?: number;
  /** @format date-time */
  expirationDate?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  institutionFxWireRatesheetId?: number;
  /** @format date-time */
  quoteDate?: string;
  /** @format int32 */
  quoteStatusTypeId?: number;
  rateId?: string;
  /** @format decimal */
  totalWireCost?: number;
  /** @format decimal */
  usdAmount?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  updatedUser?: UserAchServiceDto;
  wire?: WireAchServiceDto;
  /** @format decimal */
  wireFee?: number;
  wireFeeCurCode?: string;
  /** @format int32 */
  wireId?: number;
  wireQuoteStatusType?: WireQuoteStatusTypeAchServiceDto;
};

export type WireQuoteStatusTypeAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  id?: number;
  name?: string;
  wireQuotes?: WireQuoteAchServiceDto[];
};

export type BaseWireAchServiceDto = BaseEntityAchServiceDto & {
  account?: AccountAchServiceDto;
  additionalInformation?: string;
  /** @format decimal */
  amount?: number;
  /** @format int32 */
  approvalCount?: number;
  associatedWire?: WireAchServiceDto;
  /** @format int32 */
  associatedWireId?: number;
  beneficiary?: BeneficiaryAchServiceDto;
  beneficiaryDetails?: string;
  /** @format int32 */
  beneficiaryId?: number;
  company?: CompanyAchServiceDto;
  /** @format int32 */
  companyId?: number;
  confirmationNumber?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  debitAccountId?: number;
  destinationCurrencyCode?: string;
  /** @format date-time */
  endDate?: string;
  externallyProcessed?: boolean;
  failureReason?: string;
  /** @format int32 */
  firstRepeatOnDay?: number;
  /** @format int32 */
  frequencyTypeId?: number;
  /** @format int32 */
  id?: number;
  isDliWire?: boolean;
  isDomestic?: boolean;
  parentCompany?: CompanyAchServiceDto;
  paymentFrequencyType?: PaymentFrequencyTypeAchServiceDto;
  paymentId?: string;
  purpose?: string;
  referenceBeneficiary?: string;
  referenceNumber?: string;
  repeatOnLastBusinessDay?: boolean;
  /** @format int32 */
  secondRepeatOnDay?: number;
  /** @format date-time */
  startDate?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  /** @format date-time */
  valueDate?: string;
  /** @format int32 */
  wireCompanyId?: number;
  wireFile?: WireFileAchServiceDto;
  /** @format int32 */
  wireFileId?: number;
  wireStatusType?: WireStatusTypeAchServiceDto;
  /** @format int32 */
  wireStatusTypeId?: number;
  wireTemplate?: WireTemplateAchServiceDto;
  /** @format int32 */
  wireTemplateId?: number;
};

export type PaymentFrequencyTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  schedules?: ScheduleAchServiceDto[];
  wires?: WireAchServiceDto[];
};

export type ScheduleAchServiceDto = BaseEntityAchServiceDto & {
  canSpawnMultipleJobs?: boolean;
  /** @format int32 */
  companyId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  endDate?: string;
  /** @format int32 */
  firstRepeatOn?: number;
  /** @format int32 */
  frequencyId?: number;
  /** @format int32 */
  id?: number;
  importBatchId?: string;
  institutionFiId?: string;
  /** @format int32 */
  interval?: number;
  isWeekendIncluded?: boolean;
  /** @format date-time */
  lastScheduled?: string;
  pauseSchedule?: boolean;
  paymentFrequencyType?: PaymentFrequencyTypeAchServiceDto;
  productType?: string;
  recycleJob?: boolean;
  repeatOnLastBusinessDay?: boolean;
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  /** @format int32 */
  runningTime?: number;
  scheduleName?: string;
  scheduleSystem?: ScheduleSystemAchServiceDto;
  /** @format int32 */
  scheduleSystemId?: number;
  scheduledJobs?: ScheduledJobAchServiceDto[];
  /** @format int32 */
  secondRepeatOn?: number;
  /** @format date-time */
  startDateTime?: string;
  /** @format int32 */
  systemUniqueId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  /** @format int32 */
  userId?: number;
  /** @format date-time */
  valueDateTime?: string;
};

export type ScheduleSystemAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  schedules?: ScheduleAchServiceDto[];
};

export type ScheduledJobAchServiceDto = BaseEntityAchServiceDto & {
  /** @format guid */
  activityId?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  executionDateTime?: string;
  /** @format date-time */
  frequencyTargetDate?: string;
  /** @format int64 */
  id?: number;
  jobStatusType?: JobStatusTypeAchServiceDto;
  /** @format byte */
  jobStatusTypeId?: number;
  responseMessages?: string;
  schedule?: ScheduleAchServiceDto;
  /** @format int32 */
  scheduleId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type JobStatusTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format byte */
  id?: number;
  name?: string;
  scheduledJobs?: ScheduledJobAchServiceDto[];
};

export interface WireFileAchServiceDto {
  /** @format decimal */
  amount?: number;
  /** @format int32 */
  approvedCount?: number;
  /** @format int32 */
  batchCount?: number;
  /** @format int32 */
  companyId?: number;
  deletedBy?: string;
  /** @format date-time */
  deletedDate?: string;
  /** @format guid */
  duplicateWireFileUniqueId?: string;
  /** @format int32 */
  expiredCount?: number;
  fileArchive?: FileArchiveAchServiceDto;
  /** @format int32 */
  fileArchiveId?: number;
  /** @format int32 */
  fileSize?: number;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  institutionId?: number;
  isDeleted?: boolean;
  isDuplicated?: boolean;
  isExpired?: boolean;
  /** @format int32 */
  pendingCount?: number;
  processedBy?: string;
  /** @format date-time */
  processedDate?: string;
  /** @format int32 */
  rejectedCount?: number;
  status?: string;
  /** @format int32 */
  totalWireCount?: number;
  /** @format guid */
  wireFileUniqueId?: string;
  wires?: WireAchServiceDto[];
}

export type FileArchiveAchServiceDto = BaseEntityAchServiceDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format byte */
  fileContent?: string;
  /** @format int32 */
  fileFormatTypeId?: number;
  fileName?: string;
  /** @format int32 */
  fileTypeId?: number;
  fileValidationFailures?: FileValidationFailureAchServiceDto[];
  /** @format int32 */
  id?: number;
  isValid?: boolean;
  /** @format guid */
  uniqueId?: string;
};

export interface FileValidationFailureAchServiceDto {
  fileArchive?: FileArchiveAchServiceDto;
  /** @format int32 */
  fileArchiveId?: number;
  fileValidationFailureType?: FileValidationFailureTypeAchServiceDto;
  /** @format int32 */
  fileValidationFailureTypeId?: number;
  /** @format int32 */
  id?: number;
  validationFailureJson?: string;
}

export interface FileValidationFailureTypeAchServiceDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export type WireStatusTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  wires?: WireAchServiceDto[];
};

export type WireTemplateAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  approvalCount?: number;
  approvedBy?: TupleStringDateTimeDto[];
  beneficiary?: BeneficiaryAchServiceDto;
  /** @format int32 */
  beneficiaryId?: number;
  /** @format int32 */
  completedApprovals?: number;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  debitAccount?: AccountAchServiceDto;
  /** @format int32 */
  debitAccountId?: number;
  eligibleApprovers?: string[];
  errorSummary?: ErrorSummaryAchServiceDto;
  /** @format int32 */
  id?: number;
  initiatedRecurringWire?: boolean;
  isInternational?: boolean;
  notes?: string;
  purpose?: string;
  referenceBeneficiary?: string;
  templateName?: string;
  templateStatusType?: WireTemplateStatusTypeAchServiceDto;
  /** @format int32 */
  templateStatusTypeId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  updatedUser?: UserAchServiceDto;
  userPermissions?: string[];
  wireCompany?: CompanyAchServiceDto;
  /** @format int32 */
  wireCompanyId?: number;
  wireTemplateAudits?: WireTemplateAuditAchServiceDto[];
};

export type WireTemplateStatusTypeAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  id?: number;
  name?: string;
  wireTemplates?: WireTemplateAchServiceDto[];
};

export type WireTemplateAuditAchServiceDto = BaseEntityAchServiceDto & {
  /** @format date-time */
  actionDate?: string;
  actionUser?: UserAchServiceDto;
  /** @format int32 */
  actionUserId?: number;
  /** @format int32 */
  id?: number;
  wireTemplateActionType?: WireTemplateActionTypeAchServiceDto;
  /** @format int32 */
  wireTemplateActionTypeId?: number;
  /** @format int32 */
  wireTemplateId?: number;
};

export type WireTemplateActionTypeAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  id?: number;
  name?: string;
  wireTemplateAudits?: WireTemplateAuditAchServiceDto[];
};

export type InformationCenterConfigurationAchServiceDto = BaseEntityAchServiceDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  description?: string;
  /** @format date-time */
  endDate?: string;
  /** @format int32 */
  id?: number;
  informationCenterMessageType?: InformationCenterMessageTypeAchServiceDto;
  /** @format int32 */
  informationCenterMessageTypeId?: number;
  institution?: InstitutionAchServiceDto;
  /** @format int32 */
  institutionId?: number;
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  /** @format int32 */
  sequence?: number;
  /** @format date-time */
  startDate?: string;
  title?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type InformationCenterMessageTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  informationCenterConfigurations?: InformationCenterConfigurationAchServiceDto[];
  name?: string;
};

export type InstitutionNotificationTypeAchServiceDto = BaseEntityAchServiceDto & {
  desktopNotification?: boolean;
  email?: boolean;
  /** @format int32 */
  id?: number;
  institution?: InstitutionAchServiceDto;
  /** @format int32 */
  institutionId?: number;
  isNotificationEnabled?: boolean;
  isRequired?: boolean;
  notificationGroup?: string;
  notificationType?: NotificationTypeAchServiceDto;
  /** @format int32 */
  notificationTypeId?: number;
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  /** @format int32 */
  sortOrder?: number;
  textMessage?: boolean;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type NotificationTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  institutionNotificationTypes?: InstitutionNotificationTypeAchServiceDto[];
  isActiveByDefault?: boolean;
  name?: string;
  notificationPriorityType?: NotificationPriorityTypeAchServiceDto;
  /** @format int32 */
  notificationPriorityTypeId?: number;
  notificationProductType?: NotificationProductTypeAchServiceDto;
  /** @format int32 */
  notificationProductTypeId?: number;
  notifications?: NotificationAchServiceDto[];
  /** @format int32 */
  sortOrder?: number;
  userNotificationTypes?: UserNotificationTypeAchServiceDto[];
};

export interface NotificationPriorityTypeAchServiceDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  notificationTypes?: NotificationTypeAchServiceDto[];
}

export type NotificationProductTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  notificationTypes?: NotificationTypeAchServiceDto[];
};

export interface NotificationAchServiceDto {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  createdDateFiLocalTime?: string;
  /** @format int32 */
  id?: number;
  notificationPayload?: string;
  notificationType?: NotificationTypeAchServiceDto;
  /** @format int32 */
  notificationTypeId?: number;
  /** @format guid */
  notificationUniqueIdentifier?: string;
  showAlert?: boolean;
  /** @format int32 */
  userNotificationId?: number;
}

export type UserNotificationTypeAchServiceDto = BaseEntityAchServiceDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  desktopNotification?: boolean;
  email?: boolean;
  /** @format int32 */
  id?: number;
  isDesktopAllowed?: boolean;
  isDesktopRequired?: boolean;
  isEmailAllowed?: boolean;
  isEmailRequired?: boolean;
  isTextAllowed?: boolean;
  isTextRequired?: boolean;
  notificationGroup?: string;
  notificationType?: NotificationTypeAchServiceDto;
  /** @format int32 */
  notificationTypeId?: number;
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  /** @format int32 */
  sortOrder?: number;
  textMessage?: boolean;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
};

export type ResourceConfigurationAchServiceDto = BaseEntityAchServiceDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  displayExternalWarning?: boolean;
  externalWarningMessage?: string;
  /** @format int32 */
  id?: number;
  institution?: InstitutionAchServiceDto;
  /** @format int32 */
  institutionId?: number;
  link?: string;
  /** @format byte */
  logo?: string;
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  /** @format int32 */
  sequence?: number;
  title?: string;
  tooltip?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type RoleAchServiceDto = BaseEntityAchServiceDto & {
  associatedClaims?: AssociatedClaimAchServiceDto[];
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  description?: string;
  /** @format int32 */
  id?: number;
  institution?: InstitutionAchServiceDto;
  /** @format int32 */
  institutionId?: number;
  name?: string;
  roleType?: RoleTypeAchServiceDto;
  /** @format int32 */
  roleTypeId?: number;
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userRoles?: UserRoleAchServiceDto[];
};

export type RoleTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  roles?: RoleAchServiceDto[];
};

export type UserRoleAchServiceDto = BaseEntityAchServiceDto & {
  /** @format date-time */
  endDate?: string;
  /** @format int32 */
  id?: number;
  role?: RoleAchServiceDto;
  /** @format int32 */
  roleId?: number;
  /** @format date-time */
  startDate?: string;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
};

export interface CompanyAccountDisplaySettingAchServiceDto {
  accountMaskType?: AccountMaskTypeAchServiceDto;
  /** @format int32 */
  accountMaskTypeId?: number;
  allowOverrideMasking?: boolean;
  company?: CompanyAchServiceDto;
  /** @format int32 */
  createdBy?: number;
  createdByUser?: UserAchServiceDto;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  showAccountName?: boolean;
  /** @format int32 */
  updatedBy?: number;
  updatedByUser?: UserAchServiceDto;
  /** @format date-time */
  updatedDate?: string;
}

export interface AccountMaskTypeAchServiceDto {
  description?: string;
  /** @format int32 */
  id?: number;
}

export type CompanyLimitAchServiceDto = BaseEntityAchServiceDto & {
  company?: CompanyAchServiceDto;
  /** @format int32 */
  companyId?: number;
  /** @format decimal */
  dailyLimit?: number;
  /** @format int32 */
  id?: number;
  /** @format decimal */
  monthlyLimit?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type CompanyTypeAchServiceDto = BaseEntityAchServiceDto & {
  companies?: CompanyAchServiceDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export interface CompanyUserApprovalSettingAchServiceDto {
  boUserRequireBoApproval?: boolean;
  chUserRequireBoApproval?: boolean;
  chUserRequireChApproval?: boolean;
  company?: CompanyAchServiceDto;
  /** @format int32 */
  id?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export type FileImportLayoutAchServiceDto = BaseEntityAchServiceDto & {
  company?: CompanyAchServiceDto;
  /** @format int32 */
  companyId?: number;
  delimiter?: string;
  fileFormatType?: FileFormatTypeAchServiceDto;
  /** @format int32 */
  fileFormatTypeId?: number;
  fileImportLayoutDetails?: FileImportLayoutDetailAchServiceDto[];
  /** @format int32 */
  footerRows?: number;
  /** @format int32 */
  headerRows?: number;
  /** @format int32 */
  id?: number;
  productType?: ProductTypeAchServiceDto;
  /** @format int32 */
  productTypeId?: number;
  templateName?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type FileFormatTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export type FileImportLayoutDetailAchServiceDto = BaseEntityAchServiceDto & {
  additionalInformationFour?: string;
  additionalInformationOne?: string;
  additionalInformationThree?: string;
  additionalInformationTwo?: string;
  /** @format int32 */
  beginPosition?: number;
  /** @format int32 */
  endPosition?: number;
  fileImportField?: FileImportFieldAchServiceDto;
  /** @format int32 */
  fileImportFieldId?: number;
  fileImportLayout?: FileImportLayoutAchServiceDto;
  /** @format int32 */
  fileImportLayoutId?: number;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  order?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type FileImportFieldAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  fieldName?: string;
  fileImportFieldGroup?: FileImportFieldGroupAchServiceDto;
  /** @format int32 */
  fileImportFieldGroupId?: number;
  fileType?: FileTypeAchServiceDto;
  /** @format int32 */
  fileTypeId?: number;
  /** @format int32 */
  id?: number;
  info?: string;
  isRequired?: boolean;
};

export type FileImportFieldGroupAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  fileFormatType?: FileFormatTypeAchServiceDto;
  fileImportFields?: FileImportFieldAchServiceDto[];
  /** @format int32 */
  fileTypeId?: number;
  groupName?: string;
  /** @format int32 */
  id?: number;
  info?: string;
};

export type FileTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export type InternalTransferTransactionAchServiceDto = BaseEntityAchServiceDto & {
  /** @format decimal */
  amount?: number;
  approvedBy?: TupleStringDateTimeDto[];
  batchId?: string;
  childInternalTransferTransactions?: InternalTransferTransactionAchServiceDto[];
  comments?: string;
  company?: CompanyAchServiceDto;
  /** @format int32 */
  companyId?: number;
  /** @format int32 */
  completedApprovals?: number;
  confirmationNumber?: string;
  createdBy?: string;
  createdByUser?: UserAchServiceDto;
  /** @format date-time */
  createdDate?: string;
  eligibleApprovers?: string[];
  /** @format date-time */
  endDate?: string;
  errorSummary?: ErrorSummaryAchServiceDto;
  /** @format int32 */
  firstRepeatOnDay?: number;
  fromAccount?: AccountAchServiceDto;
  /** @format int32 */
  fromAccountId?: number;
  hasNoEndDate?: boolean;
  /** @format int32 */
  id?: number;
  internalTransferAudits?: InternalTransferAuditAchServiceDto[];
  internalTransferStatusType?: InternalTransferStatusTypeAchServiceDto;
  /** @format int32 */
  internalTransferStatusTypeId?: number;
  internalTransferTemplate?: InternalTransferTemplateAchServiceDto;
  /** @format int32 */
  internalTransferTemplateId?: number;
  isEdited?: boolean;
  /** @format date-time */
  lastEditedDate?: string;
  memo?: string;
  message?: string;
  messageType?: string;
  /** @format int32 */
  numberOfApprovalNeeded?: number;
  parentInternalTransferTransaction?: InternalTransferTransactionAchServiceDto;
  /** @format int32 */
  parentInternalTransferTransactionId?: number;
  paymentFrequencyType?: PaymentFrequencyTypeAchServiceDto;
  /** @format int32 */
  paymentFrequencyTypeId?: number;
  paymentOptionType?: PaymentOptionTypeAchServiceDto;
  /** @format int32 */
  paymentOptionTypeId?: number;
  permissions?: ProductPermissionAchServiceDto[];
  repeatOnLastBusinessDay?: boolean;
  /** @format int32 */
  seconRepeatOnDay?: number;
  /** @format date-time */
  startDate?: string;
  submittedToScheduler?: boolean;
  toAccount?: AccountAchServiceDto;
  /** @format int32 */
  toAccountId?: number;
  transactionId?: string;
  /** @format date-time */
  transferDate?: string;
  updatedBy?: string;
  updatedByUser?: UserAchServiceDto;
  /** @format date-time */
  updatedDate?: string;
};

export interface InternalTransferAuditAchServiceDto {
  comments?: string;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  internalTransferActionType?: InternalTransferActionTypeAchServiceDto;
  /** @format int32 */
  internalTransferActionTypeId?: number;
  /** @format int32 */
  internalTransferAuditId?: number;
  internalTransferTransaction?: InternalTransferTransactionAchServiceDto;
  /** @format int32 */
  internalTransferTransactionId?: number;
  user?: UserAchServiceDto;
}

export interface InternalTransferActionTypeAchServiceDto {
  description?: string;
  /** @format int32 */
  internalTransferActionTypeId?: number;
  internalTransferAudits?: InternalTransferAuditAchServiceDto[];
  name?: string;
}

export interface InternalTransferStatusTypeAchServiceDto {
  description?: string;
  /** @format int32 */
  internalTransferStatusTypeId?: number;
  internalTransferTransactions?: InternalTransferTransactionAchServiceDto[];
  name?: string;
}

export type InternalTransferTemplateAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  approvalCount?: number;
  company?: CompanyAchServiceDto;
  /** @format int32 */
  companyId?: number;
  /** @format int32 */
  completedApprovals?: number;
  /** @format int32 */
  createdBy?: number;
  createdByUser?: UserAchServiceDto;
  /** @format date-time */
  createdDate?: string;
  eligibleApprovers?: string[];
  fromAccountNumber?: string;
  /** @format int32 */
  id?: number;
  internalTransferTemplateAudits?: InternalTransferTemplateAuditAchServiceDto[];
  internalTransferTemplateDetails?: InternalTransferTemplateDetailAchServiceDto[];
  internalTransferTemplateStatusType?: InternalTransferTemplateStatusTypeAchServiceDto;
  /** @format int32 */
  internalTransferTemplateStatusTypeId?: number;
  internalTransferType?: InternalTransferTypeAchServiceDto;
  /** @format int32 */
  internalTransferTypeId?: number;
  oneToOneMemo?: string;
  templateAccountDetails?: AccountAchServiceDto[];
  templateName?: string;
  toAccountNumber?: string;
  /** @format decimal */
  totalAmount?: number;
  /** @format int32 */
  updatedBy?: number;
  updatedByUser?: UserAchServiceDto;
  /** @format date-time */
  updatedDate?: string;
  userPermissions?: string[];
};

export interface InternalTransferTemplateAuditAchServiceDto {
  /** @format int32 */
  createdBy?: number;
  createdByUser?: UserAchServiceDto;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  internalTransferTemplate?: InternalTransferTemplateAchServiceDto;
  internalTransferTemplateActionType?: InternalTransferTemplateActionTypeAchServiceDto;
  /** @format int32 */
  internalTransferTemplateActionTypeId?: number;
  /** @format int32 */
  internalTransferTemplateId?: number;
}

export interface InternalTransferTemplateActionTypeAchServiceDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface InternalTransferTemplateDetailAchServiceDto {
  /** @format decimal */
  amount?: number;
  /** @format int32 */
  createdBy?: number;
  createdByUser?: UserAchServiceDto;
  /** @format date-time */
  createdDate?: string;
  fromAccount?: AccountAchServiceDto;
  /** @format int32 */
  fromAccountId?: number;
  /** @format int32 */
  id?: number;
  internalTransferTemplate?: InternalTransferTemplateAchServiceDto;
  /** @format int32 */
  internalTransferTemplateId?: number;
  memo?: string;
  toAccount?: AccountAchServiceDto;
  /** @format int32 */
  toAccountId?: number;
  /** @format int32 */
  updatedBy?: number;
  updatedByUser?: UserAchServiceDto;
  /** @format date-time */
  updatedDate?: string;
}

export interface InternalTransferTemplateStatusTypeAchServiceDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface InternalTransferTypeAchServiceDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export type PaymentOptionTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export interface ProductPermissionAchServiceDto {
  /** @format int32 */
  id?: number;
  permission?: string;
  product?: ProductAchServiceDto;
  productAccountPermissions?: ProductAccountPermissionAchServiceDto[];
  /** @format int32 */
  productId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface ProductAccountPermissionAchServiceDto {
  accountProduct?: AccountProductAchServiceDto;
  /** @format int32 */
  accountProductId?: number;
  entitlements?: EntitlementAchServiceDto[];
  /** @format int32 */
  id?: number;
  productPermission?: ProductPermissionAchServiceDto;
  /** @format int32 */
  productPermissionId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface EntitlementAchServiceDto {
  /** @format int32 */
  id?: number;
  objectState?: ObjectStateAchServiceDto;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
}

export type UserAccountAchServiceDto = BaseEntityAchServiceDto & {
  account?: AccountAchServiceDto;
  /** @format int32 */
  accountId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  user?: UserAchServiceDto;
  userAccountLimits?: UserAccountLimitAchServiceDto[];
  /** @format int32 */
  userId?: number;
};

export type UserAccountLimitAchServiceDto = BaseEntityAchServiceDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format decimal */
  dailyLimit?: number;
  /** @format int32 */
  id?: number;
  /** @format decimal */
  perTransactionLimit?: number;
  productType?: ProductTypeAchServiceDto;
  /** @format int32 */
  productTypeId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userAccount?: UserAccountAchServiceDto;
  /** @format int32 */
  userAccountId?: number;
};

export interface InstitutionAccountDisplaySettingAchServiceDto {
  accountMaskType?: AccountMaskTypeAchServiceDto;
  /** @format int32 */
  accountMaskTypeId?: number;
  allowOverrideMasking?: boolean;
  /** @format int32 */
  createdBy?: number;
  createdByUser?: UserAchServiceDto;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  institution?: InstitutionAchServiceDto;
  showAccountName?: boolean;
  /** @format int32 */
  updatedBy?: number;
  updatedByUser?: UserAchServiceDto;
  /** @format date-time */
  updatedDate?: string;
}

export interface InstitutionAffiliationAchServiceDto {
  /** @format int32 */
  affiliatedInstitutionId?: number;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  institutionId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
}

export interface InstitutionFraudProviderAchServiceDto {
  institution?: InstitutionAchServiceDto;
  provider?: string;
  /** @format int32 */
  updatedBy?: number;
  updatedByUser?: UserAchServiceDto;
  /** @format date-time */
  updatedDate?: string;
}

export type InstitutionMessageCenterAchServiceDto = BaseEntityAchServiceDto & {
  archiveSetting?: ArchiveSettingAchServiceDto;
  /** @format int32 */
  archiveSettingId?: number;
  disclaimer?: string;
  /** @format int32 */
  id?: number;
  institution?: InstitutionAchServiceDto;
  sharedEmail?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  updatedUser?: UserAchServiceDto;
  useSharedEmail?: boolean;
};

export interface ArchiveSettingAchServiceDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface InstitutionNachaFileRecordAchServiceDto {
  addendaRecordIndicator?: string;
  blockingFactor?: string;
  checkDigit?: string;
  fileIdModifier?: string;
  formatCode?: string;
  /** @format int32 */
  id?: number;
  immediateDestination?: string;
  immediateDestinationName?: string;
  immediateOrigin?: string;
  immediateOriginName?: string;
  institution?: InstitutionAchServiceDto;
  originatingDfi?: string;
  originatorStatusCode?: string;
  priorityCode?: string;
  receivingDfi?: string;
  recordSize?: string;
}

export interface InstitutionOobConfigurationAchServiceDto {
  allowedOobChallengeFailureCount?: number;
  /** @format int32 */
  id?: number;
  institution?: InstitutionAchServiceDto;
  oobChallengePinNeeded?: boolean;
  oobEnabled?: boolean;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export type InstitutionTermAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  id?: number;
  institution?: InstitutionAchServiceDto;
  requireAcceptance?: boolean;
  termsAndConditions?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export interface InstitutionUserApprovalSettingAchServiceDto {
  boUserRequireBoApproval?: boolean;
  chUserRequireBoApproval?: boolean;
  chUserRequireChApproval?: boolean;
  /** @format int32 */
  id?: number;
  institution?: InstitutionAchServiceDto;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export type InstitutionWireInternationalWorkflowOverridesAchServiceDto = BaseEntityAchServiceDto & {
  allowAccountBalanceValidation?: boolean;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  forceInternationalUsdViaForeignCurrencyWorkflow?: boolean;
  /** @format int32 */
  id?: number;
  institution?: InstitutionAchServiceDto;
  rowStatusId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  useExternalFxQuoteRatesheets?: boolean;
  useExternalFxWireProcessing?: boolean;
  useNonCoreWireCompanies?: boolean;
};

export type LoginConfigurationAchServiceDto = BaseEntityAchServiceDto & {
  allowAlphabetsInLoginId?: boolean;
  allowAlphabetsInPassword?: boolean;
  allowLockedOutMessage?: boolean;
  allowNumbersInLoginId?: boolean;
  allowNumbersInPassword?: boolean;
  allowSpecialCharactersInLoginId?: boolean;
  allowSpecialCharactersInPassword?: boolean;
  alphabetsInLoginIdAreRequired?: boolean;
  alphabetsInPasswordAreRequired?: boolean;
  /** @format int32 */
  id?: number;
  institution?: InstitutionAchServiceDto;
  /** @format int32 */
  institutionId?: number;
  invalidLoginIdPasswordMessage?: string;
  isCompany?: boolean;
  isDefault?: boolean;
  lockedEmailMessage?: string;
  lockedOutMessage?: string;
  /** @format int32 */
  loginIdMaxLength?: number;
  /** @format int32 */
  loginIdMinLength?: number;
  /** @format int32 */
  numberOfAllowedAttemptsBeforeLock?: number;
  /** @format int32 */
  numberOfLowercaseRequiredInLoginId?: number;
  /** @format int32 */
  numberOfLowercaseRequiredInPassword?: number;
  /** @format int32 */
  numberOfPrevUsedPasswords?: number;
  /** @format int32 */
  numberOfUppercaseRequiredInLoginId?: number;
  /** @format int32 */
  numberOfUppercaseRequiredInPassword?: number;
  numbersInLoginIdAreRequired?: boolean;
  numbersInPasswordAreRequired?: boolean;
  /** @format int32 */
  passwordExpireInDays?: number;
  /** @format int32 */
  passwordMaxLength?: number;
  /** @format int32 */
  passwordMinLength?: number;
  sendLockedEmail?: boolean;
  /** @format int32 */
  sessionTimeoutMinutes?: number;
  specialCharactersInLoginIdAreRequired?: boolean;
  specialCharactersInPasswordAreRequired?: boolean;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  /** @format int32 */
  warnPasswordExpireInDays?: number;
  willPasswordExpire?: boolean;
};

export type TransactionCodeGroupAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  id?: number;
  institution?: InstitutionAchServiceDto;
  /** @format int32 */
  institutionId?: number;
  isReadOnly?: boolean;
  name?: string;
  transactionCodeGroupAssociations?: TransactionCodeGroupAssociationAchServiceDto[];
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type TransactionCodeGroupAssociationAchServiceDto = BaseEntityAchServiceDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  transactionCode?: TransactionCodeAchServiceDto;
  transactionCodeGroup?: TransactionCodeGroupAchServiceDto;
  /** @format int32 */
  transactionCodeGroupId?: number;
  /** @format int32 */
  transactionCodeId?: number;
};

export type TransactionCodeAchServiceDto = BaseEntityAchServiceDto & {
  achTransactionCodes?: AchTransactionCodeAchServiceDto[];
  /** @format int32 */
  baiCode?: number;
  baiCodeType?: BaiCodeTypeAchServiceDto;
  changeStatus?: string;
  code?: string;
  description?: string;
  excluded?: boolean;
  /** @format int32 */
  id?: number;
  institution?: InstitutionAchServiceDto;
  /** @format int32 */
  institutionId?: number;
  isDeleted?: boolean;
  isDescriptionChanged?: boolean;
  isTypeChanged?: boolean;
  ofxTransactionType?: OfxTransactionTypeAchServiceDto;
  /** @format int32 */
  ofxTransactionTypeId?: number;
  transactionCodeGroupAssociations?: TransactionCodeGroupAssociationAchServiceDto[];
  type?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export interface AchTransactionCodeAchServiceDto {
  accountType?: AccountTypeAchServiceDto;
  /** @format int32 */
  accountTypeId?: number;
  /** @format int32 */
  id?: number;
  transactionCode?: TransactionCodeAchServiceDto;
  /** @format int32 */
  transactionCodeId?: number;
  transactionType?: TransactionTypeAchServiceDto;
  /** @format int32 */
  transactionTypeId?: number;
}

export type BaiCodeTypeAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  baiCode?: number;
  /** @format int32 */
  baiCodeTitleId?: number;
  description?: string;
  isSelected?: boolean;
  level?: string;
  transactionType?: string;
};

export type OfxTransactionTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  displayName?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export interface InstitutionAchProductAchServiceDto {
  accountBalanceValidationConfiguredInCore?: boolean;
  achCompanyMatchType?: AchCompanyMatchTypeAchServiceDto;
  /** @format int32 */
  achCompanyMatchTypeId?: number;
  allowChildSupportPayments?: boolean;
  allowFederalTaxPayments?: boolean;
  allowInternationalPayments?: boolean;
  allowNotificationOfChange?: boolean;
  allowOnUsAccessManagement?: boolean;
  allowReturnReview?: boolean;
  allowSameDayAch?: boolean;
  allowStateTaxPayments?: boolean;
  allowTaxPayments?: boolean;
  allowUnbalancedPayments?: boolean;
  /** @format int32 */
  batchApprovalCount?: number;
  batchAuthenticationType?: AuthenticationTypeAchServiceDto;
  /** @format int32 */
  batchAuthenticationTypeId?: number;
  copyInitiatedNachaFiles?: boolean;
  /** @format int32 */
  daysInAdvance?: number;
  /** @format int32 */
  id?: number;
  institutionAchRoutings?: InstitutionAchRoutingAchServiceDto[];
  institutionAchSecCodes?: InstitutionAchSecCodeAchServiceDto[];
  institutionProductType?: InstitutionProductTypeAchServiceDto;
  internationalEnabled?: boolean;
  /** @format int32 */
  internationalTemplateApprovalCount?: number;
  nachaFileUploadPath?: string;
  /** @format int32 */
  paymentApprovalCount?: number;
  paymentAuthenticationType?: AuthenticationTypeAchServiceDto;
  /** @format int32 */
  paymentAuthenticationTypeId?: number;
  paymentProcessingCompanyConfiguredInCore?: boolean;
  /** @format int32 */
  recipientApprovalCount?: number;
  remoteServerHost?: string;
  remoteServerPassword?: string;
  /** @format int32 */
  remoteServerPort?: number;
  remoteServerUserName?: string;
  /** @format decimal */
  sameDayAchLimit?: number;
  stateTaxCodesArchiveFile?: FileArchiveAchServiceDto;
  /** @format int32 */
  stateTaxCodesArchiveFileId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  validateAccountBalance?: boolean;
}

export type AchCompanyMatchTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  institutionAchProducts?: InstitutionAchProductAchServiceDto[];
  name?: string;
};

export type InstitutionAchRoutingAchServiceDto = BaseEntityAchServiceDto & {
  bankName?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format date-time */
  endDate?: string;
  /** @format int32 */
  id?: number;
  institutionAchProduct?: InstitutionAchProductAchServiceDto;
  /** @format int32 */
  institutionProductTypeId?: number;
  routingNumber?: string;
  /** @format date-time */
  startDate?: string;
};

export type InstitutionAchSecCodeAchServiceDto = BaseEntityAchServiceDto & {
  achSecCode?: AchSecCodeAchServiceDto;
  /** @format int32 */
  achSecCodeId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  institutionAchProduct?: InstitutionAchProductAchServiceDto;
  /** @format int32 */
  institutionProductTypeId?: number;
};

export interface InstitutionArpProductAchServiceDto {
  allowIssuedItemActivityReview?: boolean;
  allowIssuedItemDelete?: boolean;
  allowIssuedItemEdit?: boolean;
  allowSubstituteProduct?: boolean;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeAchServiceDto;
  manageAchExceptions?: boolean;
  showAchExceptions?: boolean;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  workAchException?: boolean;
  workCheckException?: boolean;
}

export interface InstitutionBillPayProductAchServiceDto {
  allowIPayBusinessBillPayForMobile?: boolean;
  billPayServiceName?: string;
  billPayServiceUrl?: string;
  clientId?: string;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeAchServiceDto;
  landingPageUrl?: string;
  /** @format int32 */
  navigationMode?: number;
  sharedKey?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
}

export interface InstitutionElectronicDocumentsAchServiceDto {
  clientId?: string;
  electronicDocumentServiceName?: string;
  electronicDocumentServiceUri?: string;
  electronicDocumentType?: ElectronicDocumentTypeAchServiceDto;
  /** @format int32 */
  electronicDocumentTypeId?: number;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeAchServiceDto;
  /** @format double */
  monthlyFee?: number;
  /** @format int32 */
  navigationMode?: number;
  sharedKey?: string;
  showSsoFields?: boolean;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface ElectronicDocumentTypeAchServiceDto {
  description?: string;
  /** @format int32 */
  id?: number;
  institutionElectronicDocuments?: InstitutionElectronicDocumentsAchServiceDto[];
  name?: string;
}

export type InstitutionInternalTransferProductAchServiceDto = BaseEntityAchServiceDto & {
  allowLoanPaymentPastDue?: boolean;
  excludeLoanPaymentLimitValidation?: boolean;
  /** @format int32 */
  id?: number;
  institutionInternalTransferProductLinkAccounts?: InstitutionInternalTransferProductLinkAccountAchServiceDto[];
  institutionProductType?: InstitutionProductTypeAchServiceDto;
};

export type InstitutionInternalTransferProductLinkAccountAchServiceDto = BaseEntityAchServiceDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  fromAccountTypeId?: number;
  /** @format int32 */
  id?: number;
  institutionInternalTransferProduct?: InstitutionInternalTransferProductAchServiceDto;
  /** @format int32 */
  institutionProductTypeId?: number;
  /** @format int32 */
  toAccountTypeId?: number;
};

export type InstitutionProductCutoffTimeAchServiceDto = BaseEntityAchServiceDto & {
  /** @format duration */
  blackoutPeriodEndTime?: string;
  /** @format duration */
  blackoutPeriodStartTime?: string;
  cutoffTimeSubType?: CutoffTimeSubTypeAchServiceDto;
  /** @format int32 */
  cutoffTimeSubTypeId?: number;
  /** @format duration */
  endCutoffTime?: string;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeAchServiceDto;
  /** @format int32 */
  institutionProductTypeId?: number;
  processingDayType?: ProcessingDayTypeAchServiceDto;
  /** @format int32 */
  processingDayTypeId?: number;
  showInChannel?: boolean;
  /** @format duration */
  startCutoffTime?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type CutoffTimeSubTypeAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export type ProcessingDayTypeAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  id?: number;
  institutionProductCutoffTimes?: InstitutionProductCutoffTimeAchServiceDto[];
  processingDay?: string;
};

export type InstitutionReportingConfigurationAchServiceDto = BaseEntityAchServiceDto & {
  hasBai?: boolean;
  hasCsv?: boolean;
  hasDownload?: boolean;
  hasEmail?: boolean;
  hasPdf?: boolean;
  hasQuickBooks?: boolean;
  hasQuicken?: boolean;
  hasTiff?: boolean;
  hasWord?: boolean;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeAchServiceDto;
  /** @format int32 */
  institutionProductTypeId?: number;
  /** @format int32 */
  standardReportId?: number;
  supportsBai?: boolean;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type InstitutionReportingProductAchServiceDto = BaseEntityAchServiceDto & {
  channelMobile?: boolean;
  channelTablet?: boolean;
  channelWeb?: boolean;
  exportFormats?: ReportExportFormatAchServiceDto[];
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeAchServiceDto;
};

export interface ReportExportFormatAchServiceDto {
  isConfigured?: boolean;
  name?: string;
}

export type InstitutionSsoProductAchServiceDto = BaseEntityAchServiceDto & {
  clientId?: string;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeAchServiceDto;
  /** @format int32 */
  institutionProductTypeId?: number;
  landingPageUrl?: string;
  rowStatusId?: number;
  serviceUrl?: string;
  sharedEncryptionInitializationVector?: string;
  sharedEncryptionKey?: string;
  ssoLoginSystem?: SsoLoginSystemAchServiceDto;
  /** @format int32 */
  ssoLoginSystemId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
};

export type SsoLoginSystemAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  institutionSsoProducts?: InstitutionSsoProductAchServiceDto[];
  name?: string;
  /** @format int32 */
  ssoLoginSystemId?: number;
  userSsoLogins?: UserSsoLoginAchServiceDto[];
};

export type UserSsoLoginAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  rowStatusId?: number;
  ssoAccessKey?: string;
  ssoLoginId?: string;
  ssoLoginSystem?: SsoLoginSystemAchServiceDto;
  /** @format int32 */
  ssoLoginSystemId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
  /** @format int32 */
  userSsoLoginId?: number;
};

export interface InstitutionStopPaymentAchServiceDto {
  approvalCount?: number;
  /** @format double */
  feePerRequest?: number;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeAchServiceDto;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export type InstitutionWireInternationalProductAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  beneficiaryApprovalCount?: number;
  /** @format decimal */
  dailyLimit?: number;
  fxClientId?: string;
  fxPaymentNotificationEmailAddresses?: TextKeyCollectionAchServiceDto;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeAchServiceDto;
  institutionWirePaymentApprovalSettings?: InstitutionWirePaymentApprovalSettingAchServiceDto[];
  internationalUsdReadOnly?: boolean;
  /** @format byte */
  outgoingSettlementTypeId?: number;
  /** @format int32 */
  paymentApprovalCount?: number;
  /** @format byte */
  paymentApprovalType?: number;
  requirePaymentPurpose?: boolean;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  updatedUser?: UserAchServiceDto;
  validateAccountBalance?: boolean;
  wireSettlementAccount?: string;
  wireTraditionalInternationalEnabled?: boolean;
  wireUsdEnabled?: boolean;
};

export type TextKeyCollectionAchServiceDto = string[];

export interface InstitutionWirePaymentApprovalSettingAchServiceDto {
  /** @format byte */
  approvalCount?: number;
  /** @format decimal */
  endAmount?: number;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeAchServiceDto;
  /** @format int32 */
  institutionProductTypeId?: number;
  /** @format decimal */
  startAmount?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
}

export type InstitutionWireProductAchServiceDto = BaseEntityAchServiceDto & {
  allowWireFileUpload?: boolean;
  /** @format int32 */
  beneficiaryApprovalCount?: number;
  beneficiaryAuthenticationType?: AuthenticationTypeAchServiceDto;
  /** @format int32 */
  beneficiaryAuthenticationTypeId?: number;
  /** @format decimal */
  dailyLimit?: number;
  /** @format int32 */
  id?: number;
  institutionProductType?: InstitutionProductTypeAchServiceDto;
  institutionWirePaymentApprovalSettings?: InstitutionWirePaymentApprovalSettingAchServiceDto[];
  internationalEnabled?: boolean;
  limitFutureDateEnabled?: boolean;
  /** @format int32 */
  maximumFutureDays?: number;
  /** @format int32 */
  paymentApprovalCount?: number;
  /** @format byte */
  paymentApprovalType?: number;
  paymentAuthenticationType?: AuthenticationTypeAchServiceDto;
  /** @format int32 */
  paymentAuthenticationTypeId?: number;
  requirePaymentPurpose?: boolean;
  /** @format byte */
  templateApprovalCount?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  updatedUser?: UserAchServiceDto;
  wireDliInternationalEnabled?: boolean;
};

export type UserType1AchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  users?: UserAchServiceDto[];
};

export type FavoriteReportAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  id?: number;
  reportingFilter?: ReportingFilterAchServiceDto;
  /** @format int32 */
  reportingFilterId?: number;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
};

export type ReportingFilterAchServiceDto = BaseEntityAchServiceDto & {
  accountTypes?: string;
  amountOperator?: string;
  companyUniqueId?: string;
  dateType?: string;
  favoriteReports?: FavoriteReportAchServiceDto[];
  /** @format decimal */
  fromAmount?: number;
  /** @format date-time */
  fromDate?: string;
  fromPaymentId?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  institutionId?: number;
  isAscendingSort?: boolean;
  isFavorite?: boolean;
  isStandardReport?: boolean;
  name?: string;
  /** @format int32 */
  owner?: number;
  paymentIdOperator?: string;
  paymentTypes?: FilterPaymentTypeAchServiceDto[];
  postedTransactions?: boolean;
  /** @format int32 */
  priorDays?: number;
  reportType?: string;
  reportingBalanceFilter?: ReportingBalanceFilterAchServiceDto;
  reportingConfigurations?: ReportingConfigurationAchServiceDto[];
  reportingFilter1?: ReportingFilterAchServiceDto[];
  reportingFilter2?: ReportingFilterAchServiceDto;
  reportingFilterAccounts?: ReportingFilterAccountAchServiceDto[];
  reportingFilterPaymentTypes?: ReportingFilterPaymentTypeAchServiceDto[];
  reportingFilterSorts?: ReportingFilterSortAchServiceDto[];
  reportingTransactionFilter?: ReportingTransactionFilterAchServiceDto;
  /** @format int32 */
  sequence?: number;
  sortBy?: string;
  /** @format date-time */
  specificDate?: string;
  /** @format int32 */
  standardReportTypeId?: number;
  /** @format decimal */
  toAmount?: number;
  /** @format date-time */
  toDate?: string;
  toPaymentId?: string;
  transactionDirection?: string;
  transactionType?: string;
  type?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
};

export interface FilterPaymentTypeAchServiceDto {
  type?: string;
}

export type ReportingBalanceFilterAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  id?: number;
  reportingFilter?: ReportingFilterAchServiceDto;
};

export type ReportingConfigurationAchServiceDto = BaseEntityAchServiceDto & {
  hasBai?: boolean;
  hasCsv?: boolean;
  hasDownload?: boolean;
  hasEmail?: boolean;
  hasPdf?: boolean;
  hasQuickBooks?: boolean;
  hasQuicken?: boolean;
  hasTiff?: boolean;
  hasWord?: boolean;
  /** @format int32 */
  id?: number;
  product?: ProductAchServiceDto;
  /** @format int32 */
  productId?: number;
  reportingFilter?: ReportingFilterAchServiceDto;
  /** @format int32 */
  standardReportId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type ReportingFilterAccountAchServiceDto = BaseEntityAchServiceDto & {
  account?: AccountAchServiceDto;
  /** @format int32 */
  accountId?: number;
  /** @format int32 */
  id?: number;
  reportingFilter?: ReportingFilterAchServiceDto;
  /** @format int32 */
  reportingFilterId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type ReportingFilterPaymentTypeAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  id?: number;
  paymentType?: string;
  reportingFilter?: ReportingFilterAchServiceDto;
  /** @format int32 */
  reportingFilterId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export interface ReportingFilterSortAchServiceDto {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  reportingFilter?: ReportingFilterAchServiceDto;
  /** @format int32 */
  reportingFilterId?: number;
  /** @format int32 */
  sequence?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
}

export type ReportingTransactionFilterAchServiceDto = BaseEntityAchServiceDto & {
  amountOperator?: string;
  /** @format decimal */
  fromAmount?: number;
  fromPaymentId?: string;
  /** @format int32 */
  id?: number;
  paymentIdOperator?: string;
  reportingFilter?: ReportingFilterAchServiceDto;
  /** @format decimal */
  toAmount?: number;
  toPaymentId?: string;
  transactionDirection?: string;
  transactionType?: string;
};

export type TextMessagingCarrierAchServiceDto = BaseEntityAchServiceDto & {
  active?: boolean;
  /** @format int32 */
  id?: number;
  name?: string;
  providerId?: string;
  serviceId?: string;
  serviceTypeId?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export interface PendingEditOfUserAchServiceDto {
  comment?: string;
  company?: CompanyAchServiceDto;
  /** @format int32 */
  companyId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  isNew?: boolean;
  pendingEditInJson?: string;
  /** @format guid */
  pendingEditOfUserUniqueId?: string;
  /** @format int32 */
  pendingEditStatusId?: number;
  /** @format int32 */
  pendingEditTableId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  /** @format int32 */
  userId?: number;
}

export type UserAccountGroupAchServiceDto = BaseEntityAchServiceDto & {
  accountGroupName?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  /** @format byte */
  sequency?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
  userAccountGroupAccounts?: UserAccountGroupAccountAchServiceDto[];
  /** @format int32 */
  userId?: number;
};

export type UserAccountGroupAccountAchServiceDto = BaseEntityAchServiceDto & {
  account?: AccountAchServiceDto;
  /** @format int32 */
  accountId?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  sequence?: number;
  userAccountGroup?: UserAccountGroupAchServiceDto;
  /** @format int32 */
  userAccountGroupId?: number;
};

export type UserAchCompanyAchServiceDto = BaseEntityAchServiceDto & {
  achCompany?: AchCompanyAchServiceDto;
  /** @format int32 */
  achCompanyId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format decimal */
  dailyLimit?: number;
  /** @format int32 */
  id?: number;
  /** @format decimal */
  perTransactionLimit?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
};

export type UserAuditAchServiceDto = BaseEntityAchServiceDto & {
  comment?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
};

export type UserDeviceAchServiceDto = BaseEntityAchServiceDto & {
  authenticationId?: string;
  /** @format int32 */
  id?: number;
  key?: string;
  /** @format date-time */
  keyCreatedDate?: string;
  /** @format date-time */
  keyLastUsedDate?: string;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
};

export type UserIpAccessSettingAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  restricted?: boolean;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
};

export type UserIpAccessAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  ipAddress?: string;
  nickname?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
};

export type UserNotificationAchServiceDto = BaseEntityAchServiceDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  isEmailSent?: boolean;
  isRead?: boolean;
  isTextMessageSent?: boolean;
  notification?: NotificationAchServiceDto;
  /** @format int32 */
  notificationId?: number;
  notificationStatusType?: NotificationStatusTypeAchServiceDto;
  /** @format int32 */
  notificationStatusTypeId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
};

export interface NotificationStatusTypeAchServiceDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface UserOobDetailAchServiceDto {
  audioPhoneNumber?: string;
  challengePin?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  isLocked?: boolean;
  isOobPinCollected?: boolean;
  /** @format date-time */
  localSuspendEndDate?: string;
  needCollection?: boolean;
  oobAuthCount?: number;
  oobValidationMode?: OobValidationModeAchServiceDto;
  /** @format int32 */
  preferredOobValidationModeId?: number;
  remindMeCount?: number;
  smsPhoneNumber?: string;
  /** @format date-time */
  suspendEndDate?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
}

export type UserPasswordHistoryAchServiceDto = BaseEntityAchServiceDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  password?: string;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
};

export type UserProductLimitAchServiceDto = BaseEntityAchServiceDto & {
  /** @format decimal */
  approvalLimit?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  /** @format decimal */
  initiationLimit?: number;
  product?: ProductAchServiceDto;
  /** @format int32 */
  productId?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
};

export interface UserSecureTokenSecurityAchServiceDto {
  challengePin?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  isLocked?: boolean;
  /** @format date-time */
  localSuspendEndDate?: string;
  needCollection?: boolean;
  remindMeCount?: number;
  secureChallengePin?: string;
  secureTokenCredentialId?: string;
  /** @format date-time */
  suspendEndDate?: string;
  tokenAuthFailureCount?: number;
  tokenCredentialId?: string;
  tokenVendorUserId?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
}

export type UserTimeAccessSettingAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  restricted?: boolean;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
};

export type UserTimeAccessAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  dayOfWeekId?: number;
  /** @format duration */
  endTime?: string;
  /** @format int32 */
  id?: number;
  /** @format duration */
  startTime?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
  /** @format int32 */
  userId?: number;
  userTimeAccessTypeId?: number;
};

export type UserWidgetAchServiceDto = BaseEntityAchServiceDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  height?: number;
  /** @format int32 */
  id?: number;
  positionLeft?: number;
  positionTop?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  /** @format int32 */
  userId?: number;
  widget?: WidgetAchServiceDto;
  /** @format int32 */
  widgetId?: number;
  width?: number;
};

export type WidgetAchServiceDto = BaseEntityAchServiceDto & {
  defaultContent?: string;
  defaultHeight?: number;
  defaultLeft?: number;
  defaultTop?: number;
  defaultWidth?: number;
  description?: string;
  hasPermission?: boolean;
  /** @format int32 */
  id?: number;
  imageUrl?: string;
  /** @format int32 */
  institutionId?: number;
  isFullScreenAllowed?: boolean;
  isPermissionRequired?: boolean;
  isRequired?: boolean;
  isResizable?: boolean;
  maxHeight?: number;
  maxWidth?: number;
  minHeight?: number;
  minWidth?: number;
  name?: string;
  permissionMessage?: string;
  title?: string;
  userWidgets?: UserWidgetAchServiceDto[];
};

export interface BatchBalanceTypeAchServiceDto {
  achCompanies?: AchCompanyAchServiceDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export type InternationalPaymentRecipientDto = AchPaymentRecipientAchServiceDto & {
  city?: string;
  country?: string;
  iatTransactionType?: string;
  optionalAddendaLine1?: string;
  optionalAddendaLine2?: string;
  receivingBankCountry?: string;
  receivingBankName?: string;
  receivingBankNumber?: string;
  receivingBankType?: string;
  state?: string;
  streetAddress?: string;
  zipCode?: string;
};

export type ChildSupportPaymentRecipientDto = AchPaymentRecipientAchServiceDto & {
  achPaymentRecipientAddendas?: ChildSupportPaymentRecipientAddendaCollectionDto;
};

export type ChildSupportPaymentRecipientAddendaCollectionDto =
  ChildSupportPaymentRecipientAddendaDto[];

export interface ChildSupportPaymentRecipientAddendaDto {
  caseIdentifier?: string;
  employmentTermination?: boolean;
  fipsCode?: string;
  medicalSupport?: boolean;
  nonCustodialParentFirstName?: string;
  nonCustodialParentLastName?: string;
  nonCustodialParentSsn?: string;
  /** @format date-time */
  payDate?: string;
}

export type AchBatchRecipientAddendaAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  achBatchId?: number;
  achBatchRecipient?: AchBatchRecipientAchServiceDto;
  /** @format int32 */
  achBatchRecipientId?: number;
  addenda?: string;
  addendaType?: AddendaTypeAchServiceDto;
  /** @format int32 */
  addendaTypeId?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  rowNum?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
};

export type AchFederalTaxTemplateAchServiceDto = BaseEntityAchServiceDto & {
  achFederalTaxTemplateAmounts?: AchFederalTaxTemplateAmountAchServiceDto[];
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  recipientAccountNumber?: string;
  recipientAccountType?: AccountTypeAchServiceDto;
  /** @format int32 */
  recipientAccountTypeId?: number;
  recipientIdNumber?: string;
  recipientName?: string;
  recipientRoutingNumber?: string;
  taxCode?: string;
  taxPayerId?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
};

export type AchFederalTaxTemplateAmountAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  achBatchId?: number;
  achFederalAmountType?: AchFederalAmountTypeAchServiceDto;
  /** @format int32 */
  achFederalAmountTypeId?: number;
  /** @format decimal */
  amount?: number;
  amountType?: string;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
};

export interface AchFederalAmountTypeAchServiceDto {
  amountType?: string;
  description?: string;
  /** @format int32 */
  id?: number;
}

export interface AchPaymentTypeAchServiceDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export type AchStateTaxTemplateAchServiceDto = BaseEntityAchServiceDto & {
  achStateTaxTemplateAmounts?: AchStateTaxTemplateAmountAchServiceDto[];
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  recipientAccountNumber?: string;
  recipientAccountType?: AccountTypeAchServiceDto;
  /** @format int32 */
  recipientAccountTypeId?: number;
  recipientIdNumber?: string;
  recipientName?: string;
  recipientRoutingNumber?: string;
  state?: StateAchServiceDto;
  /** @format int32 */
  stateId?: number;
  taxCode?: string;
  taxPayerId?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
};

export type AchStateTaxTemplateAmountAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  achBatchId?: number;
  achStateAmountType?: AchStateAmountTypeAchServiceDto;
  /** @format int32 */
  achStateAmountTypeId?: number;
  /** @format decimal */
  amount?: number;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
};

export interface AchStateAmountTypeAchServiceDto {
  amountType?: string;
  description?: string;
  /** @format int32 */
  id?: number;
}

export type BatchStatusTypeAchServiceDto = BaseEntityAchServiceDto & {
  achBatches?: AchBatchAchServiceDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
};

export interface AchFederalTaxPaymentAchServiceDto {
  achFederalTaxPaymentAmounts?: AchFederalTaxPaymentAmountAchServiceDto[];
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  payFromAccount?: AccountAchServiceDto;
  /** @format int32 */
  payFromAccountId?: number;
  recipientAccountNumber?: string;
  recipientAccountType?: AccountTypeAchServiceDto;
  /** @format int32 */
  recipientAccountTypeId?: number;
  recipientIdNumber?: string;
  recipientName?: string;
  recipientRoutingNumber?: string;
  taxCode?: string;
  taxPayerId?: string;
  /** @format date-time */
  taxPeriodEndDate?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface AchFederalTaxPaymentAmountAchServiceDto {
  achFederalAmountType?: AchFederalAmountTypeAchServiceDto;
  /** @format int32 */
  achFederalAmountTypeId?: number;
  /** @format int32 */
  achPaymentId?: number;
  /** @format decimal */
  amount?: number;
  amountType?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface AchNachaFileCopyAuditAchServiceDto {
  achPayment?: AchPaymentAchServiceDto;
  /** @format int32 */
  achPaymentId?: number;
  /** @format int32 */
  createdBy?: number;
  createdByUser?: UserAchServiceDto;
  /** @format date-time */
  createdDate?: string;
  fileCopyStatus?: string;
  /** @format int32 */
  id?: number;
  message?: string;
  nachaFileName?: string;
}

export interface AchStateTaxPaymentAchServiceDto {
  achStateTaxPaymentAmounts?: AchStateTaxPaymentAmountAchServiceDto[];
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  payFromAccount?: AccountAchServiceDto;
  /** @format int32 */
  payFromAccountId?: number;
  recipientAccountNumber?: string;
  recipientAccountType?: AccountTypeAchServiceDto;
  /** @format int32 */
  recipientAccountTypeId?: number;
  recipientIdNumber?: string;
  recipientName?: string;
  recipientRoutingNumber?: string;
  state?: StateAchServiceDto;
  /** @format int32 */
  stateId?: number;
  taxCode?: string;
  taxPayerId?: string;
  /** @format date-time */
  taxPeriodEndDate?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface AchStateTaxPaymentAmountAchServiceDto {
  /** @format int32 */
  achPaymentId?: number;
  achStateAmountType?: AchStateAmountTypeAchServiceDto;
  /** @format int32 */
  achStateAmountTypeId?: number;
  /** @format decimal */
  amount?: number;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface AchStatusTypeAchServiceDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export type ChildSupportPaymentDto = AchPaymentAchServiceDto & {
  achPaymentRecipients?: ChildSupportPaymentRecipientCollectionDto;
};

export type ChildSupportPaymentRecipientCollectionDto = ChildSupportPaymentRecipientDto[];

export type InternationalPaymentDto = AchPaymentAchServiceDto & {
  achInternationalPaymentRecipients?: InternationalPaymentRecipientCollectionDto;
  city?: string;
  country?: string;
  state?: string;
  streetAddress?: string;
  zipCode?: string;
};

export type InternationalPaymentRecipientCollectionDto = InternationalPaymentRecipientDto[];

export type InternalTransferProductAchServiceDto = BaseEntityAchServiceDto & {
  allowLoanPaymentPastDue?: boolean;
  /** @format int32 */
  approvalCount?: number;
  /** @format int32 */
  authenticationTypeId?: number;
  /** @format decimal */
  dailyLimit?: number;
  excludeLoanPaymentLimitValidation?: boolean;
  /** @format int32 */
  id?: number;
  internalTransferProductLinkAccounts?: InternalTransferProductLinkAccountAchServiceDto[];
  product?: ProductAchServiceDto;
  /** @format byte */
  templateApprovalCount?: number;
};

export type InternalTransferProductLinkAccountAchServiceDto = BaseEntityAchServiceDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  fromAccountType?: AccountTypeAchServiceDto;
  /** @format int32 */
  fromAccountTypeId?: number;
  /** @format int32 */
  id?: number;
  internalTransferProduct?: InternalTransferProductAchServiceDto;
  /** @format int32 */
  productId?: number;
  toAccountType?: AccountTypeAchServiceDto;
  /** @format int32 */
  toAccountTypeId?: number;
};

export type WireInternationalProductAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  beneficiaryApprovalCount?: number;
  /** @format decimal */
  dailyLimit?: number;
  /** @format int32 */
  id?: number;
  internationalUsd?: boolean;
  internationalUsdReadOnly?: boolean;
  /** @format int32 */
  paymentApprovalCount?: number;
  /** @format byte */
  paymentApprovalType?: number;
  product?: ProductAchServiceDto;
  requirePaymentPurpose?: boolean;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  updatedUser?: UserAchServiceDto;
  validateAccountBalance?: boolean;
  wirePaymentApprovalSettings?: WirePaymentApprovalSettingAchServiceDto[];
  wireUsdEnabled?: boolean;
};

export interface WirePaymentApprovalSettingAchServiceDto {
  /** @format byte */
  approvalCount?: number;
  /** @format decimal */
  endAmount?: number;
  /** @format int32 */
  id?: number;
  product?: ProductAchServiceDto;
  /** @format int32 */
  productId?: number;
  /** @format decimal */
  startAmount?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  user?: UserAchServiceDto;
  wireProduct?: WireProductAchServiceDto;
}

export type WireProductAchServiceDto = BaseEntityAchServiceDto & {
  allowWireFileUpload?: boolean;
  /** @format int32 */
  beneficiaryApprovalCount?: number;
  /** @format int32 */
  beneficiaryAuthenticationTypeId?: number;
  /** @format decimal */
  dailyLimit?: number;
  /** @format int32 */
  farthestWireExistInDays?: number;
  /** @format int32 */
  id?: number;
  internationalEnabled?: boolean;
  internationalUsdReadOnly?: boolean;
  isCompanyDliUsdEnabled?: boolean;
  isCompanyWireProductEnabled?: boolean;
  isDliCompanyProductEnabled?: boolean;
  isFiDliProductEnabled?: boolean;
  isFiDliUsdEnabled?: boolean;
  isFiInternationalEnabled?: boolean;
  isFiWireProductEnabled?: boolean;
  isInternationalUsdEnabled?: boolean;
  limitFutureDateEnabled?: boolean;
  /** @format int32 */
  maximumFutureDays?: number;
  /** @format int32 */
  paymentApprovalCount?: number;
  /** @format byte */
  paymentApprovalType?: number;
  /** @format int32 */
  paymentAuthenticationTypeId?: number;
  product?: ProductAchServiceDto;
  requirePaymentPurpose?: boolean;
  requirePaymentPurposeDli?: boolean;
  /** @format byte */
  templateApprovalCount?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  updatedUser?: UserAchServiceDto;
  useExternalFxWireProcessing?: boolean;
  wirePaymentApprovalSettings?: WirePaymentApprovalSettingAchServiceDto[];
};

export type ArpExceptionAchServiceDto = BaseEntityAchServiceDto & {
  account?: AccountAchServiceDto;
  /** @format int32 */
  accountId?: number;
  activityIntentKey?: string;
  arpDecision?: ArpDecisionAchServiceDto;
  /** @format int32 */
  arpDecisionId?: number;
  checkImageNumber?: string;
  checkNumber?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  ddaBatchNumber?: string;
  ddaSequenceNumber?: string;
  /** @format date-time */
  decisionDate?: string;
  fromworkStation?: string;
  /** @format int32 */
  id?: number;
  isDebit?: boolean;
  /** @format decimal */
  issuedAmount?: number;
  /** @format date-time */
  issuedDate?: string;
  /** @format decimal */
  paidAmount?: number;
  payee?: string;
  posPayItemId?: string;
  protected?: string;
  reason?: string;
  resolved?: string;
  sourceOfEntry?: string;
  transactionId?: string;
};

export interface ArpDecisionAchServiceDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export type NonCoreWireCompanyInternationalAccountAchServiceDto = BaseEntityAchServiceDto & {
  account?: AccountAchServiceDto;
  /** @format int32 */
  accountId?: number;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format decimal */
  dailyLimit?: number;
  /** @format int32 */
  id?: number;
  nonCoreWireCompanyInternational?: NonCoreWireCompanyInternationalAchServiceDto;
  /** @format decimal */
  perTransactionLimit?: number;
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  /** @format int32 */
  wireCompanyId?: number;
};

export type NonCoreWireCompanyInternationalAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  availableBalanceValidationCoreTable?: number;
  company?: CompanyAchServiceDto;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format decimal */
  dailyLimit?: number;
  /** @format int32 */
  id?: number;
  nonCoreWireCompanyInternationalAccounts?: NonCoreWireCompanyInternationalAccountAchServiceDto[];
  /** @format decimal */
  perTransactionLimit?: number;
  rowStatus?: RowStatusAchServiceDto;
  rowStatusId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  wireInternationalBalanceValidationType?: WireInternationalBalanceValidationTypeAchServiceDto;
  /** @format int32 */
  wireInternationalBalanceValidationTypeId?: number;
};

export type WireInternationalBalanceValidationTypeAchServiceDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  id?: number;
  name?: string;
};

export type StopPaymentAchServiceDto = BaseEntityAchServiceDto & {
  account?: AccountAchServiceDto;
  /** @format int32 */
  accountId?: number;
  /** @format double */
  amount?: number;
  /** @format int32 */
  approvalCount?: number;
  /** @format int32 */
  approvalsCompleted?: number;
  approvedBy?: TupleStringDateTimeDto[];
  /** @format date-time */
  checkDate?: string;
  confirmationNumber?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  eligibleApprovers?: string[];
  /** @format int64 */
  endCheckNumber?: number;
  enteredBy?: string;
  /** @format date-time */
  expireDate?: string;
  /** @format int32 */
  id?: number;
  payee?: string;
  remarks?: string;
  /** @format int64 */
  startCheckNumber?: number;
  stopPaymentAudits?: StopPaymentAuditAchServiceDto[];
  stopPaymentStatusType?: StopPaymentStatusTypeAchServiceDto;
  /** @format int32 */
  stopPaymentStatusTypeId?: number;
  transactionId?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  userPermissions?: string[];
};

export type StopPaymentAuditAchServiceDto = BaseEntityAchServiceDto & {
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  remarks?: string;
  stopPayment?: StopPaymentAchServiceDto;
  stopPaymentAuditAction?: StopPaymentAuditActionAchServiceDto;
  /** @format int32 */
  stopPaymentAuditActionId?: number;
  /** @format int32 */
  stopPaymentId?: number;
};

export type StopPaymentAuditActionAchServiceDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
  stopPaymentAudits?: StopPaymentAuditAchServiceDto[];
};

export interface StopPaymentStatusTypeAchServiceDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export type IssuedItemAchServiceDto = BaseEntityAchServiceDto & {
  account?: AccountAchServiceDto;
  /** @format int32 */
  accountId?: number;
  accountNumber?: string;
  accountType?: string;
  actIntentKey?: string;
  /** @format decimal */
  amount?: number;
  /** @format int32 */
  batchNumber?: number;
  checkNumber?: string;
  checkType?: CheckTypeDto;
  /** @format int32 */
  checkTypeId?: number;
  confirmations?: IssuedItemConfirmationDto[];
  /** @format int32 */
  createdBy?: number;
  createdByUser?: UserAchServiceDto;
  /** @format date-time */
  createdDate?: string;
  errorSummary?: ErrorSummaryAchServiceDto;
  /** @format int32 */
  id?: number;
  /** @format date-time */
  issuedDate?: string;
  issuedItemAudits?: IssuedItemAuditDto[];
  /** @format guid */
  issuedItemBatchId?: string;
  /** @format date-time */
  issuedItemCreateDate?: string;
  issuedItemEntryType?: IssuedItemEntryTypeDto;
  /** @format int32 */
  issuedItemEntryTypeId?: number;
  /** @format int32 */
  issuedItemFileId?: number;
  issuedItemStatusType?: IssuedItemStatusTypeDto;
  /** @format int32 */
  issuedItemStatusTypeId?: number;
  payee?: string;
  referenceNumber?: string;
  /** @format int64 */
  sequenceNumber?: number;
  status?: string;
  /** @format date-time */
  voidDate?: string;
  voidStatus?: boolean;
};

export interface CheckTypeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  issuedItems?: IssuedItemAchServiceDto[];
  name?: string;
}

export type IssuedItemConfirmationDto = BaseEntityAchServiceDto & {
  confirmationNumber?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  issuedItemId?: number;
};

export type IssuedItemAuditDto = BaseEntityAchServiceDto & {
  comments?: string;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  /** @format int32 */
  id?: number;
  issuedItem?: IssuedItemAchServiceDto;
  issuedItemActionType?: IssuedItemActionTypeDto;
  /** @format int32 */
  issuedItemActionTypeId?: number;
  /** @format int32 */
  issuedItemId?: number;
  user?: UserAchServiceDto;
};

export type IssuedItemActionTypeDto = BaseEntityAchServiceDto & {
  description?: string;
  /** @format int32 */
  id?: number;
  issuedItemAudits?: IssuedItemAuditDto[];
  name?: string;
};

export interface IssuedItemEntryTypeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface IssuedItemStatusTypeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  isActive?: boolean;
  name?: string;
}

export type AchExceptionDetailDto = BaseEntityAchServiceDto & {
  /** @format int32 */
  accountId?: number;
  accountNumber?: string;
  accountType?: string;
  achCompanyId?: string;
  achCompanyName?: string;
  /** @format int32 */
  achExceptionDecisionStatusId?: number;
  /** @format decimal */
  amount?: number;
  batchNumber?: string;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  decisionBy?: string;
  /** @format date-time */
  decisionDate?: string;
  entryDescription?: string;
  exceptionItemId?: string;
  exceptionReason?: string;
  exceptionType?: string;
  fromWorkStation?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  institutionId?: number;
  /** @format date-time */
  postedDate?: string;
  secCode?: string;
  sourceOfEntry?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
};

export type AchPaymentDraftDto = BaseEntityAchServiceDto & {
  accepted?: boolean;
  account?: AccountAchServiceDto;
  achCompany?: AchCompanyAchServiceDto;
  /** @format int32 */
  achCompanyId?: number;
  achCompanyName?: string;
  achFile?: AchFileDto;
  /** @format int32 */
  achFileId?: number;
  achPayment?: AchPaymentAchServiceDto;
  achPaymentDraftRecipients?: AchPaymentDraftRecipientDto[];
  /** @format int32 */
  achPaymentId?: number;
  allowed?: boolean;
  balanced?: boolean;
  batchName?: string;
  companyIdentity?: string;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  descretionaryData?: string;
  /** @format date-time */
  effectiveDate?: string;
  entryDescription?: string;
  errorSummary?: ErrorSummaryAchServiceDto;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  offsetAccountId?: number;
  /** @format decimal */
  onUsAmount?: number;
  /** @format int32 */
  onUsCount?: number;
  secCode?: string;
  /** @format decimal */
  totalCredit?: number;
  /** @format decimal */
  totalDebit?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
  valid?: boolean;
  validationError?: string;
};

export interface AchFileDto {
  achCompanyName?: string;
  achFileSourceType?: AchFileSourceTypeDto;
  /** @format int32 */
  achFileSourceTypeId?: number;
  achPaymentDrafts?: AchPaymentDraftDto[];
  /** @format int32 */
  achPaymentRecipientsCount?: number;
  /** @format int32 */
  approvedCount?: number;
  /** @format int32 */
  batchCount?: number;
  /** @format int32 */
  batchUniqueId?: number;
  comment?: string;
  /** @format int32 */
  companyId?: number;
  createdBy?: string;
  createdByUser?: UserAchServiceDto;
  /** @format decimal */
  creditAmount?: number;
  /** @format decimal */
  debitAmount?: number;
  deleted?: boolean;
  /** @format int32 */
  expiredCount?: number;
  fileArchive?: FileArchiveAchServiceDto;
  /** @format int32 */
  fileArchiveId?: number;
  fileName?: string;
  fileSize?: string;
  hasAccess?: boolean;
  /** @format int32 */
  id?: number;
  isExpired?: boolean;
  /** @format int32 */
  pendingApprovalCount?: number;
  /** @format int32 */
  rejectedCount?: number;
  source?: string;
  status?: string;
  /** @format int32 */
  totalBatches?: number;
  /** @format int32 */
  updatedBy?: number;
  updatedByUser?: UserAchServiceDto;
  /** @format date-time */
  updatedDate?: string;
  /** @format date-time */
  uploadDate?: string;
  validationError?: string;
}

export interface AchFileSourceTypeDto {
  achFiles?: AchFileDto[];
  description?: string;
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface AchPaymentDraftRecipientDto {
  accountNumber?: string;
  /** @format int32 */
  achPaymentDraftId?: number;
  /** @format int32 */
  id?: number;
  recipientIdNumber?: string;
  recipientName?: string;
  routingNumber?: string;
}

export interface ArpProductAchServiceDto {
  allowIssuedItemActivityReview?: boolean;
  allowIssuedItemDelete?: boolean;
  allowIssuedItemEdit?: boolean;
  fiAllowSubstituteProduct?: boolean;
  fiManageAchExceptions?: boolean;
  fiShowAchExceptions?: boolean;
  fiWorkAchException?: boolean;
  fiWorkCheckException?: boolean;
  /** @format int32 */
  id?: number;
  manageAchExceptions?: boolean;
  product?: ProductAchServiceDto;
  showAchExceptions?: boolean;
  substituteProductClientId?: string;
  substituteProductLandingPageUrl?: string;
  substituteProductName?: string;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  useSubstituteProduct?: boolean;
  workAchException?: boolean;
  workAchFilter?: boolean;
  workCheckException?: boolean;
}

export interface BillPayProductAchServiceDto {
  account?: AccountAchServiceDto;
  /** @format int32 */
  accountId?: number;
  /** @format guid */
  accountUniqueId?: string;
  allowIPayBusinessBillPayForMobile?: boolean;
  billPayServiceName?: string;
  /** @format int32 */
  id?: number;
  product?: ProductAchServiceDto;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
}

export interface ElectronicDocumentsProductAchServiceDto {
  esiEmail?: string;
  esiId?: string;
  electronicDocumentServiceName?: string;
  /** @format int32 */
  electronicDocumentTypeId?: number;
  /** @format int32 */
  id?: number;
  /** @format double */
  monthlyFee?: number;
  product?: ProductAchServiceDto;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface RemoteDepositProductAchServiceDto {
  companySsoLogin?: CompanySsoLoginAchServiceDto;
  /** @format int32 */
  companySsoLoginId?: number;
  /** @format int32 */
  id?: number;
  /** @format decimal */
  monthlyFee?: number;
  remoteDepositProductType?: RemoteDepositProductTypeAchServiceDto;
  /** @format int32 */
  remoteDepositProductTypeId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
}

export interface CompanySsoLoginAchServiceDto {
  clientCompanyId?: string;
  company?: CompanyAchServiceDto;
  /** @format int32 */
  companyId?: number;
  /** @format int32 */
  id?: number;
  ssoLoginSystem?: SsoLoginSystemAchServiceDto;
  /** @format int32 */
  ssoLoginSystemId?: number;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
}

export interface RemoteDepositProductTypeAchServiceDto {
  description?: string;
  name?: string;
  /** @format int32 */
  remoteDepositProductTypeId?: number;
}

export interface ReportingProductAchServiceDto {
  /** @format int32 */
  id?: number;
  product?: ProductAchServiceDto;
}

export interface StopPaymentProductAchServiceDto {
  approvalCount?: number;
  /** @format double */
  feePerRequest?: number;
  /** @format int32 */
  id?: number;
  product?: ProductAchServiceDto;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface ArpReportFileAchServiceDto {
  account?: AccountAchServiceDto;
  /** @format int32 */
  accountId?: number;
  /** @format date-time */
  createdDate?: string;
  fileContent?: string;
  fileName?: string;
  /** @format int32 */
  id?: number;
}

export interface CoreAccountAchServiceDto {
  cifNumber?: string;
  coreStatus?: string;
  number?: string;
  type?: string;
}

export type InquiryJxAchExceptionRequestDto = BaseRequestAchServiceDto & {
  accountNumber?: string;
  accountType?: string;
  actionIntent?: string;
  itemId?: string;
};

export type HealthCheckActionRequestAchServiceDto = BaseRequestAchServiceDto & {
  skipDatabaseConnectivity?: boolean;
  skipPackageInformation?: boolean;
  skipRedisConnectivity?: boolean;
};

export type SearchIssuedItemsRequestDto = BaseRequestAchServiceDto & {
  accountIds?: number[];
  /** @format decimal */
  amountRangeEnd?: number;
  /** @format decimal */
  amountRangeStart?: number;
  checkNumber?: string;
  checkType?: CheckTypeEnumDto;
  /** @format date-time */
  createdDateEnd?: string;
  /** @format date-time */
  createdDateStart?: string;
  entryType?: IssuedItemEntryTypeEnumDto;
  entryTypes?: IssuedItemEntryTypeEnumDto[];
  /** @format date-time */
  issuedDateEnd?: string;
  /** @format date-time */
  issuedDateStart?: string;
  outputType?: OutPutTypeAchServiceDto;
  payee?: string;
  statusIds?: number[];
};

export type GetIssuedItemStatusesRequestDto = BaseRequestAchServiceDto & object;

export type UpdateIssuedItemStatusRequestDto = BaseRequestAchServiceDto & {
  batchDetail?: UpdateIssuedItemStatusBatchDto;
  /** @format date-time */
  previousProcessingDate?: string;
  /** @format duration */
  retentionPeriod?: string;
};

export interface UpdateIssuedItemStatusBatchDto {
  /** @format int32 */
  firstIssuedItemId?: number;
  /** @format int32 */
  institutionId?: number;
  /** @format int32 */
  lastIssuedItemId?: number;
}

export type RunUpdateIssuedItemStatusBatchesRequestDto = BaseRequestAchServiceDto & {
  failedBatches?: UpdateIssuedItemStatusBatchDto[];
  /** @format int32 */
  institutionIdToUpdate?: number;
  /** @format date-time */
  previousBusinessDay?: string;
};

export type RunUpdateIssuedItemStatusRequestDto = BaseRequestAchServiceDto & object;

export type GetJxArpExceptionsRequestDto = BaseRequestAchServiceDto & {
  account?: AccountAchServiceDto;
  arpExceptionSearchModel?: ArpExceptionSearchModelAchServiceDto;
  /** @format int32 */
  institutionIntId?: number;
};

export interface ArpExceptionSearchModelAchServiceDto {
  accounts?: AccountAchServiceDto[];
  checkNumber?: string;
  decisionTaken?: string;
  /** @format decimal */
  issuedAmount?: number;
  /** @format decimal */
  issuedAmountEnd?: number;
  /** @format decimal */
  issuedAmountStart?: number;
  issuedAmountType?: string;
  /** @format date-time */
  issuedDate?: string;
  /** @format date-time */
  issuedDateEnd?: string;
  issuedDateRangeType?: string;
  /** @format date-time */
  issuedDateStart?: string;
  /** @format decimal */
  paidAmount?: number;
  /** @format decimal */
  paidAmountEnd?: number;
  /** @format decimal */
  paidAmountStart?: number;
  paidAmountType?: string;
  payee?: string;
  /** @format date-time */
  postedDate?: string;
  /** @format date-time */
  postedDateEnd?: string;
  postedDateRangeType?: string;
  /** @format date-time */
  postedDateStart?: string;
  type?: string;
}

export type SearchArpExceptionsRequestDto = BaseRequestAchServiceDto & {
  account?: AccountAchServiceDto;
  arpExceptionSearchModel?: ArpExceptionSearchModelAchServiceDto;
};

export type SaveAllArpExceptionsRequestDto = BaseRequestAchServiceDto & {
  arpExceptionDetails?: ArpExceptionDetailDto[];
};

export interface ArpExceptionDetailDto {
  /** @format int32 */
  accountId?: number;
  accountNumber?: string;
  accountType?: string;
  arpExceptionDetailDecisions?: ArpExceptionDetailDecisionDto[];
  /** @format int32 */
  arpExceptionDetailId?: number;
  checkImageNumber?: string;
  checkNumber?: string;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  ddaBatchNumber?: string;
  ddaSequenceNumber?: string;
  exceptionsReason?: string;
  fiId?: string;
  fromWorkStation?: string;
  /** @format decimal */
  issuedAmount?: number;
  /** @format date-time */
  issuedDate?: string;
  issuedPayee?: string;
  /** @format decimal */
  paidAmount?: number;
  posPayItemId?: string;
  /** @format date-time */
  postDate?: string;
  protected?: string;
  resolved?: string;
  sourceOfEntry?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
}

export interface ArpExceptionDetailDecisionDto {
  /** @format int32 */
  arpExceptionDetailDecisionId?: number;
  /** @format int32 */
  arpExceptionDetailId?: number;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  decisionBy?: string;
  /** @format date-time */
  decisionDate?: string;
  decisionStatus?: string;
  remarks?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
}

export type CheckExceptionDto = ArpExceptionDetailDto & {
  /** @format guid */
  institutionCheckExceptionReturnReasonUniqueId?: string;
};

export type GetAchExceptionsRequestDto = BaseRequestAchServiceDto & {
  accounts?: AccountAchServiceDto[];
  /** @format decimal */
  amount?: number;
  /** @format decimal */
  amountFrom?: number;
  /** @format decimal */
  amountTo?: number;
  amountType?: string;
  issuingCompany?: string;
  secCodes?: string[];
};

export type FindAchExceptionsRequestDto = BaseRequestAchServiceDto & {
  achExceptionSearchModel?: AchExceptionSearchModelAchServiceDto;
  downloadOutputType?: string;
};

export type FindAchExceptionsDecisionsActivityRequestDto = BaseRequestAchServiceDto & {
  achExceptionSearchModel?: AchExceptionSearchModelAchServiceDto;
  /** @format date-time */
  currentBusinessDayCutoff?: string;
  downloadOutputType?: string;
  pagingParameters?: PagingParametersAchServiceDto;
  /** @format date-time */
  previousBusinessDayCutoff?: string;
  searchAccountNickname?: boolean;
  searchText?: string;
};

export interface PagingParametersAchServiceDto {
  orderBys?: OrderByAchServiceDto[];
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
}

export interface OrderByAchServiceDto {
  descending?: boolean;
  name?: string;
}

export type GetInstitutionPosPayAchExceptionsCutOffTimesRequestDto = BaseRequestAchServiceDto &
  object;

export type UpdateAchExceptionsRequestDto = BaseRequestAchServiceDto & {
  achExceptions?: AchExceptionDto[];
  activityIntentKey?: string;
  exceptionItemId?: string;
  institutionAchReturnCode?: string;
  pay?: boolean;
  return?: boolean;
};

export type SearchArpOutputFilesRequestDto = BaseRequestAchServiceDto & {
  accounts?: AccountAchServiceDto[];
  fileName?: string;
  /** @format date-time */
  fileReceivedDate?: string;
  /** @format date-time */
  fileReceivedDateEnd?: string;
  /** @format date-time */
  fileReceivedDateStart?: string;
  fileReceivedDateType?: string;
  outPutType?: OutPutTypeAchServiceDto;
};

export type GetAchExceptionFiltersRequestDto = BaseRequestAchServiceDto & {
  accountNumber?: string;
  accountType?: string;
  accounts?: AccountAchServiceDto[];
  achCompanyId?: string;
  achCompanyName?: string;
  /** @format decimal */
  amount?: number;
  amountType?: string;
  exceptionFilter?: string;
  /** @format date-time */
  expirationDate?: string;
  /** @format date-time */
  expirationDateEnd?: string;
  /** @format date-time */
  expirationDateStart?: string;
  expirationDateType?: string;
  /** @format decimal */
  fromAmount?: number;
  searchAccount?: AccountAchServiceDto;
  secCodes?: AchSecCodeAchServiceDto[];
  /** @format decimal */
  toAmount?: number;
};

export type ParseArpIssuedItemsRequestDto = BaseRequestAchServiceDto & {
  arpData?: string;
  /** @format int32 */
  fileImportLayoutId?: number;
  fileName?: string;
  isTransmittedFile?: boolean;
};

export type SaveArpIssuedItemsRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  accountId?: number;
  issuedFileName?: string;
  issuedItems?: IssuedItemAchServiceDto[];
  voidedIssuedItems?: IssuedItemAchServiceDto[];
};

export type GetCompanySecCodesRequestDto = BaseRequestAchServiceDto & object;

export type EndOfEodProcessRequestDto = BaseRequestAchServiceDto & {
  /** @format date-time */
  eodTime?: string;
  routingNumber?: string;
};

export type StartOfEodProcessRequestDto = BaseRequestAchServiceDto & object;

export type GetArpUploadFormatsRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  arpUploadFormatId?: number;
};

export type DeleteArpUploadFormatRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  arpUploadFormatId?: number;
};

export type SaveArpFormatRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  accountNumberBegin?: number;
  /** @format int32 */
  accountNumberEnd?: number;
  /** @format int32 */
  accountNumberOrder?: number;
  /** @format int32 */
  accountTypeBegin?: number;
  accountTypeCheckingEquals?: string;
  /** @format int32 */
  accountTypeEnd?: number;
  /** @format int32 */
  accountTypeOrder?: number;
  accountTypeSavingsEquals?: string;
  fieldDelimiter?: string;
  /** @format int32 */
  fileImportLayoutId?: number;
  /** @format int32 */
  footerRows?: number;
  /** @format int32 */
  headerRows?: number;
  /** @format int32 */
  issueDateBegin?: number;
  /** @format int32 */
  issueDateEnd?: number;
  issueDateFormat?: string;
  /** @format int32 */
  issueDateOrder?: number;
  /** @format int32 */
  itemAmountBegin?: number;
  itemAmountDecimal?: boolean;
  /** @format int32 */
  itemAmountEnd?: number;
  itemAmountFormat?: string;
  /** @format int32 */
  itemAmountOrder?: number;
  /** @format int32 */
  itemNumberBegin?: number;
  /** @format int32 */
  itemNumberEnd?: number;
  /** @format int32 */
  itemNumberOrder?: number;
  name?: string;
  /** @format int32 */
  payeeBegin?: number;
  /** @format int32 */
  payeeEnd?: number;
  /** @format int32 */
  payeeOrder?: number;
  textQualifier?: string;
  type?: string;
  /** @format int32 */
  voidDateBegin?: number;
  /** @format int32 */
  voidDateEnd?: number;
  voidDateFormat?: string;
  /** @format int32 */
  voidDateOrder?: number;
  /** @format int32 */
  voidIndicatorBegin?: number;
  /** @format int32 */
  voidIndicatorEnd?: number;
  /** @format int32 */
  voidIndicatorOrder?: number;
  voidYesIndicator?: string;
};

export type UpdateArpExceptionsRequestDto = BaseRequestAchServiceDto & {
  activityIntentKey?: string;
  arpExceptions?: ArpExceptionAchServiceDto[];
  exceptionItemId?: string;
  pay?: boolean;
  return?: boolean;
};

export type CreateCheckExceptionNotificationRequestDto = BaseRequestAchServiceDto & {
  /** @format date-time */
  previousBusinessDate?: string;
};

export type CreateAchExceptionNotificationRequestDto = BaseRequestAchServiceDto & {
  /** @format date-time */
  previousBusinessDate?: string;
};

export type RunExceptionEtlRequestDto = BaseRequestAchServiceDto & {
  fiId?: string;
};

export type SaveAchExceptionsRequestDto = BaseRequestAchServiceDto & {
  achExceptions?: AchExceptionDetailDto[];
};

export type GetMasterRecipientsRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  achCompanyId?: number;
  /** @format byte */
  achMasterRecipientStatusTypeId?: number;
  amountFilter?: AmountFilterDto;
  downloadType?: string;
  forDownload?: boolean;
  pagingParameters?: PagingParametersAchServiceDto;
  recipientName?: string;
  searchText?: string;
};

export interface AmountFilterDto {
  /** @format decimal */
  amount?: number;
  amountType?: AmountFilterTypeEnumDto;
  /** @format decimal */
  maximumAmount?: number;
  /** @format decimal */
  minimumAmount?: number;
}

export type SaveMasterRecipientRequestDto = BaseRequestAchServiceDto & {
  saveableMasterRecipients?: SaveableMasterRecipientDto[];
};

export interface SaveableMasterRecipientDto {
  accountNumber?: string;
  /** @format int32 */
  accountTypeId?: number;
  addenda?: string;
  /** @format decimal */
  defaultAmount?: number;
  /** @format int32 */
  id?: number;
  recipientIdNumber?: string;
  recipientName?: string;
  routingNumber?: string;
  /** @format int32 */
  transactionTypeId?: number;
}

export type ApproveAchMasterRecipientRequestDto = BaseRequestAchServiceDto & {
  achMasterRecipientIds?: number[];
};

export type RejectAchMasterRecipientRequestDto = BaseRequestAchServiceDto & {
  achMasterRecipientIds?: number[];
};

export type DeleteAchMasterRecipientRequestDto = BaseRequestAchServiceDto & {
  achMasterRecipientIds?: number[];
};

export type GetMasterRecipientAuditsRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  achMasterRecipientId?: number;
};

export type SearchAchBatchRequestDto = BaseRequestAchServiceDto & {
  achBatchIds?: number[];
  batchName?: string;
  companyList?: AchCompanyAchServiceDto[];
  /** @format decimal */
  creditAmount?: number;
  /** @format decimal */
  creditAmountMax?: number;
  /** @format decimal */
  creditAmountMin?: number;
  creditAmountType?: string;
  /** @format decimal */
  debitAmount?: number;
  /** @format decimal */
  debitAmountMax?: number;
  /** @format decimal */
  debitAmountMin?: number;
  debitAmountType?: string;
  /** @format date-time */
  lastUpdatedDate?: string;
  /** @format date-time */
  lastUpdatedDateEnd?: string;
  /** @format date-time */
  lastUpdatedDateStart?: string;
  lastUpdatedDateType?: string;
  outPutType?: OutPutTypeAchServiceDto;
  secCode?: string;
  status?: string;
  taxTemplateType?: TaxTemplateSearchTypeDto;
};

export type TreasuryChallengeRequestDto = BaseRequestAchServiceDto & {
  clientStatus?: string;
  oneTimePassword?: string;
};

export type CreateAchBatchRequestDto = TreasuryChallengeRequestDto & {
  achBatch?: AchBatchAchServiceDto;
};

export type UpdateAchBatchRequestDto = TreasuryChallengeRequestDto & {
  achBatch?: AchBatchAchServiceDto;
  /** @format int32 */
  achBatchId?: number;
};

export type CreateAchPaymentRequestDto = TreasuryChallengeRequestDto & {
  achPayment?: AchPaymentAchServiceDto;
  achPayments?: AchPaymentAchServiceDto[];
  isUpdateAchBatch?: boolean;
};

export type CreateInternationalPaymentRequestDto = CreateAchPaymentRequestDto & {
  achInternationalPayment?: InternationalPaymentDto;
  achInternationalPayments?: InternationalPaymentCollectionDto;
};

export type InternationalPaymentCollectionDto = InternationalPaymentDto[];

export type CreateChildSupportPaymentRequestDto = TreasuryChallengeRequestDto & {
  achPayment?: ChildSupportPaymentDto;
  achPayments?: ChildSupportPaymentCollectionDto;
  isUpdateAchBatch?: boolean;
};

export type ChildSupportPaymentCollectionDto = ChildSupportPaymentDto[];

export type DeleteAchBatchRequestDto = TreasuryChallengeRequestDto & {
  /** @format int32 */
  achBatchId?: number;
  comment?: string;
};

export type CancelAchPaymentRequestDto = TreasuryChallengeRequestDto & {
  /** @format int32 */
  achPaymentId?: number;
  comment?: string;
};

export type UninitiateAchPaymentRequestDto = TreasuryChallengeRequestDto & {
  /** @format int32 */
  achPaymentId?: number;
  comment?: string;
};

export type RejectAchPaymentRequestDto = TreasuryChallengeRequestDto & {
  achPayments?: AchPaymentAchServiceDto[];
  lookups?: LookupAchServiceDto[];
};

export type RejectAchBatchRequestDto = TreasuryChallengeRequestDto & {
  /** @format int32 */
  achBatchId?: number;
  comment?: string;
};

export type ApproveAchBatchRequestDto = TreasuryChallengeRequestDto & {
  /** @format int32 */
  achBatchId?: number;
  comment?: string;
  isApprovalNotRequired?: boolean;
};

export type ApproveAchPaymentRequestDto = TreasuryChallengeRequestDto & {
  achPayments?: AchPaymentAchServiceDto[];
  isApproversNotRequired?: boolean;
  lookups?: LookupAchServiceDto[];
};

export type UpdateAchPaymentRequestDto = TreasuryChallengeRequestDto & {
  achPayment?: AchPaymentAchServiceDto;
  /** @format int32 */
  achPaymentId?: number;
};

export type UpdateChildSupportPaymentRequestDto = UpdateAchPaymentRequestDto & {
  childSupportPayment?: ChildSupportPaymentDto;
};

export type UpdateInternationalPaymentRequestDto = UpdateAchPaymentRequestDto & {
  internationalPayment?: InternationalPaymentDto;
};

export type GetInternationalAchCountriesRequestDto = BaseRequestAchServiceDto & object;

export type GetInternationalAchPaymentRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  internationalAchPaymentId?: number;
};

export type CreateNachaFileForDownloadRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  achBatchId?: number;
  /** @format int32 */
  achPaymentId?: number;
  outPutType?: OutPutTypeAchServiceDto;
};

export type GetAchPaymentRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  achPaymentId?: number;
};

export type GetAchPaymentDraftsRequestDto = BaseRequestAchServiceDto & {
  achPaymentDraftIds?: number[];
};

export type GetAchBatchRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  achBatchId?: number;
  outPutType?: OutPutTypeAchServiceDto;
};

export type GetAchPaymentRecipientsRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  achPaymentId?: number;
};

export type GetAchBatchRecipientsRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  achBatchId?: number;
};

export type GetDomesticBankRequestDto = BaseRequestAchServiceDto & object;

export type SearchAchPaymentRequestDto = BaseRequestAchServiceDto & {
  achTransactionId?: string;
  achType?: string;
  batchName?: string;
  companyList?: AchCompanyAchServiceDto[];
  /** @format decimal */
  creditAmount?: number;
  /** @format decimal */
  creditAmountMax?: number;
  /** @format decimal */
  creditAmountMin?: number;
  /** @format decimal */
  debitAmount?: number;
  /** @format decimal */
  debitAmountMax?: number;
  /** @format decimal */
  debitAmountMin?: number;
  /** @format date-time */
  effectiveDate?: string;
  /** @format date-time */
  effectiveDateEnd?: string;
  /** @format date-time */
  effectiveDateStart?: string;
  fileArchiveIds?: number[];
  frequencyTypeIds?: number[];
  /** @format date-time */
  initiatedDate?: string;
  /** @format date-time */
  initiatedDateEnd?: string;
  /** @format date-time */
  initiatedDateStart?: string;
  isBasic?: boolean;
  isDownload?: boolean;
  isRecurring?: boolean;
  outPutType?: OutPutTypeAchServiceDto;
  paymentIds?: number[];
  secCode?: string;
  status?: string;
};

export type ValidateAchBatchNameRequestDto = BaseRequestAchServiceDto & {
  achBatch?: AchBatchAchServiceDto;
};

export type GetAchRecipientAddendaRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  achBatchRecipientId?: number;
  /** @format int32 */
  achPaymentRecipientId?: number;
};

export type GetAchFileImportLayoutRequestDto = BaseRequestAchServiceDto & {
  product?: ProductTypesEnumDto;
  productType?: string;
};

export type SaveAchFileImportLayoutRequestDto = BaseRequestAchServiceDto & {
  achFileImportLayout?: FileImportLayoutAchServiceDto;
  formatType?: FileFormatTypeEnumDto;
  importField?: AchFileImportFieldEnumDto;
};

export type SaveAchRecipientAddendaRequestDto = BaseRequestAchServiceDto & {
  achBatchRecipientAddenda?: AchBatchRecipientAddendaAchServiceDto;
  /** @format int32 */
  achBatchRecipientId?: number;
  achPaymentRecipientAddenda?: AchPaymentRecipientAddendaAchServiceDto;
  /** @format int32 */
  achPaymentRecipientId?: number;
  recipientAddendaActionType?: AchRecipientAddendaActionTypeDto;
};

export type DownloadHtmlRequestDto = BaseRequestAchServiceDto & {
  downloadType?: string;
};

export type NachaFileUploadRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  achFileId?: number;
  achPaymentType?: AchPaymentTypeEnumDto;
  isAchFileCreated?: boolean;
  nachaFileData?: string;
  nachaFileName?: string;
  uploadType?: UploadTypeEnumDto;
};

export type RecipientFileUploadRequestDto = BaseRequestAchServiceDto & {
  recipientFileData?: string;
  recipientFileName?: string;
  uploadFormat?: string;
};

export type ChangeInAchCompanyRequestDto = BaseRequestAchServiceDto & object;

export type ChangeInAchPaymentStatusRequestDto = BaseRequestAchServiceDto & {
  achPaymentReferenceNumber?: string;
  previousStatus?: string;
  status?: string;
};

export type VerifyRoutingNumberRequestDto = BaseRequestAchServiceDto & {
  routingNumber?: string;
};

export type GetOffsetAccountRequestDto = BaseRequestAchServiceDto & object;

export type SearchAchRecipientRequestDto = BaseRequestAchServiceDto & {
  achRecipientFilter?: AchRecipientFilterDto;
};

export interface AchRecipientFilterDto {
  /** @format decimal */
  amount?: number;
  /** @format decimal */
  amountMax?: number;
  /** @format decimal */
  amountMin?: number;
  amountType?: string;
  hold?: boolean;
  prenote?: boolean;
  recipientName?: string;
  recordType?: string;
  reversal?: boolean;
}

export type SubmitScheduledAchPaymentRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  achPaymentId?: number;
  /** @format int32 */
  companyId?: number;
  institutionFiId?: string;
  /** @format int64 */
  jobId?: number;
  /** @format date-time */
  nextPaymentDate?: string;
  /** @format int32 */
  userId?: number;
};

export type AchTransactionSearchRequestDto = BaseRequestAchServiceDto & {
  accounts?: AccountAchServiceDto[];
  amountType?: AmountTypeEnumDto;
  /** @format decimal */
  endAmount?: number;
  /** @format date-time */
  endDate?: string;
  searchAccount?: AccountAchServiceDto;
  /** @format decimal */
  startAmount?: number;
  /** @format date-time */
  startDate?: string;
  transactionType?: TransactionTypeEnumDto;
};

export type AchAddendaSearchRequestDto = BaseRequestAchServiceDto & {
  searchAccount?: AccountAchServiceDto;
  transactionId?: string;
};

export type InquiryAchCompanyRequestDto = BaseRequestAchServiceDto & {
  companyName?: string;
  coreSecCode?: string;
};

export type SearchAchFileActivityRequestDto = BaseRequestAchServiceDto & {
  companyIds?: number[];
  /** @format date-time */
  endDate?: string;
  /** @format int32 */
  fileArchiveId?: number;
  fileName?: string;
  isDownload?: boolean;
  processedByUserIds?: number[];
  processedDateType?: string;
  /** @format date-time */
  processedEndDate?: string;
  /** @format date-time */
  processedStartDate?: string;
  /** @format date-time */
  startDate?: string;
  uploadDateType?: string;
  userIds?: number[];
};

export type AchFileDeleteRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  achFileId?: number;
  activityIntentKey?: string;
  fileReferenceId?: string;
};

export type GetAchFileRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  achFileArchiveId?: number;
};

export type SaveTransmittedAchFilesRequestDto = BaseRequestAchServiceDto & object;

export type GetChildSupportPaymentRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  childSupportPaymentId?: number;
};

export type UploadInternationalNachaFileRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  achFileId?: number;
  achPaymentType?: AchPaymentTypeEnumDto;
  nachaFileData?: string;
  nachaFileName?: string;
  uploadType?: UploadTypeEnumDto;
};

export type GetStateTaxAmountTypesRequestDto = BaseRequestAchServiceDto & object;

export type GetFederalTaxAmountTypesRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  federalTaxCodeId?: number;
};

export type GetFederalTaxCodesRequestDto = BaseRequestAchServiceDto & object;

export type GetFederalTaxRecipientRequestDto = BaseRequestAchServiceDto & object;

export type GetStateTaxRecipientsRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  stateId?: number;
};

export type GetStateTaxCodesRequestDto = BaseRequestAchServiceDto & {
  /** @format int32 */
  stateId?: number;
};

export type GetTaxRecipientAccountTypesRequestDto = BaseRequestAchServiceDto & object;

export type ResponseDetailCollectionAchServiceDto = ResponseDetailAchServiceDto[];

export interface ResponseDetailAchServiceDto {
  /** @format int32 */
  responseCode?: number;
  responseMessage?: string;
}

export type SearchJxAchExceptionsResponseDto = BaseResponseAchServiceDto & {
  achExceptions?: AchExceptionDto[];
  protected?: string;
};

export type InquiryJxAchExceptionResponseDto = BaseResponseAchServiceDto & {
  achException?: AchExceptionDto;
};

export type HealthCheckActionResponseAchServiceDto = BaseResponseAchServiceDto & {
  databaseConnectivityStatus?: DatabaseConnectivityStatusCollectionAchServiceDto;
  getDatabaseConnectivitySuccessful?: boolean;
  getPackageInformationSuccessful?: boolean;
  getRedisConnectivitySuccessful?: boolean;
  packageInformation?: PackageInformationAchServiceDto;
  redisConnectivityStatus?: RedisConnectivityStatusCollectionAchServiceDto;
  redisMultiplexerAbleToConnect?: boolean;
};

export type DatabaseConnectivityStatusCollectionAchServiceDto =
  DatabaseConnectivityStatusAchServiceDto[];

export interface DatabaseConnectivityStatusAchServiceDto {
  ableToConnect?: boolean;
  additionalInformation?: string;
  connectionStringName?: string;
}

export interface PackageInformationAchServiceDto {
  buildInformation?: BuildInformationAchServiceDto;
  /** @format date-time */
  createdDateTime?: string;
  machineName?: string;
  releaseInformation?: ReleaseInformationAchServiceDto;
}

export interface BuildInformationAchServiceDto {
  azdoProject?: string;
  buildUrl?: string;
  commitId?: string;
  packageVersion?: string;
  repository?: string;
}

export interface ReleaseInformationAchServiceDto {
  /** @format date-time */
  deploymentDateUtc?: string;
  packageName?: string;
  packageVersion?: string;
  projectId?: string;
  releaseVersion?: string;
}

export type RedisConnectivityStatusCollectionAchServiceDto = RedisConnectivityStatusAchServiceDto[];

export interface RedisConnectivityStatusAchServiceDto {
  ableToConnect?: boolean;
  additionalInformation?: string;
  ipAddress?: string;
  redisClusterName?: string;
}

export type SearchIssuedItemsResponseDto = BaseResponseAchServiceDto & {
  issuedItems?: IssuedItemReportModelDto[];
};

export interface IssuedItemReportModelDto {
  /** @format int32 */
  accountId?: number;
  accountNumber?: string;
  accountType?: string;
  /** @format decimal */
  amount?: number;
  audits?: IssuedItemAuditReportModelDto[];
  checkNumber?: string;
  /** @format date-time */
  createdDate?: string;
  entryType?: IssuedItemEntryTypeDto;
  filename?: string;
  /** @format date-time */
  issuedDate?: string;
  /** @format int32 */
  issuedItemFileId?: number;
  itemStatus?: string;
  itemType?: string;
  payee?: string;
}

export interface IssuedItemAuditReportModelDto {
  activity?: IssuedItemActionTypeDto;
  /** @format date-time */
  createdDate?: string;
  username?: string;
}

export type GetIssuedItemStatusesResponseDto = BaseResponseAchServiceDto & {
  statuses?: IssuedItemStatusTypeDto[];
};

export type UpdateIssuedItemStatusResponseDto = BaseResponseAchServiceDto & object;

export type RunUpdateIssuedItemStatusBatchesResponseDto = BaseResponseAchServiceDto & {
  failedBatches?: UpdateIssuedItemStatusBatchDto[];
};

export type RunUpdateIssuedItemStatusResponseDto = BaseResponseAchServiceDto & object;

export type GetJxArpExceptionsResponseDto = BaseResponseAchServiceDto & {
  arpExceptions?: ArpExceptionAchServiceDto[];
};

export type SearchArpExceptionsResponseDto = BaseResponseAchServiceDto & {
  arpExceptionDetails?: ArpExceptionDetailDataDto[];
  arpExceptions?: ArpExceptionAchServiceDto[];
  hasEtlRanSuccessfully?: boolean;
};

export interface ArpExceptionDetailDataDto {
  /** @format int32 */
  accountId?: number;
  accountName?: string;
  accountNumber?: string;
  accountType?: string;
  /** @format guid */
  arpExceptionAttachmentFileIdentifier?: string;
  arpExceptionDetail?: ArpExceptionDetailDto;
  /** @format int32 */
  arpExceptionDetailId?: number;
  checkImageNumber?: string;
  checkNumber?: string;
  /** @format int32 */
  companyId?: number;
  companyName?: string;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  ddaBatchNumber?: string;
  ddaSequenceNumber?: string;
  decisionHistory?: boolean;
  decisionStatus?: string;
  decisions?: ArpExceptionDetailDecisionDto[];
  exceptionsReason?: string;
  fiId?: string;
  fromWorkStation?: string;
  institutionCheckExceptionReturnReasonDescription?: string;
  /** @format decimal */
  issuedAmount?: number;
  /** @format date-time */
  issuedDate?: string;
  issuedPayee?: string;
  /** @format date-time */
  lastDecisionDate?: string;
  lastDecisionTakenBy?: string;
  /** @format decimal */
  paidAmount?: number;
  posPayItemId?: string;
  /** @format date-time */
  postDate?: string;
  protected?: string;
  returnReasonComment?: string;
  sourceOfEntry?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
}

export type SaveAllArpExceptionsResponseDto = BaseResponseAchServiceDto & object;

export type GetAchExceptionFiltersResponseDto = BaseResponseAchServiceDto & {
  achExceptionFilters?: AchExceptionFilterDto[];
  allowPositivePay?: boolean;
};

export interface AchExceptionFilterDto {
  accountNumber?: string;
  accountType?: string;
  achCompanyName?: string;
  allowAllCredits?: string;
  allowAllDebits?: string;
  /** @format decimal */
  amountFrom?: number;
  /** @format decimal */
  amountTo?: number;
  companyId?: string;
  debitOrCredit?: string;
  exceptionFilter?: string;
  /** @format date-time */
  expirationDate?: string;
  secCode?: string;
}

export type GetAchExceptionsResponseDto = BaseResponseAchServiceDto & {
  achExceptions?: AchExceptionDto[];
  protected?: string;
};

export type FindAchExceptionsResponseDto = BaseResponseAchServiceDto & {
  achExceptionDetails?: AchExceptionDetailDataDto[];
  posPayExceptionEtlFiRuntimeStats?: PosPayExceptionEtlFiRuntimeStatsDto;
};

export interface AchExceptionDetailDataDto {
  /** @format int32 */
  accountId?: number;
  accountName?: string;
  accountNumber?: string;
  accountType?: string;
  achCompanyId?: string;
  achCompanyName?: string;
  /** @format int32 */
  achExceptionDecisionStatusId?: number;
  achExceptionDetail?: AchExceptionDetailDto;
  /** @format int32 */
  achExceptionDetailId?: number;
  /** @format decimal */
  amount?: number;
  auditHistory?: boolean;
  batchNumber?: string;
  /** @format int32 */
  companyId?: number;
  companyName?: string;
  /** @format int32 */
  createdBy?: number;
  /** @format date-time */
  createdDate?: string;
  decisionBy?: string;
  /** @format date-time */
  decisionDate?: string;
  decisionStatus?: string;
  entryDescription?: string;
  exceptionItemId?: string;
  exceptionReason?: string;
  exceptionType?: string;
  fiId?: string;
  fromWorkStation?: string;
  /** @format int32 */
  institutionId?: number;
  /** @format date-time */
  postedDate?: string;
  secCode?: string;
  /** @format int32 */
  updatedBy?: number;
  /** @format date-time */
  updatedDate?: string;
}

export interface PosPayExceptionEtlFiRuntimeStatsDto {
  hasEndTimeOccurred?: boolean;
  hasEtlRunSuccessfully?: boolean;
  hasStartTimeOccurred?: boolean;
  isEndOfDayRunning?: boolean;
  /** @format duration */
  timeUntilEndTime?: string;
  /** @format duration */
  timeUntilStartTime?: string;
}

export type FindAchExceptionsDecisionsActivityResponseDto = BaseResponseAchServiceDto & {
  pagedAchExceptionDetails?: PagedListOfAchExceptionDetailDataDto;
};

export interface PagedListOfAchExceptionDetailDataDto {
  items?: AchExceptionDetailDataDto[];
  /** @format int32 */
  maxPageSize?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  recordCountInCurrentPage?: number;
  /** @format int32 */
  totalCount?: number;
}

export type GetInstitutionPosPayAchExceptionsCutOffTimesResponseDto = BaseResponseAchServiceDto & {
  institutionPosPayAchExceptionsCutOffTimes?: InstitutionPosPayAchExceptionsCutOffTimesDto;
};

export interface InstitutionPosPayAchExceptionsCutOffTimesDto {
  /** @format date-time */
  currentBusinessDayCutoff?: string;
  /** @format date-time */
  currentBusinessDayStartTime?: string;
  /** @format date-time */
  fiLocalTime?: string;
  hasEtlRunSuccessfully?: boolean;
  institutionName?: string;
  /** @format date-time */
  previousBusinessDayCutoff?: string;
}

export type UpdateAchExceptionsResponseDto = BaseResponseAchServiceDto & object;

export type SearchArpOutputFilesResponseDto = BaseResponseAchServiceDto & {
  arpReportFiles?: ArpReportFileAchServiceDto[];
  /** @format byte */
  downloadContent?: string;
};

export type ParseArpIssuedItemsResponseDto = BaseResponseAchServiceDto & {
  arpFileErrors?: FileErrorDto[];
  issuedItems?: IssuedItemAchServiceDto[];
};

export interface FileErrorDto {
  errorText?: string;
  /** @format int32 */
  lineNumber?: number;
}

export type SaveArpIssuedItemsResponseDto = BaseResponseAchServiceDto & {
  errorInfo?: Record<string, string>;
  issuedItems?: IssuedItemAchServiceDto[];
  voidedIssuedItems?: IssuedItemAchServiceDto[];
};

export type GetCompanySecCodesResponseDto = BaseResponseAchServiceDto & {
  achCompanySecCodes?: AchCompanySecCodeAchServiceDto[];
};

export type EndOfEodProcessResponseDto = BaseResponseAchServiceDto & object;

export type StartOfEodProcessResponseDto = BaseResponseAchServiceDto & object;

export type GetArpUploadFormatsResponseDto = BaseResponseAchServiceDto & {
  arpUploadFormats?: FileImportLayoutAchServiceDto[];
};

export type DeleteArpUploadFormatResponseDto = BaseResponseAchServiceDto & object;

export type SaveArpFormatResponseDto = BaseResponseAchServiceDto & object;

export type UpdateArpExceptionsResponseDto = BaseResponseAchServiceDto & object;

export type CreateCheckExceptionNotificationResponseDto = BaseResponseAchServiceDto & object;

export type CreateAchExceptionNotificationResponseDto = BaseResponseAchServiceDto & object;

export type RunExceptionEtlResponseDto = BaseResponseAchServiceDto & object;

export type SaveAchExceptionsResponseDto = BaseResponseAchServiceDto & {
  failedAchExceptions?: AchExceptionDetailDto[];
  /** @format int32 */
  failedDecisionsCount?: number;
  /** @format int32 */
  totalDecisionsCount?: number;
};

export type GetMasterRecipientsResponseDto = BaseResponseAchServiceDto & {
  pagedRecipients?: PagedListOfAchRecipientDto;
  /** @format int32 */
  requiredApprovalCount?: number;
};

export interface PagedListOfAchRecipientDto {
  items?: AchRecipientDto[];
  /** @format int32 */
  maxPageSize?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  recordCountInCurrentPage?: number;
  /** @format int32 */
  totalCount?: number;
}

export interface AchRecipientDto {
  accountNumber?: string;
  accountTypeDescription?: string;
  /** @format int32 */
  accountTypeId?: number;
  achMasterRecipientStatusTypeDescription?: string;
  /** @format byte */
  achMasterRecipientStatusTypeId?: number;
  addenda?: string;
  /** @format int32 */
  approvalCount?: number;
  audits?: AchAuditDtoDto[];
  canApproveReject?: boolean;
  canEdit?: boolean;
  /** @format decimal */
  defaultAmount?: number;
  /** @format int32 */
  id?: number;
  recipientIdNumber?: string;
  recipientName?: string;
  /** @format int32 */
  requiredApprovals?: number;
  routingNumber?: string;
  transactionTypeAbbreviation?: string;
  /** @format int32 */
  transactionTypeId?: number;
  /** @format int32 */
  updatedBy?: number;
}

export interface AchAuditDtoDto {
  /** @format int32 */
  achActionTypeId?: number;
  /** @format date-time */
  actionDate?: string;
  /** @format int32 */
  recordId?: number;
  /** @format int32 */
  userId?: number;
}

export type SaveMasterRecipientResponseDto = BaseResponseAchServiceDto & {
  achMasterRecipients?: AchRecipientDto[];
};

export type ApproveAchMasterRecipientResponseDto = BaseResponseAchServiceDto & object;

export type RejectAchMasterRecipientResponseDto = BaseResponseAchServiceDto & object;

export type DeleteAchMasterRecipientResponseDto = BaseResponseAchServiceDto & object;

export type GetMasterRecipientAuditsResponseDto = BaseResponseAchServiceDto & {
  audits?: AuditDisplayDto[];
};

export interface AuditDisplayDto {
  action?: string;
  /** @format date-time */
  actionDate?: string;
  userAlias?: string;
}

export type CreateAchBatchResponseDto = BaseResponseAchServiceDto & {
  achBatch?: AchBatchAchServiceDto;
};

export type SearchAchBatchResponseDto = BaseResponseAchServiceDto & {
  achBatches?: AchBatchAchServiceDto[];
  /** @format byte */
  downloadContent?: string;
};

export type UpdateAchBatchResponseDto = BaseResponseAchServiceDto & {
  achBatch?: AchBatchAchServiceDto;
  errorSummary?: ErrorSummaryAchServiceDto;
};

export type TreasuryChallengeResponseDto = BaseResponseAchServiceDto & {
  actionType?: string;
  challengeMethodType?: ChallengeMethodTypeEnumAchServiceDto;
  errorCode?: string;
  hasAlternate?: boolean;
  message?: string;
  methodUsed?: string;
  sendMessage?: string;
  status?: string;
};

export type CreateAchPaymentResponseDto = TreasuryChallengeResponseDto & {
  achPayment?: AchPaymentAchServiceDto;
  achPayments?: AchPaymentAchServiceDto[];
  errorSummary?: ErrorSummaryAchServiceDto;
  successMessage?: string;
};

export type CreateChildSupportPaymentResponseDto = TreasuryChallengeResponseDto & {
  achPayment?: ChildSupportPaymentDto;
  achPayments?: ChildSupportPaymentCollectionDto;
  errorSummary?: ErrorSummaryAchServiceDto;
  successMessage?: string;
};

export type CreateInternationalPaymentResponseDto = TreasuryChallengeResponseDto & {
  achInternationalPayment?: InternationalPaymentDto;
  achInternationalPayments?: InternationalPaymentCollectionDto;
  errorSummary?: ErrorSummaryAchServiceDto;
  successMessage?: string;
};

export type RejectAchPaymentResponseDto = TreasuryChallengeResponseDto & {
  achPayments?: AchPaymentAchServiceDto[];
};

export type ApproveAchPaymentResponseDto = TreasuryChallengeResponseDto & {
  achPayments?: AchPaymentAchServiceDto[];
};

export type UpdateAchPaymentResponseDto = TreasuryChallengeResponseDto & {
  achPayment?: AchPaymentAchServiceDto;
  errorSummary?: ErrorSummaryAchServiceDto;
  successMessage?: string;
};

export type UpdateChildSupportPaymentResponseDto = TreasuryChallengeResponseDto & {
  childSupportPayment?: ChildSupportPaymentDto;
  errorSummary?: ErrorSummaryAchServiceDto;
  successMessage?: string;
};

export type UpdateInternationalPaymentResponseDto = TreasuryChallengeResponseDto & {
  errorSummary?: ErrorSummaryAchServiceDto;
  internationalPayment?: InternationalPaymentDto;
  successMessage?: string;
};

export type GetInternationalAchCountriesResponseDto = BaseResponseAchServiceDto & {
  internationalAchCountries?: InternationalAchCountryCollectionDto;
};

export type InternationalAchCountryCollectionDto = InternationalAchCountryDto[];

export interface InternationalAchCountryDto {
  countryCode?: string;
  countryName?: string;
  foreignExchangeIndicators?: ForeignExchangeIndicatorCollectionDto;
  internationalAchAccountTypes?: InternationalAchAccountTypeDto[];
  isActive?: boolean;
  receivingBankCountry?: string;
}

export type ForeignExchangeIndicatorCollectionDto = ForeignExchangeIndicatorDto[];

export interface ForeignExchangeIndicatorDto {
  indicatorCode?: string;
  indicatorName?: string;
  supportedInternationalCurrencies?: InternationalCurrencyCollectionDto;
}

export type InternationalCurrencyCollectionDto = InternationalCurrencyDto[];

export interface InternationalCurrencyDto {
  currencyCode?: string;
  currencyName?: string;
}

export interface InternationalAchAccountTypeDto {
  accountName?: string;
  allowCredit?: boolean;
  allowDebit?: boolean;
}

export type GetInternationalAchPaymentResponseDto = BaseResponseAchServiceDto & {
  achInternationalPayment?: InternationalPaymentDto;
};

export type CreateNachaFileForDownloadResponseDto = BaseResponseAchServiceDto & {
  /** @format byte */
  nachaFileContents?: string;
};

export type GetAchPaymentResponseDto = BaseResponseAchServiceDto & {
  achPayment?: AchPaymentAchServiceDto;
};

export type GetAchPaymentDraftsResponseDto = BaseResponseAchServiceDto & {
  achPayments?: AchPaymentAchServiceDto[];
};

export type GetAchBatchResponseDto = BaseResponseAchServiceDto & {
  achBatch?: AchBatchAchServiceDto;
};

export type DeleteAchBatchResponseDto = BaseResponseAchServiceDto & object;

export type GetAchPaymentRecipientsResponseDto = BaseResponseAchServiceDto & {
  achPaymentRecipients?: AchPaymentRecipientAchServiceDto[];
};

export type GetAchBatchRecipientsResponseDto = BaseResponseAchServiceDto & {
  achBatchRecipients?: AchBatchRecipientAchServiceDto[];
};

export type SearchAchPaymentResponseDto = BaseResponseAchServiceDto & {
  achPaymentTotals?: AchPaymentTotalDto[];
  achPayments?: AchPaymentAchServiceDto[];
  /** @format byte */
  downloadContent?: string;
  forDownload?: boolean;
};

export interface AchPaymentTotalDto {
  achPaymentStatusTypeDescription?: string;
  /** @format int32 */
  achPaymentStatusTypeId?: number;
  /** @format int32 */
  count?: number;
  /** @format decimal */
  totalCredit?: number;
  /** @format decimal */
  totalDebit?: number;
}

export type CancelAchPaymentResponseDto = BaseResponseAchServiceDto & object;

export type UninitiateAchPaymentResponseDto = BaseResponseAchServiceDto & object;

export type RejectAchBatchResponseDto = BaseResponseAchServiceDto & object;

export type ApproveAchBatchResponseDto = BaseResponseAchServiceDto & object;

export type ValidateAchBatchNameResponseDto = BaseResponseAchServiceDto & {
  validationMessage?: string;
};

export type GetAchRecipientAddendaResponseDto = BaseResponseAchServiceDto & {
  achBatchRecipientAddendas?: AchBatchRecipientAddendaAchServiceDto[];
  achPaymentRecipientAddendas?: AchPaymentRecipientAddendaAchServiceDto[];
};

export type GetAchFileImportLayoutResponseDto = BaseResponseAchServiceDto & {
  achFileImportLayout?: FileImportLayoutAchServiceDto[];
};

export type GetDomesticBankResponseDto = BaseResponseAchServiceDto & {
  domesticBanks?: DomesticBankAchServiceDto[];
};

export type SaveAchFileImportLayoutResponseDto = BaseResponseAchServiceDto & {
  achFileImportLayout?: FileImportLayoutAchServiceDto[];
};

export type SaveAchRecipientAddendaResponseDto = BaseResponseAchServiceDto & {
  achBatchRecipientAddendas?: AchBatchRecipientAddendaAchServiceDto[];
  achPaymentRecipientAddendas?: AchPaymentRecipientAddendaAchServiceDto[];
};

export type DownloadHtmlResponseDto = BaseResponseAchServiceDto & {
  /** @format byte */
  filePath?: string;
};

export type ChangeInAchCompanyResponseDto = BaseResponseAchServiceDto & object;

export type ChangeInAchPaymentStatusResponseDto = BaseResponseAchServiceDto & object;

export type VerifyRoutingNumberResponseDto = BaseResponseAchServiceDto & {
  isOnUs?: boolean;
  isValid?: boolean;
};

export type GetOffsetAccountResponseDto = BaseResponseAchServiceDto & {
  lookups?: LookupAchServiceDto[];
};

export type SearchAchRecipientResponseDto = BaseResponseAchServiceDto & {
  achRecipientRecords?: AchRecipientRecordDto[];
  limitedBatches?: boolean;
  limitedPayments?: boolean;
};

export interface AchRecipientRecordDto {
  accountNumber?: string;
  accountType?: string;
  /** @format decimal */
  amount?: number;
  /** @format date-time */
  effectiveDate?: string;
  hold?: boolean;
  idNumber?: string;
  isRoutingNumberOnUs?: boolean;
  isRoutingNumberValid?: boolean;
  name?: string;
  prenote?: boolean;
  /** @format int32 */
  recordId?: number;
  recordType?: string;
  referenceNumber?: string;
  reversal?: boolean;
  routingNumber?: string;
  transactionCode?: string;
  transactionType?: string;
}

export type SubmitScheduledAchPaymentResponseDto = BaseResponseAchServiceDto & object;

export type AchTransactionSearchResponseDto = BaseResponseAchServiceDto & {
  transactions?: AchTransactionDto[];
};

export interface AchTransactionDto {
  /** @format int32 */
  accountId?: number;
  accountName?: string;
  accountNumber?: string;
  accountType?: string;
  achCompanyId?: string;
  achCompanyName?: string;
  /** @format decimal */
  amount?: number;
  amountType?: string;
  ediType?: string;
  secCode?: string;
  segmentDescription?: string;
  segmentValue?: string;
  /** @format date-time */
  transactionDate?: string;
  transactionId?: string;
}

export type AchAddendaSearchResponseDto = BaseResponseAchServiceDto & {
  addendaList?: AchAddendaDto[];
};

export interface AchAddendaDto {
  segmentDescription?: string;
  segmentValue?: string;
  transactionId?: string;
}

export type InquiryAchCompanyResponseDto = BaseResponseAchServiceDto & {
  coreCompanies?: AchCompanyAchServiceDto[];
};

export type GetAchFileResponseDto = BaseResponseAchServiceDto & {
  achFile?: AchFileDto;
};

export type AchFileDeleteResponseDto = BaseResponseAchServiceDto & object;

export type SaveTransmittedAchFilesResponseDto = BaseResponseAchServiceDto & {
  /** @format int32 */
  fileCount?: number;
};

export type GetChildSupportPaymentResponseDto = BaseResponseAchServiceDto & {
  childSupportPayment?: ChildSupportPaymentDto;
};

export type UploadInternationalNachaFileResponseDto = BaseResponseAchServiceDto & {
  achInternationalPayments?: InternationalPaymentCollectionDto;
  errorMessage?: ErrorSummaryAchServiceDto;
};

export type GetStateTaxAmountTypesResponseDto = BaseResponseAchServiceDto & {
  achStateAmountTypes?: AchStateAmountTypeAchServiceDto[];
};

export type GetFederalTaxAmountTypesResponseDto = BaseResponseAchServiceDto & {
  federalTaxCodeAmountTypes?: FederalTaxCodeAmountTypeDto[];
};

export interface FederalTaxCodeAmountTypeDto {
  achFederalAmountType?: AchFederalAmountTypeAchServiceDto;
  /** @format int32 */
  achFederalAmountTypeId?: number;
  federalTaxCode?: FederalTaxCodeDto;
  /** @format int32 */
  federalTaxCodeId?: number;
  /** @format int32 */
  id?: number;
}

export interface FederalTaxCodeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  taxCode?: string;
}

export type GetFederalTaxCodesResponseDto = BaseResponseAchServiceDto & {
  federalTaxCodes?: FederalTaxCodeDto[];
};

export type GetFederalTaxRecipientResponseDto = BaseResponseAchServiceDto & {
  federalTaxRecipient?: FederalTaxRecipientDto;
};

export interface FederalTaxRecipientDto {
  accountNumber?: string;
  /** @format int32 */
  accountTypeId?: number;
  /** @format int32 */
  id?: number;
  recipientName?: string;
  routingNumber?: string;
}

export type GetStateTaxRecipientsResponseDto = BaseResponseAchServiceDto & {
  stateTaxRecipients?: InstitutionAchProductStateRecipientDto[];
};

export interface InstitutionAchProductStateRecipientDto {
  accountNumber?: string;
  /** @format int32 */
  accountTypeId?: number;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  institutionAchProductId?: number;
  recipientName?: string;
  routingNumber?: string;
  /** @format int32 */
  stateId?: number;
}

export type GetStateTaxCodesResponseDto = BaseResponseAchServiceDto & {
  stateTaxCodes?: InstitutionAchProductStateTaxCodeDto[];
};

export interface InstitutionAchProductStateTaxCodeDto {
  description?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  institutionAchProductId?: number;
  /** @format int32 */
  stateId?: number;
  taxCode?: string;
}

export type GetTaxRecipientAccountTypesResponseDto = BaseResponseAchServiceDto & {
  accountTypes?: AccountTypeAchServiceDto[];
};

export type NachaFileUploadResponseDto = BaseResponseAchServiceDto & {
  achBatches?: AchBatchAchServiceDto[];
  achPaymentDrafts?: AchPaymentDraftDto[];
  achPayments?: AchPaymentAchServiceDto[];
  allowUnbalancedAchBatch?: boolean;
  errorMessage?: ErrorSummaryAchServiceDto;
  fileName?: string;
  fileSize?: string;
  /** @format int32 */
  totalBalancedBatches?: number;
  /** @format decimal */
  totalBalancedCreditAmount?: number;
  /** @format decimal */
  totalBalancedDebitAmount?: number;
  /** @format decimal */
  totalCreditAmount?: number;
  /** @format int32 */
  totalCreditTransactions?: number;
  /** @format decimal */
  totalDebitAmount?: number;
  /** @format int32 */
  totalDebitTransactions?: number;
  /** @format int32 */
  totalUnbalancedBatches?: number;
  /** @format decimal */
  totalUnbalancedCreditAmount?: number;
  /** @format decimal */
  totalUnbalancedDebitAmount?: number;
};

export type RecipientFileUploadResponseDto = BaseResponseAchServiceDto & {
  achRecipients?: AchRecipientRecordDto[];
  errorSummaries?: FileErrorDto[];
};

export type SearchAchFileActivityResponseDto = BaseResponseAchServiceDto & {
  achFileData?: AchFileDataDto[];
  /** @format byte */
  downloadContent?: string;
  forDownload?: boolean;
};

export interface AchFileDataDto {
  /** @format int32 */
  achFileId?: number;
  /** @format int32 */
  approvedCount?: number;
  /** @format int32 */
  expiredCount?: number;
  /** @format int32 */
  fileArchiveId?: number;
  fileName?: string;
  fileSize?: string;
  /** @format int32 */
  invalidCount?: number;
  isExpired?: boolean;
  /** @format int32 */
  pendingCount?: number;
  processedByUsername?: string;
  /** @format date-time */
  processedDate?: string;
  /** @format int32 */
  rejectedCount?: number;
  source?: string;
  status?: string;
  /** @format int32 */
  totalBatchCount?: number;
  /** @format decimal */
  totalCredit?: number;
  /** @format decimal */
  totalDebit?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  /** @format date-time */
  uploadDate?: string;
  validationError?: string;
  validationErrors?: AchFileValidationErrorAchServiceDto[];
}

export interface AchFileValidationErrorAchServiceDto {
  action?: string;
  /** @format int32 */
  lineNumber?: number;
  message?: string;
  record?: string;
}

export type SearchAchNotificationOfChangeResponseDto = ActionStatusDto & {
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  maxPageSize?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  recordCountInCurrentPage?: number;
  notificationOfChanges?: SearchAchNotificationOfChangeItemDto[];
};

export interface SearchAchNotificationOfChangeItemDto {
  /** @format guid */
  achNocTransactionUniqueId?: string;
  /** @format date-time */
  effectiveDate?: string;
  /** @format date-time */
  receivedDate?: string;
  achCompanyName?: string;
  companyEntryDescription?: string;
  secCode?: AchChangeModelDto;
  recipientName?: AchChangeModelDto;
  recipientFinancialInstitution?: AchChangeModelDto;
  accountNumber?: AchChangeModelDto;
  accountType?: AchChangeModelDto;
  identificationNumber?: AchChangeModelDto;
  traceNumber?: AchChangeModelDto;
  changeCode?: string;
}

export interface AchChangeModelDto {
  original?: string;
  updated?: string;
}

export interface ActionStatusDto {
  successLevel?: ActionSuccessLevelDto;
  responseDetailCollection?: ResponseDetailCollectionDto;
}

export interface SearchAchNotificationOfChangeRequestDto {
  effectiveDateFilterOption?: DateFilterOptionsDto;
  /** @format date-time */
  effectiveDateStart?: string;
  /** @format date-time */
  effectiveDateEnd?: string;
  receivedDateFilterOption?: DateFilterOptionsDto;
  /** @format date-time */
  receivedDateStart?: string;
  /** @format date-time */
  receivedDateEnd?: string;
  achCompanies?: GuidKeyCollectionDto;
  recipientName?: string;
  pagingParameters?: PagingParametersDto;
}

export type GetAchNotificationOfChangeResponseDto = ActionStatusDto & {
  /** @format guid */
  achNocTransactionUniqueId?: string;
  /** @format date-time */
  effectiveDate?: string;
  /** @format date-time */
  receivedDate?: string;
  achCompanyName?: string;
  companyEntryDescription?: string;
  secCode?: AchChangeModelDto;
  recipientName?: AchChangeModelDto;
  recipientFinancialInstitution?: AchChangeModelDto;
  accountNumber?: AchChangeModelDto;
  accountType?: AchChangeModelDto;
  identificationNumber?: AchChangeModelDto;
  traceNumber?: AchChangeModelDto;
  changeCode?: string;
};

export type AchNotificationOfChangeReportModelDto = PagedListModelAchNotificationOfChangeModelDto &
  object;

export interface PagedListModelAchNotificationOfChangeModelDto {
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  maxPageSize?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalCount?: number;
  items?: AchNotificationOfChangeModelDto[];
  /** @format int32 */
  recordCountInCurrentPage?: number;
}

export interface AchNotificationOfChangeModelDto {
  achNotificationOfChangeUniqueId?: string;
  /** @format date-time */
  effectiveDate?: string;
  /** @format date-time */
  receivedDate?: string;
  achCompanyName?: string;
  returnReasonCode?: string;
  returnReasonDescription?: string;
  achCompanyId?: string;
}

export interface AchNoticeOfChangeFilterModelDto {
  receivedDate?: DateFilterModelDto;
  companyIds?: number[];
  pagingParameters?: PagingParametersModelDto;
}

export interface GetAchNotificationOfChangeDownloadRequestDto {
  /** @format guid */
  achNocTransactionUniqueId?: string;
  outPutType?: OutPutTypeDto;
}

export interface SearchAchNotificationOfChangeDownloadRequestDto {
  filter?: SearchAchNotificationOfChangeDownloadFilterDto;
  informationType?: string;
  outPutType?: OutPutTypeDto;
  pagingParameters?: PagingParametersDto;
}

export interface SearchAchNotificationOfChangeDownloadFilterDto {
  effectiveDateFilterOption?: DateFilterOptionsDto;
  /** @format date-time */
  effectiveDateStart?: string;
  /** @format date-time */
  effectiveDateEnd?: string;
  receivedDateFilterOption?: DateFilterOptionsDto;
  /** @format date-time */
  receivedDateStart?: string;
  /** @format date-time */
  receivedDateEnd?: string;
  achCompanies?: GuidKeyCollectionDto;
  recipientName?: string;
}

export interface AchNotificationOfChangeDetailModelDto {
  routingNumber?: AchChangeModelDto;
  discretionaryData?: AchChangeModelDto;
  recipientName?: AchChangeModelDto;
  secCode?: AchChangeModelDto;
  accountNumber?: AchChangeModelDto;
  accountType?: AchChangeModelDto;
  identificationNumber?: AchChangeModelDto;
  traceNumber?: AchChangeModelDto;
  achCompany?: string;
  changeCode?: string;
  /** @format date-time */
  effectiveDate?: string;
  companyEntryDescription?: string;
}

export interface AchNotificationOfChangeReportRequestModelDto {
  /** @format date-time */
  notificationReceivedDate?: string;
  changeCodeDescription?: string;
  isPortrait?: boolean;
}

export interface AchPaymentFilterModelDto {
  achType?: string;
  /** @minLength 1 */
  achCompanyName: string;
  achCompanyList?: AchCompanyModelDto[];
  /** @minLength 1 */
  batchName: string;
  /** @minLength 1 */
  transactionId: string;
  /** @minLength 1 */
  secCode: string;
  /** @minLength 1 */
  initiatedDateType: string;
  /**
   * @format date-time
   * @minLength 1
   */
  initiatedDate: string;
  /**
   * @format date-time
   * @minLength 1
   */
  initiatedDateStart: string;
  /**
   * @format date-time
   * @minLength 1
   */
  initiatedDateEnd: string;
  /** @minLength 1 */
  effectiveDateType: string;
  /**
   * @format date-time
   * @minLength 1
   */
  effectiveDate: string;
  /**
   * @format date-time
   * @minLength 1
   */
  effectiveDateStart: string;
  /**
   * @format date-time
   * @minLength 1
   */
  effectiveDateEnd: string;
  /** @minLength 1 */
  amountType: string;
  /** @format decimal */
  amount: number;
  /** @format decimal */
  amountMin: number;
  /** @format decimal */
  amountMax: number;
  /** @minLength 1 */
  status: string;
  /** @format decimal */
  debitAmount: number;
  /** @format decimal */
  creditAmount: number;
  /** @minLength 1 */
  creditAmountType: string;
  /** @minLength 1 */
  debitAmountType: string;
  /** @format decimal */
  debitAmountMax: number;
  /** @format decimal */
  debitAmountMin: number;
  /** @format decimal */
  creditAmountMax: number;
  /** @format decimal */
  creditAmountMin: number;
  isRecurring: boolean;
  isBasic?: boolean;
  /** @minLength 1 */
  nextPaymentDateType: string;
  /**
   * @format date-time
   * @minLength 1
   */
  nextPaymentDate: string;
  /**
   * @format date-time
   * @minLength 1
   */
  nextPaymentDateStart: string;
  /**
   * @format date-time
   * @minLength 1
   */
  nextPaymentDateEnd: string;
  fileArchiveIds?: number[];
  frequencies?: LookupModelDto[];
}

export interface RoutingNumberStatusModelDto {
  isValid: boolean;
  isOnUs: boolean;
}

export interface AchEditablePaymentModelDto {
  payment: AchPaymentModelDto;
  settings: AchSettingsModelDto;
  /** @minLength 1 */
  errorMessage: string;
  /** @minLength 1 */
  successMessage: string;
  securityMessage?: SecurityMessageModelDto;
}

export type AchPaymentWithTemplatesModelDto = AchPaymentWithBatchesModelDto & {
  achBatchSummaries?: AchPaymentModelDto[];
};

export type AchStateTaxPaymentModelDto = AchPaymentModelDto & {
  /** @format date-time */
  taxPeriodEndDate?: string;
  /**
   * @minLength 0
   * @maxLength 5
   */
  taxCode: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  taxPayerId: string;
  /** @format int32 */
  recipientAccountTypeId?: number;
  recipientAccountType?: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  recipientName: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  recipientRoutingNumber: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  recipientAccountNumber: string;
  /**
   * @minLength 0
   * @maxLength 20
   */
  recipientIdNumber?: string;
  /** @format int32 */
  stateId?: number;
  state?: string;
  /** @format int32 */
  payFromAccountId?: number;
  payFromAccountName?: string;
  /**
   * @minLength 0
   * @maxLength 20
   */
  createdBy: string;
  /** @format date-time */
  createdDate?: string;
  copiedFromTransactionId?: string;
  achStateTaxPaymentAmounts?: AchStateTaxPaymentAmountModelDto[];
};

export type AchStateTaxPaymentAmountModelDto = ModelBaseDto & {
  /** @format int32 */
  achPaymentId?: number;
  /** @format decimal */
  amount?: number;
  /** @format int32 */
  achStateAmountTypeId?: number;
  /**
   * @minLength 0
   * @maxLength 1
   */
  amountTypeName: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  amountTypeDescription: string;
  /**
   * @minLength 0
   * @maxLength 20
   */
  createdBy: string;
  /** @format date-time */
  createdDate?: string;
};

export type AchFederalTaxPaymentModelDto = AchPaymentModelDto & {
  /** @format date-time */
  taxPeriodEndDate?: string;
  /**
   * @minLength 0
   * @maxLength 5
   */
  taxCode: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  taxPayerId: string;
  /** @format int32 */
  recipientAccountTypeId?: number;
  recipientAccountType?: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  recipientName: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  recipientRoutingNumber: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  recipientAccountNumber: string;
  /**
   * @minLength 0
   * @maxLength 20
   */
  recipientIdNumber?: string;
  /** @format int32 */
  payFromAccountId?: number;
  payFromAccountName?: string;
  /**
   * @minLength 0
   * @maxLength 20
   */
  createdBy: string;
  /** @format date-time */
  createdDate?: string;
  achFederalTaxPaymentAmounts?: AchFederalTaxPaymentAmountModelDto[];
  hasAmountTypes?: boolean;
};

export type AchFederalTaxPaymentAmountModelDto = ModelBaseDto & {
  /** @format int32 */
  achPaymentId?: number;
  /** @format decimal */
  amount?: number;
  /** @format int32 */
  achFederalAmountTypeId?: number;
  amountType?: string;
  achFederalAmountTypeName?: string;
  achFederalAmountTypeDescription?: string;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
};

export type CancelAchPaymentModelDto = SecurityBaseDto & {
  /** @format int32 */
  achPaymentId?: number;
  comment?: string;
};

export type AchUninitiateModelDto = SecurityBaseDto & {
  /** @format int32 */
  achPaymentId?: number;
  comment?: string;
  isUninitiated?: boolean;
};

export interface AchPaymentSearchResponseDto {
  results?: AchPaymentModelDto[];
  totals?: AchPaymentStatusTotalDto[];
}

export interface AchPaymentStatusTotalDto {
  status?: string;
  /** @format int32 */
  count?: number;
  /** @format decimal */
  totalCredit?: number;
  /** @format decimal */
  totalDebit?: number;
}

export type InternationalAchPaymentDto = AchPaymentModelBaseDto & {
  streetAddress?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  recipients?: InternationalAchPaymentRecipientCollectionDto;
};

export type InternationalAchPaymentRecipientCollectionDto = InternationalAchPaymentRecipientDto[];

export type InternationalAchPaymentRecipientDto = AchRecipientModelDto & {
  streetAddress?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  receivingBankType?: string;
  receivingBankNumber?: string;
  receivingBankName?: string;
  receivingBankCountry?: string;
  optionalAddendaLine1?: string;
  optionalAddendaLine2?: string;
  iatTransactionType?: string;
};

export type AchPaymentListModelDto = SecurityBaseDto & {
  achPayments?: AchPaymentModelDto[];
  successMessage?: string;
  errorMessage?: string;
  bulkAchIds?: number[];
};

export type ChildSupportPaymentResponseDto = AchEditablePaymentModelDto & {
  payment?: ChildSupportPayment2Dto;
};

export type ChildSupportPayment2Dto = AchPaymentModelBaseDto & {
  recipients?: ChildSupportRecipientDto[];
};

export type ChildSupportRecipientDto = AchRecipientModelBaseDto & {
  addenda?: ChildSupportAddendaDto[];
};

export type ChildSupportAddendaDto = ModelBaseDto & {
  caseIdentifier?: string;
  employmentTermination?: boolean;
  fipsCode?: string;
  medicalSupport?: boolean;
  nonCustodialParentFirstName?: string;
  nonCustodialParentLastName?: string;
  nonCustodialParentSsn?: string;
  /** @format date-time */
  payDate?: string;
};

export type ChildSupportEditableAchPaymentModelDto = AchEditablePaymentModelDto & {
  childSupportAchPayment: ChildSupportPayment2Dto;
};

export type GetInternationalAchCountriesResponse2Dto = SecurityBaseDto & {
  internationalAchCountries?: InternationalAchCountryCollection2Dto;
};

export type InternationalAchCountryCollection2Dto = InternationalAchCountry2Dto[];

export interface InternationalAchCountry2Dto {
  countryCode?: string;
  countryName?: string;
  receivingBankCountry?: string;
  foreignExchangeIndicators?: ForeignExchangeIndicatorCollection2Dto;
  internationalAchAccountTypes?: InternationalAchAccountTypeCollectionDto;
  isActive?: boolean;
}

export type ForeignExchangeIndicatorCollection2Dto = ForeignExchangeIndicator2Dto[];

export interface ForeignExchangeIndicator2Dto {
  indicatorCode?: string;
  indicatorName?: string;
  supportedCurrencies?: InternationalCurrencyCollection2Dto;
}

export type InternationalCurrencyCollection2Dto = InternationalCurrency2Dto[];

export interface InternationalCurrency2Dto {
  currencyCode?: string;
  currencyName?: string;
}

export type InternationalAchAccountTypeCollectionDto = InternationalAchAccountType2Dto[];

export interface InternationalAchAccountType2Dto {
  accountName?: string;
  allowDebit?: boolean;
  allowCredit?: boolean;
}

export interface GetInternationalAchPaymentResponse2Dto {
  payment?: InternationalAchPaymentDto;
}

export interface CreateInternationalAchPaymentResponseDto {
  payment?: InternationalAchPaymentDto;
  /** @minLength 1 */
  errorMessage: string;
  /** @minLength 1 */
  successMessage: string;
  securityMessage?: SecurityMessageModelDto;
}

export interface CreateInternationalAchPaymentRequestDto {
  payment?: InternationalAchPaymentDto;
  securityMessage?: SecurityMessageModelDto;
}

export type InternationalEditableAchPaymentModelDto = AchEditablePaymentModelDto & {
  internationalAchPayment?: InternationalAchPaymentDto;
};

export interface UpdateInternationalAchPaymentRequestDto {
  payment?: InternationalAchPaymentDto;
  securityMessage?: SecurityMessageModelDto;
}

export type AchRecipientRecordModelDto = AchRecipientModelDto & {
  /** @minLength 1 */
  recordType: string;
  /** @minLength 1 */
  referenceNumber: string;
  /**
   * @format date-time
   * @minLength 1
   */
  effectiveDate: string;
  /** @format int32 */
  recordId: number;
};

export interface SearchAchRecipientResponseModelDto {
  achRecipientRecords?: AchRecipientRecordModelDto[];
  limitedPayments?: boolean;
  limitedBatches?: boolean;
}

export interface AchRecipientFilterModelDto {
  /** @minLength 1 */
  recordType: string;
  /** @minLength 1 */
  recipientName: string;
  /** @minLength 1 */
  amountType: string;
  /** @format decimal */
  amount: number;
  /** @format decimal */
  amountMin: number;
  /** @format decimal */
  amountMax: number;
  prenote: boolean;
  hold: boolean;
  reversal: boolean;
}

export type SearchAchReturnResponseDto = ActionStatusDto & {
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  maxPageSize?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  recordCountInCurrentPage?: number;
  returns?: SearchAchReturnItemDto[];
};

export interface SearchAchReturnItemDto {
  achCompanyName?: string;
  achCompanyId?: string;
  achCompanyDiscretionaryData?: string;
  achCompanyEntryDescription?: string;
  /** @format guid */
  achReturnTransactionUniqueId?: string;
  accountNumber?: string;
  accountType?: string;
  /** @format decimal */
  amount?: number;
  /** @format date-time */
  dateOfDeath?: string;
  identificationNumber?: string;
  /** @format date-time */
  effectiveDate?: string;
  /** @format date-time */
  receivedDate?: string;
  recipientFinancialInstitution?: string;
  recipientName?: string;
  returnReason?: string;
  secCode?: string;
  traceNumber?: string;
}

export interface SearchAchReturnRequestDto {
  effectiveDateFilterOption?: DateFilterOptionsDto;
  /** @format date-time */
  effectiveDateStart?: string;
  /** @format date-time */
  effectiveDateEnd?: string;
  receivedDateFilterOption?: DateFilterOptionsDto;
  /** @format date-time */
  receivedDateStart?: string;
  /** @format date-time */
  receivedDateEnd?: string;
  achCompanies?: GuidKeyCollectionDto;
  recipientName?: string;
  pagingParameters?: PagingParametersDto;
}

export type GetAchReturnResponseDto = ActionStatusDto & {
  /** @format guid */
  achReturnTransactionUniqueId?: string;
  /** @format date-time */
  originalEffectiveDate?: string;
  /** @format date-time */
  receivedDate?: string;
  achCompanyName?: string;
  secCode?: string;
  recipientName?: string;
  recipientFinancialInstitution?: string;
  accountNumber?: string;
  accountType?: string;
  /** @format double */
  amount?: number;
  identificationNumber?: string;
  traceNumber?: string;
  returnReason?: string;
  /** @format date-time */
  dateOfDeath?: string;
};

export type AchReturnReportModelDto = PagedListModelAchReturnModelDto & object;

export interface PagedListModelAchReturnModelDto {
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  maxPageSize?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalCount?: number;
  items?: AchReturnModelDto[];
  /** @format int32 */
  recordCountInCurrentPage?: number;
}

export interface AchReturnModelDto {
  achReturnUniqueId?: string;
  /** @format date-time */
  effectiveDate?: string;
  /** @format date-time */
  receivedDate?: string;
  achCompanyName?: string;
  returnReasonCode?: string;
  returnReasonDescription?: string;
  /** @format decimal */
  amount?: number;
  achCompanyId?: string;
}

export interface AchReturnFilterModelDto {
  receivedDate?: DateFilterModelDto;
  companyIds?: number[];
  pagingParameters?: PagingParametersModelDto;
}

export interface AchReturnDetailModelDto {
  discretionaryData?: string;
  recipientName?: string;
  secCode?: string;
  recipientFinancialInstitution?: string;
  accountType?: string;
  identificationNumber?: string;
  traceNumber?: string;
  /** @format date-time */
  dateOfDeath?: string;
  accountNumber?: string;
  /** @format date-time */
  originalEffectiveDate?: string;
  achCompany?: string;
  /** @format double */
  amount?: number;
  returnReasonCode?: string;
}

export interface AchReturnReportRequestModelDto {
  /** @format date-time */
  notificationReceivedDate?: string;
  returnReasonDescription?: string;
  isPortrait?: boolean;
}

export interface GetAchReturnDownloadRequestDto {
  /** @format guid */
  achReturnTransactionUniqueIdentifier?: string;
  outPutType?: OutPutTypeDto;
}

export interface SearchAchReturnDownloadRequestDto {
  filter?: SearchAchReturnDownloadFilterDto;
  informationType?: string;
  outPutType?: OutPutTypeDto;
  pagingParameters?: PagingParametersDto;
}

export interface SearchAchReturnDownloadFilterDto {
  effectiveDateFilterOption?: DateFilterOptionsDto;
  /** @format date-time */
  effectiveDateStart?: string;
  /** @format date-time */
  effectiveDateEnd?: string;
  receivedDateFilterOption?: DateFilterOptionsDto;
  /** @format date-time */
  receivedDateStart?: string;
  /** @format date-time */
  receivedDateEnd?: string;
  achCompanies?: GuidKeyCollectionDto;
  recipientName?: string;
}

export type GetAchChildSupportTemplateResponseDto = GetAchTemplateBaseResponseDto & {
  /** @format decimal */
  debitAmount: number;
  /** @format decimal */
  creditAmount: number;
  recipients: AchChildSupportRecipientResponseCollectionDto;
};

export type AchChildSupportRecipientResponseCollectionDto = AchChildSupportRecipientResponseDto[];

export type AchChildSupportRecipientResponseDto = AchRecipientBaseResponseDto & {
  addenda?: AchChildSupportRecipientAddendaResponseDto;
};

export type AchChildSupportRecipientAddendaResponseDto = AchChildSupportRecipientAddendaBaseDto &
  object;

export type AchChildSupportRecipientAddendaBaseDto = AchRecipientAddendaBaseDto & {
  caseIdentifier?: string;
  employmentTermination?: boolean;
  fipsCode?: string;
  medicalSupport?: boolean;
  nonCustodialParentFirstName?: string;
  nonCustodialParentLastName?: string;
  nonCustodialParentSsn?: string;
};

export interface AchRecipientAddendaBaseDto {
  /** @format guid */
  id?: string;
  /** @format guid */
  recipientId?: string;
}

export type AchRecipientBaseResponseDto = AchRecipientBaseDto & {
  /** @format guid */
  id?: string;
  /** @minLength 1 */
  accountTypeName: string;
  /** @minLength 1 */
  transactionTypeDescription: string;
};

export interface AchRecipientBaseDto {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  idNumber: string;
  /** @minLength 1 */
  routingNumber: string;
  /** @minLength 1 */
  accountNumber: string;
  accountType: BankAccountTypeDto;
  transactionType: AchTransactionTypeDto;
  /** @format decimal */
  amount: number;
  isPrenote: boolean;
  holdTransaction: boolean;
}

export type GetAchTemplateBaseResponseDto = AchTemplateBaseResponseDto & {
  /** @minLength 1 */
  name: string;
  /** @format int32 */
  achCompanyId: number;
  /**
   * @format guid
   * @minLength 1
   */
  achCompanyUniqueId: string;
  /** @minLength 1 */
  achCompanyName: string;
  /** @minLength 1 */
  companyIdentity: string;
  /** @minLength 1 */
  secCode: string;
  /** @minLength 1 */
  entryDescription: string;
  /** @minLength 1 */
  discretionaryData: string;
  restricted: boolean;
  audit?: string;
  /** @minLength 1 */
  statusDescription: string;
  status: AchTemplateStatusTypeDto;
  /**
   * @format date-time
   * @minLength 1
   */
  lastUpdated: string;
  userPermissions?: TextKeyCollectionDto;
  /** @format int32 */
  numberOfApprovalsNeeded?: number;
  /** @format int32 */
  completedApprovalCount?: number;
};

export type AchTemplateBaseResponseDto = ActionStatusDto & {
  /** @format guid */
  id?: string;
};

export type CreateAchTemplateResponseDto = AchTemplateBaseResponseDto & {
  templateStatus?: string;
  templateAudit?: string;
  securityMessage?: SecurityMessageModelDto;
};

export type CreateAchChildSupportTemplateRequestDto = AchChildSupportTemplateBaseRequestDto & {
  /** @format guid */
  id?: string;
};

export type AchChildSupportTemplateBaseRequestDto = AchTemplateBaseRequestDto & {
  recipients: AchChildSupportRecipientRequestDto[];
};

export type AchChildSupportRecipientRequestDto = AchRecipientBaseDto & {
  /** @format guid */
  id?: string;
  addenda?: AchChildSupportRecipientAddendaRequestDto;
};

export type AchChildSupportRecipientAddendaRequestDto = AchChildSupportRecipientAddendaBaseDto & {
  /** @format guid */
  id?: string;
  /** @format guid */
  recipientId?: string;
};

export interface AchTemplateBaseRequestDto {
  /** @minLength 1 */
  name: string;
  /** @format int32 */
  achCompanyId: number;
  /**
   * @format guid
   * @minLength 1
   */
  achCompanyUniqueId: string;
  /** @minLength 1 */
  companyIdentity: string;
  secCode: AchSecCodeTypeDto;
  /** @minLength 1 */
  entryDescription: string;
  /** @minLength 1 */
  discretionaryData: string;
  restricted: boolean;
}

export type UpdateAchTemplateResponseDto = AchTemplateBaseResponseDto & {
  templateStatus?: string;
  templateAudit?: string;
  securityMessage?: SecurityMessageModelDto;
};

export type UpdateAchChildSupportTemplateRequestDto = AchChildSupportTemplateBaseRequestDto & {
  /** @format guid */
  id?: string;
};

export type DeleteAchTemplateResponseDto = AchTemplateBaseResponseDto & {
  securityMessage?: SecurityMessageModelDto;
};

export type SearchAchTemplateListResponseDto = ActionStatusDto & {
  templates?: SearchAchTemplateBaseResponseCollectionDto;
};

export type SearchAchTemplateBaseResponseCollectionDto = SearchAchTemplateBaseResponseDto[];

export interface SearchAchTemplateBaseResponseDto {
  /** @format guid */
  templateId?: string;
  /** @format int32 */
  templateIntId?: number;
  templateName?: string;
  achCompanyName?: string;
  secCode?: string;
  /** @format date-time */
  lastUpdated?: string;
  status?: string;
  userPermissions?: TextKeyCollectionDto;
  /** @format int32 */
  numberOfApprovalsNeeded?: number;
  /** @format int32 */
  completedApprovalCount?: number;
}

export type SearchAchChildSupportTemplateRequestDto = SearchAchTemplateBaseRequestDto & {
  creditAmountType?: AchFilterAmountTypeDto;
  /** @format decimal */
  creditAmount?: number;
  /** @format decimal */
  creditAmountMax?: number;
};

export interface SearchAchTemplateBaseRequestDto {
  achCompanyIdList?: NumberKeyCollectionDto;
  templateName?: string;
  lastUpdatedDateType?: AchFilterDateTypeDto;
  /** @format date-time */
  lastUpdated?: string;
  /** @format date-time */
  lastUpdatedEnd?: string;
  status?: AchTemplateStatusTypeDto;
  secCode?: AchSecCodeTypeDto;
}

export interface AchTemplateDownloadModelDto {
  /** @format guid */
  filterModel?: string;
  outputType?: OutPutTypeDto;
  isPortrait?: boolean;
}

export type AchChildSupportTemplateListDownloadModelDto = AchTemplateListDownloadModelDto & {
  filterModel?: SearchAchChildSupportTemplateRequestDto;
};

export interface AchTemplateListDownloadModelDto {
  outputType?: OutPutTypeDto;
  isPortrait?: boolean;
}

export type GetAchInternationalTemplateResponseDto = GetAchTemplateBaseResponseDto & {
  /** @minLength 1 */
  streetAddress: string;
  /** @minLength 1 */
  city: string;
  /** @format int32 */
  stateId: number;
  /** @minLength 1 */
  zipCode: string;
  country?: string;
  /** @format int32 */
  destinationCountryCodeId: number;
  /** @format int32 */
  foreignExchangeIndicatorId: number;
  /** @format int32 */
  foreignExchangeReferenceIndicatorId?: number;
  foreignExchangeReference?: string;
  /** @format int32 */
  destinationCurrencyCodeId: number;
  /** @format decimal */
  debitAmount: number;
  /** @format decimal */
  creditAmount: number;
  /** @format int32 */
  originatorCurrencyCodeId?: number;
  recipients: AchInternationalRecipientResponseCollectionDto;
};

export type AchInternationalRecipientResponseCollectionDto = AchInternationalRecipientResponseDto[];

export type AchInternationalRecipientResponseDto = AchRecipientBaseResponseDto & {
  streetAddress?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  /** @format int32 */
  iatTransactionTypeId?: number;
  bankName?: string;
  /** @format int32 */
  bankIdTypeId?: number;
  /** @format int32 */
  receivingBankCountryId?: number;
  addenda?: AchInternationalRecipientAddendaCollectionDto;
};

export type AchInternationalRecipientAddendaCollectionDto = AchInternationalRecipientAddendaDto[];

export type AchInternationalRecipientAddendaDto = AchRecipientAddendaBaseDto & {
  line?: string;
};

export type CreateAchInternationalTemplateRequestDto = AchInternationalTemplateBaseRequestDto & {
  /** @format guid */
  id?: string;
};

export type AchInternationalTemplateBaseRequestDto = AchTemplateBaseRequestDto & {
  /** @minLength 1 */
  streetAddress: string;
  /** @minLength 1 */
  city: string;
  /** @format int32 */
  stateId?: number;
  /** @minLength 1 */
  zipCode: string;
  country?: string;
  /** @format int32 */
  destinationCountryCodeId?: number;
  /** @format int32 */
  foreignExchangeIndicatorId: number;
  /** @format int32 */
  foreignExchangeReferenceIndicatorId?: number;
  foreignExchangeReference?: string;
  /** @format int32 */
  destinationCurrencyCodeId: number;
  /** @format decimal */
  debitAmount: number;
  /** @format decimal */
  creditAmount: number;
  /** @format int32 */
  originatorCurrencyCodeId?: number;
  recipients: AchInternationalRecipientRequestCollectionDto;
};

export type AchInternationalRecipientRequestCollectionDto = AchInternationalRecipientRequestDto[];

export type AchInternationalRecipientRequestDto = AchRecipientBaseDto & {
  /** @format guid */
  id?: string;
  /** @minLength 1 */
  streetAddress: string;
  /** @minLength 1 */
  city: string;
  /** @minLength 1 */
  state: string;
  /** @minLength 1 */
  zipCode: string;
  /** @minLength 1 */
  country: string;
  /** @format int32 */
  iatTransactionTypeId: number;
  /** @minLength 1 */
  bankName: string;
  /** @format int32 */
  bankIdTypeId: number;
  /** @format int32 */
  receivingBankCountryId?: number;
  addenda?: AchInternationalRecipientAddendaCollectionDto;
};

export type UpdateAchInternationalTemplateRequestDto = AchInternationalTemplateBaseRequestDto & {
  /** @format guid */
  id?: string;
};

export type SearchAchInternationalTemplateRequestDto = SearchAchTemplateBaseRequestDto & {
  creditAmountType?: AchFilterAmountTypeDto;
  /** @format decimal */
  creditAmount?: number;
  /** @format decimal */
  creditAmountMax?: number;
  debitAmountType?: AchFilterAmountTypeDto;
  /** @format decimal */
  debitAmount?: number;
  /** @format decimal */
  debitAmountMax?: number;
};

export type AchInternationalTemplateListDownloadModelDto = AchTemplateListDownloadModelDto & {
  filterModel?: SearchAchInternationalTemplateRequestDto;
};

export type ApproveAchTemplateResponseDto = AchTemplateBaseResponseDto & {
  securityMessage?: SecurityMessageModelDto;
};

export interface AchTemplateApprovalModelDto {
  /** @format guid */
  id?: string;
  comments?: string;
}

export type RejectAchTemplateResponseDto = AchTemplateBaseResponseDto & {
  securityMessage?: SecurityMessageModelDto;
};

export interface AchTemplateRejectModelDto {
  /** @format guid */
  id?: string;
  comments?: string;
}

export type GetAchTemplateApproversResponseDto = AchTemplateBaseResponseDto & {
  completedApprovals?: ApprovalCollectionDto;
  availableApprovers?: TextKeyCollectionDto;
};

export type ApprovalCollectionDto = ApprovalDto[];

export interface ApprovalDto {
  name?: string;
  dateApproved?: string;
}

export type GetInternationalOptionValuesResponseDto = ActionStatusDto & {
  values?: InternationalOptionValuesDto;
};

export interface InternationalOptionValuesDto {
  bankIdTypes?: BankIdTypeDtoCollectionDto;
  cascadingValues?: InternationalCascadingValueCollectionDto;
  countries?: CountryDtoCollectionDto;
  currencies?: CurrencyDtoCollectionDto;
  foreignExchangeIndicators?: ForeignExchangeIndicatorsDtoCollectionDto;
  foreignExchangeReferenceIndicators?: ForeignExchangeReferenceIndicatorDtoCollectionDto;
  internationalTransactionTypes?: InternationalTransactionTypeDtoCollectionDto;
  states?: StateDtoCollectionDto;
}

export type BankIdTypeDtoCollectionDto = BankIdTypeDtoDto[];

export interface BankIdTypeDtoDto {
  /** @format int32 */
  id?: number;
  name?: string;
  description?: string;
}

export type InternationalCascadingValueCollectionDto = InternationalCascadingValueDto[];

export interface InternationalCascadingValueDto {
  /** @format int32 */
  countryId?: number;
  receivingBankCountries?: NumberKeyCollectionDto;
  foreignExchangeIndicators?: ForeignExchangeIndicatorCollection3Dto;
  internationalAccountTypes?: InternationalAccountTypeCollectionDto;
}

export type ForeignExchangeIndicatorCollection3Dto = ForeignExchangeIndicator3Dto[];

export interface ForeignExchangeIndicator3Dto {
  indicator?: ForeignExchangeIndicatorTypeDto;
  foreignExchangeReferenceIndicators?: ForeignExchangeReferenceIndicatorCollectionDto;
  destinationCurrencies?: CurrencyTypeCollectionDto;
}

export type ForeignExchangeReferenceIndicatorCollectionDto = ForeignExchangeReferenceIndicatorDto[];

export type CurrencyTypeCollectionDto = CurrencyTypeDto[];

export type InternationalAccountTypeCollectionDto = InternationalAccountTypeDto[];

export interface InternationalAccountTypeDto {
  accountType?: BankAccountType2Dto;
  transactionTypes?: AchTransactionTypeCollectionDto;
}

export type AchTransactionTypeCollectionDto = AchTransactionType2Dto[];

export type CountryDtoCollectionDto = CountryDtoDto[];

export interface CountryDtoDto {
  /** @format int32 */
  id?: number;
  abbreviation?: string;
  name?: string;
  isActive?: boolean;
}

export type CurrencyDtoCollectionDto = CurrencyDtoDto[];

export interface CurrencyDtoDto {
  /** @format int32 */
  id?: number;
  name?: string;
  description?: string;
}

export type ForeignExchangeIndicatorsDtoCollectionDto = ForeignExchangeIndicatorsDtoDto[];

export interface ForeignExchangeIndicatorsDtoDto {
  /** @format int32 */
  id?: number;
  name?: string;
  description?: string;
}

export type ForeignExchangeReferenceIndicatorDtoCollectionDto =
  ForeignExchangeReferenceIndicatorDtoDto[];

export interface ForeignExchangeReferenceIndicatorDtoDto {
  /** @format int32 */
  id?: number;
  name?: string;
  description?: string;
}

export type InternationalTransactionTypeDtoCollectionDto = InternationalTransactionTypeDtoDto[];

export interface InternationalTransactionTypeDtoDto {
  /** @format int32 */
  id?: number;
  name?: string;
  description?: string;
}

export type StateDtoCollectionDto = StateDtoDto[];

export interface StateDtoDto {
  /** @format int32 */
  id?: number;
  code?: string;
  name?: string;
}

export type UserIdentityDto = OfxBaseModelDto & {
  fiNumber?: string;
  companyUniqueId?: string;
  userId?: string;
  userPassword?: string;
};

export interface OfxBaseModelDto {
  ofxKey?: string;
  activityId?: string;
}

export interface OfxAuthenticationCodeDto {
  /** @format int32 */
  companyId?: number;
  companyUniqueId?: string;
  errorMessage?: string;
}

export interface OfxContextDto {
  jxEnvironment?: string;
  jxRouting?: string;
  clientId?: string;
  bankId?: string;
  /** @format int32 */
  companyId?: number;
  cifNumber?: string;
  errorMessage?: string;
}

export interface PasswordRulesDto {
  rules?: PasswordRuleDto[];
}

export interface PasswordRuleDto {
  /** @format int32 */
  ruleType?: number;
  ruleValue?: string;
  ruleMessage?: string;
}

export interface OfxAccountsModelDto {
  errorMessage?: string;
  ofxAccounts?: OfxAccountDetailModelDto[];
}

export interface OfxAccountDetailModelDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  companyId?: number;
  name?: string;
  type?: string;
  number?: string;
  description?: string;
  rowStatusId?: number;
  cifNumber?: string;
  rowStatusDescription?: string;
  /** @format decimal */
  balance?: number;
  /** @format decimal */
  collectedBalance?: number;
  /** @format decimal */
  currentBalance?: number;
  /** @format decimal */
  perTransactionLimit?: number;
  /** @format decimal */
  dailyLimit?: number;
  /** @format decimal */
  loanPaymentAmountDue?: number;
  /** @format date-time */
  loanPaymentDueDate?: string;
  allowLoanPaymentPastDue?: boolean;
  suppressAccountMasking?: boolean;
  showAccountNickName?: boolean;
  canTransferFrom?: boolean;
  /** @format decimal */
  ledgerBalance?: number;
  /** @format decimal */
  availableBalance?: number;
}

export type AccountBalanceRequestModelDto = OfxBaseModelDto & {
  /** @format int32 */
  companyId?: number;
  accountId?: string;
};

export type TransferAccountRequestDto = OfxBaseModelDto & {
  /** @format int32 */
  fromAccountId?: number;
};

export interface OfxTransactionsModelDto {
  errorMessage?: string;
  transactions?: OfxTransactionDetailDto[];
}

export interface OfxTransactionDetailDto {
  description?: string;
  /** @format decimal */
  debit?: number;
  /** @format decimal */
  credit?: number;
  /** @format date-time */
  date?: string;
  isDebit?: boolean;
  checkNumber?: string;
}

export type TransactionDetailRequestDto = OfxBaseModelDto & {
  /** @format int32 */
  id?: number;
  number?: string;
  type?: string;
  /** @format date-time */
  fromDate?: string;
  /** @format date-time */
  toDate?: string;
  requireBalanceHistory?: boolean;
  memoPostOnly?: boolean;
};

export interface OfxProductDto {
  errorMessage?: string;
  productTypeIds?: number[];
}

export type GetOfxUserAccountsRequestModelDto = OfxBaseModelDto & {
  /** @format int32 */
  userId?: number;
  /** @format int32 */
  companyId?: number;
  isBalanceRequired?: boolean;
  isTransferFromRequired?: boolean;
  searchUserString?: string;
};

export interface TransferResultDto {
  errorMessage?: string;
  transactionId?: string;
}

export type OfxTransferRequestDto = OfxBaseModelDto & {
  /** @format int32 */
  id?: number;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
  /** @format date-time */
  transferDate?: string;
  /** @format decimal */
  amount?: number;
  memo?: string;
  fromAccountNumber?: string;
  /** @format int32 */
  fromAccountId?: number;
  fromAccountType?: string;
  toAccountNumber?: string;
  /** @format int32 */
  toAccountId?: number;
  toAccountType?: string;
  /** @format int32 */
  paymentFrequencyTypeId?: number;
  /** @format int32 */
  firstRepeatOnDay?: number;
  /** @format int32 */
  secondRepeatOnDay?: number;
  repeatOnLastBusinessDay?: boolean;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  hasNoEndDate?: boolean;
  transactionId?: string;
  batchId?: string;
  /** @format int32 */
  internalTransferStatusTypeId?: number;
  /** @format int32 */
  internalTransferTemplateId?: number;
  /** @format int32 */
  paymentOptionTypeId?: number;
  isEdited?: boolean;
  /** @format int32 */
  internalTransferIdForCancel?: number;
};

export interface OfxTransfersModelDto {
  errorMessage?: string;
  transferItems?: OfxTransferItemDto[];
}

export interface OfxTransferItemDto {
  fromAccountType?: string;
  fromAccountNumber?: string;
  toAccountType?: string;
  toAccountNumber?: string;
  status?: string;
  /** @format int32 */
  id?: number;
  /** @format date-time */
  transferDate?: string;
}

export type GetTransfersRequestDto = OfxBaseModelDto & {
  transferIds?: number[];
};

export type BalanceFilterModelDto = FilterBaseModelDto & object;

export type FilterBaseModelDto = ModelBaseDto & {
  /** @minLength 1 */
  name: string;
  description?: string;
  /** @minLength 1 */
  reportType: string;
  /** @format int32 */
  standardReportTypeId?: number;
  isStandardReport?: boolean;
  /** @minLength 1 */
  dateType: string;
  /** @format date-time */
  fromDate?: string;
  /** @format date-time */
  toDate?: string;
  /** @format date-time */
  specificDate?: string;
  /** @format int32 */
  priorDays?: number;
  /** @minLength 1 */
  sortBy: string;
  isAscendingSort?: boolean;
  /** @format int32 */
  owner?: number;
  /** @minLength 1 */
  accountTypes: string;
  accounts?: FilterAccountModelDto[];
  /** @minLength 1 */
  type: string;
  /** @format int32 */
  sequence?: number;
  isFavorite?: boolean;
};

export type FilterAccountModelDto = ModelBaseDto & {
  account: CompanyAccountModelDto;
};

export type BalanceDateRangeReportModelDto = ReportResultBaseModelDto & {
  data?: BalanceDateRangeReportAccountGroupModelDto[];
};

export interface BalanceDateRangeReportAccountGroupModelDto {
  /** @minLength 1 */
  accountNumber: string;
  /** @minLength 1 */
  accountName: string;
  data?: BalanceDateRangeReportColumnModelDto[];
}

export interface BalanceDateRangeReportColumnModelDto {
  /** @format date-time */
  date?: string;
  /** @format decimal */
  openingBalance?: number;
  /** @format decimal */
  collectedBalance?: number;
  /** @format decimal */
  debits?: number;
  /** @format int32 */
  debitCount?: number;
  /** @format decimal */
  credits?: number;
  /** @format int32 */
  creditCount?: number;
  /** @format decimal */
  floatDay1?: number;
  /** @format decimal */
  floatDay2?: number;
  /** @format decimal */
  floatDay3?: number;
}

export type ReportResultBaseModelDto = ModelBaseDto & {
  /** @minLength 1 */
  title: string;
  canEmail?: boolean;
  canPrint?: boolean;
  /** @minLength 1 */
  dateType: string;
  /** @minLength 1 */
  reportType: string;
  /** @format int32 */
  totalRecords?: number;
  downloadOptions: string[];
  /** @minLength 1 */
  sortBy: string;
  isAscending?: boolean;
};

export type TransactionDateRangeReportModelDto = ReportResultBaseModelDto & {
  data?: TransactionDateRangeReportAccountGroupModelDto[];
};

export interface TransactionDateRangeReportAccountGroupModelDto {
  /** @minLength 1 */
  accountNumber: string;
  /** @minLength 1 */
  accountName: string;
  data?: TransactionDateRangeReportColumnModelDto[];
}

export interface TransactionDateRangeReportColumnModelDto {
  /** @format date-time */
  date?: string;
  /** @minLength 1 */
  accountType: string;
  /** @minLength 1 */
  checkImageNumber: string;
  /** @minLength 1 */
  checkNumber: string;
  /** @minLength 1 */
  description: string;
  accountNumber?: string;
  /** @format decimal */
  debits?: number;
  isDebit?: boolean;
  /** @format decimal */
  credits?: number;
  /** @format decimal */
  balance?: number;
  splitTransactions?: TransactionDateRangeReportColumnModelDto[];
  transactionCodeDescription?: string;
}

export type TransactionReportModelDto = ReportResultBaseModelDto & {
  /** @format decimal */
  totalTransactionAmount?: number;
  /** @format int32 */
  totalTransactionCount?: number;
  /** @format decimal */
  checkingTotalAmount?: number;
  /** @format int32 */
  checkingTotalCount?: number;
  data?: TransactionReportColumnModelDto[];
  /** @format decimal */
  savingTotalAmount?: number;
  /** @format int32 */
  savingTotalCount?: number;
};

export interface TransactionReportColumnModelDto {
  /** @minLength 1 */
  accountNumber: string;
  /** @minLength 1 */
  accountName: string;
  /** @minLength 1 */
  accountType: string;
  /** @minLength 1 */
  checkImageNumber: string;
  /** @minLength 1 */
  description: string;
  checkNumber?: string;
  /** @format decimal */
  debitAmount?: number;
  isDebit?: boolean;
  /** @format decimal */
  creditAmount?: number;
  /** @format decimal */
  balance?: number;
  splitTransactions?: TransactionReportColumnModelDto[];
  transactionCode?: string;
  transactionCodeDescription?: string;
}

export type EDIReportModelDto = ReportResultBaseModelDto & {
  accountName?: string;
  data?: EDIReportColumnModelDto[];
};

export interface EDIReportColumnModelDto {
  /** @format date-time */
  ediDate?: string;
  ediAddenda?: TupleStringStringDto[];
  /** @format decimal */
  ediAmount?: number;
}

export interface TupleStringStringDto {
  item1?: string;
  item2?: string;
}

export type SortRequestDto = ModelBaseDto & {
  reportingFilterIds?: number[];
};

export type ResearchTransactionModelDto = ModelBaseDto & {
  /**
   * @format date-time
   * @minLength 1
   */
  date: string;
  /** @minLength 1 */
  accountNumber: string;
  /** @minLength 1 */
  checkImageNumber: string;
  /** @minLength 1 */
  description: string;
  /** @format decimal */
  amount?: number;
  /** @minLength 1 */
  checkNumber: string;
  /** @minLength 1 */
  accountName: string;
  /** @minLength 1 */
  accountType: string;
  /** @minLength 1 */
  transactionId: string;
  /** @minLength 1 */
  transactionType: string;
  isDebit: boolean;
  checkNumberSortValue?: string;
  transactionCodeDescription?: string;
};

export type ResearchTransactionFilterModelDto = ModelBaseDto & {
  /** @format date-time */
  transactionDateFrom?: string;
  /** @format date-time */
  transactionDateTo?: string;
  transactionId?: string;
  referenceNumberFrom?: string;
  referenceNumberTo?: string;
  /** @format decimal */
  amountFrom?: number;
  /** @format decimal */
  amountTo?: number;
  paymentDirection?: string;
  paymentTypes?: FilterPaymentTypeModelDto[];
  accounts?: CompanyAccountModelDto[];
  accountTypes?: AccountTypeAccountsDto[];
  /** @format int32 */
  maxRecordCount?: number;
};

export type FilterPaymentTypeModelDto = ModelBaseDto & {
  /** @minLength 1 */
  type: string;
};

export interface AccountTypeAccountsDto {
  name?: string;
}

export interface DashboardSummaryModelDto {
  /** @format decimal */
  depositAmount: number;
  /** @format decimal */
  timeDepositAmount: number;
  /** @format decimal */
  loanAmount: number;
}

export interface DashboardAccountDetailModelDto {
  transactions: DashboardTransactionDetailModelDto[];
  balanceHistory: AccountBalanceDetailDto[];
}

export interface DashboardTransactionDetailModelDto {
  /**
   * @format date-time
   * @minLength 1
   */
  date: string;
  /** @format int32 */
  id?: number;
  checkImageNumber?: string;
  checkNumber?: string;
  isDebit?: boolean;
  /** @minLength 1 */
  description: string;
  /** @format decimal */
  amount: number;
  /** @format decimal */
  balance: number;
  /** @format int64 */
  postingSequence?: number;
  tranCodeType?: string;
  tranCodeDescription?: string;
}

export interface DashboardDepositTransactionDetailModelDto {
  /** @format decimal */
  currentBalance: number;
  /** @format decimal */
  availableBalance: number;
  /** @format decimal */
  collectedBalance?: number;
  /** @format decimal */
  accruedInterest?: number;
  /** @format decimal */
  interestRate?: number;
  /** @format decimal */
  interestPaidYtd?: number;
  /** @format decimal */
  interestPaidPreviousYtd?: number;
}

export interface DashboardLoanTransactionDetailModelDto {
  /** @format decimal */
  originalLoanAmount: number;
  /** @format decimal */
  currentBalance: number;
  /** @minLength 1 */
  originalLoanTerm: string;
  /** @format decimal */
  interestRate: number;
  /** @format decimal */
  accruedInterest: number;
  /** @format decimal */
  totalAmountDue: number;
  /**
   * @format date-time
   * @minLength 1
   */
  lastPaymentDate: string;
  /**
   * @format date-time
   * @minLength 1
   */
  nextPaymentDate: string;
  /** @minLength 1 */
  paymentFrequency: string;
  /** @format int32 */
  remainingPayments: number;
  /** @format decimal */
  availableCredit?: number;
  /** @format decimal */
  lineOfCreditLimit?: number;
  /** @format date-time */
  originalLoanDate?: string;
  /** @format decimal */
  originalBalance?: number;
  /** @format date-time */
  maturityDate?: string;
  /** @format decimal */
  interestPaidYtd?: number;
  /** @format decimal */
  paymentAmountDue?: number;
  /** @format decimal */
  pastAmountDue?: number;
  /** @format date-time */
  paymentDueDate?: string;
  /** @format decimal */
  currentPayoff?: number;
  /** @format date-time */
  payoffGoodThru?: string;
  /** @format decimal */
  billedPrincipal?: number;
  /** @format decimal */
  billedInterest?: number;
  /** @format decimal */
  billedEscrow?: number;
  /** @format decimal */
  billedLateCharge?: number;
  /** @format decimal */
  billedOtherCharge?: number;
  /** @format decimal */
  paymentTotalAmount?: number;
}

export interface DashboardTimeDepositTransactionDetailModelDto {
  /** @format decimal */
  currentBalance: number;
  /** @format decimal */
  originalBalance: number;
  /** @format decimal */
  interestPaidYtd: number;
  /** @format decimal */
  accruedInterest: number;
  /** @minLength 1 */
  term: string;
  /** @format decimal */
  interestRate: number;
  /**
   * @format date-time
   * @minLength 1
   */
  issuedDate: string;
  /**
   * @format date-time
   * @minLength 1
   */
  maturityDate: string;
}

export interface DashboardInformationCenterModelDto {
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  description: string;
  /** @minLength 1 */
  type: string;
  /** @format int32 */
  sequence: number;
}

export interface DashboardResourcesModelDto {
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  link: string;
  /** @minLength 1 */
  tooltip: string;
  displayExternalWarning: boolean;
  /** @minLength 1 */
  externalWarningMessage: string;
  /** @format int32 */
  sequence: number;
  /**
   * @format byte
   * @minLength 1
   */
  logo: string;
}

export interface InternalTransferTransactionModelInternalTransferDto {
  /** @format int32 */
  id?: number;
  transactionId?: string;
  memo?: string;
  status?: string;
  batchId?: string;
  /** @format decimal */
  amount?: number;
  /** @format date-time */
  transferDate?: string;
  /** @format date-time */
  createdDate?: string;
  createdBy?: UserModelMobileDto;
  /** @format date-time */
  updatedDate?: string;
  updatedBy?: UserModelMobileDto;
  toAccount?: AccountModelMobileDto;
  fromAccount?: AccountModelMobileDto;
  frequency?: FrequencyModelMobileDto;
  /** @format int32 */
  numberOfApprovalsNeeded?: number;
  audit?: string;
  paymentOptionType?: string;
}

export interface UserModelMobileDto {
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface AccountModelMobileDto {
  /** @format int32 */
  id?: number;
  name?: string;
  type?: string;
  accountDisplayLabel?: string;
}

export interface FrequencyModelMobileDto {
  type?: string;
  summary?: string;
  /** @format date-time */
  valueDate?: string;
}

export interface WireModelWiresDto {
  /** @format int32 */
  id?: number;
  transactionId?: string;
  status?: string;
  destinationCurrency?: string;
  isInternational?: boolean;
  /** @format decimal */
  amount?: number;
  beneficiary?: BeneficiaryModelWiresDto;
  /** @format date-time */
  createdDate?: string;
  createdBy?: UserModelMobileDto;
  /** @format date-time */
  updatedDate?: string;
  updatedBy?: UserModelMobileDto;
  debitAccount?: AccountModelMobileDto;
  frequency?: FrequencyModelMobileDto;
  /** @format int32 */
  numberOfApprovalsNeeded?: number;
  audit?: string;
  isUnsupportedRequest?: boolean;
}

export interface BeneficiaryModelWiresDto {
  accountNumber?: string;
  name?: string;
}

export interface AchPaymentModelAchDto {
  /** @format int32 */
  id?: number;
  name?: string;
  transactionId?: string;
  status?: string;
  secCode?: string;
  /** @format decimal */
  creditAmount?: number;
  /** @format decimal */
  debitAmount?: number;
  /** @format date-time */
  createdDate?: string;
  createdBy?: UserModelMobileDto;
  /** @format date-time */
  updatedDate?: string;
  updatedBy?: UserModelMobileDto;
  /** @format int32 */
  numberOfApprovalsNeeded?: number;
  audit?: string;
}

export interface DashboardEntitlementsModelDto {
  /** @minLength 1 */
  widget: string;
  /** @minLength 1 */
  permission: string;
}

export type DashboardAccountsGroupModelDto = ModelBaseDto & {
  accounts?: CompanyAccountModelDto[];
  /** @minLength 1 */
  name: string;
};

export type PaymentBatchModelDto = SecurityBaseDto & {
  batch?: LookupModelDto[];
};

export type DashboardPaymentResponseModelDto = ModelBaseDto & {
  type?: string;
  successMessage?: string;
  errorMessage?: string;
  transactions?: DashboardPaymentTransactionResponseModelDto[];
};

export type DashboardPaymentTransactionResponseModelDto = ModelBaseDto & {
  successMessage?: string;
  errorMessage?: string;
  transactionId?: string;
  /** @format int32 */
  completedApprovals?: number;
  /** @format int32 */
  numberOfApprovalsNeeded?: number;
};

export interface DashboardWidgetModelDto {
  /** @format int32 */
  id?: number;
  title?: string;
  description?: string;
  type?: string;
  image?: string;
  isResizable?: boolean;
  fullScreenAllowed?: boolean;
  /** @format int32 */
  minWidth?: number;
  /** @format int32 */
  maxWidth?: number;
  /** @format int32 */
  minHeight?: number;
  /** @format int32 */
  maxHeight?: number;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
  /** @format int32 */
  left?: number;
  /** @format int32 */
  top?: number;
  isRemoved?: boolean;
  hasPermission?: boolean;
  permissionMessage?: string;
  isRequired?: boolean;
  updatedBy?: string;
  /** @format date-time */
  updatedDate?: string;
}

export interface UserDashboardWidgetModelDto {
  /** @format int32 */
  id?: number;
  description?: string;
  hasPermission?: boolean;
  isRequired?: boolean;
  permissionMessage?: string;
  title?: string;
  /** @format int32 */
  top?: number;
  type?: string;
}

export interface PendingApprovalCountsModelDto {
  /** @format int32 */
  transfers?: number;
  /** @format int32 */
  loanpayments?: number;
  /** @format int32 */
  wires?: number;
  /** @format int32 */
  ach?: number;
  /** @format int32 */
  stoppayments?: number;
  /** @format int32 */
  users?: number;
}

export type DashboardWidgetOptionsModelDto = ModelBaseDto & {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  type: string;
  /** @format int32 */
  count: number;
};

export type ProductModelDto = ModelBaseDto & {
  /** @format int32 */
  id?: number;
  /** @minLength 1 */
  type: string;
  status?: string;
  name?: string;
  permissions?: ProductPermissionsModelDto;
};

export interface ProductPermissionsModelDto {
  permissions?: ProductPermissionModelDto[];
  /** @format int32 */
  productId?: number;
  productName?: string;
}

export interface ProductSettingsModelDto {
  products?: ProductModelDto[];
  billPaySettings?: BillPaySettingsModelDto;
}

export interface BillPaySettingsModelDto {
  allowIPayForMobile?: boolean;
}

export interface BannerAndModalMessageModelDto {
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  description: string;
  /** @minLength 1 */
  type: string;
}

export interface UisLoginUrlResponseDto {
  isUisEnabled?: boolean;
  uisLoginUrl?: string;
}

export interface UisLoginUrlRequestDto {
  fiId?: string;
  isMobile?: boolean;
  returnUrl?: string;
  digitalId?: string;
}

export interface GetBffLoginUrlResponseDto {
  bffLoginUrl?: string;
}

export type GetBffLoginUrlRequestDto = object;

export interface SsoViaUisRequestDto {
  authorizationCode?: string;
  fiId?: string;
  state?: string;
  isMobile?: boolean;
  returnUrl?: string;
  isEnrollment?: boolean;
}

export interface CompanyLoginResponseDto {
  alias?: string;
  companyUniqueId?: string;
  digitalId?: string;
  message?: string;
  statusCode?: string;
  userAccountSettingsLink?: string;
}

export interface CompanyLoginRequestDto {
  /** @format guid */
  userCompanyUniqueId?: string;
}

export interface CompanyLoginBffResponseDto {
  alias?: string;
  companyUniqueId?: string;
  digitalId?: string;
  message?: string;
  statusCode?: string;
  userAccountSettingsLink?: string;
}

export interface CompanyLoginBffRequestDto {
  /** @format guid */
  userCompanyUniqueId?: string;
}

export interface AgileticsSamlResponseDto {
  endPoint?: string;
  headers?: Record<string, string>;
  body?: Record<string, string>;
  httpVerb?: string;
  errorMessage?: string;
}

export interface ChannelUserModelDto {
  alias?: string;
  userUniqueId?: string;
  userUniversalId?: string;
  financialInstitutionId?: string;
  institutionUniversalId?: string;
  companyUniqueIdentifier?: string;
  companyGuidUniqueId?: string;
  digitalId?: string;
}

export type ThresholdCollectionDto = ThresholdDto[];

export interface AccountListDataModelDto {
  /** @format int32 */
  id?: number;
  /** @format decimal */
  collectedBalance?: number;
  permissions?: ProductPermissionModelDto[];
}

export type GenericEntityResponseModelDto = RequestResponseDto & {
  /** @format int32 */
  id?: number;
  name?: string;
};

export type GenericDownloadResponseModelDto = GenericDownloadResponseModelByteDto & object;

export type GenericDownloadResponseModelByteDto = RequestResponseDto & {
  fileName?: string;
  /** @format byte */
  fileContent?: string;
};

export interface ExternalReportFileDownloadModelDto {
  /** @format int32 */
  externalReportFileId?: number;
  fileOutputType?: OutPutTypeDto;
}

export type GenericEntityCollectionResponseModelDto = RequestResponseDto & {
  genericEntityResponseModels?: GenericEntityResponseModelDto[];
};

export type ExternalReportModelDto = ModelBaseDto & {
  externalReportType?: ExternalReportTypeModelDto;
  externalReportGroupIds?: number[];
  reportName?: string;
  accounts?: AccountModelDto[];
  timePeriod?: TimePeriodModelDto;
  /** @format date-time */
  activityPeriodStart?: string;
  /** @format date-time */
  activityPeriodEnd?: string;
  frequency?: FrequencyModelTimeDto;
  /** @format date-time */
  createdDate?: string;
  createdBy?: UserModelDto;
};

export type ExternalReportTypeModelDto = GenericEnumModelDto & {
  referenceId?: string;
  timePeriodTypesConstraint?: GenericEnumModelDto[];
};

export interface GenericEnumModelDto {
  /** @format int32 */
  id?: number;
  name?: string;
  displayName?: string;
  description?: string;
}

export type TimePeriodModelDto = GenericEnumModelDto & {
  /** @format int32 */
  timePeriodInterval?: number;
};

export type FrequencyModelTimeDto = GenericEnumModelDto & {
  /** @format int32 */
  repeatOnDayOne?: number;
};

export interface PagedListModelExternalReportFileModelDto {
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  maxPageSize?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalCount?: number;
  items?: ExternalReportFileModelDto[];
  /** @format int32 */
  recordCountInCurrentPage?: number;
}

export interface ExternalReportFileModelDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  externalReportId?: number;
  reportName?: string;
  fileName?: string;
  externalReportType?: ExternalReportTypeModelDto;
  jobStatusType?: JobStatusTypeEnumDto;
  /** @format date-time */
  executionStartTime?: string;
  /** @format date-time */
  executionCompleteTime?: string;
  user?: UserModelDto;
  account?: AccountModelDto;
  detail?: string;
  availableFileOutputTypes?: GenericEnumCollectionModelDto;
}

export type GenericEnumCollectionModelDto = RequestResponseDto & {
  values?: GenericEnumModelDto[];
};

export interface ExternalReportFileSearchCriteriaModelDto {
  accountIds?: number[];
  reportTypeIds?: number[];
  /** @format date-time */
  executionStartTime?: string;
  /** @format date-time */
  executionEndTime?: string;
  jobStatusTypeIds?: number[];
  userIds?: number[];
  pagingParameters?: PagingParametersModelDto;
}

export interface PagedListModelExternalReportModelDto {
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  maxPageSize?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalCount?: number;
  items?: ExternalReportModelDto[];
  /** @format int32 */
  recordCountInCurrentPage?: number;
}

export interface ExternalReportSearchCriteriaModelDto {
  accountIds?: number[];
  reportTypeIds?: number[];
  frequencyTypeIds?: number[];
  createdUserIds?: number[];
  pagingParameters?: PagingParametersModelDto;
}

export interface PagedListModelAccountModelDto {
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  maxPageSize?: number;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalCount?: number;
  items?: AccountModelDto[];
  /** @format int32 */
  recordCountInCurrentPage?: number;
}

export interface ReportAccountsModelDto {
  pagingParameters?: PagingParametersModelDto;
}

export type ExternalReportGroupModelDto = ModelBaseDto & {
  groupName?: string;
  /** @format int32 */
  externalReportGroupTemplateId?: number;
  externalReports?: ExternalReportModelDto[];
  timePeriod?: TimePeriodModelDto;
  frequency?: FrequencyModelTimeDto;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
};

export type ExternalReportGroupTemplateModelDto = ModelBaseDto & {
  groupTemplateName?: string;
  timePeriod?: TimePeriodModelDto;
  frequency?: FrequencyModelTimeDto;
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
};

export type PingResponseEntitiesDto = BaseResponseDto & {
  message?: string;
};
